(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7ff4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7ff4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iOXsB", function(module, exports) {
/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */ 







if (module.exports) {
    const Flickity = (parcelRequire("aXPw9"));
    (parcelRequire("jfd2C"));
    (parcelRequire("fTIrN"));
    (parcelRequire("ajMAu"));
    (parcelRequire("lIDw4"));
    (parcelRequire("lnSPj"));
    (parcelRequire("2GMUo"));
    (parcelRequire("fBygh"));
    module.exports = Flickity;
}

});
parcelRegister("aXPw9", function(module, exports) {






// Flickity main
/* eslint-disable max-params */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("5go2L")), (parcelRequire("3PWmK")), (parcelRequire("7KKWT")), (parcelRequire("fIHD3")), (parcelRequire("8NRtv")), (parcelRequire("cRIyt")));
    else {
        // browser global
        let _Flickity = window1.Flickity;
        window1.Flickity = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
    /* eslint-enable max-params */ // vars
    const { getComputedStyle: getComputedStyle, console: console } = window1;
    let { jQuery: jQuery } = window1;
    // -------------------------- Flickity -------------------------- //
    // globally unique identifiers
    let GUID = 0;
    // internal store of all Flickity intances
    let instances = {};
    function Flickity(element, options) {
        let queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error(`Bad element for Flickity: ${queryElement || element}`);
            return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if (this.element.flickityGUID) {
            let instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
        }
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = {
            ...this.constructor.defaults
        };
        this.option(options);
        // kick things off
        this._create();
    }
    Flickity.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: 'center',
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075,
        friction: 0.28,
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
    };
    // hash of methods triggered on _create()
    Flickity.create = {};
    let proto = Flickity.prototype;
    // inherit EventEmitter
    Object.assign(proto, EvEmitter.prototype);
    proto._create = function() {
        let { resize: resize, watchCSS: watchCSS, rightToLeft: rightToLeft } = this.options;
        // add id for Flickity.data
        let id = this.guid = ++GUID;
        this.element.flickityGUID = id; // expando
        instances[id] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.beginMargin = rightToLeft ? 'marginRight' : 'marginLeft';
        this.endMargin = rightToLeft ? 'marginLeft' : 'marginRight';
        // create viewport & slider
        this.viewport = document.createElement('div');
        this.viewport.className = 'flickity-viewport';
        this._createSlider();
        // used for keyboard navigation
        this.focusableElems = [
            this.element
        ];
        if (resize || watchCSS) window1.addEventListener('resize', this);
        // add listeners from on option
        for(let eventName in this.options.on){
            let listener = this.options.on[eventName];
            this.on(eventName, listener);
        }
        for(let method in Flickity.create)Flickity.create[method].call(this);
        if (watchCSS) this.watchCSS();
        else this.activate();
    };
    /**
 * set options
 * @param {Object} opts - options to extend
 */ proto.option = function(opts) {
        Object.assign(this.options, opts);
    };
    proto.activate = function() {
        if (this.isActive) return;
        this.isActive = true;
        this.element.classList.add('flickity-enabled');
        if (this.options.rightToLeft) this.element.classList.add('flickity-rtl');
        this.getSize();
        // move initial cell elements so they can be loaded as cells
        let cellElems = this._filterFindCellElements(this.element.children);
        this.slider.append(...cellElems);
        this.viewport.append(this.slider);
        this.element.append(this.viewport);
        // get cells from children
        this.reloadCells();
        if (this.options.accessibility) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener('keydown', this);
        }
        this.emitEvent('activate');
        this.selectInitialIndex();
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent('ready');
    };
    // slider positions the cells
    proto._createSlider = function() {
        // slider element does all the positioning
        let slider = document.createElement('div');
        slider.className = 'flickity-slider';
        this.slider = slider;
    };
    proto._filterFindCellElements = function(elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
    };
    // goes through all children
    proto.reloadCells = function() {
        // collection of item elements
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
    };
    /**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */ proto._makeCells = function(elems) {
        let cellElems = this._filterFindCellElements(elems);
        // create new Cells for collection
        return cellElems.map((cellElem)=>new Cell(cellElem));
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
    };
    // positions all cells
    proto.positionCells = function() {
        // size all cells
        this._sizeCells(this.cells);
        // position all cells
        this._positionCells(0);
    };
    /**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */ proto._positionCells = function(index) {
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        let cellX = 0;
        // get cellX
        if (index > 0) {
            let startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        this.cells.slice(index).forEach((cell)=>{
            cell.x = cellX;
            this._renderCellPosition(cell, cellX);
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
        });
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0;
    };
    proto._renderCellPosition = function(cell, x) {
        // render position of cell with in slider
        let sideOffset = this.options.rightToLeft ? -1 : 1;
        let renderX = x * sideOffset;
        if (this.options.percentPosition) renderX *= this.size.innerWidth / cell.size.width;
        let positionValue = this.getPositionValue(renderX);
        cell.element.style.transform = `translateX( ${positionValue} )`;
    };
    /**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */ proto._sizeCells = function(cells) {
        cells.forEach((cell)=>cell.getSize());
    };
    // --------------------------  -------------------------- //
    proto.updateSlides = function() {
        this.slides = [];
        if (!this.cells.length) return;
        let { beginMargin: beginMargin, endMargin: endMargin } = this;
        let slide = new Slide(beginMargin, endMargin, this.cellAlign);
        this.slides.push(slide);
        let canCellFit = this._getCanCellFit();
        this.cells.forEach((cell, i)=>{
            // just add cell if first cell in slide
            if (!slide.cells.length) {
                slide.addCell(cell);
                return;
            }
            let slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[endMargin]);
            if (canCellFit(i, slideWidth)) slide.addCell(cell);
            else {
                // doesn't fit, new slide
                slide.updateTarget();
                slide = new Slide(beginMargin, endMargin, this.cellAlign);
                this.slides.push(slide);
                slide.addCell(cell);
            }
        });
        // last slide
        slide.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
    };
    proto._getCanCellFit = function() {
        let { groupCells: groupCells } = this.options;
        if (!groupCells) return ()=>false;
        if (typeof groupCells == 'number') {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            let number = parseInt(groupCells, 10);
            return (i)=>i % number !== 0;
        }
        // default, group by width of slide
        let percent = 1;
        // parse '75%
        let percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
        if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
        let groupWidth = (this.size.innerWidth + 1) * percent;
        return (i, slideWidth)=>slideWidth <= groupWidth;
    };
    // alias _init for jQuery plugin .flickity()
    proto._init = proto.reposition = function() {
        this.positionCells();
        this.positionSliderAtSelected();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    let cellAlignShorthands = {
        left: 0,
        center: 0.5,
        right: 1
    };
    proto.setCellAlign = function() {
        let { cellAlign: cellAlign, rightToLeft: rightToLeft } = this.options;
        let shorthand = cellAlignShorthands[cellAlign];
        this.cellAlign = shorthand !== undefined ? shorthand : cellAlign;
        if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
    };
    proto.setGallerySize = function() {
        if (!this.options.setGallerySize) return;
        let height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
        this.viewport.style.height = `${height}px`;
    };
    proto._updateWrapShiftCells = function() {
        // update isWrapping
        this.isWrapping = this.getIsWrapping();
        // only for wrap-around
        if (!this.isWrapping) return;
        // unshift previous cells
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        // get before cells
        // initial gap
        let beforeGapX = this.cursorPosition;
        let lastIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(beforeGapX, lastIndex, -1);
        // get after cells
        // ending gap between last cell and end of gallery viewport
        let afterGapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
    };
    proto.getIsWrapping = function() {
        let { wrapAround: wrapAround } = this.options;
        if (!wrapAround || this.slides.length < 2) return false;
        if (wrapAround !== 'fill') return true;
        // check that slides can fit
        let gapWidth = this.slideableWidth - this.size.innerWidth;
        if (gapWidth > this.size.innerWidth) return true; // gap * 2x big, all good
        // check that content width - shifting cell is bigger than viewport width
        for (let cell of this.cells){
            if (cell.size.outerWidth > gapWidth) return false;
        }
        return true;
    };
    proto._getGapCells = function(gapX, cellIndex, increment) {
        // keep adding cells until the cover the initial gap
        let cells = [];
        while(gapX > 0){
            let cell = this.cells[cellIndex];
            if (!cell) break;
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };
    // ----- contain & wrap ----- //
    // contain cell targets so no excess sliding
    proto._containSlides = function() {
        let isContaining = this.options.contain && !this.isWrapping && this.cells.length;
        if (!isContaining) return;
        let contentWidth = this.slideableWidth - this.getLastCell().size[this.endMargin];
        // content is less than gallery size
        let isContentSmaller = contentWidth < this.size.innerWidth;
        if (isContentSmaller) // all cells fit inside gallery
        this.slides.forEach((slide)=>{
            slide.target = contentWidth * this.cellAlign;
        });
        else {
            // contain to bounds
            let beginBound = this.cursorPosition + this.cells[0].size[this.beginMargin];
            let endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach((slide)=>{
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
            });
        }
    };
    // ----- events ----- //
    /**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        let emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? '.flickity' : '';
            let $event = type;
            if (event) {
                // create jQuery event
                let jQEvent = new jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger($event, args);
        }
    };
    const unidraggerEvents = [
        'dragStart',
        'dragMove',
        'dragEnd',
        'pointerDown',
        'pointerMove',
        'pointerEnd',
        'staticClick'
    ];
    let _emitEvent = proto.emitEvent;
    proto.emitEvent = function(eventName, args) {
        if (eventName === 'staticClick') {
            // add cellElem and cellIndex args to staticClick
            let clickedCell = this.getParentCell(args[0].target);
            let cellElem = clickedCell && clickedCell.element;
            let cellIndex = clickedCell && this.cells.indexOf(clickedCell);
            args = args.concat(cellElem, cellIndex);
        }
        // do regular thing
        _emitEvent.call(this, eventName, args);
        // duck-punch in jQuery events for Unidragger events
        let isUnidraggerEvent = unidraggerEvents.includes(eventName);
        if (!isUnidraggerEvent || !jQuery || !this.$element) return;
        eventName += this.options.namespaceJQueryEvents ? '.flickity' : '';
        let event = args.shift(0);
        let jQEvent = new jQuery.Event(event);
        jQEvent.type = eventName;
        this.$element.trigger(jQEvent, args);
    };
    // -------------------------- select -------------------------- //
    /**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */ proto.select = function(index, isWrap, isInstant) {
        if (!this.isActive) return;
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.isWrapping || isWrap) index = utils.modulo(index, this.slides.length);
        // bail if invalid index
        if (!this.slides[index]) return;
        let prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) this.positionSliderAtSelected();
        else this.startAnimation();
        if (this.options.adaptiveHeight) this.setGallerySize();
        // events
        this.dispatchEvent('select', null, [
            index
        ]);
        // change event if new index
        if (index !== prevIndex) this.dispatchEvent('change', null, [
            index
        ]);
    };
    // wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function(index) {
        if (!this.isWrapping) return;
        const { selectedIndex: selectedIndex, slideableWidth: slideableWidth, slides: { length: length } } = this;
        // shift index for wrap, do not wrap dragSelect
        if (!this.isDragSelect) {
            let wrapIndex = utils.modulo(index, length);
            // go to shortest
            let delta = Math.abs(wrapIndex - selectedIndex);
            let backWrapDelta = Math.abs(wrapIndex + length - selectedIndex);
            let forewardWrapDelta = Math.abs(wrapIndex - length - selectedIndex);
            if (backWrapDelta < delta) index += length;
            else if (forewardWrapDelta < delta) index -= length;
        }
        // wrap position so slider is within normal area
        if (index < 0) this.x -= slideableWidth;
        else if (index >= length) this.x += slideableWidth;
    };
    proto.previous = function(isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
    };
    proto.next = function(isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
    };
    proto.updateSelectedSlide = function() {
        let slide = this.slides[this.selectedIndex];
        // selectedIndex could be outside of slides, if triggered before resize()
        if (!slide) return;
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };
    proto.unselectSelectedSlide = function() {
        if (this.selectedSlide) this.selectedSlide.unselect();
    };
    proto.selectInitialIndex = function() {
        let initialIndex = this.options.initialIndex;
        // already activated, select previous selectedIndex
        if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
        }
        // select with selector string
        if (initialIndex && typeof initialIndex == 'string') {
            let cell = this.queryCell(initialIndex);
            if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
            }
        }
        let index = 0;
        // select with number
        if (initialIndex && this.slides[initialIndex]) index = initialIndex;
        // select instantly
        this.select(index, false, true);
    };
    /**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */ proto.selectCell = function(value, isWrap, isInstant) {
        // get cell
        let cell = this.queryCell(value);
        if (!cell) return;
        let index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
    };
    proto.getCellSlideIndex = function(cell) {
        // get index of slide that has cell
        let cellSlide = this.slides.find((slide)=>slide.cells.includes(cell));
        return this.slides.indexOf(cellSlide);
    };
    // -------------------------- get cells -------------------------- //
    /**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */ proto.getCell = function(elem) {
        // loop through cells to get the one that matches
        for (let cell of this.cells){
            if (cell.element === elem) return cell;
        }
    };
    /**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */ proto.getCells = function(elems) {
        elems = utils.makeArray(elems);
        return elems.map((elem)=>this.getCell(elem)).filter(Boolean);
    };
    /**
 * get cell elements
 * @returns {Array} cellElems
 */ proto.getCellElements = function() {
        return this.cells.map((cell)=>cell.element);
    };
    /**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */ proto.getParentCell = function(elem) {
        // first check if elem is cell
        let cell = this.getCell(elem);
        if (cell) return cell;
        // try to get parent cell elem
        let closest = elem.closest('.flickity-slider > *');
        return this.getCell(closest);
    };
    /**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */ proto.getAdjacentCellElements = function(adjCount, index) {
        if (!adjCount) return this.selectedSlide.getCellElements();
        index = index === undefined ? this.selectedIndex : index;
        let len = this.slides.length;
        if (1 + adjCount * 2 >= len) return this.getCellElements(); // get all
        let cellElems = [];
        for(let i = index - adjCount; i <= index + adjCount; i++){
            let slideIndex = this.isWrapping ? utils.modulo(i, len) : i;
            let slide = this.slides[slideIndex];
            if (slide) cellElems = cellElems.concat(slide.getCellElements());
        }
        return cellElems;
    };
    /**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */ proto.queryCell = function(selector) {
        if (typeof selector == 'number') // use number as index
        return this.cells[selector];
        // do not select invalid selectors from hash: #123, #/. #791
        let isSelectorString = typeof selector == 'string' && !selector.match(/^[#.]?[\d/]/);
        if (isSelectorString) // use string as selector, get element
        selector = this.element.querySelector(selector);
        // get cell from element
        return this.getCell(selector);
    };
    // -------------------------- events -------------------------- //
    proto.uiChange = function() {
        this.emitEvent('uiChange');
    };
    // ----- resize ----- //
    proto.onresize = function() {
        this.watchCSS();
        this.resize();
    };
    utils.debounceMethod(Flickity, 'onresize', 150);
    proto.resize = function() {
        // #1177 disable resize behavior when animating or dragging for iOS 15
        if (!this.isActive || this.isAnimating || this.isDragging) return;
        this.getSize();
        // wrap values
        if (this.isWrapping) this.x = utils.modulo(this.x, this.slideableWidth);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
        this.emitEvent('resize');
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of various numbers
        let selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
    };
    // watches the :after property, activates/deactivates
    proto.watchCSS = function() {
        if (!this.options.watchCSS) return;
        let afterContent = getComputedStyle(this.element, ':after').content;
        // activate if :after { content: 'flickity' }
        if (afterContent.includes('flickity')) this.activate();
        else this.deactivate();
    };
    // ----- keydown ----- //
    // go previous/next if left/right keys pressed
    proto.onkeydown = function(event) {
        let { activeElement: activeElement } = document;
        let handler = Flickity.keyboardHandlers[event.key];
        // only work if element is in focus
        if (!this.options.accessibility || !activeElement || !handler) return;
        let isFocused = this.focusableElems.some((elem)=>activeElement === elem);
        if (isFocused) handler.call(this);
    };
    Flickity.keyboardHandlers = {
        ArrowLeft: function() {
            this.uiChange();
            let leftMethod = this.options.rightToLeft ? 'next' : 'previous';
            this[leftMethod]();
        },
        ArrowRight: function() {
            this.uiChange();
            let rightMethod = this.options.rightToLeft ? 'previous' : 'next';
            this[rightMethod]();
        }
    };
    // ----- focus ----- //
    proto.focus = function() {
        this.element.focus({
            preventScroll: true
        });
    };
    // -------------------------- destroy -------------------------- //
    // deactivate all Flickity functionality, but keep stuff available
    proto.deactivate = function() {
        if (!this.isActive) return;
        this.element.classList.remove('flickity-enabled');
        this.element.classList.remove('flickity-rtl');
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach((cell)=>cell.destroy());
        this.viewport.remove();
        // move child elements back into element
        this.element.append(...this.slider.children);
        if (this.options.accessibility) {
            this.element.removeAttribute('tabIndex');
            this.element.removeEventListener('keydown', this);
        }
        // set flags
        this.isActive = false;
        this.emitEvent('deactivate');
    };
    proto.destroy = function() {
        this.deactivate();
        window1.removeEventListener('resize', this);
        this.allOff();
        this.emitEvent('destroy');
        if (jQuery && this.$element) jQuery.removeData(this.element, 'flickity');
        delete this.element.flickityGUID;
        delete instances[this.guid];
    };
    // -------------------------- prototype -------------------------- //
    Object.assign(proto, animatePrototype);
    // -------------------------- extras -------------------------- //
    /**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */ Flickity.data = function(elem) {
        elem = utils.getQueryElement(elem);
        if (elem) return instances[elem.flickityGUID];
    };
    utils.htmlInit(Flickity, 'flickity');
    let { jQueryBridget: jQueryBridget } = window1;
    if (jQuery && jQueryBridget) jQueryBridget('flickity', Flickity, jQuery);
    // set internal jQuery, for Webpack + jQuery v3, #478
    Flickity.setJQuery = function(jq) {
        jQuery = jq;
    };
    Flickity.Cell = Cell;
    Flickity.Slide = Slide;
    return Flickity;
});

});
parcelRegister("5go2L", function(module, exports) {
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */ (function(global, factory) {
    // universal module definition
    if (module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != 'undefined' ? window : module.exports, function() {
    function EvEmitter() {}
    let proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // set events hash
        let events = this._events = this._events || {};
        // set listeners array
        let listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (!listeners.includes(listener)) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        let onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners){
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
    };
    return EvEmitter;
});

});

parcelRegister("3PWmK", function(module, exports) {
/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */ (function(window1, factory) {
    if (module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        let num = parseFloat(value);
        // not a percent like '100%', and a number
        let isValid = value.indexOf('%') == -1 && !isNaN(num);
        return isValid && num;
    }
    // -------------------------- measurements -------------------------- //
    let measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];
    let measurementsLength = measurements.length;
    function getZeroSize() {
        let size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        measurements.forEach((measurement)=>{
            size[measurement] = 0;
        });
        return size;
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        // use querySeletor if elem is string
        if (typeof elem == 'string') elem = document.querySelector(elem);
        // do not proceed on non-objects
        let isElement = elem && typeof elem == 'object' && elem.nodeType;
        if (!isElement) return;
        let style = getComputedStyle(elem);
        // if hidden, everything is 0
        if (style.display == 'none') return getZeroSize();
        let size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        let isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
        // get all measurements
        measurements.forEach((measurement)=>{
            let value = style[measurement];
            let num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        });
        let paddingWidth = size.paddingLeft + size.paddingRight;
        let paddingHeight = size.paddingTop + size.paddingBottom;
        let marginWidth = size.marginLeft + size.marginRight;
        let marginHeight = size.marginTop + size.marginBottom;
        let borderWidth = size.borderLeftWidth + size.borderRightWidth;
        let borderHeight = size.borderTopWidth + size.borderBottomWidth;
        // overwrite width and height if we can get it from style
        let styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingWidth + borderWidth);
        let styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

});

parcelRegister("7KKWT", function(module, exports) {
/**
 * Fizzy UI utils v3.0.0
 * MIT license
 */ (function(global, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(global);
    else // browser global
    global.fizzyUIUtils = factory(global);
})(module.exports, function factory(global) {
    let utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        return Object.assign(a, b);
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        let index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (elem.matches(selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == 'string') return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        return elems// check that elem is an actual element
        .filter((elem)=>elem instanceof HTMLElement).reduce((ffElems, elem)=>{
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return ffElems;
            }
            // filter & find items if we have a selector
            // filter
            if (elem.matches(selector)) ffElems.push(elem);
            // find children
            let childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            ffElems = ffElems.concat(...childElems);
            return ffElems;
        }, []);
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        let method = _class.prototype[methodName];
        let timeoutName = methodName + 'Timeout';
        _class.prototype[methodName] = function() {
            clearTimeout(this[timeoutName]);
            let args = arguments;
            this[timeoutName] = setTimeout(()=>{
                method.apply(this, args);
                delete this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(onDocReady) {
        let readyState = document.readyState;
        if (readyState == 'complete' || readyState == 'interactive') // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(onDocReady);
        else document.addEventListener('DOMContentLoaded', onDocReady);
    };
    // ----- htmlInit ----- //
    // http://bit.ly/3oYLusc
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + '-' + $2;
        }).toLowerCase();
    };
    let console = global.console;
    // allow user to initialize classes via [data-namespace] or .js-namespace class
    // htmlInit( Widget, 'widgetName' )
    // options are parsed from data-namespace-options
    utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            let dashedNamespace = utils.toDashed(namespace);
            let dataAttr = 'data-' + dashedNamespace;
            let dataAttrElems = document.querySelectorAll(`[${dataAttr}]`);
            let jQuery = global.jQuery;
            [
                ...dataAttrElems
            ].forEach((elem)=>{
                let attr = elem.getAttribute(dataAttr);
                let options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error(`Error parsing ${dataAttr} on ${elem.className}: ${error}`);
                    return;
                }
                // initialize
                let instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});

parcelRegister("fIHD3", function(module, exports) {

// Flickity.Cell
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("3PWmK")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Cell = factory(window1.getSize);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(getSize) {
    const cellClassName = 'flickity-cell';
    function Cell(elem) {
        this.element = elem;
        this.element.classList.add(cellClassName);
        this.x = 0;
        this.unselect();
    }
    let proto = Cell.prototype;
    proto.destroy = function() {
        // reset style
        this.unselect();
        this.element.classList.remove(cellClassName);
        this.element.style.transform = '';
        this.element.removeAttribute('aria-hidden');
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    proto.select = function() {
        this.element.classList.add('is-selected');
        this.element.removeAttribute('aria-hidden');
    };
    proto.unselect = function() {
        this.element.classList.remove('is-selected');
        this.element.setAttribute('aria-hidden', 'true');
    };
    proto.remove = function() {
        this.element.remove();
    };
    return Cell;
});

});

parcelRegister("8NRtv", function(module, exports) {
// slide
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory();
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Slide = factory();
    }
})(typeof window != 'undefined' ? window : module.exports, function factory() {
    function Slide(beginMargin, endMargin, cellAlign) {
        this.beginMargin = beginMargin;
        this.endMargin = endMargin;
        this.cellAlign = cellAlign;
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }
    let proto = Slide.prototype;
    proto.addCell = function(cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        // first cell stuff
        if (this.cells.length === 1) {
            this.x = cell.x; // x comes from first cell
            this.firstMargin = cell.size[this.beginMargin];
        }
    };
    proto.updateTarget = function() {
        let lastCell = this.getLastCell();
        let lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
        let slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.cellAlign;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.select = function() {
        this.cells.forEach((cell)=>cell.select());
    };
    proto.unselect = function() {
        this.cells.forEach((cell)=>cell.unselect());
    };
    proto.getCellElements = function() {
        return this.cells.map((cell)=>cell.element);
    };
    return Slide;
});

});

parcelRegister("cRIyt", function(module, exports) {

// animate
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("7KKWT")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.animatePrototype = factory(window1.fizzyUIUtils);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(utils) {
    // -------------------------- animate -------------------------- //
    let proto = {};
    proto.startAnimation = function() {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };
    proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();
        let previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        // animate next frame
        if (this.isAnimating) requestAnimationFrame(()=>this.animate());
    };
    proto.positionSlider = function() {
        let x = this.x;
        // wrap position around
        if (this.isWrapping) {
            x = utils.modulo(x, this.slideableWidth) - this.slideableWidth;
            this.shiftWrapCells(x);
        }
        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
    };
    proto.setTranslateX = function(x, is3d) {
        x += this.cursorPosition;
        // reverse if right-to-left and using transform
        if (this.options.rightToLeft) x = -x;
        let translateX = this.getPositionValue(x);
        // use 3D transforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = is3d ? `translate3d(${translateX},0,0)` : `translateX(${translateX})`;
    };
    proto.dispatchScrollEvent = function() {
        let firstSlide = this.slides[0];
        if (!firstSlide) return;
        let positionX = -this.x - firstSlide.target;
        let progress = positionX / this.slidesWidth;
        this.dispatchEvent('scroll', null, [
            progress,
            positionX
        ]);
    };
    proto.positionSliderAtSelected = function() {
        if (!this.cells.length) return;
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };
    proto.getPositionValue = function(position) {
        if (this.options.percentPosition) // percent position, round to 2 digits, like 12.34%
        return Math.round(position / this.size.innerWidth * 10000) * 0.01 + '%';
        else // pixel positioning
        return Math.round(position) + 'px';
    };
    proto.settle = function(previousX) {
        // keep track of frames where x hasn't moved
        let isResting = !this.isPointerDown && Math.round(this.x * 100) === Math.round(previousX * 100);
        if (isResting) this.restingFrames++;
        // stop animating if resting for 3 or more frames
        if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent('settle', null, [
                this.selectedIndex
            ]);
        }
    };
    proto.shiftWrapCells = function(x) {
        // shift before cells
        let beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        // shift after cells
        let afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
    };
    proto._shiftCells = function(cells, gap, shift) {
        cells.forEach((cell)=>{
            let cellShift = gap > 0 ? shift : 0;
            this._wrapShiftCell(cell, cellShift);
            gap -= cell.size.outerWidth;
        });
    };
    proto._unshiftCells = function(cells) {
        if (!cells || !cells.length) return;
        cells.forEach((cell)=>this._wrapShiftCell(cell, 0));
    };
    // @param {Integer} shift - 0, 1, or -1
    proto._wrapShiftCell = function(cell, shift) {
        this._renderCellPosition(cell, cell.x + this.slideableWidth * shift);
    };
    // -------------------------- physics -------------------------- //
    proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };
    proto.applyForce = function(force) {
        this.velocity += force;
    };
    proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
    };
    proto.getRestingPosition = function() {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    };
    proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) return;
        // change the position to drag position by applying force
        let dragVelocity = this.dragX - this.x;
        let dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
    };
    proto.applySelectedAttraction = function() {
        // do not attract if pointer down or no slides
        let dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) return;
        let distance = this.selectedSlide.target * -1 - this.x;
        let force = distance * this.options.selectedAttraction;
        this.applyForce(force);
    };
    return proto;
});

});


parcelRegister("jfd2C", function(module, exports) {



// drag
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("aXPw9")), (parcelRequire("dI8iz")), (parcelRequire("7KKWT")));
    else // browser global
    window1.Flickity = factory(window1, window1.Flickity, window1.Unidragger, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, Flickity, Unidragger, utils) {
    // ----- defaults ----- //
    Object.assign(Flickity.defaults, {
        draggable: '>1',
        dragThreshold: 3
    });
    // -------------------------- drag prototype -------------------------- //
    let proto = Flickity.prototype;
    Object.assign(proto, Unidragger.prototype); // inherit Unidragger
    proto.touchActionValue = '';
    // --------------------------  -------------------------- //
    Flickity.create.drag = function() {
        this.on('activate', this.onActivateDrag);
        this.on('uiChange', this._uiChangeDrag);
        this.on('deactivate', this.onDeactivateDrag);
        this.on('cellChange', this.updateDraggable);
        this.on('pointerDown', this.handlePointerDown);
        this.on('pointerUp', this.handlePointerUp);
        this.on('pointerDown', this.handlePointerDone);
        this.on('dragStart', this.handleDragStart);
        this.on('dragMove', this.handleDragMove);
        this.on('dragEnd', this.handleDragEnd);
        this.on('staticClick', this.handleStaticClick);
    // TODO updateDraggable on resize? if groupCells & slides change
    };
    proto.onActivateDrag = function() {
        this.handles = [
            this.viewport
        ];
        this.bindHandles();
        this.updateDraggable();
    };
    proto.onDeactivateDrag = function() {
        this.unbindHandles();
        this.element.classList.remove('is-draggable');
    };
    proto.updateDraggable = function() {
        // disable dragging if less than 2 slides. #278
        if (this.options.draggable === '>1') this.isDraggable = this.slides.length > 1;
        else this.isDraggable = this.options.draggable;
        this.element.classList.toggle('is-draggable', this.isDraggable);
    };
    proto._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    };
    // -------------------------- pointer events -------------------------- //
    proto.handlePointerDown = function(event) {
        if (!this.isDraggable) {
            // proceed for staticClick
            this.bindActivePointerEvents(event);
            return;
        }
        let isTouchStart = event.type === 'touchstart';
        let isTouchPointer = event.pointerType === 'touch';
        let isFocusNode = event.target.matches('input, textarea, select');
        if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
        if (!isFocusNode) this.focus();
        // blur
        if (document.activeElement !== this.element) document.activeElement.blur();
        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add('is-pointer-down');
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window1.addEventListener('scroll', this);
        this.bindActivePointerEvents(event);
    };
    // ----- move ----- //
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
    };
    // ----- up ----- //
    proto.handlePointerUp = function() {
        delete this.isTouchScrolling;
        this.viewport.classList.remove('is-pointer-down');
    };
    proto.handlePointerDone = function() {
        window1.removeEventListener('scroll', this);
        delete this.pointerDownScroll;
    };
    // -------------------------- dragging -------------------------- //
    proto.handleDragStart = function() {
        if (!this.isDraggable) return;
        this.dragStartPosition = this.x;
        this.startAnimation();
        window1.removeEventListener('scroll', this);
    };
    proto.handleDragMove = function(event, pointer, moveVector) {
        if (!this.isDraggable) return;
        event.preventDefault();
        this.previousDragX = this.dragX;
        // reverse if right-to-left
        let direction = this.options.rightToLeft ? -1 : 1;
        // wrap around move. #589
        if (this.isWrapping) moveVector.x %= this.slideableWidth;
        let dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.isWrapping) {
            // slow drag
            let originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            let endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = new Date();
    };
    proto.handleDragEnd = function() {
        if (!this.isDraggable) return;
        let { freeScroll: freeScroll } = this.options;
        if (freeScroll) this.isFreeScrolling = true;
        // set selectedIndex based on where flick will end up
        let index = this.dragEndRestingSelect();
        if (freeScroll && !this.isWrapping) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            let restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!freeScroll && index === this.selectedIndex) // boost selection if selected index has not changed
        index += this.dragEndBoostSelect();
        delete this.previousDragX;
        // apply selection
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.isWrapping;
        this.select(index);
        delete this.isDragSelect;
    };
    proto.dragEndRestingSelect = function() {
        let restingX = this.getRestingPosition();
        // how far away from selected slide
        let distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        // get closet resting going up and going down
        let positiveResting = this._getClosestResting(restingX, distance, 1);
        let negativeResting = this._getClosestResting(restingX, distance, -1);
        // use closer resting for wrap-around
        return positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
    };
    /**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */ proto._getClosestResting = function(restingX, distance, increment) {
        let index = this.selectedIndex;
        let minDistance = Infinity;
        let condition = this.options.contain && !this.isWrapping ? // if containing, keep going if distance is equal to minDistance
        (dist, minDist)=>dist <= minDist : (dist, minDist)=>dist < minDist;
        while(condition(distance, minDistance)){
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) break;
            distance = Math.abs(distance);
        }
        return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
        };
    };
    /**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */ proto.getSlideDistance = function(x, index) {
        let len = this.slides.length;
        // wrap around if at least 2 slides
        let isWrapAround = this.options.wrapAround && len > 1;
        let slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        let slide = this.slides[slideIndex];
        if (!slide) return null;
        // add distance for wrap-around slides
        let wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
    };
    proto.dragEndBoostSelect = function() {
        // do not boost if no previousDragX or dragMoveTime
        if (this.previousDragX === undefined || !this.dragMoveTime || // or if drag was held for 100 ms
        new Date() - this.dragMoveTime > 100) return 0;
        let distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        let delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) // boost to next if moving towards the right, and positive velocity
        return 1;
        else if (distance < 0 && delta < 0) // boost to previous if moving towards the left, and negative velocity
        return -1;
        return 0;
    };
    // ----- scroll ----- //
    proto.onscroll = function() {
        let scroll = getScrollPosition();
        let scrollMoveX = this.pointerDownScroll.x - scroll.x;
        let scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) this.pointerDone();
    };
    // ----- utils ----- //
    function getScrollPosition() {
        return {
            x: window1.pageXOffset,
            y: window1.pageYOffset
        };
    }
    // -----  ----- //
    return Flickity;
});

});
parcelRegister("dI8iz", function(module, exports) {

/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("5go2L")));
    else // browser global
    window1.Unidragger = factory(window1, window1.EvEmitter);
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, EvEmitter) {
    function Unidragger() {}
    // inherit EvEmitter
    let proto = Unidragger.prototype = Object.create(EvEmitter.prototype);
    // ----- bind start ----- //
    // trigger handler methods for events
    proto.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    let startEvent, activeEvents;
    if ('ontouchstart' in window1) {
        // HACK prefer Touch Events as you can preventDefault on touchstart to
        // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
        startEvent = 'touchstart';
        activeEvents = [
            'touchmove',
            'touchend',
            'touchcancel'
        ];
    } else if (window1.PointerEvent) {
        // Pointer Events
        startEvent = 'pointerdown';
        activeEvents = [
            'pointermove',
            'pointerup',
            'pointercancel'
        ];
    } else {
        // mouse events
        startEvent = 'mousedown';
        activeEvents = [
            'mousemove',
            'mouseup'
        ];
    }
    // prototype so it can be overwriteable by Flickity
    proto.touchActionValue = 'none';
    proto.bindHandles = function() {
        this._bindHandles('addEventListener', this.touchActionValue);
    };
    proto.unbindHandles = function() {
        this._bindHandles('removeEventListener', '');
    };
    /**
 * Add or remove start event
 * @param {String} bindMethod - addEventListener or removeEventListener
 * @param {String} touchAction - value for touch-action CSS property
 */ proto._bindHandles = function(bindMethod, touchAction) {
        this.handles.forEach((handle)=>{
            handle[bindMethod](startEvent, this);
            handle[bindMethod]('click', this);
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if (window1.PointerEvent) handle.style.touchAction = touchAction;
        });
    };
    proto.bindActivePointerEvents = function() {
        activeEvents.forEach((eventName)=>{
            window1.addEventListener(eventName, this);
        });
    };
    proto.unbindActivePointerEvents = function() {
        activeEvents.forEach((eventName)=>{
            window1.removeEventListener(eventName, this);
        });
    };
    // ----- event handler helpers ----- //
    // trigger method with matching pointer
    proto.withPointer = function(methodName, event) {
        if (event.pointerId === this.pointerIdentifier) this[methodName](event, event);
    };
    // trigger method with matching touch
    proto.withTouch = function(methodName, event) {
        let touch;
        for (let changedTouch of event.changedTouches)if (changedTouch.identifier === this.pointerIdentifier) touch = changedTouch;
        if (touch) this[methodName](event, touch);
    };
    // ----- start event ----- //
    proto.onmousedown = function(event) {
        this.pointerDown(event, event);
    };
    proto.ontouchstart = function(event) {
        this.pointerDown(event, event.changedTouches[0]);
    };
    proto.onpointerdown = function(event) {
        this.pointerDown(event, event);
    };
    // nodes that have text fields
    const cursorNodes = [
        'TEXTAREA',
        'INPUT',
        'SELECT',
        'OPTION'
    ];
    // input types that do not have text fields
    const clickTypes = [
        'radio',
        'checkbox',
        'button',
        'submit',
        'image',
        'file'
    ];
    /**
 * any time you set `event, pointer` it refers to:
 * @param {Event} event
 * @param {Event | Touch} pointer
 */ proto.pointerDown = function(event, pointer) {
        // dismiss multi-touch taps, right clicks, and clicks on text fields
        let isCursorNode = cursorNodes.includes(event.target.nodeName);
        let isClickType = clickTypes.includes(event.target.type);
        let isOkayElement = !isCursorNode || isClickType;
        let isOkay = !this.isPointerDown && !event.button && isOkayElement;
        if (!isOkay) return;
        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier = pointer.pointerId !== undefined ? // pointerId for pointer events, touch.indentifier for touch events
        pointer.pointerId : pointer.identifier;
        // track position for move
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        this.bindActivePointerEvents();
        this.emitEvent('pointerDown', [
            event,
            pointer
        ]);
    };
    // ----- move ----- //
    proto.onmousemove = function(event) {
        this.pointerMove(event, event);
    };
    proto.onpointermove = function(event) {
        this.withPointer('pointerMove', event);
    };
    proto.ontouchmove = function(event) {
        this.withTouch('pointerMove', event);
    };
    proto.pointerMove = function(event, pointer) {
        let moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
        };
        this.emitEvent('pointerMove', [
            event,
            pointer,
            moveVector
        ]);
        // start drag if pointer has moved far enough to start drag
        let isDragStarting = !this.isDragging && this.hasDragStarted(moveVector);
        if (isDragStarting) this.dragStart(event, pointer);
        if (this.isDragging) this.dragMove(event, pointer, moveVector);
    };
    // condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
    };
    // ----- drag ----- //
    proto.dragStart = function(event, pointer) {
        this.isDragging = true;
        this.isPreventingClicks = true; // set flag to prevent clicks
        this.emitEvent('dragStart', [
            event,
            pointer
        ]);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        this.emitEvent('dragMove', [
            event,
            pointer,
            moveVector
        ]);
    };
    // ----- end ----- //
    proto.onmouseup = function(event) {
        this.pointerUp(event, event);
    };
    proto.onpointerup = function(event) {
        this.withPointer('pointerUp', event);
    };
    proto.ontouchend = function(event) {
        this.withTouch('pointerUp', event);
    };
    proto.pointerUp = function(event, pointer) {
        this.pointerDone();
        this.emitEvent('pointerUp', [
            event,
            pointer
        ]);
        if (this.isDragging) this.dragEnd(event, pointer);
        else // pointer didn't move enough for drag to start
        this.staticClick(event, pointer);
    };
    proto.dragEnd = function(event, pointer) {
        this.isDragging = false; // reset flag
        // re-enable clicking async
        setTimeout(()=>delete this.isPreventingClicks);
        this.emitEvent('dragEnd', [
            event,
            pointer
        ]);
    };
    // triggered on pointer up & pointer cancel
    proto.pointerDone = function() {
        this.isPointerDown = false;
        delete this.pointerIdentifier;
        this.unbindActivePointerEvents();
        this.emitEvent('pointerDone');
    };
    // ----- cancel ----- //
    proto.onpointercancel = function(event) {
        this.withPointer('pointerCancel', event);
    };
    proto.ontouchcancel = function(event) {
        this.withTouch('pointerCancel', event);
    };
    proto.pointerCancel = function(event, pointer) {
        this.pointerDone();
        this.emitEvent('pointerCancel', [
            event,
            pointer
        ]);
    };
    // ----- click ----- //
    // handle all clicks and prevent clicks when dragging
    proto.onclick = function(event) {
        if (this.isPreventingClicks) event.preventDefault();
    };
    // triggered after pointer down & up with no/tiny movement
    proto.staticClick = function(event, pointer) {
        // ignore emulated mouse up clicks
        let isMouseup = event.type === 'mouseup';
        if (isMouseup && this.isIgnoringMouseUp) return;
        this.emitEvent('staticClick', [
            event,
            pointer
        ]);
        // set flag for emulated clicks 300ms after touchend
        if (isMouseup) {
            this.isIgnoringMouseUp = true;
            // reset flag after 400ms
            setTimeout(()=>{
                delete this.isIgnoringMouseUp;
            }, 400);
        }
    };
    // -----  ----- //
    return Unidragger;
});

});


parcelRegister("fTIrN", function(module, exports) {

// prev/next buttons
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("aXPw9")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity) {
    const svgURI = 'http://www.w3.org/2000/svg';
    // -------------------------- PrevNextButton -------------------------- //
    function PrevNextButton(increment, direction, arrowShape) {
        this.increment = increment;
        this.direction = direction;
        this.isPrevious = increment === 'previous';
        this.isLeft = direction === 'left';
        this._create(arrowShape);
    }
    PrevNextButton.prototype._create = function(arrowShape) {
        // properties
        let element = this.element = document.createElement('button');
        element.className = `flickity-button flickity-prev-next-button ${this.increment}`;
        let label = this.isPrevious ? 'Previous' : 'Next';
        // prevent button from submitting form https://stackoverflow.com/a/10836076/182183
        element.setAttribute('type', 'button');
        element.setAttribute('aria-label', label);
        // init as disabled
        this.disable();
        // create arrow
        let svg = this.createSVG(label, arrowShape);
        element.append(svg);
    };
    PrevNextButton.prototype.createSVG = function(label, arrowShape) {
        let svg = document.createElementNS(svgURI, 'svg');
        svg.setAttribute('class', 'flickity-button-icon');
        svg.setAttribute('viewBox', '0 0 100 100');
        // add title #1189
        let title = document.createElementNS(svgURI, 'title');
        title.append(label);
        // add path
        let path = document.createElementNS(svgURI, 'path');
        let pathMovements = getArrowMovements(arrowShape);
        path.setAttribute('d', pathMovements);
        path.setAttribute('class', 'arrow');
        // rotate arrow
        if (!this.isLeft) path.setAttribute('transform', 'translate(100, 100) rotate(180)');
        svg.append(title, path);
        return svg;
    };
    // get SVG path movmement
    function getArrowMovements(shape) {
        // use shape as movement if string
        if (typeof shape == 'string') return shape;
        let { x0: x0, x1: x1, x2: x2, x3: x3, y1: y1, y2: y2 } = shape;
        // create movement string
        return `M ${x0}, 50
    L ${x1}, ${y1 + 50}
    L ${x2}, ${y2 + 50}
    L ${x3}, 50
    L ${x2}, ${50 - y2}
    L ${x1}, ${50 - y1}
    Z`;
    }
    // -----  ----- //
    PrevNextButton.prototype.enable = function() {
        this.element.removeAttribute('disabled');
    };
    PrevNextButton.prototype.disable = function() {
        this.element.setAttribute('disabled', true);
    };
    // -------------------------- Flickity prototype -------------------------- //
    Object.assign(Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    });
    Flickity.create.prevNextButtons = function() {
        if (!this.options.prevNextButtons) return;
        let { rightToLeft: rightToLeft, arrowShape: arrowShape } = this.options;
        let prevDirection = rightToLeft ? 'right' : 'left';
        let nextDirection = rightToLeft ? 'left' : 'right';
        this.prevButton = new PrevNextButton('previous', prevDirection, arrowShape);
        this.nextButton = new PrevNextButton('next', nextDirection, arrowShape);
        this.focusableElems.push(this.prevButton.element);
        this.focusableElems.push(this.nextButton.element);
        this.handlePrevButtonClick = ()=>{
            this.uiChange();
            this.previous();
        };
        this.handleNextButtonClick = ()=>{
            this.uiChange();
            this.next();
        };
        this.on('activate', this.activatePrevNextButtons);
        this.on('select', this.updatePrevNextButtons);
    };
    let proto = Flickity.prototype;
    proto.updatePrevNextButtons = function() {
        let lastIndex = this.slides.length ? this.slides.length - 1 : 0;
        this.updatePrevNextButton(this.prevButton, 0);
        this.updatePrevNextButton(this.nextButton, lastIndex);
    };
    proto.updatePrevNextButton = function(button, disabledIndex) {
        // enable is wrapAround and at least 2 slides
        if (this.isWrapping && this.slides.length > 1) {
            button.enable();
            return;
        }
        let isEnabled = this.selectedIndex !== disabledIndex;
        button[isEnabled ? 'enable' : 'disable']();
        // if disabling button that is focused,
        // shift focus to element to maintain keyboard accessibility
        let isDisabledFocused = !isEnabled && document.activeElement === button.element;
        if (isDisabledFocused) this.focus();
    };
    proto.activatePrevNextButtons = function() {
        this.prevButton.element.addEventListener('click', this.handlePrevButtonClick);
        this.nextButton.element.addEventListener('click', this.handleNextButtonClick);
        this.element.append(this.prevButton.element, this.nextButton.element);
        this.on('deactivate', this.deactivatePrevNextButtons);
    };
    proto.deactivatePrevNextButtons = function() {
        this.prevButton.element.remove();
        this.nextButton.element.remove();
        this.prevButton.element.removeEventListener('click', this.handlePrevButtonClick);
        this.nextButton.element.removeEventListener('click', this.handleNextButtonClick);
        this.off('deactivate', this.deactivatePrevNextButtons);
    };
    // --------------------------  -------------------------- //
    Flickity.PrevNextButton = PrevNextButton;
    return Flickity;
});

});

parcelRegister("ajMAu", function(module, exports) {


// page dots
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("aXPw9")), (parcelRequire("7KKWT")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    // -------------------------- PageDots -------------------------- //
    function PageDots() {
        // create holder element
        this.holder = document.createElement('div');
        this.holder.className = 'flickity-page-dots';
        // create dots, array of elements
        this.dots = [];
    }
    PageDots.prototype.setDots = function(slidesLength) {
        // get difference between number of slides and number of dots
        let delta = slidesLength - this.dots.length;
        if (delta > 0) this.addDots(delta);
        else if (delta < 0) this.removeDots(-delta);
    };
    PageDots.prototype.addDots = function(count) {
        let newDots = new Array(count).fill().map((item, i)=>{
            let dot = document.createElement('button');
            dot.setAttribute('type', 'button');
            let num = i + 1 + this.dots.length;
            dot.className = 'flickity-page-dot';
            dot.textContent = `View slide ${num}`;
            return dot;
        });
        this.holder.append(...newDots);
        this.dots = this.dots.concat(newDots);
    };
    PageDots.prototype.removeDots = function(count) {
        // remove from this.dots collection
        let removeDots = this.dots.splice(this.dots.length - count, count);
        // remove from DOM
        removeDots.forEach((dot)=>dot.remove());
    };
    PageDots.prototype.updateSelected = function(index) {
        // remove selected class on previous
        if (this.selectedDot) {
            this.selectedDot.classList.remove('is-selected');
            this.selectedDot.removeAttribute('aria-current');
        }
        // don't proceed if no dots
        if (!this.dots.length) return;
        this.selectedDot = this.dots[index];
        this.selectedDot.classList.add('is-selected');
        this.selectedDot.setAttribute('aria-current', 'step');
    };
    Flickity.PageDots = PageDots;
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pageDots: true
    });
    Flickity.create.pageDots = function() {
        if (!this.options.pageDots) return;
        this.pageDots = new PageDots();
        this.handlePageDotsClick = this.onPageDotsClick.bind(this);
        // events
        this.on('activate', this.activatePageDots);
        this.on('select', this.updateSelectedPageDots);
        this.on('cellChange', this.updatePageDots);
        this.on('resize', this.updatePageDots);
        this.on('deactivate', this.deactivatePageDots);
    };
    let proto = Flickity.prototype;
    proto.activatePageDots = function() {
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
        this.pageDots.holder.addEventListener('click', this.handlePageDotsClick);
        this.element.append(this.pageDots.holder);
    };
    proto.onPageDotsClick = function(event) {
        let index = this.pageDots.dots.indexOf(event.target);
        if (index === -1) return; // only dot clicks
        this.uiChange();
        this.select(index);
    };
    proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected(this.selectedIndex);
    };
    proto.updatePageDots = function() {
        this.pageDots.dots.forEach((dot)=>{
            utils.removeFrom(this.focusableElems, dot);
        });
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
    };
    proto.deactivatePageDots = function() {
        this.pageDots.holder.remove();
        this.pageDots.holder.removeEventListener('click', this.handlePageDotsClick);
    };
    // -----  ----- //
    Flickity.PageDots = PageDots;
    return Flickity;
});

});

parcelRegister("lIDw4", function(module, exports) {

// player & autoPlay
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("aXPw9")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity) {
    // -------------------------- Player -------------------------- //
    function Player(autoPlay, onTick) {
        this.autoPlay = autoPlay;
        this.onTick = onTick;
        this.state = 'stopped';
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }
    // start play
    Player.prototype.play = function() {
        if (this.state === 'playing') return;
        // do not play if page is hidden, start playing when page is visible
        let isPageHidden = document.hidden;
        if (isPageHidden) {
            document.addEventListener('visibilitychange', this.onVisibilityPlay);
            return;
        }
        this.state = 'playing';
        // listen to visibility change
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        // start ticking
        this.tick();
    };
    Player.prototype.tick = function() {
        // do not tick if not playing
        if (this.state !== 'playing') return;
        // default to 3 seconds
        let time = typeof this.autoPlay == 'number' ? this.autoPlay : 3000;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout(()=>{
            this.onTick();
            this.tick();
        }, time);
    };
    Player.prototype.stop = function() {
        this.state = 'stopped';
        this.clear();
        // remove visibility change event
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    };
    Player.prototype.clear = function() {
        clearTimeout(this.timeout);
    };
    Player.prototype.pause = function() {
        if (this.state === 'playing') {
            this.state = 'paused';
            this.clear();
        }
    };
    Player.prototype.unpause = function() {
        // re-start play if paused
        if (this.state === 'paused') this.play();
    };
    // pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function() {
        let isPageHidden = document.hidden;
        this[isPageHidden ? 'pause' : 'unpause']();
    };
    Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener('visibilitychange', this.onVisibilityPlay);
    };
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pauseAutoPlayOnHover: true
    });
    Flickity.create.player = function() {
        this.player = new Player(this.options.autoPlay, ()=>{
            this.next(true);
        });
        this.on('activate', this.activatePlayer);
        this.on('uiChange', this.stopPlayer);
        this.on('pointerDown', this.stopPlayer);
        this.on('deactivate', this.deactivatePlayer);
    };
    let proto = Flickity.prototype;
    proto.activatePlayer = function() {
        if (!this.options.autoPlay) return;
        this.player.play();
        this.element.addEventListener('mouseenter', this);
    };
    // Player API, don't hate the ... thanks I know where the door is
    proto.playPlayer = function() {
        this.player.play();
    };
    proto.stopPlayer = function() {
        this.player.stop();
    };
    proto.pausePlayer = function() {
        this.player.pause();
    };
    proto.unpausePlayer = function() {
        this.player.unpause();
    };
    proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener('mouseenter', this);
    };
    // ----- mouseenter/leave ----- //
    // pause auto-play on hover
    proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) return;
        this.player.pause();
        this.element.addEventListener('mouseleave', this);
    };
    // resume auto-play on hover off
    proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener('mouseleave', this);
    };
    // -----  ----- //
    Flickity.Player = Player;
    return Flickity;
});

});

parcelRegister("lnSPj", function(module, exports) {


// add, remove cell
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("aXPw9")), (parcelRequire("7KKWT")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    // append cells to a document fragment
    function getCellsFragment(cells) {
        let fragment = document.createDocumentFragment();
        cells.forEach((cell)=>fragment.appendChild(cell.element));
        return fragment;
    }
    // -------------------------- add/remove cell prototype -------------------------- //
    let proto = Flickity.prototype;
    /**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */ proto.insert = function(elems, index) {
        let cells = this._makeCells(elems);
        if (!cells || !cells.length) return;
        let len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        let fragment = getCellsFragment(cells);
        // append to slider
        let isAppend = index === len;
        if (isAppend) this.slider.appendChild(fragment);
        else {
            let insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
        }
        // add to this.cells
        if (index === 0) // prepend, add to start
        this.cells = cells.concat(this.cells);
        else if (isAppend) // append, add to end
        this.cells = this.cells.concat(cells);
        else {
            // insert in this.cells
            let endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index);
        this.positionSliderAtSelected();
    };
    proto.append = function(elems) {
        this.insert(elems, this.cells.length);
    };
    proto.prepend = function(elems) {
        this.insert(elems, 0);
    };
    /**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */ proto.remove = function(elems) {
        let cells = this.getCells(elems);
        if (!cells || !cells.length) return;
        let minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach((cell)=>{
            cell.remove();
            let index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
        });
        this.cellChange(minCellIndex);
        this.positionSliderAtSelected();
    };
    /**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */ proto.cellSizeChange = function(elem) {
        let cell = this.getCell(elem);
        if (!cell) return;
        cell.getSize();
        let index = this.cells.indexOf(cell);
        this.cellChange(index);
    // do not position slider after lazy load
    };
    /**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 */ proto.cellChange = function(changedCellIndex) {
        let prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._updateWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex, try to maintain position & select previous selected element
        let cell = this.getCell(prevSelectedElem);
        if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent('cellChange', [
            changedCellIndex
        ]);
        // position slider
        this.select(this.selectedIndex);
    };
    // -----  ----- //
    return Flickity;
});

});

parcelRegister("2GMUo", function(module, exports) {


// lazyload
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("aXPw9")), (parcelRequire("7KKWT")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    const lazyAttr = 'data-flickity-lazyload';
    const lazySrcAttr = `${lazyAttr}-src`;
    const lazySrcsetAttr = `${lazyAttr}-srcset`;
    const imgSelector = `img[${lazyAttr}], img[${lazySrcAttr}], ` + `img[${lazySrcsetAttr}], source[${lazySrcsetAttr}]`;
    Flickity.create.lazyLoad = function() {
        this.on('select', this.lazyLoad);
        this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
    };
    let proto = Flickity.prototype;
    proto.lazyLoad = function() {
        let { lazyLoad: lazyLoad } = this.options;
        if (!lazyLoad) return;
        // get adjacent cells, use lazyLoad option for adjacent count
        let adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
        // lazy load images
        this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach((img)=>new LazyLoader(img, this.handleLazyLoadComplete));
    };
    function getCellLazyImages(cellElem) {
        // check if cell element is lazy image
        if (cellElem.matches('img')) {
            let cellAttr = cellElem.getAttribute(lazyAttr);
            let cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
            let cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);
            if (cellAttr || cellSrcAttr || cellSrcsetAttr) return cellElem;
        }
        // select lazy images in cell
        return [
            ...cellElem.querySelectorAll(imgSelector)
        ];
    }
    proto.onLazyLoadComplete = function(img, event) {
        let cell = this.getParentCell(img);
        let cellElem = cell && cell.element;
        this.cellSizeChange(cellElem);
        this.dispatchEvent('lazyLoad', event, cellElem);
    };
    // -------------------------- LazyLoader -------------------------- //
    /**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Function} onComplete - callback function
 */ function LazyLoader(img, onComplete) {
        this.img = img;
        this.onComplete = onComplete;
        this.load();
    }
    LazyLoader.prototype.handleEvent = utils.handleEvent;
    LazyLoader.prototype.load = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        // get src & srcset
        let src = this.img.getAttribute(lazyAttr) || this.img.getAttribute(lazySrcAttr);
        let srcset = this.img.getAttribute(lazySrcsetAttr);
        // set src & serset
        this.img.src = src;
        if (srcset) this.img.setAttribute('srcset', srcset);
        // remove attr
        this.img.removeAttribute(lazyAttr);
        this.img.removeAttribute(lazySrcAttr);
        this.img.removeAttribute(lazySrcsetAttr);
    };
    LazyLoader.prototype.onload = function(event) {
        this.complete(event, 'flickity-lazyloaded');
    };
    LazyLoader.prototype.onerror = function(event) {
        this.complete(event, 'flickity-lazyerror');
    };
    LazyLoader.prototype.complete = function(event, className) {
        // unbind events
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
        let mediaElem = this.img.parentNode.matches('picture') ? this.img.parentNode : this.img;
        mediaElem.classList.add(className);
        this.onComplete(this.img, event);
    };
    // -----  ----- //
    Flickity.LazyLoader = LazyLoader;
    return Flickity;
});

});

parcelRegister("fBygh", function(module, exports) {


// imagesloaded
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("aXPw9")), (parcelRequire("kh5mA")));
    else // browser global
    factory(window1.Flickity, window1.imagesLoaded);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, imagesLoaded) {
    Flickity.create.imagesLoaded = function() {
        this.on('activate', this.imagesLoaded);
    };
    Flickity.prototype.imagesLoaded = function() {
        if (!this.options.imagesLoaded) return;
        let onImagesLoadedProgress = (instance, image)=>{
            let cell = this.getParentCell(image.img);
            this.cellSizeChange(cell && cell.element);
            if (!this.options.freeScroll) this.positionSliderAtSelected();
        };
        imagesLoaded(this.slider).on('progress', onImagesLoadedProgress);
    };
    return Flickity;
});

});
parcelRegister("kh5mA", function(module, exports) {

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("5go2L")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== 'undefined' ? window : module.exports, function factory(window1, EvEmitter) {
    let $ = window1.jQuery;
    let console = window1.console;
    // -------------------------- helpers -------------------------- //
    // turn element or nodeList into an array
    function makeArray(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        let queryElem = elem;
        if (typeof elem == 'string') queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = {};
        // shift arguments if no options set
        if (typeof options == 'function') onAlways = options;
        else Object.assign(this.options, options);
        if (onAlways) this.on('always', onAlways);
        this.getImages();
        // add jQuery Deferred object
        if ($) this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    const elementNodeTypes = [
        1,
        9,
        11
    ];
    /**
 * @param {Node} elem
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName === 'IMG') this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        let { nodeType: nodeType } = elem;
        if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
        let childImgs = elem.querySelectorAll('img');
        // concat childElems to filterFound array
        for (let img of childImgs)this.addImage(img);
        // get child background images
        if (typeof this.options.background == 'string') {
            let children = elem.querySelectorAll(this.options.background);
            for (let child of children)this.addElementBackgroundImages(child);
        }
    };
    const reURL = /url\((['"])?(.*?)\1\)/gi;
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        let style = getComputedStyle(elem);
        // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        if (!style) return;
        // get url inside url("...")
        let matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            let url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        let loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        let background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        /* eslint-disable-next-line func-style */ let onProgress = (image, elem, message)=>{
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(()=>{
                this.progress(image, elem, message);
            });
        };
        this.images.forEach(function(loadingImage) {
            loadingImage.once('progress', onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent('progress', [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount === this.images.length) this.complete();
        if (this.options.debug && console) console.log(`progress: ${message}`, image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        let eventName = this.hasAnyBroken ? 'fail' : 'done';
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent('always', [
            this
        ]);
        if (this.jqDeferred) {
            let jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        // add crossOrigin attribute. #204
        if (this.img.crossOrigin) this.proxyImage.crossOrigin = this.img.crossOrigin;
        this.proxyImage.addEventListener('load', this);
        this.proxyImage.addEventListener('error', this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.proxyImage.src = this.img.currentSrc || this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        let { parentNode: parentNode } = this.img;
        // emit progress with parent <picture> or self <img>
        let elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
        this.emitEvent('progress', [
            this,
            elem,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, 'onload');
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, 'onerror');
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener('load', this);
        this.proxyImage.removeEventListener('error', this);
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.img.src = this.url;
        // check if image is already complete
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent('progress', [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, onAlways) {
            let instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});

});



parcelRegister("cHCZe", function(module, exports) {







/*!
 * Flickity v2.3.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */ (function(window1, factory) {
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define([
        './flickity',
        './drag',
        './prev-next-button',
        './page-dots',
        './player',
        './add-remove-cell',
        './lazyload'
    ], factory);
    else if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("bHp8C")), (parcelRequire("bhZ8d")), (parcelRequire("jqSQs")), (parcelRequire("fkfV7")), (parcelRequire("exPDu")), (parcelRequire("iIJLK")), (parcelRequire("jA74o")));
})(window, function factory(Flickity) {
    return Flickity;
});

});
parcelRegister("bHp8C", function(module, exports) {






// Flickity main
/* eslint-disable max-params */ (function(window1, factory) {
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define([
        'ev-emitter/ev-emitter',
        'get-size/get-size',
        'fizzy-ui-utils/utils',
        './cell',
        './slide',
        './animate'
    ], function(EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
        return factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype);
    });
    else if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("g0sjz")), (parcelRequire("974Mr")), (parcelRequire("bHzq1")), (parcelRequire("7oFqh")), (parcelRequire("f9ClY")), (parcelRequire("k215U")));
    else {
        // browser global
        var _Flickity = window1.Flickity;
        window1.Flickity = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
    }
})(window, function factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
    /* eslint-enable max-params */ 'use strict';
    // vars
    var jQuery = window1.jQuery;
    var getComputedStyle = window1.getComputedStyle;
    var console = window1.console;
    function moveElements(elems, toElem) {
        elems = utils.makeArray(elems);
        while(elems.length)toElem.appendChild(elems.shift());
    }
    // -------------------------- Flickity -------------------------- //
    // globally unique identifiers
    var GUID = 0;
    // internal store of all Flickity intances
    var instances = {};
    function Flickity(element, options) {
        var queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error('Bad element for Flickity: ' + (queryElement || element));
            return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if (this.element.flickityGUID) {
            var instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
        }
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = utils.extend({}, this.constructor.defaults);
        this.option(options);
        // kick things off
        this._create();
    }
    Flickity.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: 'center',
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075,
        friction: 0.28,
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
    };
    // hash of methods triggered on _create()
    Flickity.createMethods = [];
    var proto = Flickity.prototype;
    // inherit EventEmitter
    utils.extend(proto, EvEmitter.prototype);
    proto._create = function() {
        // add id for Flickity.data
        var id = this.guid = ++GUID;
        this.element.flickityGUID = id; // expando
        instances[id] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.originSide = this.options.rightToLeft ? 'right' : 'left';
        // create viewport & slider
        this.viewport = document.createElement('div');
        this.viewport.className = 'flickity-viewport';
        this._createSlider();
        if (this.options.resize || this.options.watchCSS) window1.addEventListener('resize', this);
        // add listeners from on option
        for(var eventName in this.options.on){
            var listener = this.options.on[eventName];
            this.on(eventName, listener);
        }
        Flickity.createMethods.forEach(function(method) {
            this[method]();
        }, this);
        if (this.options.watchCSS) this.watchCSS();
        else this.activate();
    };
    /**
 * set options
 * @param {Object} opts - options to extend
 */ proto.option = function(opts) {
        utils.extend(this.options, opts);
    };
    proto.activate = function() {
        if (this.isActive) return;
        this.isActive = true;
        this.element.classList.add('flickity-enabled');
        if (this.options.rightToLeft) this.element.classList.add('flickity-rtl');
        this.getSize();
        // move initial cell elements so they can be loaded as cells
        var cellElems = this._filterFindCellElements(this.element.children);
        moveElements(cellElems, this.slider);
        this.viewport.appendChild(this.slider);
        this.element.appendChild(this.viewport);
        // get cells from children
        this.reloadCells();
        if (this.options.accessibility) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener('keydown', this);
        }
        this.emitEvent('activate');
        this.selectInitialIndex();
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent('ready');
    };
    // slider positions the cells
    proto._createSlider = function() {
        // slider element does all the positioning
        var slider = document.createElement('div');
        slider.className = 'flickity-slider';
        slider.style[this.originSide] = 0;
        this.slider = slider;
    };
    proto._filterFindCellElements = function(elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
    };
    // goes through all children
    proto.reloadCells = function() {
        // collection of item elements
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
    };
    /**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */ proto._makeCells = function(elems) {
        var cellElems = this._filterFindCellElements(elems);
        // create new Flickity for collection
        var cells = cellElems.map(function(cellElem) {
            return new Cell(cellElem, this);
        }, this);
        return cells;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
    };
    // positions all cells
    proto.positionCells = function() {
        // size all cells
        this._sizeCells(this.cells);
        // position all cells
        this._positionCells(0);
    };
    /**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */ proto._positionCells = function(index) {
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        var cellX = 0;
        // get cellX
        if (index > 0) {
            var startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        var len = this.cells.length;
        for(var i = index; i < len; i++){
            var cell = this.cells[i];
            cell.setPosition(cellX);
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
        }
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
    };
    /**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */ proto._sizeCells = function(cells) {
        cells.forEach(function(cell) {
            cell.getSize();
        });
    };
    // --------------------------  -------------------------- //
    proto.updateSlides = function() {
        this.slides = [];
        if (!this.cells.length) return;
        var slide = new Slide(this);
        this.slides.push(slide);
        var isOriginLeft = this.originSide == 'left';
        var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';
        var canCellFit = this._getCanCellFit();
        this.cells.forEach(function(cell, i) {
            // just add cell if first cell in slide
            if (!slide.cells.length) {
                slide.addCell(cell);
                return;
            }
            var slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[nextMargin]);
            if (canCellFit.call(this, i, slideWidth)) slide.addCell(cell);
            else {
                // doesn't fit, new slide
                slide.updateTarget();
                slide = new Slide(this);
                this.slides.push(slide);
                slide.addCell(cell);
            }
        }, this);
        // last slide
        slide.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
    };
    proto._getCanCellFit = function() {
        var groupCells = this.options.groupCells;
        if (!groupCells) return function() {
            return false;
        };
        else if (typeof groupCells == 'number') {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            var number = parseInt(groupCells, 10);
            return function(i) {
                return i % number !== 0;
            };
        }
        // default, group by width of slide
        // parse '75%
        var percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
        var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
        return function(i, slideWidth) {
            /* eslint-disable-next-line no-invalid-this */ return slideWidth <= (this.size.innerWidth + 1) * percent;
        };
    };
    // alias _init for jQuery plugin .flickity()
    proto._init = proto.reposition = function() {
        this.positionCells();
        this.positionSliderAtSelected();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    var cellAlignShorthands = {
        // cell align, then based on origin side
        center: {
            left: 0.5,
            right: 0.5
        },
        left: {
            left: 0,
            right: 1
        },
        right: {
            right: 0,
            left: 1
        }
    };
    proto.setCellAlign = function() {
        var shorthand = cellAlignShorthands[this.options.cellAlign];
        this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
    };
    proto.setGallerySize = function() {
        if (this.options.setGallerySize) {
            var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = height + 'px';
        }
    };
    proto._getWrapShiftCells = function() {
        // only for wrap-around
        if (!this.options.wrapAround) return;
        // unshift previous cells
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        // get before cells
        // initial gap
        var gapX = this.cursorPosition;
        var cellIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
        // get after cells
        // ending gap between last cell and end of gallery viewport
        gapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells(gapX, 0, 1);
    };
    proto._getGapCells = function(gapX, cellIndex, increment) {
        // keep adding cells until the cover the initial gap
        var cells = [];
        while(gapX > 0){
            var cell = this.cells[cellIndex];
            if (!cell) break;
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };
    // ----- contain ----- //
    // contain cell targets so no excess sliding
    proto._containSlides = function() {
        if (!this.options.contain || this.options.wrapAround || !this.cells.length) return;
        var isRightToLeft = this.options.rightToLeft;
        var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
        var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
        var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
        // content is less than gallery size
        var isContentSmaller = contentWidth < this.size.innerWidth;
        // bounds
        var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
        var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
        // contain each cell target
        this.slides.forEach(function(slide) {
            if (isContentSmaller) // all cells fit inside gallery
            slide.target = contentWidth * this.cellAlign;
            else {
                // contain to bounds
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
            }
        }, this);
    };
    // -----  ----- //
    /**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        var emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? '.flickity' : '';
            var $event = type;
            if (event) {
                // create jQuery event
                var jQEvent = new jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger($event, args);
        }
    };
    // -------------------------- select -------------------------- //
    /**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */ proto.select = function(index, isWrap, isInstant) {
        if (!this.isActive) return;
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.options.wrapAround || isWrap) index = utils.modulo(index, this.slides.length);
        // bail if invalid index
        if (!this.slides[index]) return;
        var prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) this.positionSliderAtSelected();
        else this.startAnimation();
        if (this.options.adaptiveHeight) this.setGallerySize();
        // events
        this.dispatchEvent('select', null, [
            index
        ]);
        // change event if new index
        if (index != prevIndex) this.dispatchEvent('change', null, [
            index
        ]);
        // old v1 event name, remove in v3
        this.dispatchEvent('cellSelect');
    };
    // wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function(index) {
        var len = this.slides.length;
        var isWrapping = this.options.wrapAround && len > 1;
        if (!isWrapping) return index;
        var wrapIndex = utils.modulo(index, len);
        // go to shortest
        var delta = Math.abs(wrapIndex - this.selectedIndex);
        var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
        var forewardWrapDelta = Math.abs(wrapIndex - len - this.selectedIndex);
        if (!this.isDragSelect && backWrapDelta < delta) index += len;
        else if (!this.isDragSelect && forewardWrapDelta < delta) index -= len;
        // wrap position so slider is within normal area
        if (index < 0) this.x -= this.slideableWidth;
        else if (index >= len) this.x += this.slideableWidth;
    };
    proto.previous = function(isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
    };
    proto.next = function(isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
    };
    proto.updateSelectedSlide = function() {
        var slide = this.slides[this.selectedIndex];
        // selectedIndex could be outside of slides, if triggered before resize()
        if (!slide) return;
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        // Remove in v3?
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };
    proto.unselectSelectedSlide = function() {
        if (this.selectedSlide) this.selectedSlide.unselect();
    };
    proto.selectInitialIndex = function() {
        var initialIndex = this.options.initialIndex;
        // already activated, select previous selectedIndex
        if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
        }
        // select with selector string
        if (initialIndex && typeof initialIndex == 'string') {
            var cell = this.queryCell(initialIndex);
            if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
            }
        }
        var index = 0;
        // select with number
        if (initialIndex && this.slides[initialIndex]) index = initialIndex;
        // select instantly
        this.select(index, false, true);
    };
    /**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */ proto.selectCell = function(value, isWrap, isInstant) {
        // get cell
        var cell = this.queryCell(value);
        if (!cell) return;
        var index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
    };
    proto.getCellSlideIndex = function(cell) {
        // get index of slides that has cell
        for(var i = 0; i < this.slides.length; i++){
            var slide = this.slides[i];
            var index = slide.cells.indexOf(cell);
            if (index != -1) return i;
        }
    };
    // -------------------------- get cells -------------------------- //
    /**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */ proto.getCell = function(elem) {
        // loop through cells to get the one that matches
        for(var i = 0; i < this.cells.length; i++){
            var cell = this.cells[i];
            if (cell.element == elem) return cell;
        }
    };
    /**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */ proto.getCells = function(elems) {
        elems = utils.makeArray(elems);
        var cells = [];
        elems.forEach(function(elem) {
            var cell = this.getCell(elem);
            if (cell) cells.push(cell);
        }, this);
        return cells;
    };
    /**
 * get cell elements
 * @returns {Array} cellElems
 */ proto.getCellElements = function() {
        return this.cells.map(function(cell) {
            return cell.element;
        });
    };
    /**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */ proto.getParentCell = function(elem) {
        // first check if elem is cell
        var cell = this.getCell(elem);
        if (cell) return cell;
        // try to get parent cell elem
        elem = utils.getParent(elem, '.flickity-slider > *');
        return this.getCell(elem);
    };
    /**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */ proto.getAdjacentCellElements = function(adjCount, index) {
        if (!adjCount) return this.selectedSlide.getCellElements();
        index = index === undefined ? this.selectedIndex : index;
        var len = this.slides.length;
        if (1 + adjCount * 2 >= len) return this.getCellElements();
        var cellElems = [];
        for(var i = index - adjCount; i <= index + adjCount; i++){
            var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
            var slide = this.slides[slideIndex];
            if (slide) cellElems = cellElems.concat(slide.getCellElements());
        }
        return cellElems;
    };
    /**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */ proto.queryCell = function(selector) {
        if (typeof selector == 'number') // use number as index
        return this.cells[selector];
        if (typeof selector == 'string') {
            // do not select invalid selectors from hash: #123, #/. #791
            if (selector.match(/^[#.]?[\d/]/)) return;
            // use string as selector, get element
            selector = this.element.querySelector(selector);
        }
        // get cell from element
        return this.getCell(selector);
    };
    // -------------------------- events -------------------------- //
    proto.uiChange = function() {
        this.emitEvent('uiChange');
    };
    // keep focus on element when child UI elements are clicked
    proto.childUIPointerDown = function(event) {
        // HACK iOS does not allow touch events to bubble up?!
        if (event.type != 'touchstart') event.preventDefault();
        this.focus();
    };
    // ----- resize ----- //
    proto.onresize = function() {
        this.watchCSS();
        this.resize();
    };
    utils.debounceMethod(Flickity, 'onresize', 150);
    proto.resize = function() {
        // #1177 disable resize behavior when animating or dragging for iOS 15
        if (!this.isActive || this.isAnimating || this.isDragging) return;
        this.getSize();
        // wrap values
        if (this.options.wrapAround) this.x = utils.modulo(this.x, this.slideableWidth);
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
        this.emitEvent('resize');
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of various numbers
        var selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
    };
    // watches the :after property, activates/deactivates
    proto.watchCSS = function() {
        var watchOption = this.options.watchCSS;
        if (!watchOption) return;
        var afterContent = getComputedStyle(this.element, ':after').content;
        // activate if :after { content: 'flickity' }
        if (afterContent.indexOf('flickity') != -1) this.activate();
        else this.deactivate();
    };
    // ----- keydown ----- //
    // go previous/next if left/right keys pressed
    proto.onkeydown = function(event) {
        // only work if element is in focus
        var isNotFocused = document.activeElement && document.activeElement != this.element;
        if (!this.options.accessibility || isNotFocused) return;
        var handler = Flickity.keyboardHandlers[event.keyCode];
        if (handler) handler.call(this);
    };
    Flickity.keyboardHandlers = {
        // left arrow
        37: function() {
            var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
            this.uiChange();
            this[leftMethod]();
        },
        // right arrow
        39: function() {
            var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
            this.uiChange();
            this[rightMethod]();
        }
    };
    // ----- focus ----- //
    proto.focus = function() {
        // TODO remove scrollTo once focus options gets more support
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
        //    #Browser_compatibility
        var prevScrollY = window1.pageYOffset;
        this.element.focus({
            preventScroll: true
        });
        // hack to fix scroll jump after focus, #76
        if (window1.pageYOffset != prevScrollY) window1.scrollTo(window1.pageXOffset, prevScrollY);
    };
    // -------------------------- destroy -------------------------- //
    // deactivate all Flickity functionality, but keep stuff available
    proto.deactivate = function() {
        if (!this.isActive) return;
        this.element.classList.remove('flickity-enabled');
        this.element.classList.remove('flickity-rtl');
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach(function(cell) {
            cell.destroy();
        });
        this.element.removeChild(this.viewport);
        // move child elements back into element
        moveElements(this.slider.children, this.element);
        if (this.options.accessibility) {
            this.element.removeAttribute('tabIndex');
            this.element.removeEventListener('keydown', this);
        }
        // set flags
        this.isActive = false;
        this.emitEvent('deactivate');
    };
    proto.destroy = function() {
        this.deactivate();
        window1.removeEventListener('resize', this);
        this.allOff();
        this.emitEvent('destroy');
        if (jQuery && this.$element) jQuery.removeData(this.element, 'flickity');
        delete this.element.flickityGUID;
        delete instances[this.guid];
    };
    // -------------------------- prototype -------------------------- //
    utils.extend(proto, animatePrototype);
    // -------------------------- extras -------------------------- //
    /**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */ Flickity.data = function(elem) {
        elem = utils.getQueryElement(elem);
        var id = elem && elem.flickityGUID;
        return id && instances[id];
    };
    utils.htmlInit(Flickity, 'flickity');
    if (jQuery && jQuery.bridget) jQuery.bridget('flickity', Flickity);
    // set internal jQuery, for Webpack + jQuery v3, #478
    Flickity.setJQuery = function(jq) {
        jQuery = jq;
    };
    Flickity.Cell = Cell;
    Flickity.Slide = Slide;
    return Flickity;
});

});
parcelRegister("g0sjz", function(module, exports) {
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */ /* jshint unused: true, undef: true, strict: true */ (function(global, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, window */ if (typeof define == 'function' && define.amd) // AMD - RequireJS
    define(factory);
    else if (module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != 'undefined' ? window : module.exports, function() {
    "use strict";
    function EvEmitter() {}
    var proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return;
        // set events hash
        var events = this._events = this._events || {};
        // set listeners array
        var listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (listeners.indexOf(listener) == -1) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        var onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        var index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
    };
    return EvEmitter;
});

});

parcelRegister("974Mr", function(module, exports) {
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */ /* jshint browser: true, strict: true, undef: true, unused: true */ /* globals console: false */ (function(window1, factory) {
    /* jshint strict: false */ /* globals define, module */ if (typeof define == 'function' && define.amd) // AMD
    define(factory);
    else if (module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    'use strict';
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        var num = parseFloat(value);
        // not a percent like '100%', and a number
        var isValid = value.indexOf('%') == -1 && !isNaN(num);
        return isValid && num;
    }
    function noop() {}
    var logError = typeof console == 'undefined' ? noop : function(message) {
        console.error(message);
    };
    // -------------------------- measurements -------------------------- //
    var measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];
    var measurementsLength = measurements.length;
    function getZeroSize() {
        var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            size[measurement] = 0;
        }
        return size;
    }
    // -------------------------- getStyle -------------------------- //
    /**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */ function getStyle(elem) {
        var style = getComputedStyle(elem);
        if (!style) logError('Style returned ' + style + '. Are you running this code in a hidden iframe on Firefox? ' + 'See https://bit.ly/getsizebug1');
        return style;
    }
    // -------------------------- setup -------------------------- //
    var isSetup = false;
    var isBoxSizeOuter;
    /**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */ function setup() {
        // setup once
        if (isSetup) return;
        isSetup = true;
        // -------------------------- box sizing -------------------------- //
        /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */ var div = document.createElement('div');
        div.style.width = '200px';
        div.style.padding = '1px 2px 3px 4px';
        div.style.borderStyle = 'solid';
        div.style.borderWidth = '1px 2px 3px 4px';
        div.style.boxSizing = 'border-box';
        var body = document.body || document.documentElement;
        body.appendChild(div);
        var style = getStyle(div);
        // round value for browser zoom. desandro/masonry#928
        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
        getSize.isBoxSizeOuter = isBoxSizeOuter;
        body.removeChild(div);
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        setup();
        // use querySeletor if elem is string
        if (typeof elem == 'string') elem = document.querySelector(elem);
        // do not proceed on non-objects
        if (!elem || typeof elem != 'object' || !elem.nodeType) return;
        var style = getStyle(elem);
        // if hidden, everything is 0
        if (style.display == 'none') return getZeroSize();
        var size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
        // get all measurements
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            var value = style[measurement];
            var num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        }
        var paddingWidth = size.paddingLeft + size.paddingRight;
        var paddingHeight = size.paddingTop + size.paddingBottom;
        var marginWidth = size.marginLeft + size.marginRight;
        var marginHeight = size.marginTop + size.marginBottom;
        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
        var borderHeight = size.borderTopWidth + size.borderBottomWidth;
        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
        // overwrite width and height if we can get it from style
        var styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
        var styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

});

parcelRegister("bHzq1", function(module, exports) {

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */ /*jshint browser: true, undef: true, unused: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD
    define([
        'desandro-matches-selector/matches-selector'
    ], function(matchesSelector) {
        return factory(window1, matchesSelector);
    });
    else if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("i0Bn6")));
    else // browser global
    window1.fizzyUIUtils = factory(window1, window1.matchesSelector);
})(window, function factory(window1, matchesSelector) {
    'use strict';
    var utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        for(var prop in b)a[prop] = b[prop];
        return a;
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    var arraySlice = Array.prototype.slice;
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        if (Array.isArray(obj)) // use object if already an array
        return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        if (isArrayLike) // convert nodeList to array
        return arraySlice.call(obj);
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        var index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (matchesSelector(elem, selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == 'string') return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        var method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        var ffElems = [];
        elems.forEach(function(elem) {
            // check that elem is an actual element
            if (!(elem instanceof HTMLElement)) return;
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return;
            }
            // filter & find items if we have a selector
            // filter
            if (matchesSelector(elem, selector)) ffElems.push(elem);
            // find children
            var childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            for(var i = 0; i < childElems.length; i++)ffElems.push(childElems[i]);
        });
        return ffElems;
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        var method = _class.prototype[methodName];
        var timeoutName = methodName + 'Timeout';
        _class.prototype[methodName] = function() {
            var timeout = this[timeoutName];
            clearTimeout(timeout);
            var args = arguments;
            var _this = this;
            this[timeoutName] = setTimeout(function() {
                method.apply(_this, args);
                delete _this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(callback) {
        var readyState = document.readyState;
        if (readyState == 'complete' || readyState == 'interactive') // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(callback);
        else document.addEventListener('DOMContentLoaded', callback);
    };
    // ----- htmlInit ----- //
    // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + '-' + $2;
        }).toLowerCase();
    };
    var console = window1.console;
    /**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */ utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            var dashedNamespace = utils.toDashed(namespace);
            var dataAttr = 'data-' + dashedNamespace;
            var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
            var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
            var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
            var dataOptionsAttr = dataAttr + '-options';
            var jQuery = window1.jQuery;
            elems.forEach(function(elem) {
                var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
                var options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error('Error parsing ' + dataAttr + ' on ' + elem.className + ': ' + error);
                    return;
                }
                // initialize
                var instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});
parcelRegister("i0Bn6", function(module, exports) {
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */ /*jshint browser: true, strict: true, undef: true, unused: true */ (function(window1, factory) {
    /*global define: false, module: false */ 'use strict';
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define(factory);
    else if (module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.matchesSelector = factory();
})(window, function factory() {
    'use strict';
    var matchesMethod = function() {
        var ElemProto = window.Element.prototype;
        // check for the standard method name first
        if (ElemProto.matches) return 'matches';
        // check un-prefixed
        if (ElemProto.matchesSelector) return 'matchesSelector';
        // check vendor prefixes
        var prefixes = [
            'webkit',
            'moz',
            'ms',
            'o'
        ];
        for(var i = 0; i < prefixes.length; i++){
            var prefix = prefixes[i];
            var method = prefix + 'MatchesSelector';
            if (ElemProto[method]) return method;
        }
    }();
    return function matchesSelector(elem, selector) {
        return elem[matchesMethod](selector);
    };
});

});


parcelRegister("7oFqh", function(module, exports) {

// Flickity.Cell
(function(window1, factory) {
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define([
        'get-size/get-size'
    ], function(getSize) {
        return factory(window1, getSize);
    });
    else if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("974Mr")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Cell = factory(window1, window1.getSize);
    }
})(window, function factory(window1, getSize) {
    'use strict';
    function Cell(elem, parent) {
        this.element = elem;
        this.parent = parent;
        this.create();
    }
    var proto = Cell.prototype;
    proto.create = function() {
        this.element.style.position = 'absolute';
        this.element.setAttribute('aria-hidden', 'true');
        this.x = 0;
        this.shift = 0;
        this.element.style[this.parent.originSide] = 0;
    };
    proto.destroy = function() {
        // reset style
        this.unselect();
        this.element.style.position = '';
        var side = this.parent.originSide;
        this.element.style[side] = '';
        this.element.style.transform = '';
        this.element.removeAttribute('aria-hidden');
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    proto.setPosition = function(x) {
        this.x = x;
        this.updateTarget();
        this.renderPosition(x);
    };
    // setDefaultTarget v1 method, backwards compatibility, remove in v3
    proto.updateTarget = proto.setDefaultTarget = function() {
        var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
        this.target = this.x + this.size[marginProperty] + this.size.width * this.parent.cellAlign;
    };
    proto.renderPosition = function(x) {
        // render position of cell with in slider
        var sideOffset = this.parent.originSide === 'left' ? 1 : -1;
        var adjustedX = this.parent.options.percentPosition ? x * sideOffset * (this.parent.size.innerWidth / this.size.width) : x * sideOffset;
        this.element.style.transform = 'translateX(' + this.parent.getPositionValue(adjustedX) + ')';
    };
    proto.select = function() {
        this.element.classList.add('is-selected');
        this.element.removeAttribute('aria-hidden');
    };
    proto.unselect = function() {
        this.element.classList.remove('is-selected');
        this.element.setAttribute('aria-hidden', 'true');
    };
    /**
 * @param {Integer} shift - 0, 1, or -1
 */ proto.wrapShift = function(shift) {
        this.shift = shift;
        this.renderPosition(this.x + this.parent.slideableWidth * shift);
    };
    proto.remove = function() {
        this.element.parentNode.removeChild(this.element);
    };
    return Cell;
});

});

parcelRegister("f9ClY", function(module, exports) {
// slide
(function(window1, factory) {
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define(factory);
    else if (module.exports) // CommonJS
    module.exports = factory();
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Slide = factory();
    }
})(window, function factory() {
    'use strict';
    function Slide(parent) {
        this.parent = parent;
        this.isOriginLeft = parent.originSide == 'left';
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }
    var proto = Slide.prototype;
    proto.addCell = function(cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        // first cell stuff
        if (this.cells.length == 1) {
            this.x = cell.x; // x comes from first cell
            var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
            this.firstMargin = cell.size[beginMargin];
        }
    };
    proto.updateTarget = function() {
        var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
        var lastCell = this.getLastCell();
        var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
        var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.select = function() {
        this.cells.forEach(function(cell) {
            cell.select();
        });
    };
    proto.unselect = function() {
        this.cells.forEach(function(cell) {
            cell.unselect();
        });
    };
    proto.getCellElements = function() {
        return this.cells.map(function(cell) {
            return cell.element;
        });
    };
    return Slide;
});

});

parcelRegister("k215U", function(module, exports) {

// animate
(function(window1, factory) {
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define([
        'fizzy-ui-utils/utils'
    ], function(utils) {
        return factory(window1, utils);
    });
    else if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("bHzq1")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.animatePrototype = factory(window1, window1.fizzyUIUtils);
    }
})(window, function factory(window1, utils) {
    'use strict';
    // -------------------------- animate -------------------------- //
    var proto = {};
    proto.startAnimation = function() {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };
    proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();
        var previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        // animate next frame
        if (this.isAnimating) {
            var _this = this;
            requestAnimationFrame(function animateFrame() {
                _this.animate();
            });
        }
    };
    proto.positionSlider = function() {
        var x = this.x;
        // wrap position around
        if (this.options.wrapAround && this.cells.length > 1) {
            x = utils.modulo(x, this.slideableWidth);
            x -= this.slideableWidth;
            this.shiftWrapCells(x);
        }
        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
    };
    proto.setTranslateX = function(x, is3d) {
        x += this.cursorPosition;
        // reverse if right-to-left and using transform
        x = this.options.rightToLeft ? -x : x;
        var translateX = this.getPositionValue(x);
        // use 3D transforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = is3d ? 'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
    };
    proto.dispatchScrollEvent = function() {
        var firstSlide = this.slides[0];
        if (!firstSlide) return;
        var positionX = -this.x - firstSlide.target;
        var progress = positionX / this.slidesWidth;
        this.dispatchEvent('scroll', null, [
            progress,
            positionX
        ]);
    };
    proto.positionSliderAtSelected = function() {
        if (!this.cells.length) return;
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };
    proto.getPositionValue = function(position) {
        if (this.options.percentPosition) // percent position, round to 2 digits, like 12.34%
        return Math.round(position / this.size.innerWidth * 10000) * 0.01 + '%';
        else // pixel positioning
        return Math.round(position) + 'px';
    };
    proto.settle = function(previousX) {
        // keep track of frames where x hasn't moved
        var isResting = !this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100);
        if (isResting) this.restingFrames++;
        // stop animating if resting for 3 or more frames
        if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent('settle', null, [
                this.selectedIndex
            ]);
        }
    };
    proto.shiftWrapCells = function(x) {
        // shift before cells
        var beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        // shift after cells
        var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
    };
    proto._shiftCells = function(cells, gap, shift) {
        for(var i = 0; i < cells.length; i++){
            var cell = cells[i];
            var cellShift = gap > 0 ? shift : 0;
            cell.wrapShift(cellShift);
            gap -= cell.size.outerWidth;
        }
    };
    proto._unshiftCells = function(cells) {
        if (!cells || !cells.length) return;
        for(var i = 0; i < cells.length; i++)cells[i].wrapShift(0);
    };
    // -------------------------- physics -------------------------- //
    proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };
    proto.applyForce = function(force) {
        this.velocity += force;
    };
    proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
    };
    proto.getRestingPosition = function() {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    };
    proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) return;
        // change the position to drag position by applying force
        var dragVelocity = this.dragX - this.x;
        var dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
    };
    proto.applySelectedAttraction = function() {
        // do not attract if pointer down or no slides
        var dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) return;
        var distance = this.selectedSlide.target * -1 - this.x;
        var force = distance * this.options.selectedAttraction;
        this.applyForce(force);
    };
    return proto;
});

});


parcelRegister("bhZ8d", function(module, exports) {



// drag
(function(window1, factory) {
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define([
        './flickity',
        'unidragger/unidragger',
        'fizzy-ui-utils/utils'
    ], function(Flickity, Unidragger, utils) {
        return factory(window1, Flickity, Unidragger, utils);
    });
    else if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("bHp8C")), (parcelRequire("evKdm")), (parcelRequire("bHzq1")));
    else // browser global
    window1.Flickity = factory(window1, window1.Flickity, window1.Unidragger, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, Unidragger, utils) {
    'use strict';
    // ----- defaults ----- //
    utils.extend(Flickity.defaults, {
        draggable: '>1',
        dragThreshold: 3
    });
    // ----- create ----- //
    Flickity.createMethods.push('_createDrag');
    // -------------------------- drag prototype -------------------------- //
    var proto = Flickity.prototype;
    utils.extend(proto, Unidragger.prototype);
    proto._touchActionValue = 'pan-y';
    // --------------------------  -------------------------- //
    proto._createDrag = function() {
        this.on('activate', this.onActivateDrag);
        this.on('uiChange', this._uiChangeDrag);
        this.on('deactivate', this.onDeactivateDrag);
        this.on('cellChange', this.updateDraggable);
    // TODO updateDraggable on resize? if groupCells & slides change
    };
    proto.onActivateDrag = function() {
        this.handles = [
            this.viewport
        ];
        this.bindHandles();
        this.updateDraggable();
    };
    proto.onDeactivateDrag = function() {
        this.unbindHandles();
        this.element.classList.remove('is-draggable');
    };
    proto.updateDraggable = function() {
        // disable dragging if less than 2 slides. #278
        if (this.options.draggable == '>1') this.isDraggable = this.slides.length > 1;
        else this.isDraggable = this.options.draggable;
        if (this.isDraggable) this.element.classList.add('is-draggable');
        else this.element.classList.remove('is-draggable');
    };
    // backwards compatibility
    proto.bindDrag = function() {
        this.options.draggable = true;
        this.updateDraggable();
    };
    proto.unbindDrag = function() {
        this.options.draggable = false;
        this.updateDraggable();
    };
    proto._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    };
    // -------------------------- pointer events -------------------------- //
    proto.pointerDown = function(event, pointer) {
        if (!this.isDraggable) {
            this._pointerDownDefault(event, pointer);
            return;
        }
        var isOkay = this.okayPointerDown(event);
        if (!isOkay) return;
        this._pointerDownPreventDefault(event);
        this.pointerDownFocus(event);
        // blur
        if (document.activeElement != this.element) // do not blur if already focused
        this.pointerDownBlur();
        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add('is-pointer-down');
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window1.addEventListener('scroll', this);
        this._pointerDownDefault(event, pointer);
    };
    // default pointerDown logic, used for staticClick
    proto._pointerDownDefault = function(event, pointer) {
        // track start event position
        // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        // bind move and end events
        this._bindPostStartEvents(event);
        this.dispatchEvent('pointerDown', event, [
            pointer
        ]);
    };
    var focusNodes = {
        INPUT: true,
        TEXTAREA: true,
        SELECT: true
    };
    proto.pointerDownFocus = function(event) {
        var isFocusNode = focusNodes[event.target.nodeName];
        if (!isFocusNode) this.focus();
    };
    proto._pointerDownPreventDefault = function(event) {
        var isTouchStart = event.type == 'touchstart';
        var isTouchPointer = event.pointerType == 'touch';
        var isFocusNode = focusNodes[event.target.nodeName];
        if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
    };
    // ----- move ----- //
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
    };
    // ----- up ----- //
    proto.pointerUp = function(event, pointer) {
        delete this.isTouchScrolling;
        this.viewport.classList.remove('is-pointer-down');
        this.dispatchEvent('pointerUp', event, [
            pointer
        ]);
        this._dragPointerUp(event, pointer);
    };
    proto.pointerDone = function() {
        window1.removeEventListener('scroll', this);
        delete this.pointerDownScroll;
    };
    // -------------------------- dragging -------------------------- //
    proto.dragStart = function(event, pointer) {
        if (!this.isDraggable) return;
        this.dragStartPosition = this.x;
        this.startAnimation();
        window1.removeEventListener('scroll', this);
        this.dispatchEvent('dragStart', event, [
            pointer
        ]);
    };
    proto.pointerMove = function(event, pointer) {
        var moveVector = this._dragPointerMove(event, pointer);
        this.dispatchEvent('pointerMove', event, [
            pointer,
            moveVector
        ]);
        this._dragMove(event, pointer, moveVector);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        if (!this.isDraggable) return;
        event.preventDefault();
        this.previousDragX = this.dragX;
        // reverse if right-to-left
        var direction = this.options.rightToLeft ? -1 : 1;
        if (this.options.wrapAround) // wrap around move. #589
        moveVector.x %= this.slideableWidth;
        var dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.options.wrapAround && this.slides.length) {
            // slow drag
            var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = new Date();
        this.dispatchEvent('dragMove', event, [
            pointer,
            moveVector
        ]);
    };
    proto.dragEnd = function(event, pointer) {
        if (!this.isDraggable) return;
        if (this.options.freeScroll) this.isFreeScrolling = true;
        // set selectedIndex based on where flick will end up
        var index = this.dragEndRestingSelect();
        if (this.options.freeScroll && !this.options.wrapAround) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            var restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!this.options.freeScroll && index == this.selectedIndex) // boost selection if selected index has not changed
        index += this.dragEndBoostSelect();
        delete this.previousDragX;
        // apply selection
        // TODO refactor this, selecting here feels weird
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.options.wrapAround;
        this.select(index);
        delete this.isDragSelect;
        this.dispatchEvent('dragEnd', event, [
            pointer
        ]);
    };
    proto.dragEndRestingSelect = function() {
        var restingX = this.getRestingPosition();
        // how far away from selected slide
        var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        // get closet resting going up and going down
        var positiveResting = this._getClosestResting(restingX, distance, 1);
        var negativeResting = this._getClosestResting(restingX, distance, -1);
        // use closer resting for wrap-around
        var index = positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
        return index;
    };
    /**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */ proto._getClosestResting = function(restingX, distance, increment) {
        var index = this.selectedIndex;
        var minDistance = Infinity;
        var condition = this.options.contain && !this.options.wrapAround ? // if contain, keep going if distance is equal to minDistance
        function(dist, minDist) {
            return dist <= minDist;
        } : function(dist, minDist) {
            return dist < minDist;
        };
        while(condition(distance, minDistance)){
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) break;
            distance = Math.abs(distance);
        }
        return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
        };
    };
    /**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */ proto.getSlideDistance = function(x, index) {
        var len = this.slides.length;
        // wrap around if at least 2 slides
        var isWrapAround = this.options.wrapAround && len > 1;
        var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        var slide = this.slides[slideIndex];
        if (!slide) return null;
        // add distance for wrap-around slides
        var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
    };
    proto.dragEndBoostSelect = function() {
        // do not boost if no previousDragX or dragMoveTime
        if (this.previousDragX === undefined || !this.dragMoveTime || // or if drag was held for 100 ms
        new Date() - this.dragMoveTime > 100) return 0;
        var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        var delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) // boost to next if moving towards the right, and positive velocity
        return 1;
        else if (distance < 0 && delta < 0) // boost to previous if moving towards the left, and negative velocity
        return -1;
        return 0;
    };
    // ----- staticClick ----- //
    proto.staticClick = function(event, pointer) {
        // get clickedCell, if cell was clicked
        var clickedCell = this.getParentCell(event.target);
        var cellElem = clickedCell && clickedCell.element;
        var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
        this.dispatchEvent('staticClick', event, [
            pointer,
            cellElem,
            cellIndex
        ]);
    };
    // ----- scroll ----- //
    proto.onscroll = function() {
        var scroll = getScrollPosition();
        var scrollMoveX = this.pointerDownScroll.x - scroll.x;
        var scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) this._pointerDone();
    };
    // ----- utils ----- //
    function getScrollPosition() {
        return {
            x: window1.pageXOffset,
            y: window1.pageYOffset
        };
    }
    // -----  ----- //
    return Flickity;
});

});
parcelRegister("evKdm", function(module, exports) {

/*!
 * Unidragger v2.4.0
 * Draggable base class
 * MIT license
 */ /*jshint browser: true, unused: true, undef: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD
    define([
        'unipointer/unipointer'
    ], function(Unipointer) {
        return factory(window1, Unipointer);
    });
    else if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("fUUBu")));
    else // browser global
    window1.Unidragger = factory(window1, window1.Unipointer);
})(window, function factory(window1, Unipointer) {
    'use strict';
    // -------------------------- Unidragger -------------------------- //
    function Unidragger() {}
    // inherit Unipointer & EvEmitter
    var proto = Unidragger.prototype = Object.create(Unipointer.prototype);
    // ----- bind start ----- //
    proto.bindHandles = function() {
        this._bindHandles(true);
    };
    proto.unbindHandles = function() {
        this._bindHandles(false);
    };
    /**
 * Add or remove start event
 * @param {Boolean} isAdd
 */ proto._bindHandles = function(isAdd) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        // bind each handle
        var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
        var touchAction = isAdd ? this._touchActionValue : '';
        for(var i = 0; i < this.handles.length; i++){
            var handle = this.handles[i];
            this._bindStartEvent(handle, isAdd);
            handle[bindMethod]('click', this);
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if (window1.PointerEvent) handle.style.touchAction = touchAction;
        }
    };
    // prototype so it can be overwriteable by Flickity
    proto._touchActionValue = 'none';
    // ----- start event ----- //
    /**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto.pointerDown = function(event, pointer) {
        var isOkay = this.okayPointerDown(event);
        if (!isOkay) return;
        // track start event position
        // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        event.preventDefault();
        this.pointerDownBlur();
        // bind move and end events
        this._bindPostStartEvents(event);
        this.emitEvent('pointerDown', [
            event,
            pointer
        ]);
    };
    // nodes that have text fields
    var cursorNodes = {
        TEXTAREA: true,
        INPUT: true,
        SELECT: true,
        OPTION: true
    };
    // input types that do not have text fields
    var clickTypes = {
        radio: true,
        checkbox: true,
        button: true,
        submit: true,
        image: true,
        file: true
    };
    // dismiss inputs with text fields. flickity#403, flickity#404
    proto.okayPointerDown = function(event) {
        var isCursorNode = cursorNodes[event.target.nodeName];
        var isClickType = clickTypes[event.target.type];
        var isOkay = !isCursorNode || isClickType;
        if (!isOkay) this._pointerReset();
        return isOkay;
    };
    // kludge to blur previously focused input
    proto.pointerDownBlur = function() {
        var focused = document.activeElement;
        // do not blur body for IE10, metafizzy/flickity#117
        var canBlur = focused && focused.blur && focused != document.body;
        if (canBlur) focused.blur();
    };
    // ----- move event ----- //
    /**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto.pointerMove = function(event, pointer) {
        var moveVector = this._dragPointerMove(event, pointer);
        this.emitEvent('pointerMove', [
            event,
            pointer,
            moveVector
        ]);
        this._dragMove(event, pointer, moveVector);
    };
    // base pointer move logic
    proto._dragPointerMove = function(event, pointer) {
        var moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
        };
        // start drag if pointer has moved far enough to start drag
        if (!this.isDragging && this.hasDragStarted(moveVector)) this._dragStart(event, pointer);
        return moveVector;
    };
    // condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
    };
    // ----- end event ----- //
    /**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto.pointerUp = function(event, pointer) {
        this.emitEvent('pointerUp', [
            event,
            pointer
        ]);
        this._dragPointerUp(event, pointer);
    };
    proto._dragPointerUp = function(event, pointer) {
        if (this.isDragging) this._dragEnd(event, pointer);
        else // pointer didn't move enough for drag to start
        this._staticClick(event, pointer);
    };
    // -------------------------- drag -------------------------- //
    // dragStart
    proto._dragStart = function(event, pointer) {
        this.isDragging = true;
        // prevent clicks
        this.isPreventingClicks = true;
        this.dragStart(event, pointer);
    };
    proto.dragStart = function(event, pointer) {
        this.emitEvent('dragStart', [
            event,
            pointer
        ]);
    };
    // dragMove
    proto._dragMove = function(event, pointer, moveVector) {
        // do not drag if not dragging yet
        if (!this.isDragging) return;
        this.dragMove(event, pointer, moveVector);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        event.preventDefault();
        this.emitEvent('dragMove', [
            event,
            pointer,
            moveVector
        ]);
    };
    // dragEnd
    proto._dragEnd = function(event, pointer) {
        // set flags
        this.isDragging = false;
        // re-enable clicking async
        setTimeout((function() {
            delete this.isPreventingClicks;
        }).bind(this));
        this.dragEnd(event, pointer);
    };
    proto.dragEnd = function(event, pointer) {
        this.emitEvent('dragEnd', [
            event,
            pointer
        ]);
    };
    // ----- onclick ----- //
    // handle all clicks and prevent clicks when dragging
    proto.onclick = function(event) {
        if (this.isPreventingClicks) event.preventDefault();
    };
    // ----- staticClick ----- //
    // triggered after pointer down & up with no/tiny movement
    proto._staticClick = function(event, pointer) {
        // ignore emulated mouse up clicks
        if (this.isIgnoringMouseUp && event.type == 'mouseup') return;
        this.staticClick(event, pointer);
        // set flag for emulated clicks 300ms after touchend
        if (event.type != 'mouseup') {
            this.isIgnoringMouseUp = true;
            // reset flag after 300ms
            setTimeout((function() {
                delete this.isIgnoringMouseUp;
            }).bind(this), 400);
        }
    };
    proto.staticClick = function(event, pointer) {
        this.emitEvent('staticClick', [
            event,
            pointer
        ]);
    };
    // ----- utils ----- //
    Unidragger.getPointerPoint = Unipointer.getPointerPoint;
    // -----  ----- //
    return Unidragger;
});

});
parcelRegister("fUUBu", function(module, exports) {

/*!
 * Unipointer v2.4.0
 * base class for doing one thing with pointer event
 * MIT license
 */ /*jshint browser: true, undef: true, unused: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /* jshint strict: false */ /*global define, module, require */ if (typeof define == 'function' && define.amd) // AMD
    define([
        'ev-emitter/ev-emitter'
    ], function(EvEmitter) {
        return factory(window1, EvEmitter);
    });
    else if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("l7onx")));
    else // browser global
    window1.Unipointer = factory(window1, window1.EvEmitter);
})(window, function factory(window1, EvEmitter) {
    'use strict';
    function noop() {}
    function Unipointer() {}
    // inherit EvEmitter
    var proto = Unipointer.prototype = Object.create(EvEmitter.prototype);
    proto.bindStartEvent = function(elem) {
        this._bindStartEvent(elem, true);
    };
    proto.unbindStartEvent = function(elem) {
        this._bindStartEvent(elem, false);
    };
    /**
 * Add or remove start event
 * @param {Boolean} isAdd - remove if falsey
 */ proto._bindStartEvent = function(elem, isAdd) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
        // default to mouse events
        var startEvent = 'mousedown';
        if ('ontouchstart' in window1) // HACK prefer Touch Events as you can preventDefault on touchstart to
        // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
        startEvent = 'touchstart';
        else if (window1.PointerEvent) // Pointer Events
        startEvent = 'pointerdown';
        elem[bindMethod](startEvent, this);
    };
    // trigger handler methods for events
    proto.handleEvent = function(event) {
        var method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    // returns the touch that we're keeping track of
    proto.getTouch = function(touches) {
        for(var i = 0; i < touches.length; i++){
            var touch = touches[i];
            if (touch.identifier == this.pointerIdentifier) return touch;
        }
    };
    // ----- start event ----- //
    proto.onmousedown = function(event) {
        // dismiss clicks from right or middle buttons
        var button = event.button;
        if (button && button !== 0 && button !== 1) return;
        this._pointerDown(event, event);
    };
    proto.ontouchstart = function(event) {
        this._pointerDown(event, event.changedTouches[0]);
    };
    proto.onpointerdown = function(event) {
        this._pointerDown(event, event);
    };
    /**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto._pointerDown = function(event, pointer) {
        // dismiss right click and other pointers
        // button = 0 is okay, 1-4 not
        if (event.button || this.isPointerDown) return;
        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier = pointer.pointerId !== undefined ? // pointerId for pointer events, touch.indentifier for touch events
        pointer.pointerId : pointer.identifier;
        this.pointerDown(event, pointer);
    };
    proto.pointerDown = function(event, pointer) {
        this._bindPostStartEvents(event);
        this.emitEvent('pointerDown', [
            event,
            pointer
        ]);
    };
    // hash of events to be bound after start event
    var postStartEvents = {
        mousedown: [
            'mousemove',
            'mouseup'
        ],
        touchstart: [
            'touchmove',
            'touchend',
            'touchcancel'
        ],
        pointerdown: [
            'pointermove',
            'pointerup',
            'pointercancel'
        ]
    };
    proto._bindPostStartEvents = function(event) {
        if (!event) return;
        // get proper events to match start event
        var events = postStartEvents[event.type];
        // bind events to node
        events.forEach(function(eventName) {
            window1.addEventListener(eventName, this);
        }, this);
        // save these arguments
        this._boundPointerEvents = events;
    };
    proto._unbindPostStartEvents = function() {
        // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
        if (!this._boundPointerEvents) return;
        this._boundPointerEvents.forEach(function(eventName) {
            window1.removeEventListener(eventName, this);
        }, this);
        delete this._boundPointerEvents;
    };
    // ----- move event ----- //
    proto.onmousemove = function(event) {
        this._pointerMove(event, event);
    };
    proto.onpointermove = function(event) {
        if (event.pointerId == this.pointerIdentifier) this._pointerMove(event, event);
    };
    proto.ontouchmove = function(event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) this._pointerMove(event, touch);
    };
    /**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */ proto._pointerMove = function(event, pointer) {
        this.pointerMove(event, pointer);
    };
    // public
    proto.pointerMove = function(event, pointer) {
        this.emitEvent('pointerMove', [
            event,
            pointer
        ]);
    };
    // ----- end event ----- //
    proto.onmouseup = function(event) {
        this._pointerUp(event, event);
    };
    proto.onpointerup = function(event) {
        if (event.pointerId == this.pointerIdentifier) this._pointerUp(event, event);
    };
    proto.ontouchend = function(event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) this._pointerUp(event, touch);
    };
    /**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */ proto._pointerUp = function(event, pointer) {
        this._pointerDone();
        this.pointerUp(event, pointer);
    };
    // public
    proto.pointerUp = function(event, pointer) {
        this.emitEvent('pointerUp', [
            event,
            pointer
        ]);
    };
    // ----- pointer done ----- //
    // triggered on pointer up & pointer cancel
    proto._pointerDone = function() {
        this._pointerReset();
        this._unbindPostStartEvents();
        this.pointerDone();
    };
    proto._pointerReset = function() {
        // reset properties
        this.isPointerDown = false;
        delete this.pointerIdentifier;
    };
    proto.pointerDone = noop;
    // ----- pointer cancel ----- //
    proto.onpointercancel = function(event) {
        if (event.pointerId == this.pointerIdentifier) this._pointerCancel(event, event);
    };
    proto.ontouchcancel = function(event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) this._pointerCancel(event, touch);
    };
    /**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */ proto._pointerCancel = function(event, pointer) {
        this._pointerDone();
        this.pointerCancel(event, pointer);
    };
    // public
    proto.pointerCancel = function(event, pointer) {
        this.emitEvent('pointerCancel', [
            event,
            pointer
        ]);
    };
    // -----  ----- //
    // utility function for getting x/y coords from event
    Unipointer.getPointerPoint = function(pointer) {
        return {
            x: pointer.pageX,
            y: pointer.pageY
        };
    };
    // -----  ----- //
    return Unipointer;
});

});
parcelRegister("l7onx", function(module, exports) {
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */ /* jshint unused: true, undef: true, strict: true */ (function(global, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, window */ if (typeof define == 'function' && define.amd) // AMD - RequireJS
    define(factory);
    else if (module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != 'undefined' ? window : module.exports, function() {
    "use strict";
    function EvEmitter() {}
    var proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return;
        // set events hash
        var events = this._events = this._events || {};
        // set listeners array
        var listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (listeners.indexOf(listener) == -1) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        var onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        var index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
    };
    return EvEmitter;
});

});




parcelRegister("jqSQs", function(module, exports) {



// prev/next buttons
(function(window1, factory) {
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define([
        './flickity',
        'unipointer/unipointer',
        'fizzy-ui-utils/utils'
    ], function(Flickity, Unipointer, utils) {
        return factory(window1, Flickity, Unipointer, utils);
    });
    else if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("bHp8C")), (parcelRequire("fUUBu")), (parcelRequire("bHzq1")));
    else // browser global
    factory(window1, window1.Flickity, window1.Unipointer, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, Unipointer, utils) {
    'use strict';
    var svgURI = 'http://www.w3.org/2000/svg';
    // -------------------------- PrevNextButton -------------------------- //
    function PrevNextButton(direction, parent) {
        this.direction = direction;
        this.parent = parent;
        this._create();
    }
    PrevNextButton.prototype = Object.create(Unipointer.prototype);
    PrevNextButton.prototype._create = function() {
        // properties
        this.isEnabled = true;
        this.isPrevious = this.direction == -1;
        var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == leftDirection;
        var element = this.element = document.createElement('button');
        element.className = 'flickity-button flickity-prev-next-button';
        element.className += this.isPrevious ? ' previous' : ' next';
        // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
        element.setAttribute('type', 'button');
        // init as disabled
        this.disable();
        element.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next');
        // create arrow
        var svg = this.createSVG();
        element.appendChild(svg);
        // events
        this.parent.on('select', this.update.bind(this));
        this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
    };
    PrevNextButton.prototype.activate = function() {
        this.bindStartEvent(this.element);
        this.element.addEventListener('click', this);
        // add to DOM
        this.parent.element.appendChild(this.element);
    };
    PrevNextButton.prototype.deactivate = function() {
        // remove from DOM
        this.parent.element.removeChild(this.element);
        // click events
        this.unbindStartEvent(this.element);
        this.element.removeEventListener('click', this);
    };
    PrevNextButton.prototype.createSVG = function() {
        var svg = document.createElementNS(svgURI, 'svg');
        svg.setAttribute('class', 'flickity-button-icon');
        svg.setAttribute('viewBox', '0 0 100 100');
        var path = document.createElementNS(svgURI, 'path');
        var pathMovements = getArrowMovements(this.parent.options.arrowShape);
        path.setAttribute('d', pathMovements);
        path.setAttribute('class', 'arrow');
        // rotate arrow
        if (!this.isLeft) path.setAttribute('transform', 'translate(100, 100) rotate(180) ');
        svg.appendChild(path);
        return svg;
    };
    // get SVG path movmement
    function getArrowMovements(shape) {
        // use shape as movement if string
        if (typeof shape == 'string') return shape;
        // create movement string
        return 'M ' + shape.x0 + ',50' + ' L ' + shape.x1 + ',' + (shape.y1 + 50) + ' L ' + shape.x2 + ',' + (shape.y2 + 50) + ' L ' + shape.x3 + ',50 ' + ' L ' + shape.x2 + ',' + (50 - shape.y2) + ' L ' + shape.x1 + ',' + (50 - shape.y1) + ' Z';
    }
    PrevNextButton.prototype.handleEvent = utils.handleEvent;
    PrevNextButton.prototype.onclick = function() {
        if (!this.isEnabled) return;
        this.parent.uiChange();
        var method = this.isPrevious ? 'previous' : 'next';
        this.parent[method]();
    };
    // -----  ----- //
    PrevNextButton.prototype.enable = function() {
        if (this.isEnabled) return;
        this.element.disabled = false;
        this.isEnabled = true;
    };
    PrevNextButton.prototype.disable = function() {
        if (!this.isEnabled) return;
        this.element.disabled = true;
        this.isEnabled = false;
    };
    PrevNextButton.prototype.update = function() {
        // index of first or last slide, if previous or next
        var slides = this.parent.slides;
        // enable is wrapAround and at least 2 slides
        if (this.parent.options.wrapAround && slides.length > 1) {
            this.enable();
            return;
        }
        var lastIndex = slides.length ? slides.length - 1 : 0;
        var boundIndex = this.isPrevious ? 0 : lastIndex;
        var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
        this[method]();
    };
    PrevNextButton.prototype.destroy = function() {
        this.deactivate();
        this.allOff();
    };
    // -------------------------- Flickity prototype -------------------------- //
    utils.extend(Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    });
    Flickity.createMethods.push('_createPrevNextButtons');
    var proto = Flickity.prototype;
    proto._createPrevNextButtons = function() {
        if (!this.options.prevNextButtons) return;
        this.prevButton = new PrevNextButton(-1, this);
        this.nextButton = new PrevNextButton(1, this);
        this.on('activate', this.activatePrevNextButtons);
    };
    proto.activatePrevNextButtons = function() {
        this.prevButton.activate();
        this.nextButton.activate();
        this.on('deactivate', this.deactivatePrevNextButtons);
    };
    proto.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate();
        this.nextButton.deactivate();
        this.off('deactivate', this.deactivatePrevNextButtons);
    };
    // --------------------------  -------------------------- //
    Flickity.PrevNextButton = PrevNextButton;
    return Flickity;
});

});

parcelRegister("fkfV7", function(module, exports) {



// page dots
(function(window1, factory) {
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define([
        './flickity',
        'unipointer/unipointer',
        'fizzy-ui-utils/utils'
    ], function(Flickity, Unipointer, utils) {
        return factory(window1, Flickity, Unipointer, utils);
    });
    else if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("bHp8C")), (parcelRequire("fUUBu")), (parcelRequire("bHzq1")));
    else // browser global
    factory(window1, window1.Flickity, window1.Unipointer, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, Unipointer, utils) {
    // -------------------------- PageDots -------------------------- //
    'use strict';
    function PageDots(parent) {
        this.parent = parent;
        this._create();
    }
    PageDots.prototype = Object.create(Unipointer.prototype);
    PageDots.prototype._create = function() {
        // create holder element
        this.holder = document.createElement('ol');
        this.holder.className = 'flickity-page-dots';
        // create dots, array of elements
        this.dots = [];
        // events
        this.handleClick = this.onClick.bind(this);
        this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
    };
    PageDots.prototype.activate = function() {
        this.setDots();
        this.holder.addEventListener('click', this.handleClick);
        this.bindStartEvent(this.holder);
        // add to DOM
        this.parent.element.appendChild(this.holder);
    };
    PageDots.prototype.deactivate = function() {
        this.holder.removeEventListener('click', this.handleClick);
        this.unbindStartEvent(this.holder);
        // remove from DOM
        this.parent.element.removeChild(this.holder);
    };
    PageDots.prototype.setDots = function() {
        // get difference between number of slides and number of dots
        var delta = this.parent.slides.length - this.dots.length;
        if (delta > 0) this.addDots(delta);
        else if (delta < 0) this.removeDots(-delta);
    };
    PageDots.prototype.addDots = function(count) {
        var fragment = document.createDocumentFragment();
        var newDots = [];
        var length = this.dots.length;
        var max = length + count;
        for(var i = length; i < max; i++){
            var dot = document.createElement('li');
            dot.className = 'dot';
            dot.setAttribute('aria-label', 'Page dot ' + (i + 1));
            fragment.appendChild(dot);
            newDots.push(dot);
        }
        this.holder.appendChild(fragment);
        this.dots = this.dots.concat(newDots);
    };
    PageDots.prototype.removeDots = function(count) {
        // remove from this.dots collection
        var removeDots = this.dots.splice(this.dots.length - count, count);
        // remove from DOM
        removeDots.forEach(function(dot) {
            this.holder.removeChild(dot);
        }, this);
    };
    PageDots.prototype.updateSelected = function() {
        // remove selected class on previous
        if (this.selectedDot) {
            this.selectedDot.className = 'dot';
            this.selectedDot.removeAttribute('aria-current');
        }
        // don't proceed if no dots
        if (!this.dots.length) return;
        this.selectedDot = this.dots[this.parent.selectedIndex];
        this.selectedDot.className = 'dot is-selected';
        this.selectedDot.setAttribute('aria-current', 'step');
    };
    PageDots.prototype.onTap = PageDots.prototype.onClick = function(event) {
        var target = event.target;
        // only care about dot clicks
        if (target.nodeName != 'LI') return;
        this.parent.uiChange();
        var index = this.dots.indexOf(target);
        this.parent.select(index);
    };
    PageDots.prototype.destroy = function() {
        this.deactivate();
        this.allOff();
    };
    Flickity.PageDots = PageDots;
    // -------------------------- Flickity -------------------------- //
    utils.extend(Flickity.defaults, {
        pageDots: true
    });
    Flickity.createMethods.push('_createPageDots');
    var proto = Flickity.prototype;
    proto._createPageDots = function() {
        if (!this.options.pageDots) return;
        this.pageDots = new PageDots(this);
        // events
        this.on('activate', this.activatePageDots);
        this.on('select', this.updateSelectedPageDots);
        this.on('cellChange', this.updatePageDots);
        this.on('resize', this.updatePageDots);
        this.on('deactivate', this.deactivatePageDots);
    };
    proto.activatePageDots = function() {
        this.pageDots.activate();
    };
    proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected();
    };
    proto.updatePageDots = function() {
        this.pageDots.setDots();
    };
    proto.deactivatePageDots = function() {
        this.pageDots.deactivate();
    };
    // -----  ----- //
    Flickity.PageDots = PageDots;
    return Flickity;
});

});

parcelRegister("exPDu", function(module, exports) {



// player & autoPlay
(function(window1, factory) {
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define([
        'ev-emitter/ev-emitter',
        'fizzy-ui-utils/utils',
        './flickity'
    ], function(EvEmitter, utils, Flickity) {
        return factory(EvEmitter, utils, Flickity);
    });
    else if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("g0sjz")), (parcelRequire("bHzq1")), (parcelRequire("bHp8C")));
    else // browser global
    factory(window1.EvEmitter, window1.fizzyUIUtils, window1.Flickity);
})(window, function factory(EvEmitter, utils, Flickity) {
    'use strict';
    // -------------------------- Player -------------------------- //
    function Player(parent) {
        this.parent = parent;
        this.state = 'stopped';
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }
    Player.prototype = Object.create(EvEmitter.prototype);
    // start play
    Player.prototype.play = function() {
        if (this.state == 'playing') return;
        // do not play if page is hidden, start playing when page is visible
        var isPageHidden = document.hidden;
        if (isPageHidden) {
            document.addEventListener('visibilitychange', this.onVisibilityPlay);
            return;
        }
        this.state = 'playing';
        // listen to visibility change
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        // start ticking
        this.tick();
    };
    Player.prototype.tick = function() {
        // do not tick if not playing
        if (this.state != 'playing') return;
        var time = this.parent.options.autoPlay;
        // default to 3 seconds
        time = typeof time == 'number' ? time : 3000;
        var _this = this;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout(function() {
            _this.parent.next(true);
            _this.tick();
        }, time);
    };
    Player.prototype.stop = function() {
        this.state = 'stopped';
        this.clear();
        // remove visibility change event
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    };
    Player.prototype.clear = function() {
        clearTimeout(this.timeout);
    };
    Player.prototype.pause = function() {
        if (this.state == 'playing') {
            this.state = 'paused';
            this.clear();
        }
    };
    Player.prototype.unpause = function() {
        // re-start play if paused
        if (this.state == 'paused') this.play();
    };
    // pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function() {
        var isPageHidden = document.hidden;
        this[isPageHidden ? 'pause' : 'unpause']();
    };
    Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener('visibilitychange', this.onVisibilityPlay);
    };
    // -------------------------- Flickity -------------------------- //
    utils.extend(Flickity.defaults, {
        pauseAutoPlayOnHover: true
    });
    Flickity.createMethods.push('_createPlayer');
    var proto = Flickity.prototype;
    proto._createPlayer = function() {
        this.player = new Player(this);
        this.on('activate', this.activatePlayer);
        this.on('uiChange', this.stopPlayer);
        this.on('pointerDown', this.stopPlayer);
        this.on('deactivate', this.deactivatePlayer);
    };
    proto.activatePlayer = function() {
        if (!this.options.autoPlay) return;
        this.player.play();
        this.element.addEventListener('mouseenter', this);
    };
    // Player API, don't hate the ... thanks I know where the door is
    proto.playPlayer = function() {
        this.player.play();
    };
    proto.stopPlayer = function() {
        this.player.stop();
    };
    proto.pausePlayer = function() {
        this.player.pause();
    };
    proto.unpausePlayer = function() {
        this.player.unpause();
    };
    proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener('mouseenter', this);
    };
    // ----- mouseenter/leave ----- //
    // pause auto-play on hover
    proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) return;
        this.player.pause();
        this.element.addEventListener('mouseleave', this);
    };
    // resume auto-play on hover off
    proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener('mouseleave', this);
    };
    // -----  ----- //
    Flickity.Player = Player;
    return Flickity;
});

});

parcelRegister("iIJLK", function(module, exports) {


// add, remove cell
(function(window1, factory) {
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define([
        './flickity',
        'fizzy-ui-utils/utils'
    ], function(Flickity, utils) {
        return factory(window1, Flickity, utils);
    });
    else if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("bHp8C")), (parcelRequire("bHzq1")));
    else // browser global
    factory(window1, window1.Flickity, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, utils) {
    'use strict';
    // append cells to a document fragment
    function getCellsFragment(cells) {
        var fragment = document.createDocumentFragment();
        cells.forEach(function(cell) {
            fragment.appendChild(cell.element);
        });
        return fragment;
    }
    // -------------------------- add/remove cell prototype -------------------------- //
    var proto = Flickity.prototype;
    /**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */ proto.insert = function(elems, index) {
        var cells = this._makeCells(elems);
        if (!cells || !cells.length) return;
        var len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        var fragment = getCellsFragment(cells);
        // append to slider
        var isAppend = index == len;
        if (isAppend) this.slider.appendChild(fragment);
        else {
            var insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
        }
        // add to this.cells
        if (index === 0) // prepend, add to start
        this.cells = cells.concat(this.cells);
        else if (isAppend) // append, add to end
        this.cells = this.cells.concat(cells);
        else {
            // insert in this.cells
            var endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index, true);
    };
    proto.append = function(elems) {
        this.insert(elems, this.cells.length);
    };
    proto.prepend = function(elems) {
        this.insert(elems, 0);
    };
    /**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */ proto.remove = function(elems) {
        var cells = this.getCells(elems);
        if (!cells || !cells.length) return;
        var minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach(function(cell) {
            cell.remove();
            var index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
        }, this);
        this.cellChange(minCellIndex, true);
    };
    /**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */ proto.cellSizeChange = function(elem) {
        var cell = this.getCell(elem);
        if (!cell) return;
        cell.getSize();
        var index = this.cells.indexOf(cell);
        this.cellChange(index);
    };
    /**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 * @param {Boolean} isPositioningSlider - Positions slider after selection
 */ proto.cellChange = function(changedCellIndex, isPositioningSlider) {
        var prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._getWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex
        // try to maintain position & select previous selected element
        var cell = this.getCell(prevSelectedElem);
        if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent('cellChange', [
            changedCellIndex
        ]);
        // position slider
        this.select(this.selectedIndex);
        // do not position slider after lazy load
        if (isPositioningSlider) this.positionSliderAtSelected();
    };
    // -----  ----- //
    return Flickity;
});

});

parcelRegister("jA74o", function(module, exports) {


// lazyload
(function(window1, factory) {
    // universal module definition
    if (typeof define == 'function' && define.amd) // AMD
    define([
        './flickity',
        'fizzy-ui-utils/utils'
    ], function(Flickity, utils) {
        return factory(window1, Flickity, utils);
    });
    else if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("bHp8C")), (parcelRequire("bHzq1")));
    else // browser global
    factory(window1, window1.Flickity, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, utils) {
    'use strict';
    Flickity.createMethods.push('_createLazyload');
    var proto = Flickity.prototype;
    proto._createLazyload = function() {
        this.on('select', this.lazyLoad);
    };
    proto.lazyLoad = function() {
        var lazyLoad = this.options.lazyLoad;
        if (!lazyLoad) return;
        // get adjacent cells, use lazyLoad option for adjacent count
        var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
        var cellElems = this.getAdjacentCellElements(adjCount);
        // get lazy images in those cells
        var lazyImages = [];
        cellElems.forEach(function(cellElem) {
            var lazyCellImages = getCellLazyImages(cellElem);
            lazyImages = lazyImages.concat(lazyCellImages);
        });
        // load lazy images
        lazyImages.forEach(function(img) {
            new LazyLoader(img, this);
        }, this);
    };
    function getCellLazyImages(cellElem) {
        // check if cell element is lazy image
        if (cellElem.nodeName == 'IMG') {
            var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
            var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
            var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
            if (lazyloadAttr || srcAttr || srcsetAttr) return [
                cellElem
            ];
        }
        // select lazy images in cell
        var lazySelector = "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]";
        var imgs = cellElem.querySelectorAll(lazySelector);
        return utils.makeArray(imgs);
    }
    // -------------------------- LazyLoader -------------------------- //
    /**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Flickity} flickity - Flickity instance
 */ function LazyLoader(img, flickity) {
        this.img = img;
        this.flickity = flickity;
        this.load();
    }
    LazyLoader.prototype.handleEvent = utils.handleEvent;
    LazyLoader.prototype.load = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        // get src & srcset
        var src = this.img.getAttribute('data-flickity-lazyload') || this.img.getAttribute('data-flickity-lazyload-src');
        var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
        // set src & serset
        this.img.src = src;
        if (srcset) this.img.setAttribute('srcset', srcset);
        // remove attr
        this.img.removeAttribute('data-flickity-lazyload');
        this.img.removeAttribute('data-flickity-lazyload-src');
        this.img.removeAttribute('data-flickity-lazyload-srcset');
    };
    LazyLoader.prototype.onload = function(event) {
        this.complete(event, 'flickity-lazyloaded');
    };
    LazyLoader.prototype.onerror = function(event) {
        this.complete(event, 'flickity-lazyerror');
    };
    LazyLoader.prototype.complete = function(event, className) {
        // unbind events
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
        var cell = this.flickity.getParentCell(this.img);
        var cellElem = cell && cell.element;
        this.flickity.cellSizeChange(cellElem);
        this.img.classList.add(className);
        this.flickity.dispatchEvent('lazyLoad', event, cellElem);
    };
    // -----  ----- //
    Flickity.LazyLoader = LazyLoader;
    return Flickity;
});

});


parcelRegister("a1W8t", function(module, exports) {

/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    'use strict';
    // universal module definition
    /*global define: false, module: false, require: false */ if (typeof define == 'function' && define.amd) // AMD
    define([
        'ev-emitter/ev-emitter'
    ], function(EvEmitter) {
        return factory(window1, EvEmitter);
    });
    else if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("g0sjz")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== 'undefined' ? window : module.exports, // --------------------------  factory -------------------------- //
function factory(window1, EvEmitter) {
    'use strict';
    var $ = window1.jQuery;
    var console = window1.console;
    // -------------------------- helpers -------------------------- //
    // extend objects
    function extend(a, b) {
        for(var prop in b)a[prop] = b[prop];
        return a;
    }
    var arraySlice = Array.prototype.slice;
    // turn element or nodeList into an array
    function makeArray(obj) {
        if (Array.isArray(obj)) // use object if already an array
        return obj;
        var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        if (isArrayLike) // convert nodeList to array
        return arraySlice.call(obj);
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {Array, Element, NodeList, String} elem
 * @param {Object or Function} options - if function, use as callback
 * @param {Function} onAlways - callback function
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        var queryElem = elem;
        if (typeof elem == 'string') queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error('Bad element for imagesLoaded ' + (queryElem || elem));
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = extend({}, this.options);
        // shift arguments if no options set
        if (typeof options == 'function') onAlways = options;
        else extend(this.options, options);
        if (onAlways) this.on('always', onAlways);
        this.getImages();
        if ($) // add jQuery Deferred object
        this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.options = {};
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    /**
 * @param {Node} element
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName == 'IMG') this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        var nodeType = elem.nodeType;
        if (!nodeType || !elementNodeTypes[nodeType]) return;
        var childImgs = elem.querySelectorAll('img');
        // concat childElems to filterFound array
        for(var i = 0; i < childImgs.length; i++){
            var img = childImgs[i];
            this.addImage(img);
        }
        // get child background images
        if (typeof this.options.background == 'string') {
            var children = elem.querySelectorAll(this.options.background);
            for(i = 0; i < children.length; i++){
                var child = children[i];
                this.addElementBackgroundImages(child);
            }
        }
    };
    var elementNodeTypes = {
        1: true,
        9: true,
        11: true
    };
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        var style = getComputedStyle(elem);
        if (!style) // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        return;
        // get url inside url("...")
        var reURL = /url\((['"])?(.*?)\1\)/gi;
        var matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            var url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        var loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        var background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        var _this = this;
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        function onProgress(image, elem, message) {
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(function() {
                _this.progress(image, elem, message);
            });
        }
        this.images.forEach(function(loadingImage) {
            loadingImage.once('progress', onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent('progress', [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount == this.images.length) this.complete();
        if (this.options.debug && console) console.log('progress: ' + message, image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        var eventName = this.hasAnyBroken ? 'fail' : 'done';
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent('always', [
            this
        ]);
        if (this.jqDeferred) {
            var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        var isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        this.proxyImage.addEventListener('load', this);
        this.proxyImage.addEventListener('error', this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.proxyImage.src = this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent('progress', [
            this,
            this.img,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        var method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, 'onload');
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, 'onerror');
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener('load', this);
        this.proxyImage.removeEventListener('error', this);
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.img.src = this.url;
        // check if image is already complete
        var isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent('progress', [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, callback) {
            var instance = new ImagesLoaded(this, options, callback);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});

});

function $94c1aa313017b840$export$90ceba2564a894f8(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = document.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = document.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}


const $4a3ae8b34d8c7815$export$f6e2535fb5126e54 = (value)=>typeof value === "function";


const $3019b940a732e107$var$thresholds = {
    any: 0,
    all: 1
};
function $3019b940a732e107$export$acb1e9cb9ce4ca56(elementOrSelector, onStart, { root: root, margin: rootMargin, amount: amount = "any" } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */ if (typeof IntersectionObserver === "undefined") return ()=>{};
    const elements = (0, $94c1aa313017b840$export$90ceba2564a894f8)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries)=>{
        entries.forEach((entry)=>{
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */ if (entry.isIntersecting === Boolean(onEnd)) return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if ((0, $4a3ae8b34d8c7815$export$f6e2535fb5126e54)(newOnEnd)) activeIntersections.set(entry.target, newOnEnd);
                else observer.unobserve(entry.target);
            } else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root: root,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : $3019b940a732e107$var$thresholds[amount]
    });
    elements.forEach((element)=>observer.observe(element));
    return ()=>observer.disconnect();
}

const $cf54c628e8228616$export$ebe90cb607ad99e = {
    duration: 0.3,
    delay: 0,
    endDelay: 0,
    repeat: 0,
    easing: "ease"
};

const $231770507cde1286$export$2da9be4cfdb689b1 = {
    ms: (seconds)=>seconds * 1000,
    s: (milliseconds)=>milliseconds / 1000
};

const $5a7c6586306c883b$export$8793edee2d425525 = ()=>{};
const $5a7c6586306c883b$export$ea6e51872ab1b721 = (v)=>v;


function $27b31e5af450abd0$export$3cc6f911ef1fd837(animation, needsCommit = true) {
    if (!animation || animation.playState === "finished") return;
    // Suppress error thrown by WAAPI
    try {
        if (animation.stop) animation.stop();
        else {
            needsCommit && animation.commitStyles();
            animation.cancel();
        }
    } catch (e) {}
}


const $5f6c656c33a8bdd6$var$createAnimation = (factory)=>factory();
const $5f6c656c33a8bdd6$export$c5e4bb50450218c1 = (animationFactory, options, duration = (0, $cf54c628e8228616$export$ebe90cb607ad99e).duration)=>{
    return new Proxy({
        animations: animationFactory.map($5f6c656c33a8bdd6$var$createAnimation).filter(Boolean),
        duration: duration,
        options: options
    }, $5f6c656c33a8bdd6$export$cc1adf6fb659c762);
};
/**
 * TODO:
 * Currently this returns the first animation, ideally it would return
 * the first active animation.
 */ const $5f6c656c33a8bdd6$var$getActiveAnimation = (state)=>state.animations[0];
const $5f6c656c33a8bdd6$export$cc1adf6fb659c762 = {
    get: (target, key)=>{
        const activeAnimation = $5f6c656c33a8bdd6$var$getActiveAnimation(target);
        switch(key){
            case "duration":
                return target.duration;
            case "currentTime":
                return (0, $231770507cde1286$export$2da9be4cfdb689b1).s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
            case "playbackRate":
            case "playState":
                return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
            case "finished":
                if (!target.finished) target.finished = Promise.all(target.animations.map($5f6c656c33a8bdd6$var$selectFinished)).catch((0, $5a7c6586306c883b$export$8793edee2d425525));
                return target.finished;
            case "stop":
                return ()=>{
                    target.animations.forEach((animation)=>(0, $27b31e5af450abd0$export$3cc6f911ef1fd837)(animation));
                };
            case "forEachNative":
                /**
                 * This is for internal use only, fire a callback for each
                 * underlying animation.
                 */ return (callback)=>{
                    target.animations.forEach((animation)=>callback(animation, target));
                };
            default:
                return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined" ? undefined : ()=>target.animations.forEach((animation)=>animation[key]());
        }
    },
    set: (target, key, value)=>{
        switch(key){
            case "currentTime":
                value = (0, $231770507cde1286$export$2da9be4cfdb689b1).ms(value);
            // Fall-through
            case "playbackRate":
                for(let i = 0; i < target.animations.length; i++)target.animations[i][key] = value;
                return true;
        }
        return false;
    }
};
const $5f6c656c33a8bdd6$var$selectFinished = (animation)=>animation.finished;

const $e4cb174ad07b97b4$export$d81a3021299cadf2 = (easing)=>typeof easing === "object" && Boolean(easing.createAnimation);

const $21f0d41def87b865$export$7e4aa119212bc614 = (value)=>typeof value === "number";


const $f7cd80defa3157b3$export$981cc9ef33696dc8 = (easing)=>Array.isArray(easing) && !(0, $21f0d41def87b865$export$7e4aa119212bc614)(easing[0]);

const $5bc7f8c1e0ab24a6$export$2c9e8a9632a706b2 = (min, max, progress)=>-progress * min + progress * max + min;




const $745d21a74701acae$export$504d7abb21fa8c9 = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);


function $b5786fb950153824$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $745d21a74701acae$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $5bc7f8c1e0ab24a6$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}
function $b5786fb950153824$export$24dbcec0b26e6d9d(length) {
    const offset = [
        0
    ];
    $b5786fb950153824$export$dafee61230cf05c6(offset, length - 1);
    return offset;
}




const $45b42278db30a934$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};


function $98b1ad1828499999$export$41c5e731255a462(easing, i) {
    return (0, $f7cd80defa3157b3$export$981cc9ef33696dc8)(easing) ? easing[(0, $45b42278db30a934$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}


const $99a977444590bffe$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


function $f6298ebfcbce476f$export$89e29e4ab65e70a9(output, input = (0, $b5786fb950153824$export$24dbcec0b26e6d9d)(output.length), easing = (0, $5a7c6586306c883b$export$ea6e51872ab1b721)) {
    const length = output.length;
    /**
     * If the input length is lower than the output we
     * fill the input to match. This currently assumes the input
     * is an animation progress value so is a good candidate for
     * moving outside the function.
     */ const remainder = length - input.length;
    remainder > 0 && (0, $b5786fb950153824$export$dafee61230cf05c6)(input, remainder);
    return (t)=>{
        let i = 0;
        for(; i < length - 2; i++){
            if (t < input[i + 1]) break;
        }
        let progressInRange = (0, $99a977444590bffe$export$7d15b64cf5a3a4c4)(0, 1, (0, $745d21a74701acae$export$504d7abb21fa8c9)(input[i], input[i + 1], t));
        const segmentEasing = (0, $98b1ad1828499999$export$41c5e731255a462)(easing, i);
        progressInRange = segmentEasing(progressInRange);
        return (0, $5bc7f8c1e0ab24a6$export$2c9e8a9632a706b2)(output[i], output[i + 1], progressInRange);
    };
}



/*
  Bezier function generator

  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.

  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.

  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $5bc2147a6d858c09$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $5bc2147a6d858c09$var$subdivisionPrecision = 0.0000001;
const $5bc2147a6d858c09$var$subdivisionMaxIterations = 12;
function $5bc2147a6d858c09$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $5bc2147a6d858c09$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $5bc2147a6d858c09$var$subdivisionPrecision && ++i < $5bc2147a6d858c09$var$subdivisionMaxIterations);
    return currentT;
}
function $5bc2147a6d858c09$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $5a7c6586306c883b$export$ea6e51872ab1b721;
    const getTForX = (aX)=>$5bc2147a6d858c09$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $5bc2147a6d858c09$var$calcBezier(getTForX(t), mY1, mY2);
}


const $f83f29dde9322451$export$be3f796aed065412 = (steps, direction = "end")=>(progress)=>{
        progress = direction === "end" ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        const expanded = progress * steps;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return (0, $99a977444590bffe$export$7d15b64cf5a3a4c4)(0, 1, rounded / steps);
    };



const $fc78a9535c434d50$export$77290801a62f77a2 = (easing)=>Array.isArray(easing) && (0, $21f0d41def87b865$export$7e4aa119212bc614)(easing[0]);


const $ba39f2482511f1c2$var$namedEasings = {
    ease: (0, $5bc2147a6d858c09$export$2c575fa1d20488bd)(0.25, 0.1, 0.25, 1.0),
    "ease-in": (0, $5bc2147a6d858c09$export$2c575fa1d20488bd)(0.42, 0.0, 1.0, 1.0),
    "ease-in-out": (0, $5bc2147a6d858c09$export$2c575fa1d20488bd)(0.42, 0.0, 0.58, 1.0),
    "ease-out": (0, $5bc2147a6d858c09$export$2c575fa1d20488bd)(0.0, 0.0, 0.58, 1.0)
};
const $ba39f2482511f1c2$var$functionArgsRegex = /\((.*?)\)/;
function $ba39f2482511f1c2$export$9681b459c1c8f0f4(definition) {
    // If already an easing function, return
    if ((0, $4a3ae8b34d8c7815$export$f6e2535fb5126e54)(definition)) return definition;
    // If an easing curve definition, return bezier function
    if ((0, $fc78a9535c434d50$export$77290801a62f77a2)(definition)) return (0, $5bc2147a6d858c09$export$2c575fa1d20488bd)(...definition);
    // If we have a predefined easing function, return
    const namedEasing = $ba39f2482511f1c2$var$namedEasings[definition];
    if (namedEasing) return namedEasing;
    // If this is a steps function, attempt to create easing curve
    if (definition.startsWith("steps")) {
        const args = $ba39f2482511f1c2$var$functionArgsRegex.exec(definition);
        if (args) {
            const argsArray = args[1].split(",");
            return (0, $f83f29dde9322451$export$be3f796aed065412)(parseFloat(argsArray[0]), argsArray[1].trim());
        }
    }
    return 0, $5a7c6586306c883b$export$ea6e51872ab1b721;
}


class $fd68e4d15c2b425f$export$c35d437ae5945fcd {
    constructor(output, keyframes = [
        0,
        1
    ], { easing: easing, duration: initialDuration = (0, $cf54c628e8228616$export$ebe90cb607ad99e).duration, delay: delay = (0, $cf54c628e8228616$export$ebe90cb607ad99e).delay, endDelay: endDelay = (0, $cf54c628e8228616$export$ebe90cb607ad99e).endDelay, repeat: repeat = (0, $cf54c628e8228616$export$ebe90cb607ad99e).repeat, offset: offset, direction: direction = "normal", autoplay: autoplay = true } = {}){
        this.startTime = null;
        this.rate = 1;
        this.t = 0;
        this.cancelTimestamp = null;
        this.easing = (0, $5a7c6586306c883b$export$ea6e51872ab1b721);
        this.duration = 0;
        this.totalDuration = 0;
        this.repeat = 0;
        this.playState = "idle";
        this.finished = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
        easing = easing || (0, $cf54c628e8228616$export$ebe90cb607ad99e).easing;
        if ((0, $e4cb174ad07b97b4$export$d81a3021299cadf2)(easing)) {
            const custom = easing.createAnimation(keyframes);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            initialDuration = custom.duration || initialDuration;
        }
        this.repeat = repeat;
        this.easing = (0, $f7cd80defa3157b3$export$981cc9ef33696dc8)(easing) ? (0, $5a7c6586306c883b$export$ea6e51872ab1b721) : (0, $ba39f2482511f1c2$export$9681b459c1c8f0f4)(easing);
        this.updateDuration(initialDuration);
        const interpolate$1 = (0, $f6298ebfcbce476f$export$89e29e4ab65e70a9)(keyframes, offset, (0, $f7cd80defa3157b3$export$981cc9ef33696dc8)(easing) ? easing.map((0, $ba39f2482511f1c2$export$9681b459c1c8f0f4)) : (0, $5a7c6586306c883b$export$ea6e51872ab1b721));
        this.tick = (timestamp)=>{
            var _a;
            // TODO: Temporary fix for OptionsResolver typing
            delay;
            let t = 0;
            if (this.pauseTime !== undefined) t = this.pauseTime;
            else t = (timestamp - this.startTime) * this.rate;
            this.t = t;
            // Convert to seconds
            t /= 1000;
            // Rebase on delay
            t = Math.max(t - delay, 0);
            /**
             * If this animation has finished, set the current time
             * to the total duration.
             */ if (this.playState === "finished" && this.pauseTime === undefined) t = this.totalDuration;
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = t / this.duration;
            // TODO progress += iterationStart
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            if (!iterationProgress && progress >= 1) iterationProgress = 1;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ iterationProgress === 1 && currentIteration--;
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = currentIteration % 2;
            if (direction === "reverse" || direction === "alternate" && iterationIsOdd || direction === "alternate-reverse" && !iterationIsOdd) iterationProgress = 1 - iterationProgress;
            const p = t >= this.totalDuration ? 1 : Math.min(iterationProgress, 1);
            const latest = interpolate$1(this.easing(p));
            output(latest);
            const isAnimationFinished = this.pauseTime === undefined && (this.playState === "finished" || t >= this.totalDuration + endDelay);
            if (isAnimationFinished) {
                this.playState = "finished";
                (_a = this.resolve) === null || _a === void 0 || _a.call(this, latest);
            } else if (this.playState !== "idle") this.frameRequestId = requestAnimationFrame(this.tick);
        };
        if (autoplay) this.play();
    }
    play() {
        const now = performance.now();
        this.playState = "running";
        if (this.pauseTime !== undefined) this.startTime = now - this.pauseTime;
        else if (!this.startTime) this.startTime = now;
        this.cancelTimestamp = this.startTime;
        this.pauseTime = undefined;
        this.frameRequestId = requestAnimationFrame(this.tick);
    }
    pause() {
        this.playState = "paused";
        this.pauseTime = this.t;
    }
    finish() {
        this.playState = "finished";
        this.tick(0);
    }
    stop() {
        var _a;
        this.playState = "idle";
        if (this.frameRequestId !== undefined) cancelAnimationFrame(this.frameRequestId);
        (_a = this.reject) === null || _a === void 0 || _a.call(this, false);
    }
    cancel() {
        this.stop();
        this.tick(this.cancelTimestamp);
    }
    reverse() {
        this.rate *= -1;
    }
    commitStyles() {}
    updateDuration(duration) {
        this.duration = duration;
        this.totalDuration = duration * (this.repeat + 1);
    }
    get currentTime() {
        return this.t;
    }
    set currentTime(t) {
        if (this.pauseTime !== undefined || this.rate === 0) this.pauseTime = t;
        else this.startTime = performance.now() - t / this.rate;
    }
    get playbackRate() {
        return this.rate;
    }
    set playbackRate(rate) {
        this.rate = rate;
    }
}


var $fedf00bec75fe537$export$491112666e282270 = function() {};
var $fedf00bec75fe537$export$f5708dca728d7177 = function() {};


/**
 * The MotionValue tracks the state of a single animatable
 * value. Currently, updatedAt and current are unused. The
 * long term idea is to use this to minimise the number
 * of DOM reads, and to abstract the DOM interactions here.
 */ class $a7764340ff656e78$export$8cea36d14ee64562 {
    setAnimation(animation) {
        this.animation = animation;
        animation === null || animation === void 0 || animation.finished.then(()=>this.clearAnimation()).catch(()=>{});
    }
    clearAnimation() {
        this.animation = this.generator = undefined;
    }
}


const $fcf9f04380bda4c4$var$data = new WeakMap();
function $fcf9f04380bda4c4$export$213eea93596b44f(element) {
    if (!$fcf9f04380bda4c4$var$data.has(element)) $fcf9f04380bda4c4$var$data.set(element, {
        transforms: [],
        values: new Map()
    });
    return $fcf9f04380bda4c4$var$data.get(element);
}
function $fcf9f04380bda4c4$export$c0999ba824977ca6(motionValues, name) {
    if (!motionValues.has(name)) motionValues.set(name, new (0, $a7764340ff656e78$export$8cea36d14ee64562)());
    return motionValues.get(name);
}


function $a65b80757fccab21$export$20e507e47fae79fd(array, item) {
    array.indexOf(item) === -1 && array.push(item);
}
function $a65b80757fccab21$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}



/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ const $964374b85a301401$export$a9a762b9618d4a18 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ const $964374b85a301401$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
const $964374b85a301401$export$97b5d3c90609c212 = {
    x: "translateX",
    y: "translateY",
    z: "translateZ"
};
const $964374b85a301401$var$rotation = {
    syntax: "<angle>",
    initialValue: "0deg",
    toDefaultUnit: (v)=>v + "deg"
};
const $964374b85a301401$var$baseTransformProperties = {
    translate: {
        syntax: "<length-percentage>",
        initialValue: "0px",
        toDefaultUnit: (v)=>v + "px"
    },
    rotate: $964374b85a301401$var$rotation,
    scale: {
        syntax: "<number>",
        initialValue: 1,
        toDefaultUnit: (0, $5a7c6586306c883b$export$ea6e51872ab1b721)
    },
    skew: $964374b85a301401$var$rotation
};
const $964374b85a301401$export$a9dad2abc3d443d = new Map();
const $964374b85a301401$export$7bbd29b1fa8b68d4 = (name)=>`--motion-${name}`;
/**
 * Generate a list of every possible transform key
 */ const $964374b85a301401$var$transforms = [
    "x",
    "y",
    "z"
];
$964374b85a301401$var$order.forEach((name)=>{
    $964374b85a301401$export$a9a762b9618d4a18.forEach((axis)=>{
        $964374b85a301401$var$transforms.push(name + axis);
        $964374b85a301401$export$a9dad2abc3d443d.set($964374b85a301401$export$7bbd29b1fa8b68d4(name + axis), $964374b85a301401$var$baseTransformProperties[name]);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ const $964374b85a301401$export$11410fe03e8c4042 = (a, b)=>$964374b85a301401$var$transforms.indexOf(a) - $964374b85a301401$var$transforms.indexOf(b);
/**
 * Provide a quick way to check if a string is the name of a transform
 */ const $964374b85a301401$var$transformLookup = new Set($964374b85a301401$var$transforms);
const $964374b85a301401$export$8a546e9da811625d = (name)=>$964374b85a301401$var$transformLookup.has(name);
const $964374b85a301401$export$40eba1f1af915c93 = (element, name)=>{
    // Map x to translateX etc
    if ($964374b85a301401$export$97b5d3c90609c212[name]) name = $964374b85a301401$export$97b5d3c90609c212[name];
    const { transforms: transforms } = (0, $fcf9f04380bda4c4$export$213eea93596b44f)(element);
    (0, $a65b80757fccab21$export$20e507e47fae79fd)(transforms, name);
    /**
     * TODO: An optimisation here could be to cache the transform in element data
     * and only update if this has changed.
     */ element.style.transform = $964374b85a301401$export$785216816cb6f870(transforms);
};
const $964374b85a301401$export$785216816cb6f870 = (transforms)=>transforms.sort($964374b85a301401$export$11410fe03e8c4042).reduce($964374b85a301401$var$transformListToString, "").trim();
const $964374b85a301401$var$transformListToString = (template, name)=>`${template} ${name}(var(${$964374b85a301401$export$7bbd29b1fa8b68d4(name)}))`;


const $b2e953eb0f6b54e3$export$30a9abfd5fb9f5f6 = (name)=>name.startsWith("--");
const $b2e953eb0f6b54e3$export$7a740cb9e3dd106d = new Set();
function $b2e953eb0f6b54e3$export$9fdd8c2f6f59adb0(name) {
    if ($b2e953eb0f6b54e3$export$7a740cb9e3dd106d.has(name)) return;
    $b2e953eb0f6b54e3$export$7a740cb9e3dd106d.add(name);
    try {
        const { syntax: syntax, initialValue: initialValue } = (0, $964374b85a301401$export$a9dad2abc3d443d).has(name) ? (0, $964374b85a301401$export$a9dad2abc3d443d).get(name) : {};
        CSS.registerProperty({
            name: name,
            inherits: false,
            syntax: syntax,
            initialValue: initialValue
        });
    } catch (e) {}
}





const $bd30f8c6aace66a0$var$testAnimation = (keyframes, options)=>document.createElement("div").animate(keyframes, options);
const $bd30f8c6aace66a0$var$featureTests = {
    cssRegisterProperty: ()=>typeof CSS !== "undefined" && Object.hasOwnProperty.call(CSS, "registerProperty"),
    waapi: ()=>Object.hasOwnProperty.call(Element.prototype, "animate"),
    partialKeyframes: ()=>{
        try {
            $bd30f8c6aace66a0$var$testAnimation({
                opacity: [
                    1
                ]
            });
        } catch (e) {
            return false;
        }
        return true;
    },
    finished: ()=>Boolean($bd30f8c6aace66a0$var$testAnimation({
            opacity: [
                0,
                1
            ]
        }, {
            duration: 0.001
        }).finished),
    linearEasing: ()=>{
        try {
            $bd30f8c6aace66a0$var$testAnimation({
                opacity: 0
            }, {
                easing: "linear(0, 1)"
            });
        } catch (e) {
            return false;
        }
        return true;
    }
};
const $bd30f8c6aace66a0$var$results = {};
const $bd30f8c6aace66a0$export$cde6a56f9669daf6 = {};
for(const key in $bd30f8c6aace66a0$var$featureTests)$bd30f8c6aace66a0$export$cde6a56f9669daf6[key] = ()=>{
    if ($bd30f8c6aace66a0$var$results[key] === undefined) $bd30f8c6aace66a0$var$results[key] = $bd30f8c6aace66a0$var$featureTests[key]();
    return $bd30f8c6aace66a0$var$results[key];
};


// Create a linear easing point for every x second
const $05447f6b8679cd5c$var$resolution = 0.015;
const $05447f6b8679cd5c$export$a74bbb7e96c8ced4 = (easing, duration)=>{
    let points = "";
    const numPoints = Math.round(duration / $05447f6b8679cd5c$var$resolution);
    for(let i = 0; i < numPoints; i++)points += easing((0, $745d21a74701acae$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return points.substring(0, points.length - 2);
};
const $05447f6b8679cd5c$export$284d1118c33f9836 = (easing, duration)=>{
    if ((0, $4a3ae8b34d8c7815$export$f6e2535fb5126e54)(easing)) return (0, $bd30f8c6aace66a0$export$cde6a56f9669daf6).linearEasing() ? `linear(${$05447f6b8679cd5c$export$a74bbb7e96c8ced4(easing, duration)})` : (0, $cf54c628e8228616$export$ebe90cb607ad99e).easing;
    else return (0, $fc78a9535c434d50$export$77290801a62f77a2)(easing) ? $05447f6b8679cd5c$export$2523b8f0bd8f44cb(easing) : easing;
};
const $05447f6b8679cd5c$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



function $08b3f76d80312f04$export$3d2f5b3e7004e0cf(keyframes, readInitialValue) {
    for(let i = 0; i < keyframes.length; i++)if (keyframes[i] === null) keyframes[i] = i ? keyframes[i - 1] : readInitialValue();
    return keyframes;
}
const $08b3f76d80312f04$export$388e66a97327a012 = (keyframes)=>Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];




function $142102117cd3e567$export$b6557f397a74f857(key) {
    if ((0, $964374b85a301401$export$97b5d3c90609c212)[key]) key = (0, $964374b85a301401$export$97b5d3c90609c212)[key];
    return (0, $964374b85a301401$export$8a546e9da811625d)(key) ? (0, $964374b85a301401$export$7bbd29b1fa8b68d4)(key) : key;
}



const $bbb9b85b2d82c275$export$1d567c320f4763bc = {
    get: (element, name)=>{
        name = (0, $142102117cd3e567$export$b6557f397a74f857)(name);
        let value = (0, $b2e953eb0f6b54e3$export$30a9abfd5fb9f5f6)(name) ? element.style.getPropertyValue(name) : getComputedStyle(element)[name];
        // TODO Decide if value can be 0
        if (!value && value !== 0) {
            const definition = (0, $964374b85a301401$export$a9dad2abc3d443d).get(name);
            if (definition) value = definition.initialValue;
        }
        return value;
    },
    set: (element, name, value)=>{
        name = (0, $142102117cd3e567$export$b6557f397a74f857)(name);
        if ((0, $b2e953eb0f6b54e3$export$30a9abfd5fb9f5f6)(name)) element.style.setProperty(name, value);
        else element.style[name] = value;
    }
};




const $6dfc46d0761bc5e3$export$844ec244b1367d54 = (value)=>typeof value === "string";


function $cd612f8c1205ad4c$export$4bcf070800a2fd35(keyframes, definition) {
    var _a;
    let toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || (0, $5a7c6586306c883b$export$ea6e51872ab1b721);
    const finalKeyframe = keyframes[keyframes.length - 1];
    if ((0, $6dfc46d0761bc5e3$export$844ec244b1367d54)(finalKeyframe)) {
        const unit = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
        if (unit) toUnit = (value)=>value + unit;
    }
    return toUnit;
}


function $3344ba6373fe4df2$var$getDevToolsRecord() {
    return window.__MOTION_DEV_TOOLS_RECORD;
}
function $3344ba6373fe4df2$export$c76cd972d26986f9(element, key, keyframesDefinition, options = {}, AnimationPolyfill) {
    const record = $3344ba6373fe4df2$var$getDevToolsRecord();
    const isRecording = options.record !== false && record;
    let animation;
    let { duration: duration = (0, $cf54c628e8228616$export$ebe90cb607ad99e).duration, delay: delay = (0, $cf54c628e8228616$export$ebe90cb607ad99e).delay, endDelay: endDelay = (0, $cf54c628e8228616$export$ebe90cb607ad99e).endDelay, repeat: repeat = (0, $cf54c628e8228616$export$ebe90cb607ad99e).repeat, easing: easing = (0, $cf54c628e8228616$export$ebe90cb607ad99e).easing, persist: persist = false, direction: direction, offset: offset, allowWebkitAcceleration: allowWebkitAcceleration = false, autoplay: autoplay = true } = options;
    const data = (0, $fcf9f04380bda4c4$export$213eea93596b44f)(element);
    const valueIsTransform = (0, $964374b85a301401$export$8a546e9da811625d)(key);
    let canAnimateNatively = (0, $bd30f8c6aace66a0$export$cde6a56f9669daf6).waapi();
    /**
     * If this is an individual transform, we need to map its
     * key to a CSS variable and update the element's transform style
     */ valueIsTransform && (0, $964374b85a301401$export$40eba1f1af915c93)(element, key);
    const name = (0, $142102117cd3e567$export$b6557f397a74f857)(key);
    const motionValue = (0, $fcf9f04380bda4c4$export$c0999ba824977ca6)(data.values, name);
    /**
     * Get definition of value, this will be used to convert numerical
     * keyframes into the default value type.
     */ const definition = (0, $964374b85a301401$export$a9dad2abc3d443d).get(name);
    /**
     * Stop the current animation, if any. Because this will trigger
     * commitStyles (DOM writes) and we might later trigger DOM reads,
     * this is fired now and we return a factory function to create
     * the actual animation that can get called in batch,
     */ (0, $27b31e5af450abd0$export$3cc6f911ef1fd837)(motionValue.animation, !((0, $e4cb174ad07b97b4$export$d81a3021299cadf2)(easing) && motionValue.generator) && options.record !== false);
    /**
     * Batchable factory function containing all DOM reads.
     */ return ()=>{
        const readInitialValue = ()=>{
            var _a, _b;
            return (_b = (_a = (0, $bbb9b85b2d82c275$export$1d567c320f4763bc).get(element, name)) !== null && _a !== void 0 ? _a : definition === null || definition === void 0 ? void 0 : definition.initialValue) !== null && _b !== void 0 ? _b : 0;
        };
        /**
         * Replace null values with the previous keyframe value, or read
         * it from the DOM if it's the first keyframe.
         */ let keyframes = (0, $08b3f76d80312f04$export$3d2f5b3e7004e0cf)((0, $08b3f76d80312f04$export$388e66a97327a012)(keyframesDefinition), readInitialValue);
        /**
         * Detect unit type of keyframes.
         */ const toUnit = (0, $cd612f8c1205ad4c$export$4bcf070800a2fd35)(keyframes, definition);
        if ((0, $e4cb174ad07b97b4$export$d81a3021299cadf2)(easing)) {
            const custom = easing.createAnimation(keyframes, key !== "opacity", readInitialValue, name, motionValue);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            duration = custom.duration || duration;
        }
        /**
         * If this is a CSS variable we need to register it with the browser
         * before it can be animated natively. We also set it with setProperty
         * rather than directly onto the element.style object.
         */ if ((0, $b2e953eb0f6b54e3$export$30a9abfd5fb9f5f6)(name)) {
            if ((0, $bd30f8c6aace66a0$export$cde6a56f9669daf6).cssRegisterProperty()) (0, $b2e953eb0f6b54e3$export$9fdd8c2f6f59adb0)(name);
            else canAnimateNatively = false;
        }
        /**
         * If we've been passed a custom easing function, and this browser
         * does **not** support linear() easing, and the value is a transform
         * (and thus a pure number) we can still support the custom easing
         * by falling back to the animation polyfill.
         */ if (valueIsTransform && !(0, $bd30f8c6aace66a0$export$cde6a56f9669daf6).linearEasing() && ((0, $4a3ae8b34d8c7815$export$f6e2535fb5126e54)(easing) || (0, $f7cd80defa3157b3$export$981cc9ef33696dc8)(easing) && easing.some((0, $4a3ae8b34d8c7815$export$f6e2535fb5126e54)))) canAnimateNatively = false;
        /**
         * If we can animate this value with WAAPI, do so.
         */ if (canAnimateNatively) {
            /**
             * Convert numbers to default value types. Currently this only supports
             * transforms but it could also support other value types.
             */ if (definition) keyframes = keyframes.map((value)=>(0, $21f0d41def87b865$export$7e4aa119212bc614)(value) ? definition.toDefaultUnit(value) : value);
            /**
             * If this browser doesn't support partial/implicit keyframes we need to
             * explicitly provide one.
             */ if (keyframes.length === 1 && (!(0, $bd30f8c6aace66a0$export$cde6a56f9669daf6).partialKeyframes() || isRecording)) keyframes.unshift(readInitialValue());
            const animationOptions = {
                delay: (0, $231770507cde1286$export$2da9be4cfdb689b1).ms(delay),
                duration: (0, $231770507cde1286$export$2da9be4cfdb689b1).ms(duration),
                endDelay: (0, $231770507cde1286$export$2da9be4cfdb689b1).ms(endDelay),
                easing: !(0, $f7cd80defa3157b3$export$981cc9ef33696dc8)(easing) ? (0, $05447f6b8679cd5c$export$284d1118c33f9836)(easing, duration) : undefined,
                direction: direction,
                iterations: repeat + 1,
                fill: "both"
            };
            animation = element.animate({
                [name]: keyframes,
                offset: offset,
                easing: (0, $f7cd80defa3157b3$export$981cc9ef33696dc8)(easing) ? easing.map((thisEasing)=>(0, $05447f6b8679cd5c$export$284d1118c33f9836)(thisEasing, duration)) : undefined
            }, animationOptions);
            /**
             * Polyfill finished Promise in browsers that don't support it
             */ if (!animation.finished) animation.finished = new Promise((resolve, reject)=>{
                animation.onfinish = resolve;
                animation.oncancel = reject;
            });
            const target = keyframes[keyframes.length - 1];
            animation.finished.then(()=>{
                if (persist) return;
                // Apply styles to target
                (0, $bbb9b85b2d82c275$export$1d567c320f4763bc).set(element, name, target);
                // Ensure fill modes don't persist
                animation.cancel();
            }).catch((0, $5a7c6586306c883b$export$8793edee2d425525));
            /**
             * This forces Webkit to run animations on the main thread by exploiting
             * this condition:
             * https://trac.webkit.org/browser/webkit/trunk/Source/WebCore/platform/graphics/ca/GraphicsLayerCA.cpp?rev=281238#L1099
             *
             * This fixes Webkit's timing bugs, like accelerated animations falling
             * out of sync with main thread animations and massive delays in starting
             * accelerated animations in WKWebView.
             */ if (!allowWebkitAcceleration) animation.playbackRate = 1.000001;
        /**
             * If we can't animate the value natively then we can fallback to the numbers-only
             * polyfill for transforms.
             */ } else if (AnimationPolyfill && valueIsTransform) {
            /**
             * If any keyframe is a string (because we measured it from the DOM), we need to convert
             * it into a number before passing to the Animation polyfill.
             */ keyframes = keyframes.map((value)=>typeof value === "string" ? parseFloat(value) : value);
            /**
             * If we only have a single keyframe, we need to create an initial keyframe by reading
             * the current value from the DOM.
             */ if (keyframes.length === 1) keyframes.unshift(parseFloat(readInitialValue()));
            animation = new AnimationPolyfill((latest)=>{
                (0, $bbb9b85b2d82c275$export$1d567c320f4763bc).set(element, name, toUnit ? toUnit(latest) : latest);
            }, keyframes, Object.assign(Object.assign({}, options), {
                duration: duration,
                easing: easing
            }));
        } else {
            const target = keyframes[keyframes.length - 1];
            (0, $bbb9b85b2d82c275$export$1d567c320f4763bc).set(element, name, definition && (0, $21f0d41def87b865$export$7e4aa119212bc614)(target) ? definition.toDefaultUnit(target) : target);
        }
        if (isRecording) record(element, key, keyframes, {
            duration: duration,
            delay: delay,
            easing: easing,
            repeat: repeat,
            offset: offset
        }, "motion-one");
        motionValue.setAnimation(animation);
        if (animation && !autoplay) animation.pause();
        return animation;
    };
}


const $2a27dcaa5a61007d$export$d2312e68e1f5ad00 = (options, key)=>/**
 * TODO: Make test for this
 * Always return a new object otherwise delay is overwritten by results of stagger
 * and this results in no stagger
 */ options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options);






function $b1365191334b71a4$export$ef0b4d89074db4d0(duration = 0.1, { start: start = 0, from: from = 0, easing: easing } = {}) {
    return (i, total)=>{
        const fromIndex = (0, $21f0d41def87b865$export$7e4aa119212bc614)(from) ? from : $b1365191334b71a4$export$a7952f4918e96441(from, total);
        const distance = Math.abs(fromIndex - i);
        let delay = duration * distance;
        if (easing) {
            const maxDelay = total * duration;
            const easingFunction = (0, $ba39f2482511f1c2$export$9681b459c1c8f0f4)(easing);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return start + delay;
    };
}
function $b1365191334b71a4$export$a7952f4918e96441(from, total) {
    if (from === "first") return 0;
    else {
        const lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function $b1365191334b71a4$export$4cf8f03b86be8175(option, i, total) {
    return (0, $4a3ae8b34d8c7815$export$f6e2535fb5126e54)(option) ? option(i, total) : option;
}


function $a26acaede21a73ee$export$2a47ca22dbf0bb08(AnimatePolyfill) {
    return function animate(elements, keyframes, options = {}) {
        elements = (0, $94c1aa313017b840$export$90ceba2564a894f8)(elements);
        const numElements = elements.length;
        (0, $fedf00bec75fe537$export$f5708dca728d7177)(Boolean(numElements), "No valid element provided.");
        (0, $fedf00bec75fe537$export$f5708dca728d7177)(Boolean(keyframes), "No keyframes defined.");
        /**
         * Create and start new animations
         */ const animationFactories = [];
        for(let i = 0; i < numElements; i++){
            const element = elements[i];
            for(const key in keyframes){
                const valueOptions = (0, $2a27dcaa5a61007d$export$d2312e68e1f5ad00)(options, key);
                valueOptions.delay = (0, $b1365191334b71a4$export$4cf8f03b86be8175)(valueOptions.delay, i, numElements);
                const animation = (0, $3344ba6373fe4df2$export$c76cd972d26986f9)(element, key, keyframes[key], valueOptions, AnimatePolyfill);
                animationFactories.push(animation);
            }
        }
        return (0, $5f6c656c33a8bdd6$export$c5e4bb50450218c1)(animationFactories, options, /**
         * TODO:
         * If easing is set to spring or glide, duration will be dynamically
         * generated. Ideally we would dynamically generate this from
         * animation.effect.getComputedTiming().duration but this isn't
         * supported in iOS13 or our number polyfill. Perhaps it's possible
         * to Proxy animations returned from animateStyle that has duration
         * as a getter.
         */ options.duration);
    };
}


const $4ad2710e7b6c6f85$export$e3607ec2d7a891c4 = (0, $a26acaede21a73ee$export$2a47ca22dbf0bb08)((0, $fd68e4d15c2b425f$export$c35d437ae5945fcd));




function $d522be3249d946e5$export$290670472807ab5b(target, options = {}) {
    return (0, $5f6c656c33a8bdd6$export$c5e4bb50450218c1)([
        ()=>{
            const animation = new (0, $fd68e4d15c2b425f$export$c35d437ae5945fcd)(target, [
                0,
                1
            ], options);
            animation.finished.catch(()=>{});
            return animation;
        }
    ], options, options.duration);
}
function $d522be3249d946e5$export$e3607ec2d7a891c4(target, keyframesOrOptions, options) {
    const factory = (0, $4a3ae8b34d8c7815$export$f6e2535fb5126e54)(target) ? $d522be3249d946e5$export$290670472807ab5b : (0, $4ad2710e7b6c6f85$export$e3607ec2d7a891c4);
    return factory(target, keyframesOrOptions, options);
}


// packages/alpinejs/src/scheduler.js
var $f7be985f79bfefb2$var$flushPending = false;
var $f7be985f79bfefb2$var$flushing = false;
var $f7be985f79bfefb2$var$queue = [];
var $f7be985f79bfefb2$var$lastFlushedIndex = -1;
var $f7be985f79bfefb2$var$queueNeedsSort = false;
var $f7be985f79bfefb2$var$transactionActive = false;
function $f7be985f79bfefb2$var$scheduler(callback) {
    $f7be985f79bfefb2$var$queueJob(callback);
}
function $f7be985f79bfefb2$var$startTransaction() {
    $f7be985f79bfefb2$var$transactionActive = true;
}
function $f7be985f79bfefb2$var$commitTransaction() {
    $f7be985f79bfefb2$var$transactionActive = false;
    $f7be985f79bfefb2$var$queueFlush();
}
function $f7be985f79bfefb2$var$queueJob(job) {
    if (!$f7be985f79bfefb2$var$queue.includes(job)) {
        $f7be985f79bfefb2$var$queue.push(job);
        if (job._x_schedulerPriority !== void 0) $f7be985f79bfefb2$var$queueNeedsSort = true;
    }
    $f7be985f79bfefb2$var$queueFlush();
}
function $f7be985f79bfefb2$var$dequeueJob(job) {
    let index = $f7be985f79bfefb2$var$queue.indexOf(job);
    if (index !== -1 && index > $f7be985f79bfefb2$var$lastFlushedIndex) $f7be985f79bfefb2$var$queue.splice(index, 1);
}
function $f7be985f79bfefb2$var$queueFlush() {
    if (!$f7be985f79bfefb2$var$flushing && !$f7be985f79bfefb2$var$flushPending) {
        if ($f7be985f79bfefb2$var$transactionActive) return;
        $f7be985f79bfefb2$var$flushPending = true;
        queueMicrotask($f7be985f79bfefb2$var$flushJobs);
    }
}
function $f7be985f79bfefb2$var$flushJobs() {
    $f7be985f79bfefb2$var$flushPending = false;
    $f7be985f79bfefb2$var$flushing = true;
    for(let i = 0; i < $f7be985f79bfefb2$var$queue.length; i++){
        if ($f7be985f79bfefb2$var$queueNeedsSort) $f7be985f79bfefb2$var$sortPendingJobs(i);
        $f7be985f79bfefb2$var$queue[i]();
        $f7be985f79bfefb2$var$lastFlushedIndex = i;
    }
    $f7be985f79bfefb2$var$queue.length = 0;
    $f7be985f79bfefb2$var$lastFlushedIndex = -1;
    $f7be985f79bfefb2$var$queueNeedsSort = false;
    $f7be985f79bfefb2$var$flushing = false;
}
function $f7be985f79bfefb2$var$sortPendingJobs(start2) {
    let depths = /* @__PURE__ */ new Map();
    let sorted = $f7be985f79bfefb2$var$queue.slice(start2).sort((a, b)=>$f7be985f79bfefb2$var$compareJobs(a, b, depths));
    for(let i = 0; i < sorted.length; i++)$f7be985f79bfefb2$var$queue[start2 + i] = sorted[i];
    $f7be985f79bfefb2$var$queueNeedsSort = false;
}
function $f7be985f79bfefb2$var$compareJobs(a, b, depths) {
    if (!$f7be985f79bfefb2$var$isStructural(a)) return $f7be985f79bfefb2$var$isStructural(b) ? 1 : 0;
    if (!$f7be985f79bfefb2$var$isStructural(b)) return -1;
    let depthDifference = $f7be985f79bfefb2$var$getElementDepth(a._x_schedulerPriority.el, depths) - $f7be985f79bfefb2$var$getElementDepth(b._x_schedulerPriority.el, depths);
    return depthDifference || a._x_schedulerPriority.order - b._x_schedulerPriority.order;
}
function $f7be985f79bfefb2$var$isStructural(job) {
    return job._x_schedulerPriority !== void 0;
}
function $f7be985f79bfefb2$var$getElementDepth(el, depths) {
    if (depths.has(el)) return depths.get(el);
    let depth = 0;
    let owner = el;
    while(el){
        depth++;
        if (el._x_teleportBack) el = el._x_teleportBack;
        else if (typeof ShadowRoot === "function" && el.parentNode instanceof ShadowRoot) el = el.parentNode.host;
        else el = el.parentElement;
    }
    depths.set(owner, depth);
    return depth;
}
// packages/alpinejs/src/reactivity.js
var $f7be985f79bfefb2$var$reactive;
var $f7be985f79bfefb2$var$effect;
var $f7be985f79bfefb2$var$release;
var $f7be985f79bfefb2$var$raw;
var $f7be985f79bfefb2$var$nextStructuralEffectOrder = 0;
var $f7be985f79bfefb2$var$shouldSchedule = true;
function $f7be985f79bfefb2$var$disableEffectScheduling(callback) {
    $f7be985f79bfefb2$var$shouldSchedule = false;
    callback();
    $f7be985f79bfefb2$var$shouldSchedule = true;
}
function $f7be985f79bfefb2$var$setReactivityEngine(engine) {
    $f7be985f79bfefb2$var$reactive = engine.reactive;
    $f7be985f79bfefb2$var$release = engine.release;
    $f7be985f79bfefb2$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($f7be985f79bfefb2$var$shouldSchedule) $f7be985f79bfefb2$var$scheduler(task);
                else task();
            }
        });
    $f7be985f79bfefb2$var$raw = engine.raw;
}
function $f7be985f79bfefb2$var$overrideEffect(override) {
    $f7be985f79bfefb2$var$effect = override;
}
function $f7be985f79bfefb2$var$elementBoundEffect(el) {
    let cleanup = ()=>{};
    let wrappedEffect = (callback, options)=>{
        let priority = options?.priority === "structural" ? $f7be985f79bfefb2$var$nextStructuralEffectOrder++ : void 0;
        let effectReference = $f7be985f79bfefb2$var$effect(callback);
        if (priority !== void 0 && effectReference !== void 0) effectReference._x_schedulerPriority = {
            el: el,
            order: priority
        };
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $f7be985f79bfefb2$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup();
        }
    ];
}
function $f7be985f79bfefb2$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let oldValueJSON;
    let effectReference = $f7be985f79bfefb2$var$effect(()=>{
        let value = getter();
        let newJSON = JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = typeof oldValue === "object" ? JSON.parse(oldValueJSON) : oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        oldValueJSON = newJSON;
        firstTime = false;
    });
    return ()=>{
        $f7be985f79bfefb2$var$dequeueJob(effectReference);
        $f7be985f79bfefb2$var$release(effectReference);
    };
}
async function $f7be985f79bfefb2$var$transaction(callback) {
    $f7be985f79bfefb2$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $f7be985f79bfefb2$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $f7be985f79bfefb2$var$onAttributeAddeds = [];
var $f7be985f79bfefb2$var$onElRemoveds = [];
var $f7be985f79bfefb2$var$onElAddeds = [];
function $f7be985f79bfefb2$var$onElAdded(callback) {
    $f7be985f79bfefb2$var$onElAddeds.push(callback);
}
function $f7be985f79bfefb2$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $f7be985f79bfefb2$var$onElRemoveds.push(callback);
    }
}
function $f7be985f79bfefb2$var$onAttributesAdded(callback) {
    $f7be985f79bfefb2$var$onAttributeAddeds.push(callback);
}
function $f7be985f79bfefb2$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $f7be985f79bfefb2$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $f7be985f79bfefb2$var$cleanupElement(el) {
    el._x_effects?.forEach($f7be985f79bfefb2$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $f7be985f79bfefb2$var$observer = new MutationObserver($f7be985f79bfefb2$var$onMutate);
var $f7be985f79bfefb2$var$currentlyObserving = false;
function $f7be985f79bfefb2$var$startObservingMutations() {
    $f7be985f79bfefb2$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $f7be985f79bfefb2$var$currentlyObserving = true;
}
function $f7be985f79bfefb2$var$stopObservingMutations() {
    $f7be985f79bfefb2$var$flushObserver();
    $f7be985f79bfefb2$var$observer.disconnect();
    $f7be985f79bfefb2$var$currentlyObserving = false;
}
var $f7be985f79bfefb2$var$queuedMutations = [];
function $f7be985f79bfefb2$var$flushObserver() {
    let records = $f7be985f79bfefb2$var$observer.takeRecords();
    $f7be985f79bfefb2$var$queuedMutations.push(()=>records.length > 0 && $f7be985f79bfefb2$var$onMutate(records));
    let queueLengthWhenTriggered = $f7be985f79bfefb2$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($f7be985f79bfefb2$var$queuedMutations.length === queueLengthWhenTriggered) while($f7be985f79bfefb2$var$queuedMutations.length > 0)$f7be985f79bfefb2$var$queuedMutations.shift()();
    });
}
function $f7be985f79bfefb2$var$flushPendingMutations() {
    while($f7be985f79bfefb2$var$queuedMutations.length > 0)$f7be985f79bfefb2$var$queuedMutations.shift()();
    let records = $f7be985f79bfefb2$var$observer.takeRecords();
    if (records.length > 0) $f7be985f79bfefb2$var$onMutate(records);
}
function $f7be985f79bfefb2$var$mutateDom(callback) {
    if (!$f7be985f79bfefb2$var$currentlyObserving) return callback();
    $f7be985f79bfefb2$var$stopObservingMutations();
    try {
        return callback();
    } finally{
        $f7be985f79bfefb2$var$startObservingMutations();
    }
}
var $f7be985f79bfefb2$var$isCollecting = false;
var $f7be985f79bfefb2$var$deferredMutations = [];
function $f7be985f79bfefb2$var$deferMutations() {
    $f7be985f79bfefb2$var$isCollecting = true;
}
function $f7be985f79bfefb2$var$flushAndStopDeferringMutations() {
    $f7be985f79bfefb2$var$isCollecting = false;
    $f7be985f79bfefb2$var$onMutate($f7be985f79bfefb2$var$deferredMutations);
    $f7be985f79bfefb2$var$deferredMutations = [];
}
function $f7be985f79bfefb2$var$onMutate(mutations) {
    if ($f7be985f79bfefb2$var$isCollecting) {
        $f7be985f79bfefb2$var$deferredMutations = $f7be985f79bfefb2$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove2 = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add();
            else if (el.hasAttribute(name)) {
                remove2();
                add();
            } else remove2();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $f7be985f79bfefb2$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $f7be985f79bfefb2$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $f7be985f79bfefb2$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $f7be985f79bfefb2$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $f7be985f79bfefb2$var$scope(node) {
    return $f7be985f79bfefb2$var$mergeProxies($f7be985f79bfefb2$var$closestDataStack(node));
}
function $f7be985f79bfefb2$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$f7be985f79bfefb2$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $f7be985f79bfefb2$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $f7be985f79bfefb2$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $f7be985f79bfefb2$var$closestDataStack(node.parentNode);
}
function $f7be985f79bfefb2$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $f7be985f79bfefb2$var$mergeProxyTrap);
}
function $f7be985f79bfefb2$var$keyInPrototypeChain(obj, key) {
    if (obj === null || obj === Object.prototype) return null;
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj;
    return $f7be985f79bfefb2$var$keyInPrototypeChain(Object.getPrototypeOf(obj), key);
}
var $f7be985f79bfefb2$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $f7be985f79bfefb2$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        let target;
        for (const obj of objects){
            target = $f7be985f79bfefb2$var$keyInPrototypeChain(obj, name);
            if (target) break;
        }
        if (!target) target = objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $f7be985f79bfefb2$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $f7be985f79bfefb2$var$initInterceptors(data2, cleanup = ()=>{}) {
    let isObject3 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key, cleanup);
            else if (isObject3(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $f7be985f79bfefb2$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key, cleanup) {
            return callback(this.initialValue, ()=>$f7be985f79bfefb2$var$get(data2, path), (value)=>$f7be985f79bfefb2$var$set(data2, path, value), path, key, cleanup);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key, cleanup)=>{
                let innerValue = initialValue.initialize(data2, path, key, cleanup);
                obj.initialValue = innerValue;
                return initialize(data2, path, key, cleanup);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $f7be985f79bfefb2$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $f7be985f79bfefb2$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $f7be985f79bfefb2$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $f7be985f79bfefb2$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $f7be985f79bfefb2$var$magics = {};
function $f7be985f79bfefb2$var$magic(name, callback) {
    $f7be985f79bfefb2$var$magics[name] = callback;
}
function $f7be985f79bfefb2$var$injectMagics(obj, el) {
    let memoizedUtilities = $f7be985f79bfefb2$var$getUtilities(el);
    Object.entries($f7be985f79bfefb2$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $f7be985f79bfefb2$var$getUtilities(el) {
    let [utilities, cleanup] = $f7be985f79bfefb2$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $f7be985f79bfefb2$var$interceptor,
        ...utilities
    };
    $f7be985f79bfefb2$var$onElRemoved(el, cleanup);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $f7be985f79bfefb2$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $f7be985f79bfefb2$var$handleError(e, el, expression);
    }
}
function $f7be985f79bfefb2$var$handleError(...args) {
    return $f7be985f79bfefb2$var$errorHandler(...args);
}
var $f7be985f79bfefb2$var$errorHandler = $f7be985f79bfefb2$var$normalErrorHandler;
function $f7be985f79bfefb2$var$setErrorHandler(handler4) {
    $f7be985f79bfefb2$var$errorHandler = handler4;
}
function $f7be985f79bfefb2$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $f7be985f79bfefb2$var$shouldAutoEvaluateFunctions = true;
function $f7be985f79bfefb2$var$dontAutoEvaluateFunctions(callback) {
    let cache = $f7be985f79bfefb2$var$shouldAutoEvaluateFunctions;
    $f7be985f79bfefb2$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $f7be985f79bfefb2$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $f7be985f79bfefb2$var$evaluate(el, expression, extras = {}) {
    let result;
    $f7be985f79bfefb2$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $f7be985f79bfefb2$var$evaluateLater(...args) {
    return $f7be985f79bfefb2$var$theEvaluatorFunction(...args);
}
var $f7be985f79bfefb2$var$theEvaluatorFunction = ()=>{};
function $f7be985f79bfefb2$var$setEvaluator(newEvaluator) {
    $f7be985f79bfefb2$var$theEvaluatorFunction = newEvaluator;
}
var $f7be985f79bfefb2$var$theRawEvaluatorFunction;
function $f7be985f79bfefb2$var$setRawEvaluator(newEvaluator) {
    $f7be985f79bfefb2$var$theRawEvaluatorFunction = newEvaluator;
}
function $f7be985f79bfefb2$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $f7be985f79bfefb2$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$f7be985f79bfefb2$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $f7be985f79bfefb2$var$generateEvaluatorFromFunction(dataStack, expression) : $f7be985f79bfefb2$var$generateEvaluatorFromString(dataStack, expression, el);
    return $f7be985f79bfefb2$var$tryCatch.bind(null, el, expression, evaluator);
}
function $f7be985f79bfefb2$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$f7be985f79bfefb2$var$shouldAutoEvaluateFunctions) {
            $f7be985f79bfefb2$var$runIfTypeOfFunction(receiver, func, $f7be985f79bfefb2$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($f7be985f79bfefb2$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $f7be985f79bfefb2$var$runIfTypeOfFunction(receiver, result);
    };
}
var $f7be985f79bfefb2$var$evaluatorMemo = {};
function $f7be985f79bfefb2$var$generateFunctionFromString(expression, el) {
    if ($f7be985f79bfefb2$var$evaluatorMemo[expression]) return $f7be985f79bfefb2$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $f7be985f79bfefb2$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $f7be985f79bfefb2$var$evaluatorMemo[expression] = func;
    return func;
}
function $f7be985f79bfefb2$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $f7be985f79bfefb2$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $f7be985f79bfefb2$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$f7be985f79bfefb2$var$handleError(error2, el, expression));
            if (func.finished) {
                $f7be985f79bfefb2$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $f7be985f79bfefb2$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$f7be985f79bfefb2$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $f7be985f79bfefb2$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($f7be985f79bfefb2$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$f7be985f79bfefb2$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$f7be985f79bfefb2$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $f7be985f79bfefb2$var$evaluateRaw(...args) {
    return $f7be985f79bfefb2$var$theRawEvaluatorFunction(...args);
}
function $f7be985f79bfefb2$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $f7be985f79bfefb2$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$f7be985f79bfefb2$var$closestDataStack(el)
    ];
    let scope2 = $f7be985f79bfefb2$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $f7be985f79bfefb2$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $f7be985f79bfefb2$var$prefixAsString = "x-";
function $f7be985f79bfefb2$var$prefix(subject = "") {
    return $f7be985f79bfefb2$var$prefixAsString + subject;
}
function $f7be985f79bfefb2$var$setPrefix(newPrefix) {
    $f7be985f79bfefb2$var$prefixAsString = newPrefix;
}
var $f7be985f79bfefb2$var$directiveHandlers = {};
function $f7be985f79bfefb2$var$directive(name, callback) {
    $f7be985f79bfefb2$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$f7be985f79bfefb2$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $f7be985f79bfefb2$var$directiveOrder.indexOf(directive2);
            $f7be985f79bfefb2$var$directiveOrder.splice(pos >= 0 ? pos : $f7be985f79bfefb2$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $f7be985f79bfefb2$var$directiveExists(name) {
    return Object.keys($f7be985f79bfefb2$var$directiveHandlers).includes(name);
}
function $f7be985f79bfefb2$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $f7be985f79bfefb2$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($f7be985f79bfefb2$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($f7be985f79bfefb2$var$outNonAlpineAttributes).map($f7be985f79bfefb2$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($f7be985f79bfefb2$var$byPriority);
    return directives2.map((directive2)=>{
        return $f7be985f79bfefb2$var$getDirectiveHandler(el, directive2);
    });
}
function $f7be985f79bfefb2$var$attributesOnly(attributes) {
    return Array.from(attributes).map($f7be985f79bfefb2$var$toTransformedAttributes()).filter((attr)=>!$f7be985f79bfefb2$var$outNonAlpineAttributes(attr));
}
var $f7be985f79bfefb2$var$isDeferringHandlers = false;
var $f7be985f79bfefb2$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $f7be985f79bfefb2$var$currentHandlerStackKey = Symbol();
function $f7be985f79bfefb2$var$deferHandlingDirectives(callback) {
    $f7be985f79bfefb2$var$isDeferringHandlers = true;
    let key = Symbol();
    $f7be985f79bfefb2$var$currentHandlerStackKey = key;
    $f7be985f79bfefb2$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($f7be985f79bfefb2$var$directiveHandlerStacks.get(key).length)$f7be985f79bfefb2$var$directiveHandlerStacks.get(key).shift()();
        $f7be985f79bfefb2$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $f7be985f79bfefb2$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $f7be985f79bfefb2$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect2] = $f7be985f79bfefb2$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect2);
    let utilities = {
        Alpine: $f7be985f79bfefb2$var$alpine_default,
        effect: effect3,
        cleanup: cleanup,
        evaluateLater: $f7be985f79bfefb2$var$evaluateLater.bind($f7be985f79bfefb2$var$evaluateLater, el),
        evaluate: $f7be985f79bfefb2$var$evaluate.bind($f7be985f79bfefb2$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $f7be985f79bfefb2$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $f7be985f79bfefb2$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup] = $f7be985f79bfefb2$var$getElementBoundUtilities(el);
    $f7be985f79bfefb2$var$onAttributeRemoved(el, directive2.original, cleanup);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $f7be985f79bfefb2$var$isDeferringHandlers ? $f7be985f79bfefb2$var$directiveHandlerStacks.get($f7be985f79bfefb2$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup;
    return fullHandler;
}
var $f7be985f79bfefb2$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $f7be985f79bfefb2$var$into = (i)=>i;
function $f7be985f79bfefb2$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $f7be985f79bfefb2$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $f7be985f79bfefb2$var$attributeTransformers = [];
function $f7be985f79bfefb2$var$mapAttributes(callback) {
    $f7be985f79bfefb2$var$attributeTransformers.push(callback);
}
function $f7be985f79bfefb2$var$outNonAlpineAttributes({ name: name }) {
    return $f7be985f79bfefb2$var$alpineAttributeRegex().test(name);
}
var $f7be985f79bfefb2$var$alpineAttributeRegex = ()=>new RegExp(`^${$f7be985f79bfefb2$var$prefixAsString}([^:^.]+)\\b`);
function $f7be985f79bfefb2$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($f7be985f79bfefb2$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $f7be985f79bfefb2$var$DEFAULT = "DEFAULT";
var $f7be985f79bfefb2$var$directiveOrder = [
    "ignore",
    "ref",
    "id",
    "data",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $f7be985f79bfefb2$var$DEFAULT,
    "teleport"
];
function $f7be985f79bfefb2$var$byPriority(a, b) {
    let typeA = $f7be985f79bfefb2$var$directiveOrder.indexOf(a.type) === -1 ? $f7be985f79bfefb2$var$DEFAULT : a.type;
    let typeB = $f7be985f79bfefb2$var$directiveOrder.indexOf(b.type) === -1 ? $f7be985f79bfefb2$var$DEFAULT : b.type;
    return $f7be985f79bfefb2$var$directiveOrder.indexOf(typeA) - $f7be985f79bfefb2$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/walk.js
function $f7be985f79bfefb2$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$f7be985f79bfefb2$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $f7be985f79bfefb2$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/clone.js
var $f7be985f79bfefb2$var$isCloning = false;
function $f7be985f79bfefb2$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$f7be985f79bfefb2$var$isCloning ? fallback(...args) : callback(...args);
}
function $f7be985f79bfefb2$var$onlyDuringClone(callback) {
    return (...args)=>$f7be985f79bfefb2$var$isCloning && callback(...args);
}
var $f7be985f79bfefb2$var$interceptors = [];
function $f7be985f79bfefb2$var$interceptClone(callback) {
    $f7be985f79bfefb2$var$interceptors.push(callback);
}
function $f7be985f79bfefb2$var$cloneNode(from, to) {
    $f7be985f79bfefb2$var$interceptors.forEach((i)=>i(from, to));
    $f7be985f79bfefb2$var$isCloning = true;
    $f7be985f79bfefb2$var$dontRegisterReactiveSideEffects(()=>{
        $f7be985f79bfefb2$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $f7be985f79bfefb2$var$isCloning = false;
}
var $f7be985f79bfefb2$var$isCloningLegacy = false;
function $f7be985f79bfefb2$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $f7be985f79bfefb2$var$isCloning = true;
    $f7be985f79bfefb2$var$isCloningLegacy = true;
    $f7be985f79bfefb2$var$dontRegisterReactiveSideEffects(()=>{
        $f7be985f79bfefb2$var$cloneTree(newEl);
    });
    $f7be985f79bfefb2$var$isCloning = false;
    $f7be985f79bfefb2$var$isCloningLegacy = false;
}
function $f7be985f79bfefb2$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $f7be985f79bfefb2$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $f7be985f79bfefb2$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $f7be985f79bfefb2$var$initTree(el, shallowWalker);
}
function $f7be985f79bfefb2$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $f7be985f79bfefb2$var$effect;
    $f7be985f79bfefb2$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $f7be985f79bfefb2$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $f7be985f79bfefb2$var$overrideEffect(cache);
}
// packages/alpinejs/src/deferInit.js
var $f7be985f79bfefb2$var$activeDefers = 0;
function $f7be985f79bfefb2$var$deferInit(el, promise) {
    let record = el._x_deferInit;
    if (!record) {
        record = el._x_deferInit = {
            pending: 0,
            ownsIgnore: !el._x_ignore,
            queuedAttributes: /* @__PURE__ */ new Map()
        };
        if (record.ownsIgnore) el._x_ignore = true;
        $f7be985f79bfefb2$var$activeDefers++;
    }
    record.pending++;
    Promise.resolve(promise).catch((error2)=>{
        try {
            $f7be985f79bfefb2$var$handleError(error2, el);
        } catch (error3) {
            setTimeout(()=>{
                throw error3;
            }, 0);
        }
    }).then(()=>$f7be985f79bfefb2$var$settle(el, record));
}
function $f7be985f79bfefb2$var$settle(el, record) {
    record.pending--;
    if (record.pending > 0) return;
    $f7be985f79bfefb2$var$flushPendingMutations();
    if (record.pending > 0) return;
    if (el._x_deferInit !== record) return;
    delete el._x_deferInit;
    if (record.ownsIgnore) delete el._x_ignore;
    $f7be985f79bfefb2$var$activeDefers--;
    if (!el.isConnected) return;
    $f7be985f79bfefb2$var$replayQueuedAttributes(record);
    $f7be985f79bfefb2$var$initTree(el);
}
function $f7be985f79bfefb2$var$queueAttributesForDeferredTree(el, attrs) {
    if ($f7be985f79bfefb2$var$activeDefers === 0) return false;
    let root = $f7be985f79bfefb2$var$findClosest(el, (i)=>i._x_deferInit);
    if (!root) return false;
    $f7be985f79bfefb2$var$queueInto(root._x_deferInit, el, attrs.map(({ name: name })=>name));
    return true;
}
function $f7be985f79bfefb2$var$queueInto(record, el, names) {
    let entry = record.queuedAttributes.get(el);
    if (!entry || entry.marker !== el._x_marker) {
        entry = {
            marker: el._x_marker,
            names: /* @__PURE__ */ new Set()
        };
        record.queuedAttributes.set(el, entry);
    }
    names.forEach((name)=>entry.names.add(name));
}
function $f7be985f79bfefb2$var$replayQueuedAttributes(record) {
    record.queuedAttributes.forEach((entry, el)=>{
        if (!el.isConnected) return;
        if (!el._x_marker) return;
        if (el._x_marker !== entry.marker) return;
        let suspendedAncestor = $f7be985f79bfefb2$var$findClosest(el, (i)=>i._x_deferInit);
        if (suspendedAncestor) {
            $f7be985f79bfefb2$var$queueInto(suspendedAncestor._x_deferInit, el, Array.from(entry.names));
            return;
        }
        let attrs = Array.from(entry.names).filter((name)=>el.hasAttribute(name)).map((name)=>({
                name: name,
                value: el.getAttribute(name)
            }));
        if (attrs.length === 0) return;
        $f7be985f79bfefb2$var$directives(el, attrs).forEach((handle)=>handle());
    });
}
$f7be985f79bfefb2$var$interceptClone((from, to)=>{
    if ($f7be985f79bfefb2$var$activeDefers === 0) return;
    if (!from || from.nodeType !== 1 || !to || to.nodeType !== 1) return;
    if ($f7be985f79bfefb2$var$findClosest(from, (i)=>i._x_deferInit)) to._x_ignore = true;
});
// packages/alpinejs/src/utils/dispatch.js
function $f7be985f79bfefb2$var$dispatch(el, name, detail = {}, options = {}) {
    return el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true,
        // Allows overriding the default event options.
        ...options
    }));
}
// packages/alpinejs/src/utils/warn.js
function $f7be985f79bfefb2$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $f7be985f79bfefb2$var$started = false;
function $f7be985f79bfefb2$var$start() {
    if ($f7be985f79bfefb2$var$started) $f7be985f79bfefb2$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $f7be985f79bfefb2$var$started = true;
    if (!document.body) $f7be985f79bfefb2$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $f7be985f79bfefb2$var$dispatch(document, "alpine:init");
    $f7be985f79bfefb2$var$dispatch(document, "alpine:initializing");
    $f7be985f79bfefb2$var$startObservingMutations();
    $f7be985f79bfefb2$var$onElAdded((el)=>$f7be985f79bfefb2$var$initTree(el, $f7be985f79bfefb2$var$walk));
    $f7be985f79bfefb2$var$onElRemoved((el)=>$f7be985f79bfefb2$var$destroyTree(el));
    $f7be985f79bfefb2$var$onAttributesAdded((el, attrs)=>{
        if ($f7be985f79bfefb2$var$queueAttributesForDeferredTree(el, attrs)) return;
        $f7be985f79bfefb2$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$f7be985f79bfefb2$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($f7be985f79bfefb2$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $f7be985f79bfefb2$var$initTree(el);
    });
    $f7be985f79bfefb2$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $f7be985f79bfefb2$var$warnAboutMissingPlugins();
    });
}
var $f7be985f79bfefb2$var$rootSelectorCallbacks = [];
var $f7be985f79bfefb2$var$initSelectorCallbacks = [];
function $f7be985f79bfefb2$var$rootSelectors() {
    return $f7be985f79bfefb2$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $f7be985f79bfefb2$var$allSelectors() {
    return $f7be985f79bfefb2$var$rootSelectorCallbacks.concat($f7be985f79bfefb2$var$initSelectorCallbacks).map((fn)=>fn());
}
function $f7be985f79bfefb2$var$addRootSelector(selectorCallback) {
    $f7be985f79bfefb2$var$rootSelectorCallbacks.push(selectorCallback);
}
function $f7be985f79bfefb2$var$addInitSelector(selectorCallback) {
    $f7be985f79bfefb2$var$initSelectorCallbacks.push(selectorCallback);
}
function $f7be985f79bfefb2$var$closestRoot(el, includeInitSelectors = false) {
    return $f7be985f79bfefb2$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $f7be985f79bfefb2$var$allSelectors() : $f7be985f79bfefb2$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $f7be985f79bfefb2$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) return $f7be985f79bfefb2$var$findClosest(el._x_teleportBack, callback);
    if (el.parentNode instanceof ShadowRoot) return $f7be985f79bfefb2$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $f7be985f79bfefb2$var$findClosest(el.parentElement, callback);
}
function $f7be985f79bfefb2$var$isRoot(el) {
    return $f7be985f79bfefb2$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $f7be985f79bfefb2$var$initInterceptors2 = [];
function $f7be985f79bfefb2$var$interceptInit(callback) {
    $f7be985f79bfefb2$var$initInterceptors2.push(callback);
}
var $f7be985f79bfefb2$var$markerDispenser = 1;
function $f7be985f79bfefb2$var$initTree(el, walker = $f7be985f79bfefb2$var$walk, intercept = ()=>{}) {
    if ($f7be985f79bfefb2$var$findClosest(el, (i)=>i._x_ignore)) return;
    $f7be985f79bfefb2$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $f7be985f79bfefb2$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $f7be985f79bfefb2$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $f7be985f79bfefb2$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $f7be985f79bfefb2$var$destroyTree(root, walker = $f7be985f79bfefb2$var$walk) {
    walker(root, (el)=>{
        $f7be985f79bfefb2$var$cleanupElement(el);
        $f7be985f79bfefb2$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $f7be985f79bfefb2$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($f7be985f79bfefb2$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $f7be985f79bfefb2$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $f7be985f79bfefb2$var$tickStack = [];
var $f7be985f79bfefb2$var$isHolding = false;
function $f7be985f79bfefb2$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $f7be985f79bfefb2$var$isHolding || setTimeout(()=>{
            $f7be985f79bfefb2$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $f7be985f79bfefb2$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $f7be985f79bfefb2$var$releaseNextTicks() {
    $f7be985f79bfefb2$var$isHolding = false;
    while($f7be985f79bfefb2$var$tickStack.length)$f7be985f79bfefb2$var$tickStack.shift()();
}
function $f7be985f79bfefb2$var$holdNextTicks() {
    $f7be985f79bfefb2$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $f7be985f79bfefb2$var$setClasses(el, value) {
    if (Array.isArray(value)) return $f7be985f79bfefb2$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $f7be985f79bfefb2$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $f7be985f79bfefb2$var$setClasses(el, value());
    return $f7be985f79bfefb2$var$setClassesFromString(el, value);
}
function $f7be985f79bfefb2$var$splitClasses(classString) {
    return classString.split(/\s/).filter(Boolean);
}
function $f7be985f79bfefb2$var$setClassesFromString(el, classString) {
    let missingClasses = (classString2)=>$f7be985f79bfefb2$var$splitClasses(classString2).filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $f7be985f79bfefb2$var$setClassesFromObject(el, classObject) {
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? $f7be985f79bfefb2$var$splitClasses(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? $f7be985f79bfefb2$var$splitClasses(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $f7be985f79bfefb2$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $f7be985f79bfefb2$var$setStylesFromObject(el, value);
    return $f7be985f79bfefb2$var$setStylesFromString(el, value);
}
function $f7be985f79bfefb2$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $f7be985f79bfefb2$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $f7be985f79bfefb2$var$setStyles(el, previousStyles);
    };
}
function $f7be985f79bfefb2$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $f7be985f79bfefb2$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $f7be985f79bfefb2$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$f7be985f79bfefb2$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $f7be985f79bfefb2$var$registerTransitionsFromHelper(el, modifiers, value);
    else $f7be985f79bfefb2$var$registerTransitionsFromClassString(el, expression, value);
});
function $f7be985f79bfefb2$var$registerTransitionsFromClassString(el, classString, stage) {
    $f7be985f79bfefb2$var$registerTransitionObject(el, $f7be985f79bfefb2$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $f7be985f79bfefb2$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $f7be985f79bfefb2$var$registerTransitionObject(el, $f7be985f79bfefb2$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $f7be985f79bfefb2$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $f7be985f79bfefb2$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $f7be985f79bfefb2$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $f7be985f79bfefb2$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $f7be985f79bfefb2$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $f7be985f79bfefb2$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $f7be985f79bfefb2$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $f7be985f79bfefb2$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $f7be985f79bfefb2$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $f7be985f79bfefb2$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $f7be985f79bfefb2$var$closestHide(parent);
}
function $f7be985f79bfefb2$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $f7be985f79bfefb2$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $f7be985f79bfefb2$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $f7be985f79bfefb2$var$once(()=>{
        $f7be985f79bfefb2$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $f7be985f79bfefb2$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $f7be985f79bfefb2$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $f7be985f79bfefb2$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $f7be985f79bfefb2$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $f7be985f79bfefb2$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $f7be985f79bfefb2$var$mutateDom(()=>{
                stages.end();
            });
            $f7be985f79bfefb2$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $f7be985f79bfefb2$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/utils/bind.js
function $f7be985f79bfefb2$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $f7be985f79bfefb2$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $f7be985f79bfefb2$var$camelCase(name) : name;
    switch(name){
        case "value":
            $f7be985f79bfefb2$var$bindInputValue(el, value);
            break;
        case "style":
            $f7be985f79bfefb2$var$bindStyles(el, value);
            break;
        case "class":
            $f7be985f79bfefb2$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $f7be985f79bfefb2$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $f7be985f79bfefb2$var$bindAttribute(el, name, value);
            break;
    }
}
function $f7be985f79bfefb2$var$bindInputValue(el, value) {
    if ($f7be985f79bfefb2$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
    } else if ($f7be985f79bfefb2$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$f7be985f79bfefb2$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $f7be985f79bfefb2$var$updateSelect(el, value);
    else if (el.tagName === "OPTION") $f7be985f79bfefb2$var$bindAttribute(el, "value", value);
    else {
        if (el.value === value && (typeof value !== "object" || value === null)) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $f7be985f79bfefb2$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $f7be985f79bfefb2$var$setClasses(el, value);
}
function $f7be985f79bfefb2$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $f7be985f79bfefb2$var$setStyles(el, value);
}
function $f7be985f79bfefb2$var$bindAttributeAndProperty(el, name, value) {
    $f7be985f79bfefb2$var$bindAttribute(el, name, value);
    $f7be985f79bfefb2$var$setPropertyIfChanged(el, name, value);
}
function $f7be985f79bfefb2$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $f7be985f79bfefb2$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($f7be985f79bfefb2$var$isBooleanAttr(name)) value = name;
        if ($f7be985f79bfefb2$var$isObjectAttr(value)) value = JSON.stringify(value);
        $f7be985f79bfefb2$var$setIfChanged(el, name, value);
    }
}
function $f7be985f79bfefb2$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $f7be985f79bfefb2$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $f7be985f79bfefb2$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $f7be985f79bfefb2$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f7be985f79bfefb2$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $f7be985f79bfefb2$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $f7be985f79bfefb2$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $f7be985f79bfefb2$var$isBooleanAttr(attrName) {
    return $f7be985f79bfefb2$var$booleanAttributes.has(attrName);
}
function $f7be985f79bfefb2$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $f7be985f79bfefb2$var$isObjectAttr(value) {
    return typeof value === "object" && value !== null;
}
function $f7be985f79bfefb2$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $f7be985f79bfefb2$var$getAttributeBinding(el, name, fallback);
}
function $f7be985f79bfefb2$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $f7be985f79bfefb2$var$dontAutoEvaluateFunctions(()=>{
            return $f7be985f79bfefb2$var$evaluate(el, binding.expression);
        });
    }
    return $f7be985f79bfefb2$var$getAttributeBinding(el, name, fallback);
}
function $f7be985f79bfefb2$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($f7be985f79bfefb2$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $f7be985f79bfefb2$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $f7be985f79bfefb2$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $f7be985f79bfefb2$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $f7be985f79bfefb2$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $f7be985f79bfefb2$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $f7be985f79bfefb2$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($f7be985f79bfefb2$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($f7be985f79bfefb2$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($f7be985f79bfefb2$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $f7be985f79bfefb2$var$dequeueJob(reference);
        $f7be985f79bfefb2$var$release(reference);
    };
}
function $f7be985f79bfefb2$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $f7be985f79bfefb2$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($f7be985f79bfefb2$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $f7be985f79bfefb2$var$stores = {};
var $f7be985f79bfefb2$var$isReactive = false;
function $f7be985f79bfefb2$var$store(name, value) {
    if (!$f7be985f79bfefb2$var$isReactive) {
        $f7be985f79bfefb2$var$stores = $f7be985f79bfefb2$var$reactive($f7be985f79bfefb2$var$stores);
        $f7be985f79bfefb2$var$isReactive = true;
    }
    if (value === void 0) return $f7be985f79bfefb2$var$stores[name];
    $f7be985f79bfefb2$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value._x_interceptor) $f7be985f79bfefb2$var$stores[name] = value.initialize($f7be985f79bfefb2$var$stores, name, name, ()=>{});
    else $f7be985f79bfefb2$var$initInterceptors($f7be985f79bfefb2$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $f7be985f79bfefb2$var$stores[name].init();
}
function $f7be985f79bfefb2$var$getStores() {
    return $f7be985f79bfefb2$var$stores;
}
// packages/alpinejs/src/binds.js
var $f7be985f79bfefb2$var$binds = {};
function $f7be985f79bfefb2$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $f7be985f79bfefb2$var$applyBindingsObject(name, getBindings());
    else $f7be985f79bfefb2$var$binds[name] = getBindings;
    return ()=>{};
}
function $f7be985f79bfefb2$var$injectBindingProviders(obj) {
    Object.entries($f7be985f79bfefb2$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $f7be985f79bfefb2$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $f7be985f79bfefb2$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $f7be985f79bfefb2$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $f7be985f79bfefb2$var$datas = {};
function $f7be985f79bfefb2$var$data(name, callback) {
    $f7be985f79bfefb2$var$datas[name] = callback;
}
function $f7be985f79bfefb2$var$injectDataProviders(obj, context) {
    Object.entries($f7be985f79bfefb2$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $f7be985f79bfefb2$var$Alpine = {
    get reactive () {
        return $f7be985f79bfefb2$var$reactive;
    },
    get release () {
        return $f7be985f79bfefb2$var$release;
    },
    get effect () {
        return $f7be985f79bfefb2$var$effect;
    },
    get raw () {
        return $f7be985f79bfefb2$var$raw;
    },
    get transaction () {
        return $f7be985f79bfefb2$var$transaction;
    },
    version: "3.17.5",
    flushAndStopDeferringMutations: $f7be985f79bfefb2$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $f7be985f79bfefb2$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $f7be985f79bfefb2$var$disableEffectScheduling,
    startObservingMutations: $f7be985f79bfefb2$var$startObservingMutations,
    stopObservingMutations: $f7be985f79bfefb2$var$stopObservingMutations,
    setReactivityEngine: $f7be985f79bfefb2$var$setReactivityEngine,
    onAttributeRemoved: $f7be985f79bfefb2$var$onAttributeRemoved,
    onAttributesAdded: $f7be985f79bfefb2$var$onAttributesAdded,
    closestDataStack: $f7be985f79bfefb2$var$closestDataStack,
    skipDuringClone: $f7be985f79bfefb2$var$skipDuringClone,
    onlyDuringClone: $f7be985f79bfefb2$var$onlyDuringClone,
    addRootSelector: $f7be985f79bfefb2$var$addRootSelector,
    addInitSelector: $f7be985f79bfefb2$var$addInitSelector,
    setErrorHandler: $f7be985f79bfefb2$var$setErrorHandler,
    interceptClone: $f7be985f79bfefb2$var$interceptClone,
    addScopeToNode: $f7be985f79bfefb2$var$addScopeToNode,
    deferMutations: $f7be985f79bfefb2$var$deferMutations,
    mapAttributes: $f7be985f79bfefb2$var$mapAttributes,
    evaluateLater: $f7be985f79bfefb2$var$evaluateLater,
    interceptInit: $f7be985f79bfefb2$var$interceptInit,
    initInterceptors: $f7be985f79bfefb2$var$initInterceptors,
    injectMagics: $f7be985f79bfefb2$var$injectMagics,
    setEvaluator: $f7be985f79bfefb2$var$setEvaluator,
    setRawEvaluator: $f7be985f79bfefb2$var$setRawEvaluator,
    mergeProxies: $f7be985f79bfefb2$var$mergeProxies,
    extractProp: $f7be985f79bfefb2$var$extractProp,
    findClosest: $f7be985f79bfefb2$var$findClosest,
    onElRemoved: $f7be985f79bfefb2$var$onElRemoved,
    closestRoot: $f7be985f79bfefb2$var$closestRoot,
    destroyTree: $f7be985f79bfefb2$var$destroyTree,
    interceptor: $f7be985f79bfefb2$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $f7be985f79bfefb2$var$transition,
    setStyles: // INTERNAL
    $f7be985f79bfefb2$var$setStyles,
    mutateDom: // INTERNAL
    $f7be985f79bfefb2$var$mutateDom,
    deferInit: $f7be985f79bfefb2$var$deferInit,
    directive: $f7be985f79bfefb2$var$directive,
    entangle: $f7be985f79bfefb2$var$entangle,
    throttle: $f7be985f79bfefb2$var$throttle,
    debounce: $f7be985f79bfefb2$var$debounce,
    evaluate: $f7be985f79bfefb2$var$evaluate,
    evaluateRaw: $f7be985f79bfefb2$var$evaluateRaw,
    initTree: $f7be985f79bfefb2$var$initTree,
    nextTick: $f7be985f79bfefb2$var$nextTick,
    prefixed: $f7be985f79bfefb2$var$prefix,
    prefix: $f7be985f79bfefb2$var$setPrefix,
    plugin: $f7be985f79bfefb2$var$plugin,
    magic: $f7be985f79bfefb2$var$magic,
    store: $f7be985f79bfefb2$var$store,
    start: $f7be985f79bfefb2$var$start,
    clone: $f7be985f79bfefb2$var$clone,
    cloneNode: // INTERNAL
    $f7be985f79bfefb2$var$cloneNode,
    // INTERNAL
    bound: $f7be985f79bfefb2$var$getBinding,
    $data: $f7be985f79bfefb2$var$scope,
    watch: $f7be985f79bfefb2$var$watch,
    walk: $f7be985f79bfefb2$var$walk,
    data: $f7be985f79bfefb2$var$data,
    bind: $f7be985f79bfefb2$var$bind2
};
var $f7be985f79bfefb2$var$alpine_default = $f7be985f79bfefb2$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $f7be985f79bfefb2$var$makeMap(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
var $f7be985f79bfefb2$var$EMPTY_OBJ = Object.freeze({});
var $f7be985f79bfefb2$var$EMPTY_ARR = Object.freeze([]);
var $f7be985f79bfefb2$var$extend = Object.assign;
var $f7be985f79bfefb2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f7be985f79bfefb2$var$hasOwn = (val, key)=>$f7be985f79bfefb2$var$hasOwnProperty.call(val, key);
var $f7be985f79bfefb2$var$isArray = Array.isArray;
var $f7be985f79bfefb2$var$isMap = (val)=>$f7be985f79bfefb2$var$toTypeString(val) === "[object Map]";
var $f7be985f79bfefb2$var$isString = (val)=>typeof val === "string";
var $f7be985f79bfefb2$var$isSymbol = (val)=>typeof val === "symbol";
var $f7be985f79bfefb2$var$isObject = (val)=>val !== null && typeof val === "object";
var $f7be985f79bfefb2$var$objectToString = Object.prototype.toString;
var $f7be985f79bfefb2$var$toTypeString = (value)=>$f7be985f79bfefb2$var$objectToString.call(value);
var $f7be985f79bfefb2$var$toRawType = (value)=>{
    return $f7be985f79bfefb2$var$toTypeString(value).slice(8, -1);
};
var $f7be985f79bfefb2$var$isIntegerKey = (key)=>$f7be985f79bfefb2$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $f7be985f79bfefb2$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $f7be985f79bfefb2$var$camelizeRE = /-\w/g;
var $f7be985f79bfefb2$var$camelize = $f7be985f79bfefb2$var$cacheStringFunction((str)=>{
    return str.replace($f7be985f79bfefb2$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
var $f7be985f79bfefb2$var$hyphenateRE = /\B([A-Z])/g;
var $f7be985f79bfefb2$var$hyphenate = $f7be985f79bfefb2$var$cacheStringFunction((str)=>str.replace($f7be985f79bfefb2$var$hyphenateRE, "-$1").toLowerCase());
var $f7be985f79bfefb2$var$capitalize = $f7be985f79bfefb2$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var $f7be985f79bfefb2$var$toHandlerKey = $f7be985f79bfefb2$var$cacheStringFunction((str)=>{
    const s = str ? `on${$f7be985f79bfefb2$var$capitalize(str)}` : ``;
    return s;
});
var $f7be985f79bfefb2$var$hasChanged = (value, oldValue)=>!Object.is(value, oldValue);
var $f7be985f79bfefb2$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $f7be985f79bfefb2$var$isBooleanAttr2 = /* @__PURE__ */ $f7be985f79bfefb2$var$makeMap($f7be985f79bfefb2$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
function $f7be985f79bfefb2$var$warn2(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
var $f7be985f79bfefb2$var$activeEffectScope;
var $f7be985f79bfefb2$var$activeSub;
var $f7be985f79bfefb2$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
var $f7be985f79bfefb2$var$ReactiveEffect = class {
    constructor(fn){
        this.fn = fn;
        this.deps = void 0;
        this.depsTail = void 0;
        this.flags = 5;
        this.next = void 0;
        this.cleanup = void 0;
        this.scheduler = void 0;
        if ($f7be985f79bfefb2$var$activeEffectScope) {
            if ($f7be985f79bfefb2$var$activeEffectScope.active) $f7be985f79bfefb2$var$activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($f7be985f79bfefb2$var$pausedQueueEffects.has(this)) {
                $f7be985f79bfefb2$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $f7be985f79bfefb2$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $f7be985f79bfefb2$var$cleanupEffect(this);
        $f7be985f79bfefb2$var$prepareDeps(this);
        const prevEffect = $f7be985f79bfefb2$var$activeSub;
        const prevShouldTrack = $f7be985f79bfefb2$var$shouldTrack;
        $f7be985f79bfefb2$var$activeSub = this;
        $f7be985f79bfefb2$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            if ($f7be985f79bfefb2$var$activeSub !== this) $f7be985f79bfefb2$var$warn2("Active effect was not restored correctly - this is likely a Vue internal bug.");
            $f7be985f79bfefb2$var$cleanupDeps(this);
            $f7be985f79bfefb2$var$activeSub = prevEffect;
            $f7be985f79bfefb2$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$f7be985f79bfefb2$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $f7be985f79bfefb2$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $f7be985f79bfefb2$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($f7be985f79bfefb2$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $f7be985f79bfefb2$var$isDirty(this);
    }
};
var $f7be985f79bfefb2$var$batchDepth = 0;
var $f7be985f79bfefb2$var$batchedSub;
var $f7be985f79bfefb2$var$batchedComputed;
function $f7be985f79bfefb2$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $f7be985f79bfefb2$var$batchedComputed;
        $f7be985f79bfefb2$var$batchedComputed = sub;
        return;
    }
    sub.next = $f7be985f79bfefb2$var$batchedSub;
    $f7be985f79bfefb2$var$batchedSub = sub;
}
function $f7be985f79bfefb2$var$startBatch() {
    $f7be985f79bfefb2$var$batchDepth++;
}
function $f7be985f79bfefb2$var$endBatch() {
    if (--$f7be985f79bfefb2$var$batchDepth > 0) return;
    if ($f7be985f79bfefb2$var$batchedComputed) {
        let e = $f7be985f79bfefb2$var$batchedComputed;
        $f7be985f79bfefb2$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error2;
    while($f7be985f79bfefb2$var$batchedSub){
        let e = $f7be985f79bfefb2$var$batchedSub;
        $f7be985f79bfefb2$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error2) error2 = err;
            }
            e = next;
        }
    }
    if (error2) throw error2;
}
function $f7be985f79bfefb2$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $f7be985f79bfefb2$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $f7be985f79bfefb2$var$removeSub(link);
            $f7be985f79bfefb2$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $f7be985f79bfefb2$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($f7be985f79bfefb2$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $f7be985f79bfefb2$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $f7be985f79bfefb2$var$globalVersion) return;
    computed.globalVersion = $f7be985f79bfefb2$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$f7be985f79bfefb2$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $f7be985f79bfefb2$var$activeSub;
    const prevShouldTrack = $f7be985f79bfefb2$var$shouldTrack;
    $f7be985f79bfefb2$var$activeSub = computed;
    $f7be985f79bfefb2$var$shouldTrack = true;
    try {
        $f7be985f79bfefb2$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || $f7be985f79bfefb2$var$hasChanged(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $f7be985f79bfefb2$var$activeSub = prevSub;
        $f7be985f79bfefb2$var$shouldTrack = prevShouldTrack;
        $f7be985f79bfefb2$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $f7be985f79bfefb2$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subsHead === link) dep.subsHead = nextSub;
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$f7be985f79bfefb2$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $f7be985f79bfefb2$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $f7be985f79bfefb2$var$effect2(fn, options) {
    if (fn.effect instanceof $f7be985f79bfefb2$var$ReactiveEffect) fn = fn.effect.fn;
    const e = new $f7be985f79bfefb2$var$ReactiveEffect(fn);
    if (options) $f7be985f79bfefb2$var$extend(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $f7be985f79bfefb2$var$stop(runner) {
    runner.effect.stop();
}
var $f7be985f79bfefb2$var$shouldTrack = true;
var $f7be985f79bfefb2$var$trackStack = [];
function $f7be985f79bfefb2$var$pauseTracking() {
    $f7be985f79bfefb2$var$trackStack.push($f7be985f79bfefb2$var$shouldTrack);
    $f7be985f79bfefb2$var$shouldTrack = false;
}
function $f7be985f79bfefb2$var$resetTracking() {
    const last = $f7be985f79bfefb2$var$trackStack.pop();
    $f7be985f79bfefb2$var$shouldTrack = last === void 0 ? true : last;
}
function $f7be985f79bfefb2$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $f7be985f79bfefb2$var$activeSub;
        $f7be985f79bfefb2$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $f7be985f79bfefb2$var$activeSub = prevSub;
        }
    }
}
var $f7be985f79bfefb2$var$globalVersion = 0;
var $f7be985f79bfefb2$var$Link = class {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
};
var $f7be985f79bfefb2$var$Dep = class {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        this.activeLink = void 0;
        this.subs = void 0;
        this.map = void 0;
        this.key = void 0;
        this.sc = 0;
        this.__v_skip = true;
        this.subsHead = void 0;
    }
    track(debugInfo) {
        if (!$f7be985f79bfefb2$var$activeSub || !$f7be985f79bfefb2$var$shouldTrack || $f7be985f79bfefb2$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $f7be985f79bfefb2$var$activeSub) {
            link = this.activeLink = new $f7be985f79bfefb2$var$Link($f7be985f79bfefb2$var$activeSub, this);
            if (!$f7be985f79bfefb2$var$activeSub.deps) $f7be985f79bfefb2$var$activeSub.deps = $f7be985f79bfefb2$var$activeSub.depsTail = link;
            else {
                link.prevDep = $f7be985f79bfefb2$var$activeSub.depsTail;
                $f7be985f79bfefb2$var$activeSub.depsTail.nextDep = link;
                $f7be985f79bfefb2$var$activeSub.depsTail = link;
            }
            $f7be985f79bfefb2$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $f7be985f79bfefb2$var$activeSub.depsTail;
                link.nextDep = void 0;
                $f7be985f79bfefb2$var$activeSub.depsTail.nextDep = link;
                $f7be985f79bfefb2$var$activeSub.depsTail = link;
                if ($f7be985f79bfefb2$var$activeSub.deps === link) $f7be985f79bfefb2$var$activeSub.deps = next;
            }
        }
        if ($f7be985f79bfefb2$var$activeSub.onTrack) $f7be985f79bfefb2$var$activeSub.onTrack($f7be985f79bfefb2$var$extend({
            effect: $f7be985f79bfefb2$var$activeSub
        }, debugInfo));
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $f7be985f79bfefb2$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $f7be985f79bfefb2$var$startBatch();
        try {
            for(let head = this.subsHead; head; head = head.nextSub)if (head.sub.onTrigger && !(head.sub.flags & 8)) head.sub.onTrigger($f7be985f79bfefb2$var$extend({
                effect: head.sub
            }, debugInfo));
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $f7be985f79bfefb2$var$endBatch();
        }
    }
};
function $f7be985f79bfefb2$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$f7be985f79bfefb2$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        if (link.dep.subsHead === void 0) link.dep.subsHead = link;
        link.dep.subs = link;
    }
}
var $f7be985f79bfefb2$var$targetMap = /* @__PURE__ */ new WeakMap();
var $f7be985f79bfefb2$var$ITERATE_KEY = /* @__PURE__ */ Symbol("Object iterate");
var $f7be985f79bfefb2$var$MAP_KEY_ITERATE_KEY = /* @__PURE__ */ Symbol("Map keys iterate");
var $f7be985f79bfefb2$var$ARRAY_ITERATE_KEY = /* @__PURE__ */ Symbol("Array iterate");
function $f7be985f79bfefb2$var$track(target, type, key) {
    if ($f7be985f79bfefb2$var$shouldTrack && $f7be985f79bfefb2$var$activeSub) {
        let depsMap = $f7be985f79bfefb2$var$targetMap.get(target);
        if (!depsMap) $f7be985f79bfefb2$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $f7be985f79bfefb2$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track({
            target: target,
            type: type,
            key: key
        });
    }
}
function $f7be985f79bfefb2$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $f7be985f79bfefb2$var$targetMap.get(target);
    if (!depsMap) {
        $f7be985f79bfefb2$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger({
            target: target,
            type: type,
            key: key,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
    };
    $f7be985f79bfefb2$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = $f7be985f79bfefb2$var$isArray(target);
        const isArrayIndex = targetIsArray && $f7be985f79bfefb2$var$isIntegerKey(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $f7be985f79bfefb2$var$ARRAY_ITERATE_KEY || !$f7be985f79bfefb2$var$isSymbol(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($f7be985f79bfefb2$var$ARRAY_ITERATE_KEY));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($f7be985f79bfefb2$var$ITERATE_KEY));
                        if ($f7be985f79bfefb2$var$isMap(target)) run(depsMap.get($f7be985f79bfefb2$var$MAP_KEY_ITERATE_KEY));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($f7be985f79bfefb2$var$ITERATE_KEY));
                        if ($f7be985f79bfefb2$var$isMap(target)) run(depsMap.get($f7be985f79bfefb2$var$MAP_KEY_ITERATE_KEY));
                    }
                    break;
                case "set":
                    if ($f7be985f79bfefb2$var$isMap(target)) run(depsMap.get($f7be985f79bfefb2$var$ITERATE_KEY));
                    break;
            }
        }
    }
    $f7be985f79bfefb2$var$endBatch();
}
function $f7be985f79bfefb2$var$reactiveReadArray(array) {
    const raw2 = $f7be985f79bfefb2$var$toRaw(array);
    if (raw2 === array) return raw2;
    $f7be985f79bfefb2$var$track(raw2, "iterate", $f7be985f79bfefb2$var$ARRAY_ITERATE_KEY);
    return $f7be985f79bfefb2$var$isShallow(array) ? raw2 : raw2.map($f7be985f79bfefb2$var$toReactive);
}
function $f7be985f79bfefb2$var$shallowReadArray(arr) {
    $f7be985f79bfefb2$var$track(arr = $f7be985f79bfefb2$var$toRaw(arr), "iterate", $f7be985f79bfefb2$var$ARRAY_ITERATE_KEY);
    return arr;
}
function $f7be985f79bfefb2$var$toWrapped(target, item) {
    if ($f7be985f79bfefb2$var$isReadonly(target)) return $f7be985f79bfefb2$var$isReactive2(target) ? $f7be985f79bfefb2$var$toReadonly($f7be985f79bfefb2$var$toReactive(item)) : $f7be985f79bfefb2$var$toReadonly(item);
    return $f7be985f79bfefb2$var$toReactive(item);
}
var $f7be985f79bfefb2$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $f7be985f79bfefb2$var$iterator(this, Symbol.iterator, (item)=>$f7be985f79bfefb2$var$toWrapped(this, item));
    },
    concat (...args) {
        return $f7be985f79bfefb2$var$reactiveReadArray(this).concat(...args.map((x)=>$f7be985f79bfefb2$var$isArray(x) ? $f7be985f79bfefb2$var$reactiveReadArray(x) : x));
    },
    entries () {
        return $f7be985f79bfefb2$var$iterator(this, "entries", (value)=>{
            value[1] = $f7be985f79bfefb2$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $f7be985f79bfefb2$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $f7be985f79bfefb2$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$f7be985f79bfefb2$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $f7be985f79bfefb2$var$apply(this, "find", fn, thisArg, (item)=>$f7be985f79bfefb2$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $f7be985f79bfefb2$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $f7be985f79bfefb2$var$apply(this, "findLast", fn, thisArg, (item)=>$f7be985f79bfefb2$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $f7be985f79bfefb2$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $f7be985f79bfefb2$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $f7be985f79bfefb2$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $f7be985f79bfefb2$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $f7be985f79bfefb2$var$reactiveReadArray(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $f7be985f79bfefb2$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $f7be985f79bfefb2$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $f7be985f79bfefb2$var$noTracking(this, "pop");
    },
    push (...args) {
        return $f7be985f79bfefb2$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $f7be985f79bfefb2$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $f7be985f79bfefb2$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $f7be985f79bfefb2$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $f7be985f79bfefb2$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $f7be985f79bfefb2$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $f7be985f79bfefb2$var$reactiveReadArray(this).toReversed();
    },
    toSorted (comparer) {
        return $f7be985f79bfefb2$var$reactiveReadArray(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $f7be985f79bfefb2$var$reactiveReadArray(this).toSpliced(...args);
    },
    unshift (...args) {
        return $f7be985f79bfefb2$var$noTracking(this, "unshift", args);
    },
    values () {
        return $f7be985f79bfefb2$var$iterator(this, "values", (item)=>$f7be985f79bfefb2$var$toWrapped(this, item));
    }
};
function $f7be985f79bfefb2$var$iterator(self2, method, wrapValue) {
    const arr = $f7be985f79bfefb2$var$shallowReadArray(self2);
    const iter = arr[method]();
    if (arr !== self2 && !$f7be985f79bfefb2$var$isShallow(self2)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
var $f7be985f79bfefb2$var$arrayProto = Array.prototype;
function $f7be985f79bfefb2$var$apply(self2, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $f7be985f79bfefb2$var$shallowReadArray(self2);
    const needsWrap = arr !== self2 && !$f7be985f79bfefb2$var$isShallow(self2);
    const methodFn = arr[method];
    if (methodFn !== $f7be985f79bfefb2$var$arrayProto[method]) {
        const result2 = methodFn.apply(self2, args);
        return needsWrap ? $f7be985f79bfefb2$var$toReactive(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self2) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $f7be985f79bfefb2$var$toWrapped(self2, item), index, self2);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self2);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $f7be985f79bfefb2$var$reduce(self2, method, fn, args) {
    const arr = $f7be985f79bfefb2$var$shallowReadArray(self2);
    const needsWrap = arr !== self2 && !$f7be985f79bfefb2$var$isShallow(self2);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self2) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $f7be985f79bfefb2$var$toWrapped(self2, acc);
                }
                return fn.call(this, acc, $f7be985f79bfefb2$var$toWrapped(self2, item), index, self2);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self2);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $f7be985f79bfefb2$var$toWrapped(self2, result) : result;
}
function $f7be985f79bfefb2$var$searchProxy(self2, method, args) {
    const arr = $f7be985f79bfefb2$var$toRaw(self2);
    $f7be985f79bfefb2$var$track(arr, "iterate", $f7be985f79bfefb2$var$ARRAY_ITERATE_KEY);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $f7be985f79bfefb2$var$isProxy(args[0])) {
        args[0] = $f7be985f79bfefb2$var$toRaw(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $f7be985f79bfefb2$var$noTracking(self2, method, args = []) {
    $f7be985f79bfefb2$var$pauseTracking();
    $f7be985f79bfefb2$var$startBatch();
    const res = $f7be985f79bfefb2$var$toRaw(self2)[method].apply(self2, args);
    $f7be985f79bfefb2$var$endBatch();
    $f7be985f79bfefb2$var$resetTracking();
    return res;
}
var $f7be985f79bfefb2$var$isNonTrackableKeys = /* @__PURE__ */ $f7be985f79bfefb2$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $f7be985f79bfefb2$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter($f7be985f79bfefb2$var$isSymbol));
function $f7be985f79bfefb2$var$hasOwnProperty2(key) {
    if (!$f7be985f79bfefb2$var$isSymbol(key)) key = String(key);
    const obj = $f7be985f79bfefb2$var$toRaw(this);
    $f7be985f79bfefb2$var$track(obj, "has", key);
    return obj.hasOwnProperty(key);
}
var $f7be985f79bfefb2$var$BaseReactiveHandler = class {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $f7be985f79bfefb2$var$shallowReadonlyMap : $f7be985f79bfefb2$var$readonlyMap : isShallow2 ? $f7be985f79bfefb2$var$shallowReactiveMap : $f7be985f79bfefb2$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = $f7be985f79bfefb2$var$isArray(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $f7be985f79bfefb2$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $f7be985f79bfefb2$var$hasOwnProperty2;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $f7be985f79bfefb2$var$isRef(target) ? target : receiver);
        if ($f7be985f79bfefb2$var$isSymbol(key) ? $f7be985f79bfefb2$var$builtInSymbols.has(key) : $f7be985f79bfefb2$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $f7be985f79bfefb2$var$track(target, "get", key);
        if (isShallow2) return res;
        if ($f7be985f79bfefb2$var$isRef(res)) {
            const value = targetIsArray && $f7be985f79bfefb2$var$isIntegerKey(key) ? res : res.value;
            return isReadonly2 && $f7be985f79bfefb2$var$isObject(value) ? $f7be985f79bfefb2$var$readonly(value) : value;
        }
        if ($f7be985f79bfefb2$var$isObject(res)) return isReadonly2 ? $f7be985f79bfefb2$var$readonly(res) : $f7be985f79bfefb2$var$reactive2(res);
        return res;
    }
};
var $f7be985f79bfefb2$var$MutableReactiveHandler = class extends $f7be985f79bfefb2$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = $f7be985f79bfefb2$var$isArray(target) && $f7be985f79bfefb2$var$isIntegerKey(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $f7be985f79bfefb2$var$isReadonly(oldValue);
            if (!$f7be985f79bfefb2$var$isShallow(value) && !$f7be985f79bfefb2$var$isReadonly(value)) {
                oldValue = $f7be985f79bfefb2$var$toRaw(oldValue);
                value = $f7be985f79bfefb2$var$toRaw(value);
            }
            if (!isArrayWithIntegerKey && $f7be985f79bfefb2$var$isRef(oldValue) && !$f7be985f79bfefb2$var$isRef(value)) {
                if (isOldValueReadonly) {
                    $f7be985f79bfefb2$var$warn2(`Set operation on key "${String(key)}" failed: target is readonly.`, target[key]);
                    return true;
                } else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : $f7be985f79bfefb2$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, $f7be985f79bfefb2$var$isRef(target) ? target : receiver);
        if (target === $f7be985f79bfefb2$var$toRaw(receiver) && result) {
            if (!hadKey) $f7be985f79bfefb2$var$trigger(target, "add", key, value);
            else if ($f7be985f79bfefb2$var$hasChanged(value, oldValue)) $f7be985f79bfefb2$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = $f7be985f79bfefb2$var$hasOwn(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $f7be985f79bfefb2$var$trigger(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!$f7be985f79bfefb2$var$isSymbol(key) || !$f7be985f79bfefb2$var$builtInSymbols.has(key)) $f7be985f79bfefb2$var$track(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $f7be985f79bfefb2$var$track(target, "iterate", $f7be985f79bfefb2$var$isArray(target) ? "length" : $f7be985f79bfefb2$var$ITERATE_KEY);
        return Reflect.ownKeys(target);
    }
};
var $f7be985f79bfefb2$var$ReadonlyReactiveHandler = class extends $f7be985f79bfefb2$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        $f7be985f79bfefb2$var$warn2(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
    deleteProperty(target, key) {
        $f7be985f79bfefb2$var$warn2(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $f7be985f79bfefb2$var$mutableHandlers = /* @__PURE__ */ new $f7be985f79bfefb2$var$MutableReactiveHandler();
var $f7be985f79bfefb2$var$readonlyHandlers = /* @__PURE__ */ new $f7be985f79bfefb2$var$ReadonlyReactiveHandler();
var $f7be985f79bfefb2$var$toShallow = (value)=>value;
var $f7be985f79bfefb2$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $f7be985f79bfefb2$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $f7be985f79bfefb2$var$toRaw(target);
        const targetIsMap = $f7be985f79bfefb2$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $f7be985f79bfefb2$var$toShallow : isReadonly2 ? $f7be985f79bfefb2$var$toReadonly : $f7be985f79bfefb2$var$toReactive;
        !isReadonly2 && $f7be985f79bfefb2$var$track(rawTarget, "iterate", isKeyOnly ? $f7be985f79bfefb2$var$MAP_KEY_ITERATE_KEY : $f7be985f79bfefb2$var$ITERATE_KEY);
        return $f7be985f79bfefb2$var$extend(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $f7be985f79bfefb2$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            $f7be985f79bfefb2$var$warn2(`${$f7be985f79bfefb2$var$capitalize(type)} operation ${key}failed: target is readonly.`, $f7be985f79bfefb2$var$toRaw(this));
        }
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $f7be985f79bfefb2$var$createInstrumentations(readonly2, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $f7be985f79bfefb2$var$toRaw(target);
            const rawKey = $f7be985f79bfefb2$var$toRaw(key);
            if (!readonly2) {
                if ($f7be985f79bfefb2$var$hasChanged(key, rawKey)) $f7be985f79bfefb2$var$track(rawTarget, "get", key);
                $f7be985f79bfefb2$var$track(rawTarget, "get", rawKey);
            }
            const { has: has } = $f7be985f79bfefb2$var$getProto(rawTarget);
            const wrap = shallow ? $f7be985f79bfefb2$var$toShallow : readonly2 ? $f7be985f79bfefb2$var$toReadonly : $f7be985f79bfefb2$var$toReactive;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly2 && $f7be985f79bfefb2$var$track($f7be985f79bfefb2$var$toRaw(target), "iterate", $f7be985f79bfefb2$var$ITERATE_KEY);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $f7be985f79bfefb2$var$toRaw(target);
            const rawKey = $f7be985f79bfefb2$var$toRaw(key);
            if (!readonly2) {
                if ($f7be985f79bfefb2$var$hasChanged(key, rawKey)) $f7be985f79bfefb2$var$track(rawTarget, "has", key);
                $f7be985f79bfefb2$var$track(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $f7be985f79bfefb2$var$toRaw(target);
            const wrap = shallow ? $f7be985f79bfefb2$var$toShallow : readonly2 ? $f7be985f79bfefb2$var$toReadonly : $f7be985f79bfefb2$var$toReactive;
            !readonly2 && $f7be985f79bfefb2$var$track(rawTarget, "iterate", $f7be985f79bfefb2$var$ITERATE_KEY);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    $f7be985f79bfefb2$var$extend(instrumentations, readonly2 ? {
        add: $f7be985f79bfefb2$var$createReadonlyMethod("add"),
        set: $f7be985f79bfefb2$var$createReadonlyMethod("set"),
        delete: $f7be985f79bfefb2$var$createReadonlyMethod("delete"),
        clear: $f7be985f79bfefb2$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $f7be985f79bfefb2$var$toRaw(this);
            const proto = $f7be985f79bfefb2$var$getProto(target);
            const rawValue = $f7be985f79bfefb2$var$toRaw(value);
            const valueToAdd = !shallow && !$f7be985f79bfefb2$var$isShallow(value) && !$f7be985f79bfefb2$var$isReadonly(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || $f7be985f79bfefb2$var$hasChanged(value, valueToAdd) && proto.has.call(target, value) || $f7be985f79bfefb2$var$hasChanged(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $f7be985f79bfefb2$var$trigger(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$f7be985f79bfefb2$var$isShallow(value) && !$f7be985f79bfefb2$var$isReadonly(value)) value = $f7be985f79bfefb2$var$toRaw(value);
            const target = $f7be985f79bfefb2$var$toRaw(this);
            const { has: has, get: get2 } = $f7be985f79bfefb2$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $f7be985f79bfefb2$var$toRaw(key);
                hadKey = has.call(target, key);
            } else $f7be985f79bfefb2$var$checkIdentityKeys(target, has, key);
            const oldValue = get2.call(target, key);
            target.set(key, value);
            if (!hadKey) $f7be985f79bfefb2$var$trigger(target, "add", key, value);
            else if ($f7be985f79bfefb2$var$hasChanged(value, oldValue)) $f7be985f79bfefb2$var$trigger(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $f7be985f79bfefb2$var$toRaw(this);
            const { has: has, get: get2 } = $f7be985f79bfefb2$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $f7be985f79bfefb2$var$toRaw(key);
                hadKey = has.call(target, key);
            } else $f7be985f79bfefb2$var$checkIdentityKeys(target, has, key);
            const oldValue = get2 ? get2.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $f7be985f79bfefb2$var$trigger(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $f7be985f79bfefb2$var$toRaw(this);
            const hadItems = target.size !== 0;
            const oldTarget = $f7be985f79bfefb2$var$isMap(target) ? new Map(target) : new Set(target);
            const result = target.clear();
            if (hadItems) $f7be985f79bfefb2$var$trigger(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $f7be985f79bfefb2$var$createIterableMethod(method, readonly2, shallow);
    });
    return instrumentations;
}
function $f7be985f79bfefb2$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $f7be985f79bfefb2$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get($f7be985f79bfefb2$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $f7be985f79bfefb2$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $f7be985f79bfefb2$var$createInstrumentationGetter(false, false)
};
var $f7be985f79bfefb2$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $f7be985f79bfefb2$var$createInstrumentationGetter(true, false)
};
function $f7be985f79bfefb2$var$checkIdentityKeys(target, has, key) {
    const rawKey = $f7be985f79bfefb2$var$toRaw(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = $f7be985f79bfefb2$var$toRawType(target);
        $f7be985f79bfefb2$var$warn2(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $f7be985f79bfefb2$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $f7be985f79bfefb2$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $f7be985f79bfefb2$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $f7be985f79bfefb2$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $f7be985f79bfefb2$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $f7be985f79bfefb2$var$reactive2(target) {
    if (/* @__PURE__ */ $f7be985f79bfefb2$var$isReadonly(target)) return target;
    return $f7be985f79bfefb2$var$createReactiveObject(target, false, $f7be985f79bfefb2$var$mutableHandlers, $f7be985f79bfefb2$var$mutableCollectionHandlers, $f7be985f79bfefb2$var$reactiveMap);
}
function $f7be985f79bfefb2$var$readonly(target) {
    return $f7be985f79bfefb2$var$createReactiveObject(target, true, $f7be985f79bfefb2$var$readonlyHandlers, $f7be985f79bfefb2$var$readonlyCollectionHandlers, $f7be985f79bfefb2$var$readonlyMap);
}
function $f7be985f79bfefb2$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!$f7be985f79bfefb2$var$isObject(target)) {
        $f7be985f79bfefb2$var$warn2(`value cannot be made ${isReadonly2 ? "readonly" : "reactive"}: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $f7be985f79bfefb2$var$targetTypeMap($f7be985f79bfefb2$var$toRawType(target));
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $f7be985f79bfefb2$var$isReactive2(value) {
    if (/* @__PURE__ */ $f7be985f79bfefb2$var$isReadonly(value)) return /* @__PURE__ */ $f7be985f79bfefb2$var$isReactive2(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $f7be985f79bfefb2$var$isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $f7be985f79bfefb2$var$isShallow(value) {
    return !!(value && value["__v_isShallow"]);
}
function $f7be985f79bfefb2$var$isProxy(value) {
    return value ? !!value["__v_raw"] : false;
}
function $f7be985f79bfefb2$var$toRaw(observed) {
    const raw2 = observed && observed["__v_raw"];
    return raw2 ? /* @__PURE__ */ $f7be985f79bfefb2$var$toRaw(raw2) : observed;
}
var $f7be985f79bfefb2$var$toReactive = (value)=>$f7be985f79bfefb2$var$isObject(value) ? /* @__PURE__ */ $f7be985f79bfefb2$var$reactive2(value) : value;
var $f7be985f79bfefb2$var$toReadonly = (value)=>$f7be985f79bfefb2$var$isObject(value) ? /* @__PURE__ */ $f7be985f79bfefb2$var$readonly(value) : value;
function $f7be985f79bfefb2$var$isRef(r) {
    return r ? r["__v_isRef"] === true : false;
}
// packages/alpinejs/src/magics/$nextTick.js
$f7be985f79bfefb2$var$magic("nextTick", ()=>$f7be985f79bfefb2$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$f7be985f79bfefb2$var$magic("dispatch", (el)=>$f7be985f79bfefb2$var$dispatch.bind($f7be985f79bfefb2$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$f7be985f79bfefb2$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $f7be985f79bfefb2$var$watch(getter, callback);
        cleanup(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$f7be985f79bfefb2$var$magic("store", $f7be985f79bfefb2$var$getStores);
// packages/alpinejs/src/magics/$data.js
$f7be985f79bfefb2$var$magic("data", (el)=>$f7be985f79bfefb2$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$f7be985f79bfefb2$var$magic("root", (el)=>$f7be985f79bfefb2$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$f7be985f79bfefb2$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $f7be985f79bfefb2$var$mergeProxies($f7be985f79bfefb2$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $f7be985f79bfefb2$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $f7be985f79bfefb2$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $f7be985f79bfefb2$var$globalIdMemo = {};
function $f7be985f79bfefb2$var$findAndIncrementId(name) {
    if (!$f7be985f79bfefb2$var$globalIdMemo[name]) $f7be985f79bfefb2$var$globalIdMemo[name] = 0;
    return ++$f7be985f79bfefb2$var$globalIdMemo[name];
}
function $f7be985f79bfefb2$var$closestIdRoot(el, name) {
    return $f7be985f79bfefb2$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $f7be985f79bfefb2$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $f7be985f79bfefb2$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$f7be985f79bfefb2$var$magic("id", (el, { cleanup: cleanup })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $f7be985f79bfefb2$var$cacheIdByNameOnElement(el, cacheKey, cleanup, ()=>{
            let root = $f7be985f79bfefb2$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $f7be985f79bfefb2$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$f7be985f79bfefb2$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $f7be985f79bfefb2$var$cacheIdByNameOnElement(el, cacheKey, cleanup, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$f7be985f79bfefb2$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$f7be985f79bfefb2$var$warnMissingPluginMagic("Focus", "focus", "focus");
$f7be985f79bfefb2$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $f7be985f79bfefb2$var$warnMissingPluginMagic(name, magicName, slug) {
    $f7be985f79bfefb2$var$magic(magicName, (el)=>$f7be985f79bfefb2$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$f7be985f79bfefb2$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.setWithModifiers;
        let releaseEntanglement = $f7be985f79bfefb2$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$f7be985f79bfefb2$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup })=>{
    if (el.tagName.toLowerCase() !== "template") $f7be985f79bfefb2$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $f7be985f79bfefb2$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $f7be985f79bfefb2$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $f7be985f79bfefb2$var$mutateDom(()=>{
        $f7be985f79bfefb2$var$skipDuringClone(()=>{
            placeInDom(clone2, target, modifiers);
            $f7be985f79bfefb2$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $f7be985f79bfefb2$var$getTarget(expression);
        $f7be985f79bfefb2$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup(()=>$f7be985f79bfefb2$var$mutateDom(()=>{
            clone2.remove();
            $f7be985f79bfefb2$var$destroyTree(clone2);
        }));
});
var $f7be985f79bfefb2$var$teleportContainerDuringClone = document.createElement("div");
function $f7be985f79bfefb2$var$getTarget(expression) {
    let target = $f7be985f79bfefb2$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $f7be985f79bfefb2$var$teleportContainerDuringClone;
    })();
    if (!target) $f7be985f79bfefb2$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $f7be985f79bfefb2$var$handler = ()=>{};
$f7be985f79bfefb2$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$f7be985f79bfefb2$var$directive("ignore", $f7be985f79bfefb2$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$f7be985f79bfefb2$var$directive("effect", $f7be985f79bfefb2$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($f7be985f79bfefb2$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $f7be985f79bfefb2$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $f7be985f79bfefb2$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $f7be985f79bfefb2$var$camelCase2(event);
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("passive")) options.passive = modifiers[modifiers.indexOf("passive") + 1] !== "false";
    handler4 = $f7be985f79bfefb2$var$addDebounceOrThrottle(modifiers, handler4);
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($f7be985f79bfefb2$var$isKeyEvent(event) || $f7be985f79bfefb2$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($f7be985f79bfefb2$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $f7be985f79bfefb2$var$addDebounceOrThrottle(modifiers, handler4) {
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $f7be985f79bfefb2$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f7be985f79bfefb2$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $f7be985f79bfefb2$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f7be985f79bfefb2$var$throttle(handler4, wait);
    }
    return handler4;
}
function $f7be985f79bfefb2$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $f7be985f79bfefb2$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f7be985f79bfefb2$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f7be985f79bfefb2$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $f7be985f79bfefb2$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $f7be985f79bfefb2$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
var $f7be985f79bfefb2$var$nonKeyModifiers = [
    // x-on's own modifiers:
    "window",
    "document",
    "prevent",
    "stop",
    "once",
    "capture",
    "self",
    "away",
    "outside",
    "passive",
    "dot",
    "camel",
    "preserve-scroll",
    // x-model's own modifiers:
    "blur",
    "change",
    "lazy",
    "number",
    "boolean",
    "trim",
    "fill",
    "unintrusive",
    "parent"
];
function $f7be985f79bfefb2$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((modifier, index)=>{
        if (modifier === "false" && modifiers[index - 1] === "passive") return false;
        return !$f7be985f79bfefb2$var$nonKeyModifiers.includes(modifier);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $f7be985f79bfefb2$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $f7be985f79bfefb2$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $f7be985f79bfefb2$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($f7be985f79bfefb2$var$isClickEvent(e.type)) return false;
            if ($f7be985f79bfefb2$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $f7be985f79bfefb2$var$keyToModifiers(key) {
    if (!key) return [];
    key = $f7be985f79bfefb2$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$f7be985f79bfefb2$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = $f7be985f79bfefb2$var$findClosest(el, (element)=>element !== el);
    let evaluateGet = $f7be985f79bfefb2$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $f7be985f79bfefb2$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $f7be985f79bfefb2$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $f7be985f79bfefb2$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($f7be985f79bfefb2$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $f7be985f79bfefb2$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($f7be985f79bfefb2$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($f7be985f79bfefb2$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($f7be985f79bfefb2$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($f7be985f79bfefb2$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let form = el.form;
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!form._x_pendingModelUpdates) form._x_pendingModelUpdates = [];
                form._x_pendingModelUpdates.push(syncCallback);
                cleanup(()=>{
                    if (form._x_pendingModelUpdates) form._x_pendingModelUpdates.splice(form._x_pendingModelUpdates.indexOf(syncCallback), 1);
                });
            }
        }
        if (hasEnterModifier) listeners.push($f7be985f79bfefb2$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove2)=>remove2());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $f7be985f79bfefb2$var$on(el, event, modifiers, (e)=>{
            setValue($f7be985f79bfefb2$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $f7be985f79bfefb2$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($f7be985f79bfefb2$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $f7be985f79bfefb2$var$on(el.form, "reset", [], (e)=>{
            $f7be985f79bfefb2$var$nextTick(()=>el._x_model && el._x_model.set($f7be985f79bfefb2$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        },
        setWithModifiers: $f7be985f79bfefb2$var$addDebounceOrThrottle(modifiers, setValue)
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        $f7be985f79bfefb2$var$mutateDom(()=>{
            if ($f7be985f79bfefb2$var$isCheckbox(el)) {
                if (Array.isArray(value)) el.checked = value.some((val)=>val == el.value);
                else el.checked = !!value;
            } else if ($f7be985f79bfefb2$var$isRadio(el)) {
                if (typeof value === "boolean") el.checked = $f7be985f79bfefb2$var$safeParseBoolean(el.value) === value;
                else el.checked = el.value == value;
            } else $f7be985f79bfefb2$var$bind(el, "value", value);
        });
    };
    if (el.tagName === "SELECT") {
        let observer2 = new MutationObserver(()=>{
            el._x_forceModelUpdate(getValue());
        });
        observer2.observe(el, {
            childList: true
        });
        cleanup(()=>observer2.disconnect());
    }
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $f7be985f79bfefb2$var$getInputValue(el, modifiers, event, currentValue) {
    return $f7be985f79bfefb2$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($f7be985f79bfefb2$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $f7be985f79bfefb2$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $f7be985f79bfefb2$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$f7be985f79bfefb2$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f7be985f79bfefb2$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f7be985f79bfefb2$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($f7be985f79bfefb2$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $f7be985f79bfefb2$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $f7be985f79bfefb2$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $f7be985f79bfefb2$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $f7be985f79bfefb2$var$isNumeric2(number) ? number : rawValue;
}
function $f7be985f79bfefb2$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $f7be985f79bfefb2$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f7be985f79bfefb2$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$f7be985f79bfefb2$var$directive("cloak", (el)=>{
    if ($f7be985f79bfefb2$var$isCloning) return el.removeAttribute($f7be985f79bfefb2$var$prefix("cloak"));
    queueMicrotask(()=>$f7be985f79bfefb2$var$mutateDom(()=>el.removeAttribute($f7be985f79bfefb2$var$prefix("cloak"))));
});
// packages/alpinejs/src/directives/x-init.js
$f7be985f79bfefb2$var$addInitSelector(()=>`[${$f7be985f79bfefb2$var$prefix("init")}]`);
$f7be985f79bfefb2$var$directive("init", $f7be985f79bfefb2$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$f7be985f79bfefb2$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f7be985f79bfefb2$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$f7be985f79bfefb2$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f7be985f79bfefb2$var$mutateDom(()=>{
                Array.from(el.children).forEach((child)=>$f7be985f79bfefb2$var$destroyTree(child));
                el.innerHTML = value ?? "";
                el._x_ignoreSelf = true;
                $f7be985f79bfefb2$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    }, {
        priority: "structural"
    });
});
// packages/alpinejs/src/directives/x-bind.js
$f7be985f79bfefb2$var$mapAttributes($f7be985f79bfefb2$var$startingWith(":", $f7be985f79bfefb2$var$into($f7be985f79bfefb2$var$prefix("bind:"))));
var $f7be985f79bfefb2$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup })=>{
    if (!value) {
        let bindingProviders = {};
        $f7be985f79bfefb2$var$injectBindingProviders(bindingProviders);
        let getBindings = $f7be985f79bfefb2$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $f7be985f79bfefb2$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $f7be985f79bfefb2$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $f7be985f79bfefb2$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $f7be985f79bfefb2$var$mutateDom(()=>$f7be985f79bfefb2$var$bind(el, value, result, modifiers));
        }));
    cleanup(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$f7be985f79bfefb2$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$f7be985f79bfefb2$var$directive("bind", $f7be985f79bfefb2$var$handler2);
function $f7be985f79bfefb2$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$f7be985f79bfefb2$var$addRootSelector(()=>`[${$f7be985f79bfefb2$var$prefix("data")}]`);
var $f7be985f79bfefb2$var$dataForReconciliation = Symbol();
$f7be985f79bfefb2$var$directive("data", (el, { expression: expression }, { cleanup: cleanup })=>{
    if ($f7be985f79bfefb2$var$shouldSkipRegisteringDataDuringClone(el)) return;
    let dataToReconcile = el[$f7be985f79bfefb2$var$dataForReconciliation];
    if (dataToReconcile?.expression === expression) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $f7be985f79bfefb2$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $f7be985f79bfefb2$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $f7be985f79bfefb2$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $f7be985f79bfefb2$var$injectMagics(data2, el);
    let reactiveData;
    if (dataToReconcile?.reactiveData) {
        reactiveData = dataToReconcile.reactiveData;
        $f7be985f79bfefb2$var$reconcileData(reactiveData, data2);
        let initialized = {
            expression: expression
        };
        el[$f7be985f79bfefb2$var$dataForReconciliation] = initialized;
        queueMicrotask(()=>{
            if (el[$f7be985f79bfefb2$var$dataForReconciliation] === initialized) delete el[$f7be985f79bfefb2$var$dataForReconciliation];
        });
    } else reactiveData = $f7be985f79bfefb2$var$reactive(data2);
    $f7be985f79bfefb2$var$initInterceptors(reactiveData, cleanup);
    let undo = $f7be985f79bfefb2$var$addScopeToNode(el, reactiveData);
    $f7be985f79bfefb2$var$skipDuringClone(()=>{
        reactiveData["init"] && $f7be985f79bfefb2$var$evaluate(el, reactiveData["init"]);
    })();
    cleanup(()=>{
        reactiveData["destroy"] && $f7be985f79bfefb2$var$evaluate(el, reactiveData["destroy"]);
        undo();
        let removed = {
            reactiveData: reactiveData
        };
        el[$f7be985f79bfefb2$var$dataForReconciliation] = removed;
        queueMicrotask(()=>{
            if (el[$f7be985f79bfefb2$var$dataForReconciliation] === removed) delete el[$f7be985f79bfefb2$var$dataForReconciliation];
        });
    });
});
function $f7be985f79bfefb2$var$reconcileData(target, source) {
    Object.keys(source).forEach((key)=>{
        let descriptor = Object.getOwnPropertyDescriptor(source, key);
        let existingDescriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor.get || descriptor.set || existingDescriptor?.get || existingDescriptor?.set) {
            if (existingDescriptor) delete target[key];
            if (!existingDescriptor) target[key] = void 0;
            descriptor.get || descriptor.set ? Object.defineProperty(target, key, descriptor) : target[key] = source[key];
        } else target[key] = source[key];
    });
    Object.keys(target).filter((key)=>!Object.prototype.hasOwnProperty.call(source, key)).forEach((key)=>delete target[key]);
}
$f7be985f79bfefb2$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $f7be985f79bfefb2$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$f7be985f79bfefb2$var$isCloning) return false;
    if ($f7be985f79bfefb2$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$f7be985f79bfefb2$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $f7be985f79bfefb2$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $f7be985f79bfefb2$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $f7be985f79bfefb2$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $f7be985f79bfefb2$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$f7be985f79bfefb2$var$directive("for", $f7be985f79bfefb2$var$skipDuringClone((el, { expression: expression }, { effect: effect3, cleanup: cleanup })=>{
    let iteratorNames = $f7be985f79bfefb2$var$parseForExpression(expression);
    let evaluateItems = $f7be985f79bfefb2$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $f7be985f79bfefb2$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_lookup = /* @__PURE__ */ new Map();
    effect3(()=>$f7be985f79bfefb2$var$loop(el, iteratorNames, evaluateItems, evaluateKey), {
        priority: "structural"
    });
    cleanup(()=>{
        el._x_lookup.forEach((el2)=>$f7be985f79bfefb2$var$mutateDom(()=>{
                $f7be985f79bfefb2$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_lookup;
        delete el._x_lastRenderedEl;
    });
}));
function $f7be985f79bfefb2$var$refreshScope(scope2) {
    return (newScope)=>{
        Object.entries(newScope).forEach(([key, value])=>{
            scope2[key] = value;
        });
    };
}
function $f7be985f79bfefb2$var$loop(templateEl, iteratorNames, evaluateItems, evaluateKey) {
    evaluateItems((items)=>{
        if ($f7be985f79bfefb2$var$isNumeric3(items)) items = Array.from({
            length: items
        }, (_, i)=>i + 1);
        if (items === void 0 || items === null) items = [];
        if (items instanceof Set) items = Array.from(items);
        if (items instanceof Map) items = Array.from(items);
        let oldLookup = templateEl._x_lookup;
        let lookup = /* @__PURE__ */ new Map();
        templateEl._x_lookup = lookup;
        let hasStringKeys = $f7be985f79bfefb2$var$isObject2(items);
        let scopeEntries = Object.entries(items).map(([index, item])=>{
            if (!hasStringKeys) index = parseInt(index);
            let scope2 = $f7be985f79bfefb2$var$getIterationScopeVariables(iteratorNames, item, index, items);
            let key;
            evaluateKey((innerKey)=>{
                if (typeof innerKey === "object") $f7be985f79bfefb2$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
                if (oldLookup.has(innerKey)) {
                    lookup.set(innerKey, oldLookup.get(innerKey));
                    oldLookup.delete(innerKey);
                }
                key = innerKey;
            }, {
                scope: {
                    index: index,
                    ...scope2
                }
            });
            return [
                key,
                scope2
            ];
        });
        $f7be985f79bfefb2$var$mutateDom(()=>{
            oldLookup.forEach((el)=>{
                $f7be985f79bfefb2$var$destroyTree(el);
                el.remove();
            });
            let added = /* @__PURE__ */ new Set();
            let prev = templateEl;
            scopeEntries.forEach(([key, scope2])=>{
                if (lookup.has(key)) {
                    let el = lookup.get(key);
                    el._x_refreshXForScope(scope2);
                    if (prev.nextElementSibling !== el) {
                        if (prev.nextElementSibling) el.replaceWith(prev.nextElementSibling);
                        prev.after(el);
                    }
                    prev = el;
                    if (el._x_currentIfEl) {
                        if (el.nextElementSibling !== el._x_currentIfEl) prev.after(el._x_currentIfEl);
                        prev = el._x_currentIfEl;
                    }
                    return;
                }
                if (templateEl.content.children.length > 1) $f7be985f79bfefb2$var$warn("x-for templates require a single root element, additional elements will be ignored.", templateEl);
                let clone2 = document.importNode(templateEl.content, true).firstElementChild;
                let reactiveScope = $f7be985f79bfefb2$var$reactive(scope2);
                $f7be985f79bfefb2$var$addScopeToNode(clone2, reactiveScope, templateEl);
                clone2._x_refreshXForScope = $f7be985f79bfefb2$var$refreshScope(reactiveScope);
                lookup.set(key, clone2);
                added.add(clone2);
                prev.after(clone2);
                prev = clone2;
            });
            added.forEach((clone2)=>$f7be985f79bfefb2$var$initTree(clone2));
            if (prev !== templateEl) templateEl._x_lastRenderedEl = prev;
            else delete templateEl._x_lastRenderedEl;
        });
    });
}
function $f7be985f79bfefb2$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\b(?:in|of)\b([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $f7be985f79bfefb2$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $f7be985f79bfefb2$var$isNumeric3(subject) {
    return typeof subject !== "object" && !isNaN(subject);
}
function $f7be985f79bfefb2$var$isObject2(subject) {
    return typeof subject === "object" && !Array.isArray(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $f7be985f79bfefb2$var$handler3() {}
$f7be985f79bfefb2$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup })=>{
    let root = $f7be985f79bfefb2$var$closestRoot(el);
    if (!root) return;
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup(()=>delete root._x_refs[expression]);
};
$f7be985f79bfefb2$var$directive("ref", $f7be985f79bfefb2$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$f7be985f79bfefb2$var$directive("if", $f7be985f79bfefb2$var$skipDuringClone((el, { expression: expression }, { effect: effect3, cleanup: cleanup })=>{
    if (el.tagName.toLowerCase() !== "template") $f7be985f79bfefb2$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $f7be985f79bfefb2$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $f7be985f79bfefb2$var$addScopeToNode(clone2, {}, el);
        $f7be985f79bfefb2$var$mutateDom(()=>{
            el.after(clone2);
            $f7be985f79bfefb2$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_lastRenderedEl = clone2;
        el._x_undoIf = ()=>{
            $f7be985f79bfefb2$var$mutateDom(()=>{
                $f7be985f79bfefb2$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
            delete el._x_lastRenderedEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }), {
        priority: "structural"
    });
    cleanup(()=>el._x_undoIf && el._x_undoIf());
}));
// packages/alpinejs/src/directives/x-id.js
$f7be985f79bfefb2$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$f7be985f79bfefb2$var$setIdRoot(el, name));
});
$f7be985f79bfefb2$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$f7be985f79bfefb2$var$mapAttributes($f7be985f79bfefb2$var$startingWith("@", $f7be985f79bfefb2$var$into($f7be985f79bfefb2$var$prefix("on:"))));
$f7be985f79bfefb2$var$directive("on", $f7be985f79bfefb2$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup })=>{
    let evaluate2 = expression ? $f7be985f79bfefb2$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $f7be985f79bfefb2$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$f7be985f79bfefb2$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$f7be985f79bfefb2$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$f7be985f79bfefb2$var$warnMissingPluginDirective("Focus", "trap", "focus");
$f7be985f79bfefb2$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $f7be985f79bfefb2$var$warnMissingPluginDirective(name, directiveName, slug) {
    $f7be985f79bfefb2$var$directive(directiveName, (el)=>$f7be985f79bfefb2$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$f7be985f79bfefb2$var$alpine_default.setEvaluator($f7be985f79bfefb2$var$normalEvaluator);
$f7be985f79bfefb2$var$alpine_default.setRawEvaluator($f7be985f79bfefb2$var$normalRawEvaluator);
$f7be985f79bfefb2$var$alpine_default.setReactivityEngine({
    reactive: $f7be985f79bfefb2$var$reactive2,
    // Since Vue 3.2, the scheduler is called with no arguments, so we wrap
    // the effect to hand Alpine's scheduler the runner it expects to queue.
    effect: (callback, options = {})=>{
        let runner;
        runner = $f7be985f79bfefb2$var$effect2(callback, {
            scheduler: ()=>{
                if (!runner) return;
                options.scheduler ? options.scheduler(runner) : runner();
            }
        });
        return runner;
    },
    release: $f7be985f79bfefb2$var$stop,
    raw: $f7be985f79bfefb2$var$toRaw
});
var $f7be985f79bfefb2$export$b7ee041e4ad2afec = $f7be985f79bfefb2$var$alpine_default;
// packages/alpinejs/builds/module.js
var $f7be985f79bfefb2$export$2e2bcd8739ae039 = $f7be985f79bfefb2$export$b7ee041e4ad2afec;
 /*! Bundled license information:

@vue/shared/dist/shared.esm-bundler.js:
  (**
  * @vue/shared v3.5.41
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)

@vue/reactivity/dist/reactivity.esm-bundler.js:
  (**
  * @vue/reactivity v3.5.41
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)
*/ 

// packages/intersect/src/index.js
function $290e903578575c63$export$1f4807a235930d45(Alpine) {
    Alpine.directive("intersect", Alpine.skipDuringClone((el, { value: value, expression: expression, modifiers: modifiers }, { evaluateLater: evaluateLater, cleanup: cleanup })=>{
        let evaluate = evaluateLater(expression);
        let threshold = $290e903578575c63$var$getThreshold(modifiers);
        let options = {
            rootMargin: $290e903578575c63$var$getRootMargin(modifiers),
            threshold: threshold,
            root: modifiers.includes("parent") ? el.parentElement : null
        };
        if (modifiers.includes("dwell")) {
            $290e903578575c63$var$observeForDwell(el, value, modifiers, evaluate, cleanup, options, threshold);
            return;
        }
        let observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting === (value === "leave")) return;
                evaluate();
                modifiers.includes("once") && observer.disconnect();
            });
        }, options);
        observer.observe(el);
        cleanup(()=>{
            observer.disconnect();
        });
    }));
}
function $290e903578575c63$var$observeForDwell(el, value, modifiers, evaluate, cleanup, options, threshold) {
    let dwellTimeout;
    let lastEntry;
    let hasEvaluated = false;
    let isConfirmingDwell = false;
    let duration = $290e903578575c63$var$getDwellDuration(modifiers);
    let observer;
    let clearDwellTimeout = ()=>{
        clearTimeout(dwellTimeout);
        dwellTimeout = void 0;
    };
    let completeDwell = ()=>{
        isConfirmingDwell = false;
        if (!lastEntry || document.hidden || !$290e903578575c63$var$meetsDwellThreshold(lastEntry, value, threshold)) return;
        hasEvaluated = true;
        evaluate();
        if (modifiers.includes("once")) {
            observer.disconnect();
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        }
    };
    let observe = ()=>{
        observer && observer.disconnect();
        observer = new IntersectionObserver(handleEntries, options);
        observer.observe(el);
    };
    let confirmDwell = ()=>{
        dwellTimeout = void 0;
        if (document.hidden) return;
        let pendingEntries = observer.takeRecords();
        if (pendingEntries.some((entry)=>!$290e903578575c63$var$meetsDwellThreshold(entry, value, threshold))) {
            handleEntries(pendingEntries);
            return;
        }
        isConfirmingDwell = true;
        lastEntry = void 0;
        observe();
    };
    let beginDwell = ()=>{
        if (dwellTimeout !== void 0 || hasEvaluated || document.hidden || !lastEntry) return;
        if (!$290e903578575c63$var$meetsDwellThreshold(lastEntry, value, threshold)) return;
        dwellTimeout = setTimeout(confirmDwell, duration);
    };
    let handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            lastEntry = entry;
            if (!$290e903578575c63$var$meetsDwellThreshold(entry, value, threshold)) {
                clearDwellTimeout();
                hasEvaluated = false;
                isConfirmingDwell = false;
                return;
            }
            if (isConfirmingDwell) {
                completeDwell();
                return;
            }
            beginDwell();
        });
    };
    let handleVisibilityChange = ()=>{
        if (document.hidden) {
            clearDwellTimeout();
            lastEntry = void 0;
            hasEvaluated = false;
            isConfirmingDwell = false;
            observer.disconnect();
            return;
        }
        observe();
    };
    observe();
    document.addEventListener("visibilitychange", handleVisibilityChange);
    cleanup(()=>{
        clearDwellTimeout();
        observer.disconnect();
        document.removeEventListener("visibilitychange", handleVisibilityChange);
    });
}
function $290e903578575c63$var$meetsDwellThreshold(entry, value, threshold) {
    let meetsThreshold = threshold === 0 ? entry.isIntersecting : entry.isIntersecting && entry.intersectionRatio >= threshold;
    return value === "leave" ? !meetsThreshold : meetsThreshold;
}
function $290e903578575c63$var$getDwellDuration(modifiers) {
    let rawDuration = modifiers[modifiers.indexOf("dwell") + 1] || "";
    let match = rawDuration.match(/^([0-9]+)(ms)?$/);
    return match ? Number(match[1]) : 250;
}
function $290e903578575c63$var$getThreshold(modifiers) {
    if (modifiers.includes("full")) return 0.99;
    if (modifiers.includes("half")) return 0.5;
    if (!modifiers.includes("threshold")) return 0;
    let threshold = modifiers[modifiers.indexOf("threshold") + 1];
    if (threshold === "100") return 1;
    if (threshold === "0") return 0;
    return Number(`.${threshold}`);
}
function $290e903578575c63$var$getLengthValue(rawValue) {
    let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
    return match ? match[1] + (match[2] || "px") : void 0;
}
function $290e903578575c63$var$getRootMargin(modifiers) {
    const key = "margin";
    const fallback = "0px 0px 0px 0px";
    const index = modifiers.indexOf(key);
    if (index === -1) return fallback;
    let values = [];
    for(let i = 1; i < 5; i++)values.push($290e903578575c63$var$getLengthValue(modifiers[index + i] || ""));
    values = values.filter((v)=>v !== void 0);
    return values.length ? values.join(" ").trim() : fallback;
}
// packages/intersect/builds/module.js
var $290e903578575c63$export$2e2bcd8739ae039 = $290e903578575c63$export$1f4807a235930d45;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $6402438dfd14940e$var$extendStatics = function(d, b) {
    $6402438dfd14940e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $6402438dfd14940e$var$extendStatics(d, b);
};
function $6402438dfd14940e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $6402438dfd14940e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6402438dfd14940e$export$18ce0697a983be9b = function() {
    $6402438dfd14940e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6402438dfd14940e$export$18ce0697a983be9b.apply(this, arguments);
};
function $6402438dfd14940e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6402438dfd14940e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6402438dfd14940e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6402438dfd14940e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $6402438dfd14940e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $6402438dfd14940e$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $6402438dfd14940e$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $6402438dfd14940e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6402438dfd14940e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6402438dfd14940e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $6402438dfd14940e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $6402438dfd14940e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $6402438dfd14940e$export$45d3717a4c69092e(o, m, p);
}
function $6402438dfd14940e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6402438dfd14940e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6402438dfd14940e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6402438dfd14940e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6402438dfd14940e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6402438dfd14940e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $6402438dfd14940e$export$10c90e4f7922046c(v) {
    return this instanceof $6402438dfd14940e$export$10c90e4f7922046c ? (this.v = v, this) : new $6402438dfd14940e$export$10c90e4f7922046c(v);
}
function $6402438dfd14940e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6402438dfd14940e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6402438dfd14940e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6402438dfd14940e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $6402438dfd14940e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6402438dfd14940e$export$19a8beecd37a4c45 === "function" ? $6402438dfd14940e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6402438dfd14940e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $6402438dfd14940e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $6402438dfd14940e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6402438dfd14940e$export$45d3717a4c69092e(result, mod, k);
    }
    $6402438dfd14940e$var$__setModuleDefault(result, mod);
    return result;
}
function $6402438dfd14940e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6402438dfd14940e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $6402438dfd14940e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $6402438dfd14940e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $6402438dfd14940e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $6402438dfd14940e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $6402438dfd14940e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $6402438dfd14940e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $6402438dfd14940e$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $6402438dfd14940e$export$2e2bcd8739ae039 = {
    __extends: $6402438dfd14940e$export$a8ba968b8961cb8a,
    __assign: $6402438dfd14940e$export$18ce0697a983be9b,
    __rest: $6402438dfd14940e$export$3c9a16f847548506,
    __decorate: $6402438dfd14940e$export$29e00dfd3077644b,
    __param: $6402438dfd14940e$export$d5ad3fd78186038f,
    __esDecorate: $6402438dfd14940e$export$3a84e1ae4e97e9b0,
    __runInitializers: $6402438dfd14940e$export$d831c04e792af3d,
    __propKey: $6402438dfd14940e$export$6a2a36740a146cb8,
    __setFunctionName: $6402438dfd14940e$export$d1a06452d3489bc7,
    __metadata: $6402438dfd14940e$export$f1db080c865becb9,
    __awaiter: $6402438dfd14940e$export$1050f835b63b671e,
    __generator: $6402438dfd14940e$export$67ebef60e6f28a6,
    __createBinding: $6402438dfd14940e$export$45d3717a4c69092e,
    __exportStar: $6402438dfd14940e$export$f33643c0debef087,
    __values: $6402438dfd14940e$export$19a8beecd37a4c45,
    __read: $6402438dfd14940e$export$8d051b38c9118094,
    __spread: $6402438dfd14940e$export$afc72e2116322959,
    __spreadArrays: $6402438dfd14940e$export$6388937ca91ccae8,
    __spreadArray: $6402438dfd14940e$export$1216008129fb82ed,
    __await: $6402438dfd14940e$export$10c90e4f7922046c,
    __asyncGenerator: $6402438dfd14940e$export$e427f37a30a4de9b,
    __asyncDelegator: $6402438dfd14940e$export$bbd80228419bb833,
    __asyncValues: $6402438dfd14940e$export$e3b29a3d6162315f,
    __makeTemplateObject: $6402438dfd14940e$export$4fb47efe1390b86f,
    __importStar: $6402438dfd14940e$export$c21735bcef00d192,
    __importDefault: $6402438dfd14940e$export$da59b14a69baef04,
    __classPrivateFieldGet: $6402438dfd14940e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $6402438dfd14940e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $6402438dfd14940e$export$81fdc39f203e4e04,
    __addDisposableResource: $6402438dfd14940e$export$88ac25d8e944e405,
    __disposeResources: $6402438dfd14940e$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $6402438dfd14940e$export$889dfb5d17574b0b
};











function $e8cc0172ecd48925$export$83ccd85155ba9791(current, next, prev, labels) {
    var _a;
    if ((0, $21f0d41def87b865$export$7e4aa119212bc614)(next)) return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
}



function $da35d0d6f9639689$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $a65b80757fccab21$export$fe2d9b4e03920b4c)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $da35d0d6f9639689$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $da35d0d6f9639689$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $5bc7f8c1e0ab24a6$export$2c9e8a9632a706b2)(startTime, endTime, offset[i]),
        easing: (0, $98b1ad1828499999$export$41c5e731255a462)(easing, i)
    });
}


function $b35f06f577ea1ad9$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) return a.value === null ? 1 : -1;
    else return a.at - b.at;
}



function $38c066f1b4693223$export$cddc5598d4bb8461(definition, options = {}) {
    var _a;
    const animationDefinitions = $38c066f1b4693223$export$ecf4a6d05c8cfe84(definition, options);
    /**
     * Create and start animations
     */ const animationFactories = animationDefinitions.map((definition)=>(0, $3344ba6373fe4df2$export$c76cd972d26986f9)(...definition, (0, $fd68e4d15c2b425f$export$c35d437ae5945fcd))).filter(Boolean);
    return (0, $5f6c656c33a8bdd6$export$c5e4bb50450218c1)(animationFactories, options, // Get the duration from the first animation definition
    (_a = animationDefinitions[0]) === null || _a === void 0 ? void 0 : _a[3].duration);
}
function $38c066f1b4693223$export$ecf4a6d05c8cfe84(definition, _a = {}) {
    var { defaultOptions: defaultOptions = {} } = _a, timelineOptions = (0, $6402438dfd14940e$export$3c9a16f847548506)(_a, [
        "defaultOptions"
    ]);
    const animationDefinitions = [];
    const elementSequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the definition array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < definition.length; i++){
        const segment = definition[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if ((0, $6dfc46d0761bc5e3$export$844ec244b1367d54)(segment)) {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $e8cc0172ecd48925$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        const [elementDefinition, keyframes, options = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (options.at !== undefined) currentTime = (0, $e8cc0172ecd48925$export$83ccd85155ba9791)(currentTime, options.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        /**
         * Find all the elements specified in the definition and parse value
         * keyframes from their timeline definitions.
         */ const elements = (0, $94c1aa313017b840$export$90ceba2564a894f8)(elementDefinition, elementCache);
        const numElements = elements.length;
        for(let elementIndex = 0; elementIndex < numElements; elementIndex++){
            const element = elements[elementIndex];
            const elementSequence = $38c066f1b4693223$var$getElementSequence(element, elementSequences);
            for(const key in keyframes){
                const valueSequence = $38c066f1b4693223$var$getValueSequence(key, elementSequence);
                let valueKeyframes = (0, $08b3f76d80312f04$export$388e66a97327a012)(keyframes[key]);
                const valueOptions = (0, $2a27dcaa5a61007d$export$d2312e68e1f5ad00)(options, key);
                let { duration: duration = defaultOptions.duration || (0, $cf54c628e8228616$export$ebe90cb607ad99e).duration, easing: easing = defaultOptions.easing || (0, $cf54c628e8228616$export$ebe90cb607ad99e).easing } = valueOptions;
                if ((0, $e4cb174ad07b97b4$export$d81a3021299cadf2)(easing)) {
                    (0, $fedf00bec75fe537$export$f5708dca728d7177)(key === "opacity" || valueKeyframes.length > 1, "spring must be provided 2 keyframes within timeline()");
                    const custom = easing.createAnimation(valueKeyframes, key !== "opacity", ()=>0, key);
                    easing = custom.easing;
                    valueKeyframes = custom.keyframes || valueKeyframes;
                    duration = custom.duration || duration;
                }
                const delay = (0, $b1365191334b71a4$export$4cf8f03b86be8175)(options.delay, elementIndex, numElements) || 0;
                const startTime = currentTime + delay;
                const targetTime = startTime + duration;
                /**
                 *
                 */ let { offset: offset = (0, $b5786fb950153824$export$24dbcec0b26e6d9d)(valueKeyframes.length) } = valueOptions;
                /**
                 * If there's only one offset of 0, fill in a second with length 1
                 *
                 * TODO: Ensure there's a test that covers this removal
                 */ if (offset.length === 1 && offset[0] === 0) offset[1] = 1;
                /**
                 * Fill out if offset if fewer offsets than keyframes
                 */ const remainder = offset.length - valueKeyframes.length;
                remainder > 0 && (0, $b5786fb950153824$export$dafee61230cf05c6)(offset, remainder);
                /**
                 * If only one value has been set, ie [1], push a null to the start of
                 * the keyframe array. This will let us mark a keyframe at this point
                 * that will later be hydrated with the previous value.
                 */ valueKeyframes.length === 1 && valueKeyframes.unshift(null);
                /**
                 * Add keyframes, mapping offsets to absolute time.
                 */ (0, $da35d0d6f9639689$export$89dfa6760a9f76e7)(valueSequence, valueKeyframes, easing, offset, startTime, targetTime);
                maxDuration = Math.max(delay + duration, maxDuration);
                totalDuration = Math.max(targetTime, totalDuration);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */ elementSequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $b35f06f577ea1ad9$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $745d21a74701acae$export$504d7abb21fa8c9)(0, totalDuration, at));
                valueEasing.push(easing || (0, $cf54c628e8228616$export$ebe90cb607ad99e).easing);
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift("linear");
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            animationDefinitions.push([
                element,
                key,
                keyframes,
                Object.assign(Object.assign(Object.assign({}, defaultOptions), {
                    duration: totalDuration,
                    easing: valueEasing,
                    offset: valueOffset
                }), timelineOptions)
            ]);
        }
    });
    return animationDefinitions;
}
function $38c066f1b4693223$var$getElementSequence(element, sequences) {
    !sequences.has(element) && sequences.set(element, {});
    return sequences.get(element);
}
function $38c066f1b4693223$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}


function $fbb64c38649f4737$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $fbb64c38649f4737$var$hasPassiveEvents = false;
if (typeof window !== 'undefined') {
    var $fbb64c38649f4737$var$passiveTestOptions = {
        get passive () {
            $fbb64c38649f4737$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener('testPassive', null, $fbb64c38649f4737$var$passiveTestOptions);
    window.removeEventListener('testPassive', null, $fbb64c38649f4737$var$passiveTestOptions);
}
var $fbb64c38649f4737$var$isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
var $fbb64c38649f4737$var$locks = [];
var $fbb64c38649f4737$var$documentListenerAdded = false;
var $fbb64c38649f4737$var$initialClientY = -1;
var $fbb64c38649f4737$var$previousBodyOverflowSetting = void 0;
var $fbb64c38649f4737$var$previousBodyPosition = void 0;
var $fbb64c38649f4737$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $fbb64c38649f4737$var$allowTouchMove = function allowTouchMove(el) {
    return $fbb64c38649f4737$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $fbb64c38649f4737$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($fbb64c38649f4737$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $fbb64c38649f4737$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($fbb64c38649f4737$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
            $fbb64c38649f4737$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + 'px';
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($fbb64c38649f4737$var$previousBodyOverflowSetting === undefined) {
        $fbb64c38649f4737$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }
};
var $fbb64c38649f4737$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($fbb64c38649f4737$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $fbb64c38649f4737$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $fbb64c38649f4737$var$previousBodyPaddingRight = undefined;
    }
    if ($fbb64c38649f4737$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $fbb64c38649f4737$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $fbb64c38649f4737$var$previousBodyOverflowSetting = undefined;
    }
};
var $fbb64c38649f4737$var$setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(function() {
        // If previousBodyPosition is already set, don't set it again.
        if ($fbb64c38649f4737$var$previousBodyPosition === undefined) {
            $fbb64c38649f4737$var$previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left
            };
            // Update the dom inside an animation frame 
            var _window = window, scrollY = _window.scrollY, scrollX = _window.scrollX, innerHeight = _window.innerHeight;
            document.body.style.position = 'fixed';
            document.body.style.top = -scrollY;
            document.body.style.left = -scrollX;
            setTimeout(function() {
                return window.requestAnimationFrame(function() {
                    // Attempt to check if the bottom bar appeared due to the position change
                    var bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollY >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = -(scrollY + bottomBarHeight);
                });
            }, 300);
        }
    });
};
var $fbb64c38649f4737$var$restorePositionSetting = function restorePositionSetting() {
    if ($fbb64c38649f4737$var$previousBodyPosition !== undefined) {
        // Convert the position from "px" to Int
        var y = -parseInt(document.body.style.top, 10);
        var x = -parseInt(document.body.style.left, 10);
        // Restore styles
        document.body.style.position = $fbb64c38649f4737$var$previousBodyPosition.position;
        document.body.style.top = $fbb64c38649f4737$var$previousBodyPosition.top;
        document.body.style.left = $fbb64c38649f4737$var$previousBodyPosition.left;
        // Restore scroll
        window.scrollTo(x, y);
        $fbb64c38649f4737$var$previousBodyPosition = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $fbb64c38649f4737$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $fbb64c38649f4737$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $fbb64c38649f4737$var$initialClientY;
    if ($fbb64c38649f4737$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $fbb64c38649f4737$var$preventDefault(event);
    if ($fbb64c38649f4737$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $fbb64c38649f4737$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $fbb64c38649f4737$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($fbb64c38649f4737$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $fbb64c38649f4737$var$locks = [].concat($fbb64c38649f4737$var$_toConsumableArray($fbb64c38649f4737$var$locks), [
        lock
    ]);
    if ($fbb64c38649f4737$var$isIosDevice) $fbb64c38649f4737$var$setPositionFixed();
    else $fbb64c38649f4737$var$setOverflowHidden(options);
    if ($fbb64c38649f4737$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $fbb64c38649f4737$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $fbb64c38649f4737$var$handleScroll(event, targetElement);
        };
        if (!$fbb64c38649f4737$var$documentListenerAdded) {
            document.addEventListener('touchmove', $fbb64c38649f4737$var$preventDefault, $fbb64c38649f4737$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $fbb64c38649f4737$var$documentListenerAdded = true;
        }
    }
};
var $fbb64c38649f4737$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($fbb64c38649f4737$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $fbb64c38649f4737$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($fbb64c38649f4737$var$documentListenerAdded) {
            document.removeEventListener('touchmove', $fbb64c38649f4737$var$preventDefault, $fbb64c38649f4737$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $fbb64c38649f4737$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $fbb64c38649f4737$var$initialClientY = -1;
    }
    if ($fbb64c38649f4737$var$isIosDevice) $fbb64c38649f4737$var$restorePositionSetting();
    else $fbb64c38649f4737$var$restoreOverflowSetting();
    $fbb64c38649f4737$var$locks = [];
};
var $fbb64c38649f4737$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
        return;
    }
    $fbb64c38649f4737$var$locks = $fbb64c38649f4737$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($fbb64c38649f4737$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($fbb64c38649f4737$var$documentListenerAdded && $fbb64c38649f4737$var$locks.length === 0) {
            document.removeEventListener('touchmove', $fbb64c38649f4737$var$preventDefault, $fbb64c38649f4737$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $fbb64c38649f4737$var$documentListenerAdded = false;
        }
    }
    if ($fbb64c38649f4737$var$isIosDevice) $fbb64c38649f4737$var$restorePositionSetting();
    else $fbb64c38649f4737$var$restoreOverflowSetting();
};


var $1decf37d04b148ec$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $1decf37d04b148ec$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $1decf37d04b148ec$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $1decf37d04b148ec$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $1decf37d04b148ec$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $1decf37d04b148ec$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $1decf37d04b148ec$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $1decf37d04b148ec$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $1decf37d04b148ec$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $1decf37d04b148ec$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $1decf37d04b148ec$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1decf37d04b148ec$var$root = $1decf37d04b148ec$var$freeGlobal || $1decf37d04b148ec$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $1decf37d04b148ec$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1decf37d04b148ec$var$objectToString = $1decf37d04b148ec$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1decf37d04b148ec$var$nativeMax = Math.max, $1decf37d04b148ec$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1decf37d04b148ec$var$now = function() {
    return $1decf37d04b148ec$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $1decf37d04b148ec$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($1decf37d04b148ec$var$FUNC_ERROR_TEXT);
    wait = $1decf37d04b148ec$var$toNumber(wait) || 0;
    if ($1decf37d04b148ec$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $1decf37d04b148ec$var$nativeMax($1decf37d04b148ec$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $1decf37d04b148ec$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1decf37d04b148ec$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1decf37d04b148ec$var$now());
    }
    function debounced() {
        var time = $1decf37d04b148ec$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $1decf37d04b148ec$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($1decf37d04b148ec$var$FUNC_ERROR_TEXT);
    if ($1decf37d04b148ec$var$isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $1decf37d04b148ec$var$debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1decf37d04b148ec$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1decf37d04b148ec$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $1decf37d04b148ec$var$isSymbol(value) {
    return typeof value == 'symbol' || $1decf37d04b148ec$var$isObjectLike(value) && $1decf37d04b148ec$var$objectToString.call(value) == $1decf37d04b148ec$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $1decf37d04b148ec$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($1decf37d04b148ec$var$isSymbol(value)) return $1decf37d04b148ec$var$NAN;
    if ($1decf37d04b148ec$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $1decf37d04b148ec$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($1decf37d04b148ec$var$reTrim, '');
    var isBinary = $1decf37d04b148ec$var$reIsBinary.test(value);
    return isBinary || $1decf37d04b148ec$var$reIsOctal.test(value) ? $1decf37d04b148ec$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $1decf37d04b148ec$var$reIsBadHex.test(value) ? $1decf37d04b148ec$var$NAN : +value;
}
$1decf37d04b148ec$exports = $1decf37d04b148ec$var$throttle;


const $9211fbba4da27573$var$Navigation = ()=>{
    const navBar = document.getElementById('page-navbar');
    const navEl = document.getElementById('page-navbar-sidebar');
    // const navOverflowEl = document.querySelector('.side-nav-overflow-wrapper');
    const navOverflowEl = document.querySelector('.mobile-side-nav-overflow-wrapper');
    const navItemEls = navEl?.querySelectorAll('.nav-item-js');
    /* Button nav trigger */ document.addEventListener('nav:toggle', (e)=>{
        if (e.detail) openNav();
        else closeNav();
    });
    /* Navbar hide on scroll */ let lastScrollTop = 0;
    const navToggleOffset = document.querySelector('.giantpeach-banner')?.offsetHeight ?? window.innerHeight;
    const openNav = ()=>{
        const modalOverflowElements = document.querySelectorAll('.modal-overflow');
        document.body.classList.add('nav-open');
        (0, $fbb64c38649f4737$export$24fdf68abf432c44)(navOverflowEl);
        modalOverflowElements.forEach((el)=>{
            (0, $fbb64c38649f4737$export$24fdf68abf432c44)(el);
        });
        (0, $38c066f1b4693223$export$cddc5598d4bb8461)([
            [
                navEl,
                {
                    opacity: 1,
                    visibility: 'visible'
                },
                {
                    duration: 0.3,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ]
                }
            ],
            [
                navItemEls,
                {
                    opacity: 1
                },
                {
                    duration: 0.3,
                    delay: (0, $b1365191334b71a4$export$ef0b4d89074db4d0)(0.1),
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ],
                    at: '-0.2'
                }
            ]
        ]);
    };
    const closeNav = (duration = 0.3)=>{
        document.body.classList.remove("nav-open");
        (0, $fbb64c38649f4737$export$45a3ef215b2a5866)();
        (0, $38c066f1b4693223$export$cddc5598d4bb8461)([
            [
                navEl,
                {
                    opacity: 0,
                    visibility: 'hidden'
                },
                {
                    duration: duration,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ]
                }
            ],
            [
                navItemEls,
                {
                    opacity: 0
                },
                {
                    duration: duration,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ]
                }
            ]
        ]);
    };
    closeNav(0);
};
var $9211fbba4da27573$export$2e2bcd8739ae039 = $9211fbba4da27573$var$Navigation;


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $14363946691fc7b4$var$t = globalThis, $14363946691fc7b4$export$b4d10f6001c083c2 = $14363946691fc7b4$var$t.ShadowRoot && (void 0 === $14363946691fc7b4$var$t.ShadyCSS || $14363946691fc7b4$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $14363946691fc7b4$var$s = Symbol(), $14363946691fc7b4$var$o = new WeakMap;
class $14363946691fc7b4$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $14363946691fc7b4$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($14363946691fc7b4$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $14363946691fc7b4$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $14363946691fc7b4$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $14363946691fc7b4$export$8d80f9cac07cdb3 = (t)=>new $14363946691fc7b4$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $14363946691fc7b4$var$s), $14363946691fc7b4$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $14363946691fc7b4$export$505d1e8739bad805(o, t, $14363946691fc7b4$var$s);
}, $14363946691fc7b4$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($14363946691fc7b4$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $14363946691fc7b4$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $14363946691fc7b4$export$ee69dfd951e24778 = $14363946691fc7b4$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $14363946691fc7b4$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $4ac9cab3d310a309$var$i, defineProperty: $4ac9cab3d310a309$var$e, getOwnPropertyDescriptor: $4ac9cab3d310a309$var$h, getOwnPropertyNames: $4ac9cab3d310a309$var$r, getOwnPropertySymbols: $4ac9cab3d310a309$var$o, getPrototypeOf: $4ac9cab3d310a309$var$n } = Object, $4ac9cab3d310a309$var$a = globalThis, $4ac9cab3d310a309$var$c = $4ac9cab3d310a309$var$a.trustedTypes, $4ac9cab3d310a309$var$l = $4ac9cab3d310a309$var$c ? $4ac9cab3d310a309$var$c.emptyScript : "", $4ac9cab3d310a309$var$p = $4ac9cab3d310a309$var$a.reactiveElementPolyfillSupport, $4ac9cab3d310a309$var$d = (t, s)=>t, $4ac9cab3d310a309$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $4ac9cab3d310a309$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $4ac9cab3d310a309$export$53a6892c50694894 = (t, s)=>!$4ac9cab3d310a309$var$i(t, s), $4ac9cab3d310a309$var$b = {
    attribute: !0,
    type: String,
    converter: $4ac9cab3d310a309$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $4ac9cab3d310a309$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $4ac9cab3d310a309$var$a.litPropertyMetadata ??= new WeakMap;
class $4ac9cab3d310a309$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $4ac9cab3d310a309$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $4ac9cab3d310a309$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $4ac9cab3d310a309$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $4ac9cab3d310a309$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($4ac9cab3d310a309$var$d("elementProperties"))) return;
        const t = $4ac9cab3d310a309$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($4ac9cab3d310a309$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($4ac9cab3d310a309$var$d("properties"))) {
            const t = this.properties, s = [
                ...$4ac9cab3d310a309$var$r(t),
                ...$4ac9cab3d310a309$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $14363946691fc7b4$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $14363946691fc7b4$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $14363946691fc7b4$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $4ac9cab3d310a309$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $4ac9cab3d310a309$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            this[e] = r ?? this._$Ej?.get(e) ?? r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i, e = !1, h) {
        if (void 0 !== t) {
            const r = this.constructor;
            if (!1 === e && (h = this[t]), i ??= r.getPropertyOptions(t), !((i.hasChanged ?? $4ac9cab3d310a309$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(r._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$4ac9cab3d310a309$export$c7c07a37856565d.elementStyles = [], $4ac9cab3d310a309$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $4ac9cab3d310a309$export$c7c07a37856565d[$4ac9cab3d310a309$var$d("elementProperties")] = new Map, $4ac9cab3d310a309$export$c7c07a37856565d[$4ac9cab3d310a309$var$d("finalized")] = new Map, $4ac9cab3d310a309$var$p?.({
    ReactiveElement: $4ac9cab3d310a309$export$c7c07a37856565d
}), ($4ac9cab3d310a309$var$a.reactiveElementVersions ??= []).push("2.1.2");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7c8bf60562922b0b$var$t = globalThis, $7c8bf60562922b0b$var$i = (t)=>t, $7c8bf60562922b0b$var$s = $7c8bf60562922b0b$var$t.trustedTypes, $7c8bf60562922b0b$var$e = $7c8bf60562922b0b$var$s ? $7c8bf60562922b0b$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $7c8bf60562922b0b$var$h = "$lit$", $7c8bf60562922b0b$var$o = `lit$${Math.random().toFixed(9).slice(2)}$`, $7c8bf60562922b0b$var$n = "?" + $7c8bf60562922b0b$var$o, $7c8bf60562922b0b$var$r = `<${$7c8bf60562922b0b$var$n}>`, $7c8bf60562922b0b$var$l = document, $7c8bf60562922b0b$var$c = ()=>$7c8bf60562922b0b$var$l.createComment(""), $7c8bf60562922b0b$var$a = (t)=>null === t || "object" != typeof t && "function" != typeof t, $7c8bf60562922b0b$var$u = Array.isArray, $7c8bf60562922b0b$var$d = (t)=>$7c8bf60562922b0b$var$u(t) || "function" == typeof t?.[Symbol.iterator], $7c8bf60562922b0b$var$f = "[ \t\n\f\r]", $7c8bf60562922b0b$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $7c8bf60562922b0b$var$_ = /-->/g, $7c8bf60562922b0b$var$m = />/g, $7c8bf60562922b0b$var$p = RegExp(`>|${$7c8bf60562922b0b$var$f}(?:([^\\s"'>=/]+)(${$7c8bf60562922b0b$var$f}*=${$7c8bf60562922b0b$var$f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $7c8bf60562922b0b$var$g = /'/g, $7c8bf60562922b0b$var$$ = /"/g, $7c8bf60562922b0b$var$y = /^(?:script|style|textarea|title)$/i, $7c8bf60562922b0b$var$x = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $7c8bf60562922b0b$export$c0bb0b647f701bb5 = $7c8bf60562922b0b$var$x(1), $7c8bf60562922b0b$export$7ed1367e7fa1ad68 = $7c8bf60562922b0b$var$x(2), $7c8bf60562922b0b$export$47d5b44d225be5b4 = $7c8bf60562922b0b$var$x(3), $7c8bf60562922b0b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $7c8bf60562922b0b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $7c8bf60562922b0b$var$C = new WeakMap, $7c8bf60562922b0b$var$P = $7c8bf60562922b0b$var$l.createTreeWalker($7c8bf60562922b0b$var$l, 129);
function $7c8bf60562922b0b$var$V(t, i) {
    if (!$7c8bf60562922b0b$var$u(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $7c8bf60562922b0b$var$e ? $7c8bf60562922b0b$var$e.createHTML(i) : i;
}
const $7c8bf60562922b0b$var$N = (t, i)=>{
    const s = t.length - 1, e = [];
    let n, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $7c8bf60562922b0b$var$v;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, f = 0;
        for(; f < s.length && (c.lastIndex = f, u = c.exec(s), null !== u);)f = c.lastIndex, c === $7c8bf60562922b0b$var$v ? "!--" === u[1] ? c = $7c8bf60562922b0b$var$_ : void 0 !== u[1] ? c = $7c8bf60562922b0b$var$m : void 0 !== u[2] ? ($7c8bf60562922b0b$var$y.test(u[2]) && (n = RegExp("</" + u[2], "g")), c = $7c8bf60562922b0b$var$p) : void 0 !== u[3] && (c = $7c8bf60562922b0b$var$p) : c === $7c8bf60562922b0b$var$p ? ">" === u[0] ? (c = n ?? $7c8bf60562922b0b$var$v, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $7c8bf60562922b0b$var$p : '"' === u[3] ? $7c8bf60562922b0b$var$$ : $7c8bf60562922b0b$var$g) : c === $7c8bf60562922b0b$var$$ || c === $7c8bf60562922b0b$var$g ? c = $7c8bf60562922b0b$var$p : c === $7c8bf60562922b0b$var$_ || c === $7c8bf60562922b0b$var$m ? c = $7c8bf60562922b0b$var$v : (c = $7c8bf60562922b0b$var$p, n = void 0);
        const x = c === $7c8bf60562922b0b$var$p && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $7c8bf60562922b0b$var$v ? s + $7c8bf60562922b0b$var$r : d >= 0 ? (e.push(a), s.slice(0, d) + $7c8bf60562922b0b$var$h + s.slice(d) + $7c8bf60562922b0b$var$o + x) : s + $7c8bf60562922b0b$var$o + (-2 === d ? i : x);
    }
    return [
        $7c8bf60562922b0b$var$V(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $7c8bf60562922b0b$var$S {
    constructor({ strings: t, _$litType$: i }, e){
        let r;
        this.parts = [];
        let l = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $7c8bf60562922b0b$var$N(t, i);
        if (this.el = $7c8bf60562922b0b$var$S.createElement(f, e), $7c8bf60562922b0b$var$P.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $7c8bf60562922b0b$var$P.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($7c8bf60562922b0b$var$h)) {
                    const i = v[a++], s = r.getAttribute(t).split($7c8bf60562922b0b$var$o), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: l,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $7c8bf60562922b0b$var$I : "?" === e[1] ? $7c8bf60562922b0b$var$L : "@" === e[1] ? $7c8bf60562922b0b$var$z : $7c8bf60562922b0b$var$H
                    }), r.removeAttribute(t);
                } else t.startsWith($7c8bf60562922b0b$var$o) && (d.push({
                    type: 6,
                    index: l
                }), r.removeAttribute(t));
                if ($7c8bf60562922b0b$var$y.test(r.tagName)) {
                    const t = r.textContent.split($7c8bf60562922b0b$var$o), i = t.length - 1;
                    if (i > 0) {
                        r.textContent = $7c8bf60562922b0b$var$s ? $7c8bf60562922b0b$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)r.append(t[s], $7c8bf60562922b0b$var$c()), $7c8bf60562922b0b$var$P.nextNode(), d.push({
                            type: 2,
                            index: ++l
                        });
                        r.append(t[i], $7c8bf60562922b0b$var$c());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $7c8bf60562922b0b$var$n) d.push({
                    type: 2,
                    index: l
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($7c8bf60562922b0b$var$o, t + 1));)d.push({
                        type: 7,
                        index: l
                    }), t += $7c8bf60562922b0b$var$o.length - 1;
                }
            }
            l++;
        }
    }
    static createElement(t, i) {
        const s = $7c8bf60562922b0b$var$l.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $7c8bf60562922b0b$var$M(t, i, s = t, e) {
    if (i === $7c8bf60562922b0b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $7c8bf60562922b0b$var$a(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $7c8bf60562922b0b$var$M(t, h._$AS(t, i.values), h, e)), i;
}
class $7c8bf60562922b0b$var$R {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $7c8bf60562922b0b$var$l).importNode(i, !0);
        $7c8bf60562922b0b$var$P.currentNode = e;
        let h = $7c8bf60562922b0b$var$P.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $7c8bf60562922b0b$var$k(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $7c8bf60562922b0b$var$Z(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $7c8bf60562922b0b$var$P.nextNode(), o++);
        }
        return $7c8bf60562922b0b$var$P.currentNode = $7c8bf60562922b0b$var$l, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $7c8bf60562922b0b$var$k {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $7c8bf60562922b0b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $7c8bf60562922b0b$var$M(this, t, i), $7c8bf60562922b0b$var$a(t) ? t === $7c8bf60562922b0b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $7c8bf60562922b0b$export$45b790e32b2810ee && this._$AR(), this._$AH = $7c8bf60562922b0b$export$45b790e32b2810ee) : t !== this._$AH && t !== $7c8bf60562922b0b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $7c8bf60562922b0b$var$d(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $7c8bf60562922b0b$export$45b790e32b2810ee && $7c8bf60562922b0b$var$a(this._$AH) ? this._$AA.nextSibling.data = t : this.T($7c8bf60562922b0b$var$l.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $7c8bf60562922b0b$var$S.createElement($7c8bf60562922b0b$var$V(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $7c8bf60562922b0b$var$R(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $7c8bf60562922b0b$var$C.get(t.strings);
        return void 0 === i && $7c8bf60562922b0b$var$C.set(t.strings, i = new $7c8bf60562922b0b$var$S(t)), i;
    }
    k(t) {
        $7c8bf60562922b0b$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $7c8bf60562922b0b$var$k(this.O($7c8bf60562922b0b$var$c()), this.O($7c8bf60562922b0b$var$c()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, s) {
        for(this._$AP?.(!1, !0, s); t !== this._$AB;){
            const s = $7c8bf60562922b0b$var$i(t).nextSibling;
            $7c8bf60562922b0b$var$i(t).remove(), t = s;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $7c8bf60562922b0b$var$H {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $7c8bf60562922b0b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $7c8bf60562922b0b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $7c8bf60562922b0b$var$M(this, t, i, 0), o = !$7c8bf60562922b0b$var$a(t) || t !== this._$AH && t !== $7c8bf60562922b0b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $7c8bf60562922b0b$var$M(this, e[s + n], i, n), r === $7c8bf60562922b0b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$7c8bf60562922b0b$var$a(r) || r !== this._$AH[n], r === $7c8bf60562922b0b$export$45b790e32b2810ee ? t = $7c8bf60562922b0b$export$45b790e32b2810ee : t !== $7c8bf60562922b0b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $7c8bf60562922b0b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $7c8bf60562922b0b$var$I extends $7c8bf60562922b0b$var$H {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $7c8bf60562922b0b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $7c8bf60562922b0b$var$L extends $7c8bf60562922b0b$var$H {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $7c8bf60562922b0b$export$45b790e32b2810ee);
    }
}
class $7c8bf60562922b0b$var$z extends $7c8bf60562922b0b$var$H {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $7c8bf60562922b0b$var$M(this, t, i, 0) ?? $7c8bf60562922b0b$export$45b790e32b2810ee) === $7c8bf60562922b0b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $7c8bf60562922b0b$export$45b790e32b2810ee && s !== $7c8bf60562922b0b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $7c8bf60562922b0b$export$45b790e32b2810ee && (s === $7c8bf60562922b0b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $7c8bf60562922b0b$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $7c8bf60562922b0b$var$M(this, t);
    }
}
const $7c8bf60562922b0b$export$8613d1ca9052b22e = {
    M: $7c8bf60562922b0b$var$h,
    P: $7c8bf60562922b0b$var$o,
    A: $7c8bf60562922b0b$var$n,
    C: 1,
    L: $7c8bf60562922b0b$var$N,
    R: $7c8bf60562922b0b$var$R,
    D: $7c8bf60562922b0b$var$d,
    V: $7c8bf60562922b0b$var$M,
    I: $7c8bf60562922b0b$var$k,
    H: $7c8bf60562922b0b$var$H,
    N: $7c8bf60562922b0b$var$L,
    U: $7c8bf60562922b0b$var$z,
    B: $7c8bf60562922b0b$var$I,
    F: $7c8bf60562922b0b$var$Z
}, $7c8bf60562922b0b$var$B = $7c8bf60562922b0b$var$t.litHtmlPolyfillSupport;
$7c8bf60562922b0b$var$B?.($7c8bf60562922b0b$var$S, $7c8bf60562922b0b$var$k), ($7c8bf60562922b0b$var$t.litHtmlVersions ??= []).push("3.3.3");
const $7c8bf60562922b0b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $7c8bf60562922b0b$var$k(i.insertBefore($7c8bf60562922b0b$var$c(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8d9a7cd3eb30e1a4$var$s = globalThis;
class $8d9a7cd3eb30e1a4$export$3f2f9f5909897157 extends (0, $4ac9cab3d310a309$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $7c8bf60562922b0b$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $7c8bf60562922b0b$export$9c068ae9cc5db4e8;
    }
}
$8d9a7cd3eb30e1a4$export$3f2f9f5909897157._$litElement$ = !0, $8d9a7cd3eb30e1a4$export$3f2f9f5909897157["finalized"] = !0, $8d9a7cd3eb30e1a4$var$s.litElementHydrateSupport?.({
    LitElement: $8d9a7cd3eb30e1a4$export$3f2f9f5909897157
});
const $8d9a7cd3eb30e1a4$var$o = $8d9a7cd3eb30e1a4$var$s.litElementPolyfillSupport;
$8d9a7cd3eb30e1a4$var$o?.({
    LitElement: $8d9a7cd3eb30e1a4$export$3f2f9f5909897157
});
const $8d9a7cd3eb30e1a4$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($8d9a7cd3eb30e1a4$var$s.litElementVersions ??= []).push("4.2.2");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7ea04fa520387474$export$6acf61af03e62db = !1;





var $2de768523eeac01a$exports = {};
$2de768523eeac01a$exports = "/*! Flickity v3.0.0\nhttps://flickity.metafizzy.co\n---------------------------------------------- */\n.flickity-enabled{position:relative}.flickity-enabled:focus{outline:0}.flickity-viewport{touch-action:pan-y;height:100%;position:relative;overflow:hidden}.flickity-slider{width:100%;height:100%;position:absolute;left:0}.flickity-rtl .flickity-slider{left:unset;right:0}.flickity-enabled.is-draggable{-webkit-tap-highlight-color:transparent;-webkit-user-select:none;user-select:none}.flickity-enabled.is-draggable .flickity-viewport{cursor:move;cursor:grab}.flickity-enabled.is-draggable .flickity-viewport.is-pointer-down{cursor:grabbing}.flickity-cell{position:absolute;left:0}.flickity-rtl .flickity-cell{left:unset;right:0}.flickity-button{color:#333;background:#ffffffbf;border:none;position:absolute}.flickity-button:hover{cursor:pointer;background:#fff}.flickity-button:focus{outline:0;box-shadow:0 0 0 5px #19f}.flickity-button:active{opacity:.6}.flickity-button:disabled{opacity:.3;cursor:auto;pointer-events:none}.flickity-button-icon{fill:currentColor}.flickity-prev-next-button{border-radius:50%;width:44px;height:44px;top:50%;transform:translateY(-50%)}.flickity-prev-next-button.previous{left:10px}.flickity-prev-next-button.next{right:10px}.flickity-rtl .flickity-prev-next-button.previous{left:auto;right:10px}.flickity-rtl .flickity-prev-next-button.next{left:10px;right:auto}.flickity-prev-next-button .flickity-button-icon{width:60%;height:60%;position:absolute;top:20%;left:20%}.flickity-page-dots{text-align:center;flex-wrap:wrap;justify-content:center;width:100%;display:flex;position:absolute;bottom:-25px}.flickity-rtl .flickity-page-dots{direction:rtl}.flickity-page-dot{cursor:pointer;appearance:none;text-indent:-9999px;background:#33333340;border:none;border-radius:50%;width:10px;height:10px;margin:0 8px;padding:0;display:block;overflow:hidden}.flickity-rtl .flickity-page-dot{text-indent:9999px}.flickity-page-dot:focus{outline:0;box-shadow:0 0 0 5px #19f}.flickity-page-dot.is-selected{background:#333}*,:before,:after,::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#3b82f680;--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border:0 solid #e5e7eb}:before,:after{--tw-content:\"\"}html,:host{-webkit-text-size-adjust:100%;tab-size:4;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent;font-family:GeneralSans,serif;line-height:1.5}body{line-height:inherit;margin:0}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-feature-settings:normal;font-variation-settings:normal;font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-feature-settings:inherit;font-variation-settings:inherit;font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:#0000;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{margin:0;padding:0;list-style:none}dialog{padding:0}textarea{resize:vertical}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}input:where([type=text]),input:where(:not([type])),input:where([type=email]),input:where([type=url]),input:where([type=password]),input:where([type=number]),input:where([type=date]),input:where([type=datetime-local]),input:where([type=month]),input:where([type=search]),input:where([type=tel]),input:where([type=time]),input:where([type=week]),select:where([multiple]),textarea,select{appearance:none;--tw-shadow:0 0 #0000;background-color:#fff;border-width:1px;border-color:#6b7280;border-radius:0;padding:.5rem .75rem;font-size:1rem;line-height:1.5rem}input:where([type=text]):focus,input:where(:not([type])):focus,input:where([type=email]):focus,input:where([type=url]):focus,input:where([type=password]):focus,input:where([type=number]):focus,input:where([type=date]):focus,input:where([type=datetime-local]):focus,input:where([type=month]):focus,input:where([type=search]):focus,input:where([type=tel]):focus,input:where([type=time]):focus,input:where([type=week]):focus,select:where([multiple]):focus,textarea:focus,select:focus{outline-offset:2px;--tw-ring-inset:var(--tw-empty, );--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#2563eb;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);border-color:#2563eb;outline:2px solid #0000}input::placeholder,textarea::placeholder{color:#6b7280;opacity:1}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-date-and-time-value{min-height:1.5em;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit{padding-top:0;padding-bottom:0}::-webkit-datetime-edit-year-field{padding-top:0;padding-bottom:0}::-webkit-datetime-edit-month-field{padding-top:0;padding-bottom:0}::-webkit-datetime-edit-day-field{padding-top:0;padding-bottom:0}::-webkit-datetime-edit-hour-field{padding-top:0;padding-bottom:0}::-webkit-datetime-edit-minute-field{padding-top:0;padding-bottom:0}::-webkit-datetime-edit-second-field{padding-top:0;padding-bottom:0}::-webkit-datetime-edit-millisecond-field{padding-top:0;padding-bottom:0}::-webkit-datetime-edit-meridiem-field{padding-top:0;padding-bottom:0}select{-webkit-print-color-adjust:exact;print-color-adjust:exact;background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");background-position:right .5rem center;background-repeat:no-repeat;background-size:1.5em 1.5em;padding-right:2.5rem}select:where([multiple]),select:where([size]:not([size=\"1\"])){background-image:initial;background-position:initial;background-repeat:unset;background-size:initial;print-color-adjust:unset;padding-right:.75rem}input:where([type=checkbox]),input:where([type=radio]){appearance:none;-webkit-print-color-adjust:exact;print-color-adjust:exact;vertical-align:middle;-webkit-user-select:none;user-select:none;color:#2563eb;--tw-shadow:0 0 #0000;background-color:#fff;background-origin:border-box;border-width:1px;border-color:#6b7280;flex-shrink:0;width:1rem;height:1rem;padding:0;display:inline-block}input:where([type=checkbox]){border-radius:0}input:where([type=radio]){border-radius:100%}input:where([type=checkbox]):focus,input:where([type=radio]):focus{outline-offset:2px;--tw-ring-inset:var(--tw-empty, );--tw-ring-offset-width:2px;--tw-ring-offset-color:#fff;--tw-ring-color:#2563eb;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);outline:2px solid #0000}input:where([type=checkbox]):checked,input:where([type=radio]):checked{background-color:currentColor;background-position:50%;background-repeat:no-repeat;background-size:100% 100%;border-color:#0000}input:where([type=checkbox]):checked{background-image:url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e\")}@media (forced-colors:active){input:where([type=checkbox]):checked{appearance:auto}}input:where([type=radio]):checked{background-image:url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e\")}@media (forced-colors:active){input:where([type=radio]):checked{appearance:auto}}input:where([type=checkbox]):checked:hover,input:where([type=checkbox]):checked:focus,input:where([type=radio]):checked:hover,input:where([type=radio]):checked:focus{background-color:currentColor;border-color:#0000}input:where([type=checkbox]):indeterminate{background-color:currentColor;background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3e%3cpath stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8h8'/%3e%3c/svg%3e\");background-position:50%;background-repeat:no-repeat;background-size:100% 100%;border-color:#0000}@media (forced-colors:active){input:where([type=checkbox]):indeterminate{appearance:auto}}input:where([type=checkbox]):indeterminate:hover,input:where([type=checkbox]):indeterminate:focus{background-color:currentColor;border-color:#0000}input:where([type=file]){background:unset;border-color:inherit;font-size:unset;line-height:inherit;border-width:0;border-radius:0;padding:0}input:where([type=file]):focus{outline:1px solid buttontext;outline:1px auto -webkit-focus-ring-color}.content{--containerWidth:clamp(800px, 76.1115vw, 1230px);--gap:clamp(20px, 4.16vw, 40px);--full:auto;--content:min(var(--containerWidth), 100% - var(--gap) * 2);--popout:minmax(0, 2rem);--fluid:1fr;grid-template-columns:[gap-start] var(--gap) [fluid-start] var(--fluid) [content-start] var(--content) [content-end] var(--fluid) [fluid-end] var(--gap) [gap-end];display:grid}.content>*{grid-column:content}.content>.content{grid-column:full;grid-template-columns:inherit}.content-inner{width:100%;margin-left:auto;margin-right:auto}@media (width>=1024px){.content-inner{max-width:min(86vw,870px)}}.content-default{grid-column:content}.content-full{grid-column:gap}.\\!content-fluid{grid-column:fluid!important}.content-fluid{grid-column:fluid}.prose{font-size:1.125rem}.prose :where(.block-btn-wrap):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:clamp(24px,2.222vw,32px);margin-bottom:clamp(24px,2.222vw,32px)}.prose :where(.giantpeach-buttonlist):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:32px;margin-bottom:32px}.prose :where(.giantpeach-buttonlist .gp-btn):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0;margin-bottom:0}.prose :where(p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.2rem;line-height:1.4}.prose :where(p a:not(.not-prose)):not(:where([class~=not-prose],[class~=not-prose] *)){text-underline-position:from-font;text-decoration:underline}.prose :where(ul):not(:where([class~=not-prose],[class~=not-prose] *)){list-style:initial;margin-top:1.5rem;margin-bottom:1.5rem;padding-left:1rem;line-height:1.555}.prose :where(ol):not(:where([class~=not-prose],[class~=not-prose] *)){list-style:initial;margin-top:1.5rem;margin-bottom:1.5rem;padding-left:1rem;line-height:1.555;list-style-type:decimal}.prose :where(li:not(:last-child)):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:.6rem}.prose :where(li):not(:where([class~=not-prose],[class~=not-prose] *))::marker{color:currentColor}.prose :where(.prose>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(.prose>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0!important}.pointer-events-none{pointer-events:none}.pointer-events-auto{pointer-events:auto}.\\!visible{visibility:visible!important}.visible{visibility:visible}.invisible{visibility:hidden}.\\!static{position:static!important}.static{position:static}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.sticky{position:sticky}.inset-0{inset:0}.inset-\\[400px\\]{inset:400px}.-left-2{left:-.5rem}.-top-px{top:-1px}.bottom-0{bottom:0}.bottom-4{bottom:1rem}.bottom-5{bottom:1.25rem}.bottom-\\[72px\\]{bottom:72px}.bottom-full{bottom:100%}.left-0{left:0}.left-1\\/2{left:50%}.left-4{left:1rem}.left-5{left:1.25rem}.right-0{right:0}.right-5{right:1.25rem}.top-0{top:0}.top-1\\/2{top:50%}.top-3{top:.75rem}.top-5{top:1.25rem}.top-\\[10px\\]{top:10px}.top-\\[50svh\\]{top:50svh}.top-\\[63px\\]{top:63px}.top-full{top:100%}.top-px{top:1px}.-z-10{z-index:-10}.z-10{z-index:10}.z-20{z-index:20}.z-30{z-index:30}.z-40{z-index:40}.z-50{z-index:50}.z-\\[100\\]{z-index:100}.z-\\[101\\]{z-index:101}.z-\\[2\\]{z-index:2}.z-\\[99\\]{z-index:99}.order-1{order:1}.order-2{order:2}.order-3{order:3}.m-auto{margin:auto}.-my-\\[2px\\]{margin-top:-2px;margin-bottom:-2px}.mx-auto{margin-left:auto;margin-right:auto}.my-10{margin-top:2.5rem;margin-bottom:2.5rem}.my-15{margin-top:3.75rem;margin-bottom:3.75rem}.my-5{margin-top:1.25rem;margin-bottom:1.25rem}.my-6{margin-top:1.5rem;margin-bottom:1.5rem}.\\!mb-0{margin-bottom:0!important}.\\!mb-1{margin-bottom:.25rem!important}.\\!mb-10{margin-bottom:2.5rem!important}.\\!mb-2{margin-bottom:.5rem!important}.\\!mb-4{margin-bottom:1rem!important}.\\!mb-6{margin-bottom:1.5rem!important}.-mb-px{margin-bottom:-1px}.-ml-5{margin-left:-1.25rem}.-ml-px{margin-left:-1px}.-mt-5{margin-top:-1.25rem}.mb-0{margin-bottom:0}.mb-0\\.5{margin-bottom:.125rem}.mb-1{margin-bottom:.25rem}.mb-10{margin-bottom:2.5rem}.mb-12{margin-bottom:3rem}.mb-15{margin-bottom:3.75rem}.mb-2{margin-bottom:.5rem}.mb-3{margin-bottom:.75rem}.mb-4{margin-bottom:1rem}.mb-5{margin-bottom:1.25rem}.mb-6{margin-bottom:1.5rem}.mb-8{margin-bottom:2rem}.mb-\\[10px\\]{margin-bottom:10px}.mb-\\[16px\\]{margin-bottom:16px}.ml-1\\.5{margin-left:.375rem}.ml-3{margin-left:.75rem}.ml-auto{margin-left:auto}.mr-1{margin-right:.25rem}.mt-1{margin-top:.25rem}.mt-10{margin-top:2.5rem}.mt-15{margin-top:3.75rem}.mt-16{margin-top:4rem}.mt-2{margin-top:.5rem}.mt-20{margin-top:5rem}.mt-3{margin-top:.75rem}.mt-4{margin-top:1rem}.mt-6{margin-top:1.5rem}.mt-7{margin-top:1.75rem}.mt-8{margin-top:2rem}.mt-\\[30px\\]{margin-top:30px}.mt-auto{margin-top:auto}.box-border{box-sizing:border-box}.line-clamp-2{-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.block{display:block}.inline-block{display:inline-block}.flex{display:flex}.grid{display:grid}.\\!hidden{display:none!important}.hidden{display:none}.aspect-\\[1096\\/540\\]{aspect-ratio:1096/540}.aspect-\\[266\\/318\\]{aspect-ratio:266/318}.aspect-\\[35\\/18\\]{aspect-ratio:35/18}.aspect-\\[35\\/22\\]{aspect-ratio:35/22}.aspect-\\[35\\/52\\]{aspect-ratio:35/52}.aspect-\\[350\\/220\\]{aspect-ratio:350/220}.aspect-\\[350\\/643\\]{aspect-ratio:350/643}.aspect-\\[352\\/536\\]{aspect-ratio:352/536}.aspect-\\[353\\/562\\]{aspect-ratio:353/562}.aspect-square{aspect-ratio:1}.aspect-video{aspect-ratio:16/9}.size-10{width:2.5rem;height:2.5rem}.size-11{width:2.75rem;height:2.75rem}.size-12{width:3rem;height:3rem}.size-\\[38px\\]{width:38px;height:38px}.size-\\[44px\\]{width:44px;height:44px}.size-full{width:100%;height:100%}.\\!h-auto{height:auto!important}.\\!h-full{height:100%!important}.h-1{height:.25rem}.h-12{height:3rem}.h-3\\/5{height:60%}.h-5{height:1.25rem}.h-\\[11px\\]{height:11px}.h-\\[150px\\]{height:150px}.h-\\[200px\\]{height:200px}.h-\\[21\\.1vw\\]{height:21.1vw}.h-\\[2px\\]{height:2px}.h-\\[35\\.5vw\\]{height:35.5vw}.h-\\[40px\\]{height:40px}.h-\\[68px\\]{height:68px}.h-\\[80svh\\]{height:80svh}.h-\\[calc\\(300px\\+\\(100svh-300px\\)\\*\\(var\\(--scroll-percent\\)\\)\\)\\]{height:calc(300px + (100svh - 300px) * (var(--scroll-percent)))}.h-auto{height:auto}.h-full{height:100%}.h-px{height:1px}.h-svh{height:100svh}.max-h-\\[24px\\]{max-height:24px}.max-h-\\[55vh\\]{max-height:55vh}.min-h-\\[112vw\\]{min-height:112vw}.min-h-\\[300px\\]{min-height:300px}.min-h-\\[400px\\]{min-height:400px}.min-h-\\[560px\\]{min-height:560px}.min-h-\\[580px\\]{min-height:580px}.min-h-full{min-height:100%}.\\!w-auto{width:auto!important}.w-0\\.5{width:.125rem}.w-1\\/2{width:50%}.w-4{width:1rem}.w-\\[1095px\\]{width:1095px}.w-\\[14px\\]{width:14px}.w-\\[164px\\]{width:164px}.w-\\[16px\\]{width:16px}.w-\\[1em\\]{width:1em}.w-\\[400px\\]{width:400px}.w-\\[66px\\]{width:66px}.w-\\[71px\\]{width:71px}.w-\\[98\\%\\]{width:98%}.w-\\[calc\\(100\\%\\*\\(var\\(--scroll-percent\\)\\)\\)\\]{width:calc(100% * (var(--scroll-percent)))}.w-\\[calc\\(100\\%-24px\\)\\]{width:calc(100% - 24px)}.w-\\[calc\\(100\\%_\\+_20px\\)\\]{width:calc(100% + 20px)}.w-\\[calc\\(100\\%_-_32px\\)\\]{width:calc(100% - 32px)}.w-\\[calc\\(100\\%_-_40px\\)\\]{width:calc(100% - 40px)}.w-auto{width:auto}.w-fit{width:fit-content}.w-full{width:100%}.w-svw{width:100svw}.min-w-12{min-width:3rem}.min-w-\\[60px\\]{min-width:60px}.min-w-\\[880px\\]{min-width:880px}.min-w-\\[calc\\(100vw-40px\\)\\]{min-width:calc(100vw - 40px)}.\\!max-w-\\[1096px\\]{max-width:1096px!important}.max-w-\\[130px\\]{max-width:130px}.max-w-\\[680px\\]{max-width:680px}.max-w-full{max-width:100%}.max-w-lg{max-width:32rem}.max-w-none{max-width:none}.flex-1{flex:1}.flex-shrink-0{flex-shrink:0}.origin-center{transform-origin:50%}.origin-left{transform-origin:0}.origin-top{transform-origin:top}.\\!translate-x-0{--tw-translate-x:0px!important;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))!important}.\\!translate-y-0{--tw-translate-y:0px!important;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))!important}.-translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-translate-x-full{--tw-translate-x:-100%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-translate-x-px{--tw-translate-x:-1px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-translate-y-1\\/2{--tw-translate-y:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-0\\.5{--tw-translate-x:.125rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-full{--tw-translate-x:100%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-0{--tw-translate-y:0px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-px{--tw-translate-y:1px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.\\!-rotate-180{--tw-rotate:-180deg!important;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))!important}.\\!-rotate-45{--tw-rotate:-45deg!important;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))!important}.\\!rotate-45{--tw-rotate:45deg!important;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))!important}.rotate-0{--tw-rotate:0deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-180{--tw-rotate:180deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.\\!scale-x-0{--tw-scale-x:0!important;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))!important}.scale-x-100{--tw-scale-x:1;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.scale-x-90{--tw-scale-x:.9;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform{transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.cursor-pointer{cursor:pointer}.select-none{-webkit-user-select:none;user-select:none}.resize{resize:both}.snap-y{scroll-snap-type:y var(--tw-scroll-snap-strictness)}.snap-mandatory{--tw-scroll-snap-strictness:mandatory}.snap-start{scroll-snap-align:start}.scroll-my-10{scroll-margin-top:2.5rem;scroll-margin-bottom:2.5rem}.\\!grid-cols-\\[1fr_1fr\\]{grid-template-columns:1fr 1fr!important}.\\!grid-cols-\\[2fr_3fr\\]{grid-template-columns:2fr 3fr!important}.\\!grid-cols-\\[3fr_2fr\\]{grid-template-columns:3fr 2fr!important}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-\\[1fr_1fr\\]{grid-template-columns:1fr 1fr}.grid-cols-\\[auto_100px\\]{grid-template-columns:auto 100px}.\\!grid-rows-\\[1fr\\]{grid-template-rows:1fr!important}.grid-rows-\\[0fr\\]{grid-template-rows:0fr}.grid-rows-\\[1fr\\]{grid-template-rows:1fr}.grid-rows-\\[1fr_auto\\]{grid-template-rows:1fr auto}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.place-items-start{place-items:start}.place-items-end{place-items:end}.place-items-center{place-items:center}.place-items-baseline{place-items:baseline}.place-items-stretch{place-items:stretch stretch}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.items-baseline{align-items:baseline}.items-stretch{align-items:stretch}.\\!justify-start{justify-content:flex-start!important}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}.justify-items-start{justify-items:start}.justify-items-end{justify-items:end}.justify-items-center{justify-items:center}.justify-items-stretch{justify-items:stretch}.gap-1{gap:.25rem}.gap-10{gap:2.5rem}.gap-2{gap:.5rem}.gap-3{gap:.75rem}.gap-4{gap:1rem}.gap-5{gap:1.25rem}.gap-6{gap:1.5rem}.gap-8{gap:2rem}.gap-9{gap:2.25rem}.gap-\\[30px\\]{gap:30px}.gap-\\[60px\\]{gap:60px}.gap-\\[6px\\]{gap:6px}.gap-y-1{row-gap:.25rem}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-y-auto{overflow-y:auto}.overflow-x-hidden{overflow-x:hidden}.overflow-y-hidden{overflow-y:hidden}.overflow-y-scroll{overflow-y:scroll}.text-ellipsis{text-overflow:ellipsis}.whitespace-nowrap{white-space:nowrap}.\\!rounded-none{border-radius:0!important}.rounded{border-radius:20px}.rounded-\\[10px\\]{border-radius:10px}.rounded-full{border-radius:9999px}.rounded-xl{border-radius:.75rem}.rounded-b{border-bottom-right-radius:20px;border-bottom-left-radius:20px}.rounded-r{border-top-right-radius:20px;border-bottom-right-radius:20px}.border-b{border-bottom-width:1px}.border-hidden{border-style:hidden}.\\!bg-white{--tw-bg-opacity:1!important;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))!important}.bg-beige{--tw-bg-opacity:1;background-color:rgb(245 245 240/var(--tw-bg-opacity,1))}.bg-black\\/50{background-color:#00000080}.bg-blue{--tw-bg-opacity:1;background-color:rgb(192 234 241/var(--tw-bg-opacity,1))}.bg-current{background-color:currentColor}.bg-gray{--tw-bg-opacity:1;background-color:rgb(42 46 52/var(--tw-bg-opacity,1))}.bg-gray-light{--tw-bg-opacity:1;background-color:rgb(233 234 236/var(--tw-bg-opacity,1))}.bg-green{--tw-bg-opacity:1;background-color:rgb(1 78 70/var(--tw-bg-opacity,1))}.bg-green-dark{--tw-bg-opacity:1;background-color:rgb(12 46 45/var(--tw-bg-opacity,1))}.bg-green-light{--tw-bg-opacity:1;background-color:rgb(203 253 219/var(--tw-bg-opacity,1))}.bg-orange{--tw-bg-opacity:1;background-color:rgb(237 114 81/var(--tw-bg-opacity,1))}.bg-slate-200{--tw-bg-opacity:1;background-color:rgb(226 232 240/var(--tw-bg-opacity,1))}.bg-slate-300{--tw-bg-opacity:1;background-color:rgb(203 213 225/var(--tw-bg-opacity,1))}.bg-slate-500{--tw-bg-opacity:1;background-color:rgb(100 116 139/var(--tw-bg-opacity,1))}.bg-white{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}.bg-white\\/25{background-color:#ffffff40}.bg-white\\/75{background-color:#ffffffbf}.bg-gradient-to-b{background-image:linear-gradient(to bottom, var(--tw-gradient-stops))}.from-green{--tw-gradient-from:#014e46 var(--tw-gradient-from-position);--tw-gradient-to:#014e4600 var(--tw-gradient-to-position);--tw-gradient-stops:var(--tw-gradient-from), var(--tw-gradient-to)}.from-transparent{--tw-gradient-from:transparent var(--tw-gradient-from-position);--tw-gradient-to:#0000 var(--tw-gradient-to-position);--tw-gradient-stops:var(--tw-gradient-from), var(--tw-gradient-to)}.to-black\\/\\[0\\.1\\]{--tw-gradient-to:#0000001a var(--tw-gradient-to-position)}.to-green-dark{--tw-gradient-to:#0c2e2d var(--tw-gradient-to-position)}.to-white{--tw-gradient-to:#fff var(--tw-gradient-to-position)}.bg-cover{background-size:cover}.\\!object-contain{object-fit:contain!important}.object-cover{object-fit:cover}.object-center{object-position:center}.p-4{padding:1rem}.p-5{padding:1.25rem}.px-2\\.5{padding-left:.625rem;padding-right:.625rem}.px-4{padding-left:1rem;padding-right:1rem}.px-5{padding-left:1.25rem;padding-right:1.25rem}.px-8{padding-left:2rem;padding-right:2rem}.px-\\[10px\\]{padding-left:10px;padding-right:10px}.px-\\[20px\\]{padding-left:20px;padding-right:20px}.px-\\[30px\\]{padding-left:30px;padding-right:30px}.py-0{padding-top:0;padding-bottom:0}.py-1\\.5{padding-top:.375rem;padding-bottom:.375rem}.py-10{padding-top:2.5rem;padding-bottom:2.5rem}.py-15{padding-top:3.75rem;padding-bottom:3.75rem}.py-16{padding-top:4rem;padding-bottom:4rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-4{padding-top:1rem;padding-bottom:1rem}.py-8{padding-top:2rem;padding-bottom:2rem}.py-9{padding-top:2.25rem;padding-bottom:2.25rem}.py-\\[11px\\]{padding-top:11px;padding-bottom:11px}.py-\\[50px\\]{padding-top:50px;padding-bottom:50px}.pb-0{padding-bottom:0}.pb-10{padding-bottom:2.5rem}.pb-15{padding-bottom:3.75rem}.pb-2{padding-bottom:.5rem}.pb-20{padding-bottom:5rem}.pb-3{padding-bottom:.75rem}.pb-4{padding-bottom:1rem}.pb-6{padding-bottom:1.5rem}.pb-\\[20px\\]{padding-bottom:20px}.pb-\\[42px\\]{padding-bottom:42px}.pb-px{padding-bottom:1px}.pl-6{padding-left:1.5rem}.pr-4{padding-right:1rem}.pt-10{padding-top:2.5rem}.pt-25{padding-top:6.25rem}.pt-3{padding-top:.75rem}.pt-30{padding-top:7.5rem}.pt-4{padding-top:1rem}.pt-6{padding-top:1.5rem}.pt-\\[11px\\]{padding-top:11px}.pt-\\[140px\\]{padding-top:140px}.pt-\\[90px\\]{padding-top:90px}.\\!text-left{text-align:left!important}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.align-middle{vertical-align:middle}.font-general{font-family:GeneralSans,serif}.\\!text-h4\\/\\[1\\.4\\]{font-size:clamp(24px,1.94vw,28px)!important;line-height:1.4!important}.\\!text-lg\\/\\[48px\\]{font-size:1.125rem!important;line-height:48px!important}.\\!text-sm{font-size:.875rem!important;line-height:1.25rem!important}.text-\\[0px\\]{font-size:0}.text-\\[14px\\]{font-size:14px}.text-\\[14px\\]\\/\\[1\\.3\\]{font-size:14px;line-height:1.3}.text-\\[14px\\]\\/\\[1\\]{font-size:14px;line-height:1}.text-\\[16px\\]{font-size:16px}.text-\\[16px\\]\\/\\[1\\.4\\]{font-size:16px;line-height:1.4}.text-\\[17px\\]\\/\\[65px\\]{font-size:17px;line-height:65px}.text-\\[18px\\]{font-size:18px}.text-\\[20px\\]{font-size:20px}.text-\\[20px\\]\\/\\[1\\.2\\]{font-size:20px;line-height:1.2}.text-\\[20px\\]\\/\\[1\\.4\\]{font-size:20px;line-height:1.4}.text-\\[22px\\]{font-size:22px}.text-\\[24px\\]{font-size:24px}.text-\\[25px\\]{font-size:25px}.text-\\[32px\\]\\/\\[1\\.2\\]{font-size:32px;line-height:1.2}.text-base{font-size:1rem;line-height:1.4}.text-base\\/\\[1\\.8125\\]{font-size:1rem;line-height:1.8125}.text-h1-2{font-size:clamp(44px,5.55vw,80px);line-height:1.2}.text-h3{font-size:clamp(32px,2.5vw,36px);line-height:1.2}.text-h4{font-size:clamp(24px,1.94vw,28px);line-height:1.2}.text-hexagon{font-size:clamp(44px,5.55vw,80px);line-height:1.2}.text-hexagon-p{font-size:clamp(14px,1.25vw,18px);line-height:1.58}.text-lead{font-size:clamp(18px,1.66vw,24px);line-height:1.4}.text-lg{font-size:1.125rem;line-height:1.4}.text-lg\\/\\[48px\\]{font-size:1.125rem;line-height:48px}.text-md{font-size:1rem;line-height:1.4}.text-md\\/\\[40px\\]{font-size:1rem;line-height:40px}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xl\\/\\[1\\]{font-size:1.25rem;line-height:1}.text-xs{font-size:.75rem;line-height:1rem}.\\!font-medium{font-weight:500!important}.font-bold{font-weight:700}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.not-italic{font-style:normal}.leading-\\[0\\]{line-height:0}.leading-\\[36px\\]{line-height:36px}.leading-\\[44px\\]{line-height:44px}.tracking-\\[0\\.15em\\]{letter-spacing:.15em}.tracking-wider{letter-spacing:.05em}.\\!text-green-dark{--tw-text-opacity:1!important;color:rgb(12 46 45/var(--tw-text-opacity,1))!important}.\\!text-inherit{color:inherit!important}.\\!text-white{--tw-text-opacity:1!important;color:rgb(255 255 255/var(--tw-text-opacity,1))!important}.text-beige{--tw-text-opacity:1;color:rgb(245 245 240/var(--tw-text-opacity,1))}.text-black{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity,1))}.text-blue{--tw-text-opacity:1;color:rgb(192 234 241/var(--tw-text-opacity,1))}.text-green{--tw-text-opacity:1;color:rgb(1 78 70/var(--tw-text-opacity,1))}.text-green-dark{--tw-text-opacity:1;color:rgb(12 46 45/var(--tw-text-opacity,1))}.text-green-light{--tw-text-opacity:1;color:rgb(203 253 219/var(--tw-text-opacity,1))}.text-inherit{color:inherit}.text-orange{--tw-text-opacity:1;color:rgb(237 114 81/var(--tw-text-opacity,1))}.text-slate-500{--tw-text-opacity:1;color:rgb(100 116 139/var(--tw-text-opacity,1))}.text-white{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1))}.text-white\\/50{color:#ffffff80}.\\!opacity-100{opacity:1!important}.opacity-0{opacity:0}.opacity-100{opacity:1}.opacity-20{opacity:.2}.opacity-25{opacity:.25}.opacity-40{opacity:.4}.opacity-50{opacity:.5}.opacity-60{opacity:.6}.opacity-75{opacity:.75}.brightness-\\[1000\\]{--tw-brightness:brightness(1000);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.invert{--tw-invert:invert(100%);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.saturate-0{--tw-saturate:saturate(0);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.backdrop-blur-\\[20px\\]{--tw-backdrop-blur:blur(20px);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-all{transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-transform{transition-property:transform;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.delay-0{transition-delay:0s}.delay-300{transition-delay:.3s}.duration-100{transition-duration:.1s}.duration-150{transition-duration:.15s}.duration-200{transition-duration:.2s}.duration-300{transition-duration:.3s}.duration-500{transition-duration:.5s}.ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.will-change-auto{will-change:auto}.will-change-transform{will-change:transform}.bg-header-navbar{backdrop-filter:blur(20px);background:linear-gradient(#cbfddb33 0% 100%),linear-gradient(#fff9 0%,#f5f5f599 100%)}.svg-adjust svg{width:100%;height:auto}:root{--gap:clamp(20px, 4.16vw, 60px)}[x-cloak]{display:none!important}@font-face{font-family:GeneralSans;src:url(GeneralSans-Regular.59789f03.otf)format(\"opentype\");font-weight:400;font-style:normal}@font-face{font-family:GeneralSans;src:url(GeneralSans-Medium.bff293e7.otf)format(\"opentype\");font-weight:500;font-style:normal}.container .container{padding-left:0;padding-right:0}.wp-block-force-loading{display:none}::selection{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1));background-color:#6a7d71aa}.gp-logoslider{mask-image:linear-gradient(90deg,#0000 0%,#000 10% 90%,#0000 100%)}.flickity-slider{align-items:center;display:flex}body.gp-theme{-webkit-font-smoothing:antialiased;--tw-text-opacity:1;color:rgb(12 46 45/var(--tw-text-opacity,1));font-family:GeneralSans,serif;font-size:1.125rem;line-height:1.4}.entry-content{z-index:10;position:relative}h1,.is-style-h1{letter-spacing:-.02em;margin-bottom:1rem;font-family:loretta-display,serif;font-size:clamp(52px,6.25vw,90px);font-weight:400;line-height:1.1}.is-style-h1-2{letter-spacing:-.02em;margin-bottom:1rem;font-family:loretta-display,serif;font-size:clamp(44px,5.55vw,80px);font-weight:400;line-height:1.2}h2,.is-style-h2{margin-bottom:1.5rem;font-family:loretta-display,serif;font-size:clamp(40px,4.16vw,60px);font-weight:400;line-height:1.2}@media (width>=1024px){h2,.is-style-h2{margin-bottom:2rem}}h2,.is-style-h2{letter-spacing:-.02em}h3,.is-style-h3{margin-bottom:1rem;font-family:GeneralSans,serif;font-size:clamp(32px,2.5vw,36px);font-weight:400;line-height:1.2}@media (width>=1024px){h3,.is-style-h3{margin-bottom:2rem}}h3,.is-style-h3{letter-spacing:0}h4,.is-style-h4{letter-spacing:0;margin-bottom:1rem;font-family:GeneralSans,serif;font-size:clamp(24px,1.94vw,28px);font-weight:400;line-height:1.2}h5,.is-style-h6{letter-spacing:0;font-family:GeneralSans,serif;font-size:20px;font-weight:400}h6,.is-style-h6{letter-spacing:0;font-family:GeneralSans,serif;font-size:18px;font-weight:400}.text-hexagon{letter-spacing:-.02em;font-variant:lining-nums;margin-bottom:0!important;font-family:loretta-display,serif!important}.pretitle,.is-style-pretitle{text-transform:uppercase;letter-spacing:.04em;margin-bottom:.625rem;font-family:GeneralSans,serif;font-weight:500;font-size:.875rem!important;line-height:1.25rem!important}.wp-block-list.is-style-featured{text-align:left;gap:1rem;margin-top:1.25rem;margin-left:0;margin-right:0;padding-left:0;padding-right:0;list-style-type:none;margin-bottom:-1rem!important}@media (width>=1024px){.wp-block-list.is-style-featured{columns:2;margin-top:2rem}}.wp-block-list.is-style-featured>li{z-index:10;text-transform:uppercase;align-items:center;gap:1rem;margin-right:.75rem;font-size:.875rem;font-weight:500;line-height:1.25rem;display:flex;position:relative;margin-bottom:1rem!important}@media (width>=1024px){.wp-block-list.is-style-featured>li{gap:1.25rem;padding-right:2rem}}.wp-block-list.is-style-featured>li{letter-spacing:.04em}.wp-block-list.is-style-featured>li:before{--tw-bg-opacity:1;background-color:rgb(203 253 219/var(--tw-bg-opacity,1));text-align:center;--tw-text-opacity:1;width:2.25rem;min-width:2.25rem;height:2.25rem;color:rgb(12 46 45/var(--tw-text-opacity,1));border-radius:9999px;display:inline-block;font-size:1rem!important;line-height:32px!important}@media (width>=1024px){.wp-block-list.is-style-featured>li:before{width:2.75rem;min-width:2.75rem;height:2.75rem;font-size:1rem!important;line-height:44px!important}}ul.wp-block-list.is-style-featured>li:before{content:\"\";background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNDUgMTEuMjNMMCA1Ljc4TDAuNjggNS4xMUw1LjQ1IDkuODhMMTUuMzIgMEwxNiAwLjY4TDUuNDUgMTEuMjNaIiBmaWxsPSIjMEMyRTJEIi8+Cjwvc3ZnPgo=);background-position:50%;background-repeat:no-repeat}.prose p{font-size:clamp(16px,1.39vw,20px)}.prose .giantpeach-media{margin-top:2.5rem;margin-bottom:2.5rem}@media (width>=1024px){.prose .giantpeach-media{margin-top:3.75rem;margin-bottom:3.75rem}}p.is-style-lead,.is-style-lead{font-size:clamp(18px,1.66vw,24px);line-height:1.4;font-weight:400!important}.wp-block-giantpeach-card{z-index:30;position:relative}.wp-block-giantpeach-card:first-child{z-index:21}.wp-block-giantpeach-card:nth-child(2){z-index:20}.wp-block-giantpeach-card:nth-child(3){z-index:19}.wp-block-giantpeach-card:nth-child(4){z-index:18}.wp-block-giantpeach-card:nth-child(5){z-index:17}.wp-block-giantpeach-card:nth-child(6){z-index:16}.wp-block-giantpeach-card:nth-child(7){z-index:15}.wp-block-giantpeach-card:nth-child(8){z-index:14}.wp-block-giantpeach-card:nth-child(9){z-index:13}.wp-block-giantpeach-card:nth-child(10){z-index:12}.wp-block-giantpeach-card:nth-child(11){z-index:11}.wp-block-giantpeach-card:nth-child(12){z-index:10}.wp-block-giantpeach-card:nth-child(13){z-index:9}.wp-block-giantpeach-card:nth-child(14){z-index:8}.wp-block-giantpeach-card:nth-child(15){z-index:7}.wp-block-giantpeach-card:nth-child(16){z-index:6}.wp-block-giantpeach-card:nth-child(17){z-index:5}.wp-block-giantpeach-card:nth-child(18){z-index:4}.wp-block-giantpeach-card:nth-child(19){z-index:3}.wp-block-giantpeach-card:nth-child(20){z-index:2}.arrow-gradient{text-align:center;background-image:url(cta-gradient.c5b0874a.svg);background-position:50%;background-size:cover;flex-direction:column;justify-content:center;min-height:112vw;display:flex}@media (width>=1024px){.arrow-gradient{min-height:40vw}}.wp-site-blocks .entry-content+.giantpeach-card{margin-top:-1.25rem;padding-top:1.25rem}.wp-site-blocks strong,.wp-site-blocks bold,.wp-site-blocks b{font-weight:500}.wp-site-blocks .entry-content+.giantpeach-card{z-index:2}body.gp-theme .transition-block{--tw-translate-y:60px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));opacity:0}body.gp-theme .transition-block-fade{opacity:0}body.gp-theme .transition-block-prose>:not(.block-btn):not(.btn-text){transition-property:opacity,transform;transition-duration:.5s,.5s}body.gp-theme .transition-block-prose>*{opacity:0;transition-delay:.6s;transform:translateY(15px)}body.gp-theme .transition-block-prose>:first-child{transition-delay:0s,0s}body.gp-theme .transition-block-prose>:nth-child(2){transition-delay:.15s,.15s}body.gp-theme .transition-block-prose>:nth-child(3){transition-delay:.3s,.3s}body.gp-theme .transition-block-prose>:nth-child(4){transition-delay:.45s,.45s}body.gp-theme .transition-block-prose.animated>*{opacity:1;transform:translateY(0)}body.gp-theme .transition-block-prose.animated.opacity-p>p:not([class*=is-style]){opacity:.5}.banner-overlay{background:linear-gradient(#0000 0%,#0009 100%)}.is-style-small{font-size:clamp(14px,1.11vw,16px)!important}.child-my-reset>:first-child{margin-top:0!important}.child-my-reset>:last-child{margin-bottom:0!important}.contact-form [type=text],.contact-form [type=email],.contact-form [type=url],.contact-form [type=password],.contact-form [type=number],.contact-form [type=date],.contact-form [type=datetime-local],.contact-form [type=month],.contact-form [type=search],.contact-form [type=tel],.contact-form [type=time],.contact-form [type=week],.contact-form [multiple],.contact-form textarea,.contact-form select{background:0 0;box-shadow:none!important;font-size:16px!important}.contact-form [type=text]:placeholder-shown,.contact-form [type=email]:placeholder-shown,.contact-form [type=url]:placeholder-shown,.contact-form [type=password]:placeholder-shown,.contact-form [type=number]:placeholder-shown,.contact-form [type=date]:placeholder-shown,.contact-form [type=datetime-local]:placeholder-shown,.contact-form [type=month]:placeholder-shown,.contact-form [type=search]:placeholder-shown,.contact-form [type=tel]:placeholder-shown,.contact-form [type=time]:placeholder-shown,.contact-form [type=week]:placeholder-shown,.contact-form [multiple]:placeholder-shown,.contact-form textarea:placeholder-shown,.contact-form select:not(:checked){opacity:.4}.contact-form select.has-value,.contact-form [type=text]:focus,.contact-form [type=email]:focus,.contact-form [type=url]:focus,.contact-form [type=password]:focus,.contact-form [type=number]:focus,.contact-form [type=date]:focus,.contact-form [type=datetime-local]:focus,.contact-form [type=month]:focus,.contact-form [type=search]:focus,.contact-form [type=tel]:focus,.contact-form [type=time]:focus,.contact-form [type=week]:focus,.contact-form [multiple]:focus,.contact-form textarea:focus,.contact-form select:focus,.contact-form [type=text]:active,.contact-form [type=email]:active,.contact-form [type=url]:active,.contact-form [type=password]:active,.contact-form [type=number]:active,.contact-form [type=date]:active,.contact-form [type=datetime-local]:active,.contact-form [type=month]:active,.contact-form [type=search]:active,.contact-form [type=tel]:active,.contact-form [type=time]:active,.contact-form [type=week]:active,.contact-form [multiple]:active,.contact-form textarea:active,.contact-form select:active{opacity:1!important}.contact-form .gform-theme--framework{--gf-ctrl-border-color-error:var(--color-orange);--gf-ctrl-label-color-req:#ffffff80;--gf-ctrl-accent-color:var(--color-green);--gf-ctrl-choice-check-color:var(--color-green);--gf-ctrl-desc-color-error:#ffffff82;--gf-color-success:#fff;--gf-local-border-color:#ffffff40;--gf-local-shadow:none;--gf-ctrl-shadow-color-focus:#fff;--gf-ctrl-desc-border-color-consent:#fff;--gf-form-gap-y:24px;--gf-ctrl-size:44px;--gf-ctrl-size-sm:44px;--gf-ctrl-size-md:44px;--gf-ctrl-size-lg:44px;--gf-form-footer-margin-y-start:32px;--gf-radius:999px!important}.contact-form .gform_validation_errors{display:none}.gform_wrapper.gravity-theme .gform_fields{grid-row-gap:0!important;grid-column-gap:24px!important}.gform_required_legend{display:none}.gfield_label{--tw-text-opacity:1!important;color:rgb(12 46 45/var(--tw-text-opacity,1))!important;gap:.125rem!important;margin-bottom:12px!important;font-size:.875rem!important;font-weight:400!important;line-height:1.25rem!important}.gfield_label .gfield_required{color:inherit!important}.gform_wrapper.gravity-theme .gfield_error [aria-invalid=true]{border-bottom:1px solid #c02b0a;border-top:none!important;border-left:none!important;border-right:none!important}.gform_wrapper.gravity-theme .gfield_error [aria-invalid=true][type=checkbox]{border:1px solid #c02b0a!important}.gfield .gfield_description.validation_message{display:none!important}.gfield.gfield_error .gfield_label .gfield_required{display:inline-block!important}.gfield.gfield--type-consent{position:relative}@media (width>=1024px){.gfield.gfield--type-consent{max-width:500px}}.gfield_radio .gchoice,.gfield_checkbox .gchoice,.ginput_container_checkbox,.ginput_container_consent{position:relative}.ginput_container_consent input[type=checkbox]{background-color:#0000!important;border-width:1px!important;border-color:#ffffff40!important;width:20px!important;height:20px!important;padding:0!important;position:absolute!important;top:3px!important;left:0!important}.ginput_container_checkbox input[type=checkbox],.ginput_container_radio input[type=radio]{background-color:#0000!important;border-width:1px!important;border-color:#014e4640!important;width:20px!important;height:20px!important;padding:0!important;position:absolute!important;top:3px!important;left:0!important}.gform-theme--framework .gfield--type-choice .gchoice{align-items:center}.ginput_container_consent .gform-field-label{padding-left:2.75rem;display:block;color:#ffffff80!important;font-size:16px!important;line-height:1.625!important}.gfield_radio .gchoice .gform-field-label,.ginput_container_checkbox .gform-field-label{cursor:pointer;padding-left:1.25rem;display:block;font-size:16px!important;line-height:1.625!important}.gfield--type-consent+.gfield--type-consent,.gfield--type-consent+.gfield--type-radio{margin-top:1.25rem!important}.gform-theme--framework input[type=checkbox]:before{--tw-text-opacity:1!important;color:rgb(1 78 70/var(--tw-text-opacity,1))!important}.ginput_container_radio input[type=radio]:checked{accent-color:#fff!important;background-color:#014e46!important}.gform-theme--framework input[type=radio]:before{background-color:#fff!important}.contact-form textarea{height:200px!important;border-radius:20px!important;min-block-size:200px!important}.contact-form input,.contact-form textarea{--tw-text-opacity:1!important;color:rgb(12 46 45/var(--tw-text-opacity,1))!important;border-color:currentColor!important;padding-left:1.5rem!important;padding-right:1.5rem!important;transition-duration:.1s!important}.contact-form input::placeholder,.contact-form textarea::placeholder{--tw-text-opacity:1!important;color:rgb(12 46 45/var(--tw-text-opacity,1))!important;font-size:.875rem!important;line-height:1.25rem!important}:is(.contact-form input:blank,.contact-form textarea:blank){opacity:.4!important}.contact-form input:focus,.contact-form textarea:focus{box-shadow:none!important;outline:none!important}.prose :where(.giantpeach-buttonlist .contact-form form .gform_footer .gform_button):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0!important;margin-bottom:0!important}.contact-form form .gform_footer .gform_button{white-space:nowrap!important;--tw-bg-opacity:1!important;background-color:rgb(1 78 70/var(--tw-bg-opacity,1))!important;text-align:center!important;--tw-text-opacity:1!important;min-width:145px!important;color:rgb(255 255 255/var(--tw-text-opacity,1))!important;border-radius:9999px!important;font-size:1rem!important;font-weight:400!important;line-height:1.8125!important;transition-duration:.2s!important;display:inline-block!important}body.mobile-safari .contact-form form .gform_footer .gform_button .gp-btn-text{display:inline-block!important;transform:translateY(-1px)!important}.contact-form form .gform_footer .gform_button:hover{--tw-bg-opacity:1!important;background-color:rgb(12 46 45/var(--tw-bg-opacity,1))!important}@media not all and (width>=768px){.contact-form form .gform_footer .gform_button{width:100%!important}}.contact-form form .gform_footer .gform_button:focus{outline:none!important}.contact-form form .gform_footer .gform_button i{color:inherit!important}.gform-theme--framework select:where(:not(.gform-theme__disable):not(.gform-theme__disable *):not(.gform-theme__disable-framework):not(.gform-theme__disable-framework *)):where(:not([multiple])){background-position:right 24px bottom 50%;background-repeat:no-repeat;background-size:15px;--tw-border-opacity:1!important;border-color:rgb(12 46 45/var(--tw-border-opacity,1))!important;background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDggNTEyIj48IS0tIUZvbnQgQXdlc29tZSBQcm8gNi43LjIgYnkgQGZvbnRhd2Vzb21lIC0gaHR0cHM6Ly9mb250YXdlc29tZS5jb20gTGljZW5zZSAtIGh0dHBzOi8vZm9udGF3ZXNvbWUuY29tL2xpY2Vuc2UgKENvbW1lcmNpYWwgTGljZW5zZSkgQ29weXJpZ2h0IDIwMjUgRm9udGljb25zLCBJbmMuLS0+PHBhdGggZD0iTTIyNCAzNzQuNmwxMS4zLTExLjMgMTYwLTE2MEw0MDYuNiAxOTIgMzg0IDE2OS40bC0xMS4zIDExLjNMMjI0IDMyOS40IDc1LjMgMTgwLjcgNjQgMTY5LjQgNDEuNCAxOTJsMTEuMyAxMS4zIDE2MCAxNjBMMjI0IDM3NC42eiIvPjwvc3ZnPg==)!important;padding-left:24px!important;font-size:14px!important}.gform-theme--framework select:where(:not(.gform-theme__disable):not(.gform-theme__disable *):not(.gform-theme__disable-framework):not(.gform-theme__disable-framework *)):where(:not([multiple])):focus{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDggNTEyIj48IS0tIUZvbnQgQXdlc29tZSBQcm8gNi43LjIgYnkgQGZvbnRhd2Vzb21lIC0gaHR0cHM6Ly9mb250YXdlc29tZS5jb20gTGljZW5zZSAtIGh0dHBzOi8vZm9udGF3ZXNvbWUuY29tL2xpY2Vuc2UgKENvbW1lcmNpYWwgTGljZW5zZSkgQ29weXJpZ2h0IDIwMjUgRm9udGljb25zLCBJbmMuLS0+PHBhdGggZD0iTTIyNCAxMzcuNGwxMS4zIDExLjMgMTYwIDE2MEw0MDYuNiAzMjAgMzg0IDM0Mi42bC0xMS4zLTExLjNMMjI0IDE4Mi42IDc1LjMgMzMxLjMgNjQgMzQyLjYgNDEuNCAzMjBsMTEuMy0xMS4zIDE2MC0xNjBMMjI0IDEzNy40eiIvPjwvc3ZnPg==)!important}.contact-map{border-radius:20px;overflow:hidden}.contact-map .mapouter{text-align:right;width:100%;position:relative;height:400px!important}@media (width>=1024px){.contact-map .mapouter{height:500px!important}}.contact-map .gmap_canvas{width:100%;overflow:hidden;background:0 0!important;height:400px!important}@media (width>=1024px){.contact-map .gmap_canvas{height:500px!important}}.contact-map iframe{width:100%;height:400px!important}@media (width>=1024px){.contact-map iframe{height:500px!important}}.grid-hexagons{grid-template-rows:repeat(2,minmax(0,1fr));grid-template-columns:repeat(4,minmax(0,1fr));column-gap:1.25rem;display:grid}@media (width>=1024px){.grid-hexagons{grid-template-rows:repeat(1,minmax(0,1fr));grid-template-columns:repeat(3,minmax(0,1fr));gap:2rem}}.grid-hexagons>:not(:nth-child(2)){margin-top:-20%}@media (width>=1024px){.grid-hexagons>:not(:nth-child(2)){margin-top:36%}}@media screen and (width<=992px){.grid-hexagons .giantpeach-hexagon:first-child{grid-area:2/1/3/3}.grid-hexagons .giantpeach-hexagon:nth-child(2){grid-area:1/2/2/4}.grid-hexagons .giantpeach-hexagon:nth-child(3){grid-area:2/3/3/5}}.grid-hexagons.transition-block-class .giantpeach-hexagon{transition-duration:1s;transition-delay:.1s}.grid-hexagons.transition-block-class .giantpeach-hexagon:nth-child(2){--tw-translate-y:-17px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@media (width>=1024px){.grid-hexagons.transition-block-class .giantpeach-hexagon:nth-child(2){--tw-translate-y:50px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}}.grid-hexagons.transition-block-class .giantpeach-hexagon:first-child{--tw-translate-y:7px;--tw-translate-x:-7px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@media (width>=1024px){.grid-hexagons.transition-block-class .giantpeach-hexagon:first-child{--tw-translate-y:-50px;--tw-translate-x:0px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}}.grid-hexagons.transition-block-class .giantpeach-hexagon:nth-child(3){--tw-translate-y:7px;--tw-translate-x:7px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@media (width>=1024px){.grid-hexagons.transition-block-class .giantpeach-hexagon:nth-child(3){--tw-translate-y:-50px;--tw-translate-x:0px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}}.grid-hexagons.transition-block-class.animated .giantpeach-hexagon{--tw-translate-x:0px!important;--tw-translate-y:0px!important;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))!important}.process-tile h3{--tw-text-opacity:1;color:rgb(203 253 219/var(--tw-text-opacity,1));margin-bottom:.5rem!important}@media (width>=1024px){.process-tile h3{margin-bottom:1rem!important}}.process-tile p{font-size:.875rem!important;line-height:1.25rem!important}@media (width>=1024px){.process-tile p{font-size:1rem!important;line-height:1.4!important}}.giantpeach-ctawide .giantpeach-contentwrapper.max-lg\\:text-center+.giantpeach-buttonlist{text-align:center}.footer-copy-overflow{text-overflow:ellipsis;display:box;line-clamp:2;-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.footer-copy-overflow.active{-webkit-box-orient:initial;line-clamp:initial;-webkit-line-clamp:initial;overflow:initial;text-overflow:initial;display:block}.termsfeed-com---nb-simple{border-radius:30px!important;max-width:600px!important;bottom:15px!important;right:15px!important}@media screen and (width<=600px){.termsfeed-com---nb-simple{max-width:calc(100% - 30px)!important}}.termsfeed-com---nb .cc-nb-main-container{padding:2rem!important}.termsfeed-com---nb .cc-nb-text{font-size:15px!important}.termsfeed-com---palette-light .cc-nb-okagree,.termsfeed-com---palette-light .cc-nb-reject,.termsfeed-com---palette-light .cc-cp-foot-save{--tw-bg-opacity:1!important;background-color:rgb(12 46 45/var(--tw-bg-opacity,1))!important}.termsfeed-com---nb .cc-nb-okagree,.termsfeed-com---nb .cc-nb-reject,.termsfeed-com---nb .cc-nb-changep,.termsfeed-com---palette-light .cc-cp-foot-save{white-space:nowrap!important;vertical-align:middle!important;border-radius:9999px!important;font-size:1rem!important;font-weight:400!important;line-height:1.8125!important}.wp-block-embed-youtube{border-radius:20px;margin-top:2.5rem;margin-bottom:2.5rem;overflow:hidden}@media (width>=1024px){.wp-block-embed-youtube{margin-top:3.75rem;margin-bottom:3.75rem}}body.mobile-safari .gp-btn .gp-btn-text{display:inline-block;transform:translateY(-1px)}.giantpeach-contentscrollable .snap-y.snap-mandatory{scroll-container-target:local always}@media (width>=768px){.md\\:content{--containerWidth:clamp(800px, 76.1115vw, 1230px);--gap:clamp(20px, 4.16vw, 40px);--full:auto;--content:min(var(--containerWidth), 100% - var(--gap) * 2);--popout:minmax(0, 2rem);--fluid:1fr;grid-template-columns:[gap-start] var(--gap) [fluid-start] var(--fluid) [content-start] var(--content) [content-end] var(--fluid) [fluid-end] var(--gap) [gap-end];display:grid}.md\\:content>*{grid-column:content}.md\\:content>.md\\:content{grid-column:full;grid-template-columns:inherit}.prose :where(.md\\:block-btn-wrap):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:clamp(24px,2.222vw,32px);margin-bottom:clamp(24px,2.222vw,32px)}}@media (width>=1024px){.prose :where(.lg\\:block-btn-wrap):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:clamp(24px,2.222vw,32px);margin-bottom:clamp(24px,2.222vw,32px)}}@media (width>=1280px){.prose :where(.xl\\:block-btn-wrap):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:clamp(24px,2.222vw,32px);margin-bottom:clamp(24px,2.222vw,32px)}}.after\\:absolute:after{content:var(--tw-content);position:absolute}.after\\:left-0:after{content:var(--tw-content);left:0}.after\\:top-full:after{content:var(--tw-content);top:100%}.after\\:block:after{content:var(--tw-content);display:block}.after\\:h-5:after{content:var(--tw-content);height:1.25rem}.after\\:w-full:after{content:var(--tw-content);width:100%}.after\\:-translate-y-px:after{content:var(--tw-content);--tw-translate-y:-1px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.after\\:bg-green-light:after{content:var(--tw-content);--tw-bg-opacity:1;background-color:rgb(203 253 219/var(--tw-bg-opacity,1))}.after\\:content-\\[\\'\\'\\]:after{--tw-content:\"\";content:var(--tw-content)}.after\\:clip-triangle-down:after{content:var(--tw-content);clip-path:polygon(0 0,100% 0,100% 10%,50% 100%,0 10%)}.first\\:mt-0:first-child{margin-top:0}.last\\:border-0:last-child{border-width:0}.\\*\\:last\\:mb-0:last-child>*{margin-bottom:0}.hover\\:\\!bg-green:hover{--tw-bg-opacity:1!important;background-color:rgb(1 78 70/var(--tw-bg-opacity,1))!important}.hover\\:bg-green:hover{--tw-bg-opacity:1;background-color:rgb(1 78 70/var(--tw-bg-opacity,1))}.hover\\:bg-green-dark:hover{--tw-bg-opacity:1;background-color:rgb(12 46 45/var(--tw-bg-opacity,1))}.hover\\:bg-green-light:hover{--tw-bg-opacity:1;background-color:rgb(203 253 219/var(--tw-bg-opacity,1))}.hover\\:bg-orange:hover{--tw-bg-opacity:1;background-color:rgb(237 114 81/var(--tw-bg-opacity,1))}.hover\\:bg-white:hover{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}.hover\\:\\!text-green:hover{--tw-text-opacity:1!important;color:rgb(1 78 70/var(--tw-text-opacity,1))!important}.hover\\:\\!text-green-dark:hover{--tw-text-opacity:1!important;color:rgb(12 46 45/var(--tw-text-opacity,1))!important}.hover\\:\\!text-green-light:hover{--tw-text-opacity:1!important;color:rgb(203 253 219/var(--tw-text-opacity,1))!important}.hover\\:\\!text-orange:hover{--tw-text-opacity:1!important;color:rgb(237 114 81/var(--tw-text-opacity,1))!important}.hover\\:\\!text-white:hover{--tw-text-opacity:1!important;color:rgb(255 255 255/var(--tw-text-opacity,1))!important}.hover\\:text-blue:hover{--tw-text-opacity:1;color:rgb(192 234 241/var(--tw-text-opacity,1))}.hover\\:text-green:hover{--tw-text-opacity:1;color:rgb(1 78 70/var(--tw-text-opacity,1))}.hover\\:text-green-dark:hover{--tw-text-opacity:1;color:rgb(12 46 45/var(--tw-text-opacity,1))}.hover\\:text-green-light:hover{--tw-text-opacity:1;color:rgb(203 253 219/var(--tw-text-opacity,1))}.hover\\:text-orange:hover{--tw-text-opacity:1;color:rgb(237 114 81/var(--tw-text-opacity,1))}.hover\\:text-white:hover{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1))}.hover\\:\\!opacity-100:hover{opacity:1!important}.group\\/projectcard:hover .group-hover\\/projectcard\\:grid-rows-\\[1fr\\],.group\\/projectcarouselcard:hover .group-hover\\/projectcarouselcard\\:grid-rows-\\[1fr\\]{grid-template-rows:1fr}.group\\/postcard:hover .group-hover\\/postcard\\:bg-green-dark{--tw-bg-opacity:1;background-color:rgb(12 46 45/var(--tw-bg-opacity,1))}.group:hover .group-hover\\:bg-orange{--tw-bg-opacity:1;background-color:rgb(237 114 81/var(--tw-bg-opacity,1))}.group\\/postcard:hover .group-hover\\/postcard\\:text-green-light{--tw-text-opacity:1;color:rgb(203 253 219/var(--tw-text-opacity,1))}.group\\/projectcarouselcard:hover .group-hover\\/projectcarouselcard\\:text-white,.group:hover .group-hover\\:text-white{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1))}.group\\/projectcard:hover .group-hover\\/projectcard\\:opacity-0{opacity:0}.group\\/projectcard:hover .group-hover\\/projectcard\\:opacity-100{opacity:1}.group\\/projectcarouselcard:hover .group-hover\\/projectcarouselcard\\:opacity-0{opacity:0}.group\\/projectcarouselcard:hover .group-hover\\/projectcarouselcard\\:opacity-100{opacity:1}.group\\/projectcard:hover .group-hover\\/projectcard\\:delay-100{transition-delay:.1s}.group\\/projectcarouselcard:hover .group-hover\\/projectcarouselcard\\:delay-300{transition-delay:.3s}.group\\/projectcarouselcard:hover .group-hover\\/projectcarouselcard\\:duration-500{transition-duration:.5s}.peer\\/catradio:checked~.peer-checked\\/catradio\\:\\!bg-green{--tw-bg-opacity:1!important;background-color:rgb(1 78 70/var(--tw-bg-opacity,1))!important}.peer\\/catradio:checked~.peer-checked\\/catradio\\:\\!text-green-light{--tw-text-opacity:1!important;color:rgb(203 253 219/var(--tw-text-opacity,1))!important}.activecls\\:opacity-100.active{opacity:1}.glide-arrow-disabled\\:\\!text-white\\/25.glide__arrow--disabled{color:#ffffff40!important}.glide-bullet-active\\:bg-blue.glide__bullet--active{--tw-bg-opacity:1;background-color:rgb(192 234 241/var(--tw-bg-opacity,1))}.glide__slide--transformed .glide-transformed\\:grid-rows-\\[1fr\\]{grid-template-rows:1fr}.glide__slide--transformed .glide-transformed\\:opacity-0{opacity:0}.glide__slide--transformed .glide-transformed\\:opacity-100{opacity:1}.glide__slide--transformed .glide-transformed\\:delay-500{transition-delay:.5s}.glide__slide--transformed .glide-transformed\\:duration-500{transition-duration:.5s}@media not all and (width>=1024px){.max-lg\\:absolute{position:absolute}.max-lg\\:left-1\\/2{left:50%}.max-lg\\:block{display:block}.max-lg\\:w-\\[260\\%\\]{width:260%}.max-lg\\:w-full{width:100%}.max-lg\\:-translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.max-lg\\:\\!p-0{padding:0!important}.max-lg\\:pb-10{padding-bottom:2.5rem}.max-lg\\:text-center{text-align:center}.max-lg\\:text-green-light{--tw-text-opacity:1;color:rgb(203 253 219/var(--tw-text-opacity,1))}.max-lg\\:\\!opacity-100{opacity:1!important}.max-lg\\:opacity-100{opacity:1}.max-lg\\:opacity-40{opacity:.4}}@media not all and (width>=768px){.max-md\\:block{display:block}.max-md\\:w-\\[calc\\(100vw-40px\\+40px\\*\\(var\\(--scroll-percent\\)\\)\\)\\]{width:calc(100vw - 40px + 40px * (var(--scroll-percent)))}.max-md\\:w-full{width:100%}}@media not all and (width>=640px){.max-sm\\:h-full{height:100%}.max-sm\\:w-full{width:100%}}@media (width>=768px){.md\\:right-10{right:2.5rem}.md\\:-mr-5{margin-right:-1.25rem}.md\\:mt-0{margin-top:0}.md\\:block{display:block}.md\\:inline-block{display:inline-block}.md\\:hidden{display:none}.md\\:aspect-\\[1095\\/650\\]{aspect-ratio:1095/650}.md\\:aspect-\\[35\\/20\\]{aspect-ratio:35/20}.md\\:aspect-\\[420\\/264\\]{aspect-ratio:420/264}.md\\:aspect-\\[420\\/562\\]{aspect-ratio:420/562}.md\\:aspect-auto{aspect-ratio:auto}.md\\:h-\\[160vh\\]{height:160vh}.md\\:h-\\[200px\\]{height:200px}.md\\:h-\\[205px\\]{height:205px}.md\\:h-full{height:100%}.md\\:min-h-\\[250px\\]{min-height:250px}.md\\:w-\\[190px\\]{width:190px}.md\\:w-\\[194px\\]{width:194px}.md\\:w-\\[40\\%\\]{width:40%}.md\\:min-w-\\[650px\\]{min-width:650px}.md\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.md\\:flex-row{flex-direction:row}.md\\:flex-row-reverse{flex-direction:row-reverse}.md\\:place-items-start{place-items:start}.md\\:place-items-end{place-items:end}.md\\:place-items-center{place-items:center}.md\\:place-items-baseline{place-items:baseline}.md\\:place-items-stretch{place-items:stretch stretch}.md\\:items-start{align-items:flex-start}.md\\:items-end{align-items:flex-end}.md\\:items-center{align-items:center}.md\\:items-baseline{align-items:baseline}.md\\:items-stretch{align-items:stretch}.md\\:justify-start{justify-content:flex-start}.md\\:justify-end{justify-content:flex-end}.md\\:justify-center{justify-content:center}.md\\:justify-between{justify-content:space-between}.md\\:justify-around{justify-content:space-around}.md\\:justify-evenly{justify-content:space-evenly}.md\\:justify-items-start{justify-items:start}.md\\:justify-items-end{justify-items:end}.md\\:justify-items-center{justify-items:center}.md\\:justify-items-stretch{justify-items:stretch}.md\\:overflow-hidden{overflow:hidden}.md\\:overflow-x-hidden{overflow-x:hidden}.md\\:overflow-y-hidden{overflow-y:hidden}.md\\:whitespace-break-spaces{white-space:break-spaces}.md\\:border-hidden{border-style:hidden}.md\\:p-8{padding:2rem}.md\\:px-0{padding-left:0;padding-right:0}.md\\:px-5{padding-left:1.25rem;padding-right:1.25rem}.md\\:py-16{padding-top:4rem;padding-bottom:4rem}.md\\:py-2\\.5{padding-top:.625rem;padding-bottom:.625rem}.md\\:py-24{padding-top:6rem;padding-bottom:6rem}.md\\:py-8{padding-top:2rem;padding-bottom:2rem}.md\\:pr-8{padding-right:2rem}.md\\:text-md{font-size:1rem;line-height:1.4}}@media (width>=1024px){.lg\\:pointer-events-none{pointer-events:none}.lg\\:invisible{visibility:hidden}.lg\\:absolute{position:absolute}.lg\\:relative{position:relative}.lg\\:sticky{position:sticky}.lg\\:bottom-0{bottom:0}.lg\\:bottom-5{bottom:1.25rem}.lg\\:bottom-8{bottom:2rem}.lg\\:bottom-\\[112px\\]{bottom:112px}.lg\\:bottom-auto{bottom:auto}.lg\\:left-0{left:0}.lg\\:left-1\\/2{left:50%}.lg\\:left-5{left:1.25rem}.lg\\:left-8{left:2rem}.lg\\:left-auto{left:auto}.lg\\:right-0{right:0}.lg\\:right-full{right:100%}.lg\\:top-0{top:0}.lg\\:top-1\\/2{top:50%}.lg\\:top-5{top:1.25rem}.lg\\:top-\\[30\\%\\]{top:30%}.lg\\:top-\\[87px\\]{top:87px}.lg\\:order-1{order:1}.lg\\:order-2{order:2}.lg\\:order-none{order:0}.lg\\:my-0{margin-top:0;margin-bottom:0}.lg\\:my-15{margin-top:3.75rem;margin-bottom:3.75rem}.lg\\:my-20{margin-top:5rem;margin-bottom:5rem}.lg\\:my-25{margin-top:6.25rem;margin-bottom:6.25rem}.lg\\:my-30{margin-top:7.5rem;margin-bottom:7.5rem}.lg\\:my-8{margin-top:2rem;margin-bottom:2rem}.lg\\:my-\\[30px\\]{margin-top:30px;margin-bottom:30px}.lg\\:\\!mb-8{margin-bottom:2rem!important}.lg\\:-mt-6{margin-top:-1.5rem}.lg\\:mb-0{margin-bottom:0}.lg\\:mb-15{margin-bottom:3.75rem}.lg\\:mb-16{margin-bottom:4rem}.lg\\:mb-20{margin-bottom:5rem}.lg\\:mb-4{margin-bottom:1rem}.lg\\:mb-8{margin-bottom:2rem}.lg\\:ml-auto{margin-left:auto}.lg\\:mr-4{margin-right:1rem}.lg\\:mt-0{margin-top:0}.lg\\:mt-10{margin-top:2.5rem}.lg\\:mt-15{margin-top:3.75rem}.lg\\:mt-16{margin-top:4rem}.lg\\:mt-20{margin-top:5rem}.lg\\:mt-30{margin-top:7.5rem}.lg\\:mt-6{margin-top:1.5rem}.lg\\:mt-\\[100px\\]{margin-top:100px}.lg\\:mt-\\[146px\\]{margin-top:146px}.lg\\:\\!block{display:block!important}.lg\\:block{display:block}.lg\\:inline-block{display:inline-block}.lg\\:flex{display:flex}.lg\\:grid{display:grid}.lg\\:hidden{display:none}.lg\\:aspect-\\[920\\/650\\]{aspect-ratio:920/650}.lg\\:aspect-square{aspect-ratio:1}.lg\\:h-6{height:1.5rem}.lg\\:h-\\[80px\\]{height:80px}.lg\\:h-\\[calc\\(100vh\\*\\(var\\(--scroll-percent\\)\\)\\)\\]{height:calc(100vh * (var(--scroll-percent)))}.lg\\:max-h-\\[32px\\]{max-height:32px}.lg\\:max-h-\\[calc\\(100svh_-_346px\\)\\]{max-height:calc(100svh - 346px)}.lg\\:min-h-\\[40vw\\]{min-height:40vw}.lg\\:min-h-\\[500px\\]{min-height:500px}.lg\\:min-h-\\[740px\\]{min-height:740px}.lg\\:min-h-\\[74svh\\]{min-height:74svh}.lg\\:min-h-\\[98vh\\]{min-height:98vh}.lg\\:w-4\\/5{width:80%}.lg\\:w-5{width:1.25rem}.lg\\:w-\\[220px\\]{width:220px}.lg\\:w-\\[310px\\]{width:310px}.lg\\:w-\\[40\\%\\]{width:40%}.lg\\:w-\\[48\\.9895\\%\\]{width:48.9895%}.lg\\:w-\\[97px\\]{width:97px}.lg\\:w-\\[calc\\(100\\%_-_40px\\)\\]{width:calc(100% - 40px)}.lg\\:w-\\[calc\\(100\\%_-_64px\\)\\]{width:calc(100% - 64px)}.lg\\:w-full{width:100%}.lg\\:min-w-\\[100px\\]{min-width:100px}.lg\\:min-w-\\[48\\.9595\\%\\]{min-width:48.9595%}.lg\\:min-w-\\[800px\\]{min-width:800px}.lg\\:max-w-\\[160px\\]{max-width:160px}.lg\\:max-w-\\[600px\\]{max-width:600px}.lg\\:max-w-\\[630px\\]{max-width:630px}.lg\\:flex-1{flex:1}.lg\\:flex-\\[0\\.8\\]{flex:.8}.lg\\:-translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.lg\\:-translate-y-1\\/2{--tw-translate-y:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.lg\\:-translate-y-full{--tw-translate-y:-100%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.lg\\:scroll-my-20{scroll-margin-top:5rem;scroll-margin-bottom:5rem}.lg\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.lg\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.lg\\:grid-cols-\\[140px_auto_140px\\]{grid-template-columns:140px auto 140px}.lg\\:grid-cols-\\[1fr_70px\\]{grid-template-columns:1fr 70px}.lg\\:grid-cols-\\[auto_8px\\]{grid-template-columns:auto 8px}.lg\\:flex-row{flex-direction:row}.lg\\:flex-col{flex-direction:column}.lg\\:place-items-start{place-items:start}.lg\\:place-items-end{place-items:end}.lg\\:place-items-center{place-items:center}.lg\\:place-items-baseline{place-items:baseline}.lg\\:place-items-stretch{place-items:stretch stretch}.lg\\:items-start{align-items:flex-start}.lg\\:items-end{align-items:flex-end}.lg\\:items-center{align-items:center}.lg\\:items-baseline{align-items:baseline}.lg\\:items-stretch{align-items:stretch}.lg\\:justify-start{justify-content:flex-start}.lg\\:justify-end{justify-content:flex-end}.lg\\:justify-center{justify-content:center}.lg\\:justify-between{justify-content:space-between}.lg\\:justify-around{justify-content:space-around}.lg\\:justify-evenly{justify-content:space-evenly}.lg\\:justify-items-start{justify-items:start}.lg\\:justify-items-end{justify-items:end}.lg\\:justify-items-center{justify-items:center}.lg\\:justify-items-stretch{justify-items:stretch}.lg\\:\\!gap-8{gap:2rem!important}.lg\\:gap-0{gap:0}.lg\\:gap-12{gap:3rem}.lg\\:gap-4{gap:1rem}.lg\\:gap-8{gap:2rem}.lg\\:gap-\\[120px\\]{gap:120px}.lg\\:gap-\\[15px\\]{gap:15px}.lg\\:gap-\\[30px\\]{gap:30px}.lg\\:gap-\\[60px\\]{gap:60px}.lg\\:self-center{align-self:center}.lg\\:overflow-auto{overflow:auto}.lg\\:overflow-hidden{overflow:hidden}.lg\\:overflow-x-hidden{overflow-x:hidden}.lg\\:overflow-y-hidden{overflow-y:hidden}.lg\\:rounded{border-radius:20px}.lg\\:rounded-full{border-radius:9999px}.lg\\:rounded-none{border-radius:0}.lg\\:border-hidden{border-style:hidden}.lg\\:bg-beige{--tw-bg-opacity:1;background-color:rgb(245 245 240/var(--tw-bg-opacity,1))}.lg\\:bg-transparent{background-color:#0000}.lg\\:p-2{padding:.5rem}.lg\\:p-5{padding:1.25rem}.lg\\:p-8{padding:2rem}.lg\\:px-0{padding-left:0;padding-right:0}.lg\\:px-10{padding-left:2.5rem;padding-right:2.5rem}.lg\\:px-5{padding-left:1.25rem;padding-right:1.25rem}.lg\\:px-8{padding-left:2rem;padding-right:2rem}.lg\\:px-\\[30px\\]{padding-left:30px;padding-right:30px}.lg\\:py-15{padding-top:3.75rem;padding-bottom:3.75rem}.lg\\:py-40{padding-top:10rem;padding-bottom:10rem}.lg\\:py-8{padding-top:2rem;padding-bottom:2rem}.lg\\:py-\\[11px\\]{padding-top:11px;padding-bottom:11px}.lg\\:py-\\[50px\\]{padding-top:50px;padding-bottom:50px}.lg\\:py-\\[60px\\]{padding-top:60px;padding-bottom:60px}.lg\\:pb-0{padding-bottom:0}.lg\\:pb-10{padding-bottom:2.5rem}.lg\\:pb-15{padding-bottom:3.75rem}.lg\\:pb-30{padding-bottom:7.5rem}.lg\\:pr-\\[14\\%\\]{padding-right:14%}.lg\\:pr-\\[80px\\]{padding-right:80px}.lg\\:pt-15{padding-top:3.75rem}.lg\\:text-left{text-align:left}.lg\\:text-center{text-align:center}.lg\\:text-right{text-align:right}.lg\\:\\!text-base{font-size:1rem!important;line-height:1.4!important}.lg\\:\\!text-h3\\/\\[1\\.4\\]{font-size:clamp(32px,2.5vw,36px)!important;line-height:1.4!important}.lg\\:text-\\[14px\\]{font-size:14px}.lg\\:text-\\[15px\\]{font-size:15px}.lg\\:text-\\[16px\\]{font-size:16px}.lg\\:text-\\[20px\\]{font-size:20px}.lg\\:text-\\[22px\\]\\/\\[1\\.4\\]{font-size:22px;line-height:1.4}.lg\\:text-\\[24px\\]{font-size:24px}.lg\\:text-\\[26px\\]{font-size:26px}.lg\\:text-\\[36px\\]{font-size:36px}.lg\\:text-lg{font-size:1.125rem;line-height:1.4}.lg\\:opacity-0{opacity:0}.lg\\:opacity-100{opacity:1}.lg\\:opacity-40{opacity:.4}.lg\\:delay-0{transition-delay:0s}.lg\\:duration-300{transition-duration:.3s}.lg\\:duration-500{transition-duration:.5s}.lg\\:margin-stagger-3:nth-child(3n+2){transform:translateY(20px)}.lg\\:margin-stagger-3:nth-child(3n+3){transform:translateY(40px)}.evenchilddiv\\:lg\\:ml-auto>div:nth-child(2n){margin-left:auto}}@media (width>=1280px){.xl\\:block{display:block}.xl\\:inline-block{display:inline-block}.xl\\:hidden{display:none}.xl\\:h-\\[500px\\]{height:500px}.xl\\:min-h-\\[500px\\]{min-height:500px}.xl\\:min-w-\\[1096px\\]{min-width:1096px}.xl\\:max-w-\\[720px\\]{max-width:720px}.xl\\:place-items-start{place-items:start}.xl\\:place-items-end{place-items:end}.xl\\:place-items-center{place-items:center}.xl\\:place-items-baseline{place-items:baseline}.xl\\:place-items-stretch{place-items:stretch stretch}.xl\\:items-start{align-items:flex-start}.xl\\:items-end{align-items:flex-end}.xl\\:items-center{align-items:center}.xl\\:items-baseline{align-items:baseline}.xl\\:items-stretch{align-items:stretch}.xl\\:justify-start{justify-content:flex-start}.xl\\:justify-end{justify-content:flex-end}.xl\\:justify-center{justify-content:center}.xl\\:justify-between{justify-content:space-between}.xl\\:justify-around{justify-content:space-around}.xl\\:justify-evenly{justify-content:space-evenly}.xl\\:justify-items-start{justify-items:start}.xl\\:justify-items-end{justify-items:end}.xl\\:justify-items-center{justify-items:center}.xl\\:justify-items-stretch{justify-items:stretch}.xl\\:gap-8{gap:2rem}.xl\\:overflow-hidden{overflow:hidden}.xl\\:overflow-x-hidden{overflow-x:hidden}.xl\\:overflow-y-hidden{overflow-y:hidden}.xl\\:border-hidden{border-style:hidden}}@media (width>=1536px){.\\32 xl\\:max-h-\\[36px\\]{max-height:36px}.\\32 xl\\:max-w-\\[180px\\]{max-width:180px}.\\32 xl\\:flex-\\[1\\.6\\]{flex:1.6}}@media (width>=1920px){.\\33 xl\\:h-\\[80svh\\]{height:80svh}}.\\[\\&\\.flickity-enabled\\]\\:block.flickity-enabled{display:block}.\\[\\&\\:first-child_a\\]\\:\\!pt-0:first-child a{padding-top:0!important}.\\[\\&_\\+\\.giantpeach-card\\]\\:-mt-5+.giantpeach-card{margin-top:-1.25rem}.\\[\\&_\\+\\.giantpeach-card\\]\\:rounded-t+.giantpeach-card{border-top-left-radius:20px;border-top-right-radius:20px}.\\[\\&_\\+\\.giantpeach-card\\]\\:pt-5+.giantpeach-card{padding-top:1.25rem}@media not all and (width>=768px){.\\[\\&_\\.block-btn-wrap\\:only-child_\\.gp-btn\\]\\:max-md\\:w-auto .block-btn-wrap:only-child .gp-btn{width:auto}.\\[\\&_\\.block-btn-wrap\\:only-child_\\.gp-btn\\]\\:max-md\\:px-8 .block-btn-wrap:only-child .gp-btn{padding-left:2rem;padding-right:2rem}}@media (width>=1024px){.\\[\\&_\\.block-btn-wrap\\]\\:lg\\:mt-8 .block-btn-wrap{margin-top:2rem}}.\\[\\&_\\.flickity-viewport\\]\\:h-\\[var\\(--testimonial-temp-height\\)\\] .flickity-viewport{height:var(--testimonial-temp-height)}.\\[\\&_\\.flickity-viewport\\]\\:duration-300 .flickity-viewport{transition-duration:.3s}@media not all and (width>=768px){.\\[\\&_\\.giantpeach-buttonlist\\]\\:max-md\\:w-full .giantpeach-buttonlist{width:100%}}@media (width>=768px){.\\[\\&_\\.giantpeach-buttonlist\\]\\:md\\:mx-auto .giantpeach-buttonlist{margin-left:auto;margin-right:auto}}@media (width>=1024px){.\\[\\&_\\.giantpeach-buttonlist\\]\\:lg\\:ml-auto .giantpeach-buttonlist{margin-left:auto}.\\[\\&_\\.giantpeach-buttonlist\\]\\:lg\\:mr-0 .giantpeach-buttonlist{margin-right:0}}@media not all and (width>=768px){.\\[\\&_\\.giantpeach-buttonlist_\\.block-btn-wrap\\]\\:max-md\\:flex-1 .giantpeach-buttonlist .block-btn-wrap{flex:1}}@media (width>=1024px){.\\[\\&_\\.giantpeach-contentwrapper\\:nth-child\\(2n\\)\\]\\:lg\\:pt-\\[100px\\] .giantpeach-contentwrapper:nth-child(2n){padding-top:100px}.\\[\\&_\\.giantpeach-contentwrapper\\]\\:lg\\:flex-1 .giantpeach-contentwrapper{flex:1}}@media not all and (width>=1024px){.\\[\\&_\\.giantpeach-processtile\\:first-child\\]\\:max-lg\\:\\!opacity-100 .giantpeach-processtile:first-child{opacity:1!important}}.\\[\\&_\\.giantpeach-testimonial\\]\\:\\!my-0 .giantpeach-testimonial{margin-top:0!important;margin-bottom:0!important}.\\[\\&_\\.gp-btn\\]\\:\\!text-green .gp-btn{--tw-text-opacity:1!important;color:rgb(1 78 70/var(--tw-text-opacity,1))!important}.\\[\\&_\\.gp-btn\\]\\:hover\\:\\!text-white:hover .gp-btn{--tw-text-opacity:1!important;color:rgb(255 255 255/var(--tw-text-opacity,1))!important}@media not all and (width>=768px){.\\[\\&_\\.gp-btn\\]\\:max-md\\:w-full .gp-btn{width:100%}.\\[\\&_\\.gp-btn\\]\\:max-md\\:px-4 .gp-btn{padding-left:1rem;padding-right:1rem}}.\\[\\&_a\\:hover\\]\\:bg-white a:hover{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}.\\[\\&_a\\:hover\\]\\:\\!text-green-dark a:hover{--tw-text-opacity:1!important;color:rgb(12 46 45/var(--tw-text-opacity,1))!important}.\\[\\&_a\\:hover\\]\\:text-green-light a:hover{--tw-text-opacity:1;color:rgb(203 253 219/var(--tw-text-opacity,1))}.\\[\\&_a\\:hover\\]\\:opacity-100 a:hover{opacity:1}.\\[\\&_a\\]\\:duration-75 a{transition-duration:75ms}.\\[\\&_h1\\]\\:mb-6 h1{margin-bottom:1.5rem}.\\[\\&_h1\\]\\:mt-3 h1{margin-top:.75rem}.\\[\\&_h1\\]\\:last\\:\\!mb-0:last-child h1{margin-bottom:0!important}@media (width>=1024px){.\\[\\&_h1\\]\\:lg\\:mb-8 h1{margin-bottom:2rem}.\\[\\&_h1\\]\\:lg\\:px-16 h1{padding-left:4rem;padding-right:4rem}}.\\[\\&_img\\]\\:\\!h-auto img{height:auto!important}.\\[\\&_img\\]\\:scale-\\[1\\.005\\] img{--tw-scale-x:1.005;--tw-scale-y:1.005;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.\\[\\&_img\\]\\:duration-300 img{transition-duration:.3s}.group\\/postcard:hover .group-hover\\/postcard\\:\\[\\&_img\\]\\:scale-\\[1\\.05\\] img,.group\\/projectcard:hover .group-hover\\/projectcard\\:\\[\\&_img\\]\\:scale-\\[1\\.05\\] img,.group\\/projectcarouselcard:hover .group-hover\\/projectcarouselcard\\:\\[\\&_img\\]\\:scale-\\[1\\.05\\] img{--tw-scale-x:1.05;--tw-scale-y:1.05;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.\\[\\&_p\\]\\:\\!text-md p{font-size:1rem!important;line-height:1.4!important}.\\[\\&_p\\]\\:\\!text-sm p{font-size:.875rem!important;line-height:1.25rem!important}.\\[\\&_p\\]\\:text-base p{font-size:1rem;line-height:1.4}.\\[\\&_p\\]\\:last\\:\\!mt-4:last-child p{margin-top:1rem!important}@media not all and (width>=1024px){.\\[\\&_p\\]\\:max-lg\\:leading-\\[1\\.2\\] p{line-height:1.2}}@media (width>=1024px){.\\[\\&_p\\]\\:lg\\:\\!text-lg p{font-size:1.125rem!important;line-height:1.4!important}.\\[\\&_p\\]\\:lg\\:\\!text-md p{font-size:1rem!important;line-height:1.4!important}.\\[\\&_p\\]\\:lg\\:text-lg p{font-size:1.125rem;line-height:1.4}}.\\[\\&_svg\\]\\:\\!h-full svg{height:100%!important}.\\[\\&_svg\\]\\:w-\\[20px\\] svg{width:20px}.\\[\\&_svg_\\.path\\]\\:duration-300 svg .path{transition-duration:.3s}.active .\\[\\.active_\\&\\]\\:delay-300{transition-delay:.3s}@media (width>=1024px){.active .\\[\\.active_\\&\\]\\:lg\\:pointer-events-auto{pointer-events:auto}.active .\\[\\.active_\\&\\]\\:lg\\:visible{visibility:visible}.active .\\[\\.active_\\&\\]\\:lg\\:\\!translate-y-0{--tw-translate-y:0px!important;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))!important}.active .\\[\\.active_\\&\\]\\:lg\\:opacity-100{opacity:1}.active~.giantpeach-contentscrollableelement .\\[\\.active_\\~_\\.giantpeach-contentscrollableelement_\\&\\]\\:lg\\:translate-y-full{--tw-translate-y:100%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}}.has-beige-background-color .\\[\\.has-beige-background-color_\\&\\]\\:bg-white{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}.nav-open .\\[\\.nav-open_\\&\\]\\:opacity-0{opacity:0}.nav-open .\\[\\.nav-open_\\&\\]\\:opacity-100{opacity:1}.nav-open .\\[\\.nav-open_\\&_svg_path\\]\\:fill-green-light svg path{fill:#cbfddb}";


const $839d4b41baaa67a8$var$tailwindEl = (0, $14363946691fc7b4$export$8d80f9cac07cdb3)($2de768523eeac01a$exports);
class $839d4b41baaa67a8$export$5b1a024ae3b8b2b4 extends (0, $8d9a7cd3eb30e1a4$export$3f2f9f5909897157) {
    static styles = [
        $839d4b41baaa67a8$var$tailwindEl
    ];
}


class $9e22c64f4428d1ac$export$41fb9f06171c75f4 extends (0, $839d4b41baaa67a8$export$5b1a024ae3b8b2b4) {
    static get properties() {
        return {
            target: {
                type: String
            },
            toggled: {
                type: Boolean
            },
            invert: {
                type: Boolean
            }
        };
    }
    constructor(){
        super();
        this.target = "";
        this.toggled = false;
        this.invert = false;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    render() {
        return (0, $7c8bf60562922b0b$export$c0bb0b647f701bb5)`<slot @click="${this._onClick}"></slot>`;
    }
    _onClick(e) {
        e.preventDefault();
        let togged = true;
        this.dispatchEvent(new CustomEvent("element:trigger", {
            detail: {
                target: this.target,
                state: this.invert ? !togged : togged
            },
            composed: true,
            bubbles: true
        }));
    }
}
customElements.define("peach-trigger", $9e22c64f4428d1ac$export$41fb9f06171c75f4);




class $831c5ca258efb277$export$644db29b3dffde4c extends (0, $839d4b41baaa67a8$export$5b1a024ae3b8b2b4) {
    static get properties() {
        return {
            open: {
                type: Boolean,
                reflect: true
            },
            id: {
                type: String
            },
            class: {
                type: String,
                reflect: true
            },
            backgroundClose: {
                type: Boolean
            },
            parentOpacity: {
                type: Number
            },
            _hasDuration: {
                type: Boolean
            },
            _backgroundElement: {
                type: Object
            }
        };
    }
    constructor(){
        super();
        this.open = false;
        this.backgroundClose = true;
        this.parentOpacity = this.open ? 1 : 0;
        this._hasDuration = true;
        this.inner = null;
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener("element:trigger", this._onElementTrigger.bind(this));
        this.inner = this.querySelector("peach-off-canvas-inner");
    }
    firstUpdated() {
        this._backgroundElement = this.shadowRoot.querySelector(".off-canvas");
    }
    get classes() {
        // object of wrapper classes, each class is a boolean
        // if the class is true, it will be added to the element
        const clses = {
            "off-canvas": true,
            open: this.open,
            "pointer-events-auto": this.open,
            "pointer-events-none": !this.open,
            fixed: true,
            "inset-0": true,
            "transition-all": true,
            "duration-500": true,
            "opacity-0": true,
            "off-canvas-open:opacity-100": this.open,
            "off-canvas-open:bg-black/25": this.open
        };
        // return a string of classes that are true
        return Object.keys(clses).filter((cls)=>clses[cls]).join(" ");
    }
    show() {
        this.open = true;
        this.parentOpacity = 1;
        if (this.inner) this.inner.setAttribute("open", this.open);
    }
    hide() {
        this.open = false;
        this.parentOpacity = 0;
        if (this.inner) this.inner.removeAttribute("open");
    }
    render() {
        return (0, $7c8bf60562922b0b$export$c0bb0b647f701bb5)`
      <div
        id="${this.id}"
        open="${this.open}"
        style="opacity: ${this.parentOpacity};"
        @click="${this._backgroundClick}"
        class="${this.classes}"
        @transitionEnd="${this._transitionEnd}"
      >
        <slot style="pointer-events: ${this.open ? "auto" : "none"};"></slot>
      </div>
    `;
    }
    _onElementTrigger(e) {
        if (e.detail.target === this.id) {
            this.show();
            return;
        }
    }
    _backgroundClick(e) {
        e.preventDefault();
        if (this.backgroundClose && e.target === this._backgroundElement) this.hide();
    }
    _transitionEnd(e) {
        if (!this.open) this.hide();
    }
}
customElements.define("peach-off-canvas", $831c5ca258efb277$export$644db29b3dffde4c);




class $fa6eda3c6c25b122$export$de188bf114294331 extends (0, $839d4b41baaa67a8$export$5b1a024ae3b8b2b4) {
    static get properties() {
        return {
            class: {
                type: String,
                reflect: true
            },
            orientation: {
                type: String
            },
            open: {
                type: Boolean
            }
        };
    }
    constructor(){
        super();
        this.orientation = "left";
    }
    get classes() {
        const clses = {
            "off-canvas-inner": true,
            "transition-all": true,
            "duration-500": true,
            "bg-white": true,
            absolute: true,
            "max-w-full": true,
            "top-0": true,
            "bottom-0": true,
            "overflow-y-auto": true,
            "off-canvas-open:translate-x-0": true,
            "delay-50": true,
            "w-[400px]": true
        };
        if (this.orientation === "left") {
            clses["left-0"] = true;
            clses["-translate-x-full"] = true;
        }
        if (this.orientation === "right") {
            clses["right-0"] = true;
            clses["translate-x-full"] = true;
        }
        return Object.keys(clses).filter((cls)=>clses[cls]).join(" ");
    }
    render() {
        return (0, $7c8bf60562922b0b$export$c0bb0b647f701bb5)`
      <div class="${this.classes}" data-open="${this.open}">
        <slot></slot>
      </div>
    `;
    }
}
customElements.define("peach-off-canvas-inner", $fa6eda3c6c25b122$export$de188bf114294331);






function $095c2f534c3ef332$var$slugify(str) {
    return str.toLowerCase().replace(/\s/g, "-");
}
class $095c2f534c3ef332$export$d99097c13d4dac9f extends (0, $839d4b41baaa67a8$export$5b1a024ae3b8b2b4) {
    static get properties() {
        return {
            open: {
                type: Boolean,
                reflect: true
            },
            _id: {
                type: String
            },
            id: {
                type: String
            },
            elNumber: {
                type: Number
            },
            headerClass: {
                type: String
            }
        };
    }
    constructor(){
        super();
        this.open = false;
        this.elNumber = parseInt(Array.prototype.indexOf.call(this.parentNode.children, this)) + 1;
    }
    connectedCallback() {
        super.connectedCallback();
        this._distributeChildren();
    }
    _distributeChildren() {
        // get first child
        if (this.children.length > 0) {
            this.children[0].setAttribute("slot", "header");
            this._id = $095c2f534c3ef332$var$slugify(this.children[0].textContent);
            this.id = this._id;
        }
        // get all other children
        if (this.children.length > 1) for(let i = 1; i < this.children.length; i++)this.children[i].setAttribute("slot", "content");
    }
    update(changedProperties) {
        super.update(changedProperties);
    // console.log(changedProperties);
    //if (changedProperties.has("open")) {
    //  if (changedProperties.open == false) {
    //  }
    //}
    }
    get innerClasses() {
        const clses = {
            grid: true,
            "grid-rows-[0fr]": !this.open,
            "grid-rows-[1fr]": this.open,
            "transition-all": true,
            "duration-500": true
        };
        return Object.keys(clses).filter((cls)=>clses[cls]).join(" ");
    }
    _toggle() {
        this.open = !this.open;
        this.dispatchEvent(new CustomEvent("accordion:click", {
            detail: {
                open: this.open,
                id: this._id
            },
            composed: true,
            bubbles: true
        }));
    }
    render() {
        const zeroPad = (num, places)=>String(num).padStart(places, '0');
        return (0, $7c8bf60562922b0b$export$c0bb0b647f701bb5)`
      <div>
        <dt>
          <button
            class="${this.headerClass}"
            @click="${this._toggle}"
            aria-controls="${this._id}"
            ?aria-expanded="${this.open}"
          >
            <span>${zeroPad(this.elNumber, 2)}</span>
            <slot name="header"></slot>
            <span class="inline-block ml-auto text-[22px] lg:text-[26px]">
              <svg class="${this.open ? 'hidden' : 'inline-block'} w-[1em]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M248 72l0-24-48 0 0 24 0 160L40 232l-24 0 0 48 24 0 160 0 0 160 0 24 48 0 0-24 0-160 160 0 24 0 0-48-24 0-160 0 0-160z"/></svg>
              <svg class="${this.open ? 'inline-block' : 'hidden'} w-[1em]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 272l-16 0L32 272l-16 0 0-32 16 0 384 0 16 0 0 32z"/></svg>
            </span>
          </button>
        </dt>
        <dd id="${this._id}" class="${this.innerClasses}">
          <div class="overflow-hidden">
            <slot name="content"></slot>
          </div>
        </dd>
      </div>
    `;
    }
}
customElements.define("peach-accordion-item", $095c2f534c3ef332$export$d99097c13d4dac9f);


class $4d26c4a42ea51cbf$export$a766cd26d0d69044 extends (0, $839d4b41baaa67a8$export$5b1a024ae3b8b2b4) {
    static get properties() {
        return {
            type: {
                type: String
            },
            // "single" or "multiple"
            openFirst: {
                type: Boolean
            } // true or false
        };
    }
    constructor(){
        super();
        this.type = "single";
        this.openFirst = true;
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener("accordion:click", this._onToggle.bind(this));
        this.onInit();
    }
    onInit() {
        if (this.openFirst && this.children) [
            ...this.children
        ][0]._toggle();
    }
    _onToggle(e) {
        if (this.type === "single") [
            ...this.children
        ].forEach((child)=>{
            if (child._id !== e.detail.id) child.open = false;
        });
    }
    render() {
        return (0, $7c8bf60562922b0b$export$c0bb0b647f701bb5)`
      <div>
        <slot></slot>
      </div>
    `;
    }
}
customElements.define("peach-accordion", $4d26c4a42ea51cbf$export$a766cd26d0d69044);


function $318b5cce15d78d5d$export$2e2bcd8739ae039() {}





var $iOXsB = parcelRequire("iOXsB");
const $53123ad321311283$var$Logos = (sliderNode)=>{
    const children = sliderNode.children;
    // Make clones just in case
    [].forEach.call(children, (el)=>{
        let clone = el.cloneNode(true);
        sliderNode.appendChild(clone);
    });
    const options = {
        accessibility: true,
        resize: true,
        autoplay: false,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        percentPosition: true
    };
    let flkty = new (0, (/*@__PURE__*/$parcel$interopDefault($iOXsB)))(sliderNode, options);
    let requestId = false;
    flkty.x = 0;
    play();
    function play() {
        flkty.x -= 0.6;
        flkty.settle(flkty.x);
        requestId = window.requestAnimationFrame(play);
    }
    function pause() {
        if (requestId) {
            window.cancelAnimationFrame(requestId);
            requestId = undefined;
        }
    }
    sliderNode.addEventListener("mouseenter", ()=>pause());
    sliderNode.addEventListener("mouseleave", ()=>play());
};
var $53123ad321311283$export$2e2bcd8739ae039 = $53123ad321311283$var$Logos;




const $bfe5ba0c26ac0ed9$var$resizeHandlers = new WeakMap();
let $bfe5ba0c26ac0ed9$var$observer;
function $bfe5ba0c26ac0ed9$var$getElementSize(target, borderBoxSize) {
    if (borderBoxSize) {
        const { inlineSize: inlineSize, blockSize: blockSize } = borderBoxSize[0];
        return {
            width: inlineSize,
            height: blockSize
        };
    } else if (target instanceof SVGElement && "getBBox" in target) return target.getBBox();
    else return {
        width: target.offsetWidth,
        height: target.offsetHeight
    };
}
function $bfe5ba0c26ac0ed9$var$notifyTarget({ target: target, contentRect: contentRect, borderBoxSize: borderBoxSize }) {
    var _a;
    (_a = $bfe5ba0c26ac0ed9$var$resizeHandlers.get(target)) === null || _a === void 0 || _a.forEach((handler)=>{
        handler({
            target: target,
            contentSize: contentRect,
            get size () {
                return $bfe5ba0c26ac0ed9$var$getElementSize(target, borderBoxSize);
            }
        });
    });
}
function $bfe5ba0c26ac0ed9$var$notifyAll(entries) {
    entries.forEach($bfe5ba0c26ac0ed9$var$notifyTarget);
}
function $bfe5ba0c26ac0ed9$var$createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    $bfe5ba0c26ac0ed9$var$observer = new ResizeObserver($bfe5ba0c26ac0ed9$var$notifyAll);
}
function $bfe5ba0c26ac0ed9$export$81a0e12ec749d682(target, handler) {
    if (!$bfe5ba0c26ac0ed9$var$observer) $bfe5ba0c26ac0ed9$var$createResizeObserver();
    const elements = (0, $94c1aa313017b840$export$90ceba2564a894f8)(target);
    elements.forEach((element)=>{
        let elementHandlers = $bfe5ba0c26ac0ed9$var$resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            $bfe5ba0c26ac0ed9$var$resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        $bfe5ba0c26ac0ed9$var$observer === null || $bfe5ba0c26ac0ed9$var$observer === void 0 || $bfe5ba0c26ac0ed9$var$observer.observe(element);
    });
    return ()=>{
        elements.forEach((element)=>{
            const elementHandlers = $bfe5ba0c26ac0ed9$var$resizeHandlers.get(element);
            elementHandlers === null || elementHandlers === void 0 || elementHandlers.delete(handler);
            if (!(elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.size)) $bfe5ba0c26ac0ed9$var$observer === null || $bfe5ba0c26ac0ed9$var$observer === void 0 || $bfe5ba0c26ac0ed9$var$observer.unobserve(element);
        });
    };
}


const $97086e03643fe580$var$windowCallbacks = new Set();
let $97086e03643fe580$var$windowResizeHandler;
function $97086e03643fe580$var$createWindowResizeHandler() {
    $97086e03643fe580$var$windowResizeHandler = ()=>{
        const size = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        const info = {
            target: window,
            size: size,
            contentSize: size
        };
        $97086e03643fe580$var$windowCallbacks.forEach((callback)=>callback(info));
    };
    window.addEventListener("resize", $97086e03643fe580$var$windowResizeHandler);
}
function $97086e03643fe580$export$7fc81011b72cd94d(callback) {
    $97086e03643fe580$var$windowCallbacks.add(callback);
    if (!$97086e03643fe580$var$windowResizeHandler) $97086e03643fe580$var$createWindowResizeHandler();
    return ()=>{
        $97086e03643fe580$var$windowCallbacks.delete(callback);
        if (!$97086e03643fe580$var$windowCallbacks.size && $97086e03643fe580$var$windowResizeHandler) $97086e03643fe580$var$windowResizeHandler = undefined;
    };
}



function $de51fb72f3404753$export$4380c87abf28fdf(a, b) {
    return (0, $4a3ae8b34d8c7815$export$f6e2535fb5126e54)(a) ? (0, $97086e03643fe580$export$7fc81011b72cd94d)(a) : (0, $bfe5ba0c26ac0ed9$export$81a0e12ec749d682)(a, b);
}


/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $06e4a95beae2adec$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */ const $00919d2cd79d2624$var$maxElapsed = 50;
const $00919d2cd79d2624$var$createAxisInfo = ()=>({
        current: 0,
        offset: [],
        progress: 0,
        scrollLength: 0,
        targetOffset: 0,
        targetLength: 0,
        containerLength: 0,
        velocity: 0
    });
const $00919d2cd79d2624$export$38ba9ec5092d2d70 = ()=>({
        time: 0,
        x: $00919d2cd79d2624$var$createAxisInfo(),
        y: $00919d2cd79d2624$var$createAxisInfo()
    });
const $00919d2cd79d2624$var$keys = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
function $00919d2cd79d2624$var$updateAxisInfo(element, axisName, info, time) {
    const axis = info[axisName];
    const { length: length, position: position } = $00919d2cd79d2624$var$keys[axisName];
    const prev = axis.current;
    const prevTime = info.time;
    axis.current = element[`scroll${position}`];
    axis.scrollLength = element[`scroll${length}`] - element[`client${length}`];
    axis.offset.length = 0;
    axis.offset[0] = 0;
    axis.offset[1] = axis.scrollLength;
    axis.progress = (0, $745d21a74701acae$export$504d7abb21fa8c9)(0, axis.scrollLength, axis.current);
    const elapsed = time - prevTime;
    axis.velocity = elapsed > $00919d2cd79d2624$var$maxElapsed ? 0 : (0, $06e4a95beae2adec$export$eab0632f7ad4f9d7)(axis.current - prev, elapsed);
}
function $00919d2cd79d2624$export$55f50a00c84f0ed3(element, info, time) {
    $00919d2cd79d2624$var$updateAxisInfo(element, "x", info, time);
    $00919d2cd79d2624$var$updateAxisInfo(element, "y", info, time);
    info.time = time;
}





function $fd394662c978afbb$export$6858938830d6a6db(element, container) {
    let inset = {
        x: 0,
        y: 0
    };
    let current = element;
    while(current && current !== container){
        if (current instanceof HTMLElement) {
            inset.x += current.offsetLeft;
            inset.y += current.offsetTop;
            current = current.offsetParent;
        } else if (current instanceof SVGGraphicsElement && "getBBox" in current) {
            const { top: top, left: left } = current.getBBox();
            inset.x += left;
            inset.y += top;
            /**
             * Assign the next parent element as the <svg /> tag.
             */ while(current && current.tagName !== "svg")current = current.parentNode;
        }
    }
    return inset;
}


const $72fe1e2991b0235c$export$e59548524dcf6540 = {
    Enter: [
        [
            0,
            1
        ],
        [
            1,
            1
        ]
    ],
    Exit: [
        [
            0,
            0
        ],
        [
            1,
            0
        ]
    ],
    Any: [
        [
            1,
            0
        ],
        [
            0,
            1
        ]
    ],
    All: [
        [
            0,
            0
        ],
        [
            1,
            1
        ]
    ]
};




const $279bb24dc4be1371$export$5329d185756d2568 = {
    start: 0,
    center: 0.5,
    end: 1
};
function $279bb24dc4be1371$export$1a4fccdf0f25754b(edge, length, inset = 0) {
    let delta = 0;
    /**
     * If we have this edge defined as a preset, replace the definition
     * with the numerical value.
     */ if ($279bb24dc4be1371$export$5329d185756d2568[edge] !== undefined) edge = $279bb24dc4be1371$export$5329d185756d2568[edge];
    /**
     * Handle unit values
     */ if ((0, $6dfc46d0761bc5e3$export$844ec244b1367d54)(edge)) {
        const asNumber = parseFloat(edge);
        if (edge.endsWith("px")) delta = asNumber;
        else if (edge.endsWith("%")) edge = asNumber / 100;
        else if (edge.endsWith("vw")) delta = asNumber / 100 * document.documentElement.clientWidth;
        else if (edge.endsWith("vh")) delta = asNumber / 100 * document.documentElement.clientHeight;
        else edge = asNumber;
    }
    /**
     * If the edge is defined as a number, handle as a progress value.
     */ if ((0, $21f0d41def87b865$export$7e4aa119212bc614)(edge)) delta = length * edge;
    return inset + delta;
}


const $d787295b6339a0c9$var$defaultOffset = [
    0,
    0
];
function $d787295b6339a0c9$export$1d98ea10734f1dc1(offset, containerLength, targetLength, targetInset) {
    let offsetDefinition = Array.isArray(offset) ? offset : $d787295b6339a0c9$var$defaultOffset;
    let targetPoint = 0;
    let containerPoint = 0;
    if ((0, $21f0d41def87b865$export$7e4aa119212bc614)(offset)) /**
         * If we're provided offset: [0, 0.5, 1] then each number x should become
         * [x, x], so we default to the behaviour of mapping 0 => 0 of both target
         * and container etc.
         */ offsetDefinition = [
        offset,
        offset
    ];
    else if ((0, $6dfc46d0761bc5e3$export$844ec244b1367d54)(offset)) {
        offset = offset.trim();
        if (offset.includes(" ")) offsetDefinition = offset.split(" ");
        else /**
             * If we're provided a definition like "100px" then we want to apply
             * that only to the top of the target point, leaving the container at 0.
             * Whereas a named offset like "end" should be applied to both.
             */ offsetDefinition = [
            offset,
            (0, $279bb24dc4be1371$export$5329d185756d2568)[offset] ? offset : `0`
        ];
    }
    targetPoint = (0, $279bb24dc4be1371$export$1a4fccdf0f25754b)(offsetDefinition[0], targetLength, targetInset);
    containerPoint = (0, $279bb24dc4be1371$export$1a4fccdf0f25754b)(offsetDefinition[1], containerLength);
    return targetPoint - containerPoint;
}


const $4d5b1b0d37b2cf47$var$point = {
    x: 0,
    y: 0
};
function $4d5b1b0d37b2cf47$export$44b097f22602edfc(container, info, options) {
    let { offset: offsetDefinition = (0, $72fe1e2991b0235c$export$e59548524dcf6540).All } = options;
    const { target: target = container, axis: axis = "y" } = options;
    const lengthLabel = axis === "y" ? "height" : "width";
    const inset = target !== container ? (0, $fd394662c978afbb$export$6858938830d6a6db)(target, container) : $4d5b1b0d37b2cf47$var$point;
    /**
     * Measure the target and container. If they're the same thing then we
     * use the container's scrollWidth/Height as the target, from there
     * all other calculations can remain the same.
     */ const targetSize = target === container ? {
        width: container.scrollWidth,
        height: container.scrollHeight
    } : {
        width: target.clientWidth,
        height: target.clientHeight
    };
    const containerSize = {
        width: container.clientWidth,
        height: container.clientHeight
    };
    /**
     * Reset the length of the resolved offset array rather than creating a new one.
     * TODO: More reusable data structures for targetSize/containerSize would also be good.
     */ info[axis].offset.length = 0;
    /**
     * Populate the offset array by resolving the user's offset definition into
     * a list of pixel scroll offets.
     */ let hasChanged = !info[axis].interpolate;
    const numOffsets = offsetDefinition.length;
    for(let i = 0; i < numOffsets; i++){
        const offset = (0, $d787295b6339a0c9$export$1d98ea10734f1dc1)(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);
        if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) hasChanged = true;
        info[axis].offset[i] = offset;
    }
    /**
     * If the pixel scroll offsets have changed, create a new interpolator function
     * to map scroll value into a progress.
     */ if (hasChanged) {
        info[axis].interpolate = (0, $f6298ebfcbce476f$export$89e29e4ab65e70a9)((0, $b5786fb950153824$export$24dbcec0b26e6d9d)(numOffsets), info[axis].offset);
        info[axis].interpolatorOffsets = [
            ...info[axis].offset
        ];
    }
    info[axis].progress = info[axis].interpolate(info[axis].current);
}


function $a71c24e68bdd4958$var$measure(container, target = container, info) {
    /**
     * Find inset of target within scrollable container
     */ info.x.targetOffset = 0;
    info.y.targetOffset = 0;
    if (target !== container) {
        let node = target;
        while(node && node != container){
            info.x.targetOffset += node.offsetLeft;
            info.y.targetOffset += node.offsetTop;
            node = node.offsetParent;
        }
    }
    info.x.targetLength = target === container ? target.scrollWidth : target.clientWidth;
    info.y.targetLength = target === container ? target.scrollHeight : target.clientHeight;
    info.x.containerLength = container.clientWidth;
    info.y.containerLength = container.clientHeight;
}
function $a71c24e68bdd4958$export$9dd72aeec3645b49(element, onScroll, info, options = {}) {
    const axis = options.axis || "y";
    return {
        measure: ()=>$a71c24e68bdd4958$var$measure(element, options.target, info),
        update: (time)=>{
            (0, $00919d2cd79d2624$export$55f50a00c84f0ed3)(element, info, time);
            if (options.offset || options.target) (0, $4d5b1b0d37b2cf47$export$44b097f22602edfc)(element, info, options);
        },
        notify: (0, $4a3ae8b34d8c7815$export$f6e2535fb5126e54)(onScroll) ? ()=>onScroll(info) : $a71c24e68bdd4958$var$scrubAnimation(onScroll, info[axis])
    };
}
function $a71c24e68bdd4958$var$scrubAnimation(controls, axisInfo) {
    controls.pause();
    controls.forEachNative((animation, { easing: easing })=>{
        var _a, _b;
        if (animation.updateDuration) {
            if (!easing) animation.easing = (0, $5a7c6586306c883b$export$ea6e51872ab1b721);
            animation.updateDuration(1);
        } else {
            const timingOptions = {
                duration: 1000
            };
            if (!easing) timingOptions.easing = "linear";
            (_b = (_a = animation.effect) === null || _a === void 0 ? void 0 : _a.updateTiming) === null || _b === void 0 || _b.call(_a, timingOptions);
        }
    });
    return ()=>{
        controls.currentTime = axisInfo.progress;
    };
}


const $ba289e0a3f6556fe$var$scrollListeners = new WeakMap();
const $ba289e0a3f6556fe$var$resizeListeners = new WeakMap();
const $ba289e0a3f6556fe$var$onScrollHandlers = new WeakMap();
const $ba289e0a3f6556fe$var$getEventTarget = (element)=>element === document.documentElement ? window : element;
function $ba289e0a3f6556fe$export$209876d7b1ac8f3(onScroll, _a = {}) {
    var { container: container = document.documentElement } = _a, options = (0, $6402438dfd14940e$export$3c9a16f847548506)(_a, [
        "container"
    ]);
    let containerHandlers = $ba289e0a3f6556fe$var$onScrollHandlers.get(container);
    /**
     * Get the onScroll handlers for this container.
     * If one isn't found, create a new one.
     */ if (!containerHandlers) {
        containerHandlers = new Set();
        $ba289e0a3f6556fe$var$onScrollHandlers.set(container, containerHandlers);
    }
    /**
     * Create a new onScroll handler for the provided callback.
     */ const info = (0, $00919d2cd79d2624$export$38ba9ec5092d2d70)();
    const containerHandler = (0, $a71c24e68bdd4958$export$9dd72aeec3645b49)(container, onScroll, info, options);
    containerHandlers.add(containerHandler);
    /**
     * Check if there's a scroll event listener for this container.
     * If not, create one.
     */ if (!$ba289e0a3f6556fe$var$scrollListeners.has(container)) {
        const listener = ()=>{
            const time = performance.now();
            for (const handler of containerHandlers)handler.measure();
            for (const handler of containerHandlers)handler.update(time);
            for (const handler of containerHandlers)handler.notify();
        };
        $ba289e0a3f6556fe$var$scrollListeners.set(container, listener);
        const target = $ba289e0a3f6556fe$var$getEventTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $ba289e0a3f6556fe$var$resizeListeners.set(container, (0, $de51fb72f3404753$export$4380c87abf28fdf)(container, listener));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const listener = $ba289e0a3f6556fe$var$scrollListeners.get(container);
    const onLoadProcesss = requestAnimationFrame(listener);
    return ()=>{
        var _a;
        if (typeof onScroll !== "function") onScroll.stop();
        cancelAnimationFrame(onLoadProcesss);
        /**
         * Check if we even have any handlers for this container.
         */ const containerHandlers = $ba289e0a3f6556fe$var$onScrollHandlers.get(container);
        if (!containerHandlers) return;
        containerHandlers.delete(containerHandler);
        if (containerHandlers.size) return;
        /**
         * If no more handlers, remove the scroll listener too.
         */ const listener = $ba289e0a3f6556fe$var$scrollListeners.get(container);
        $ba289e0a3f6556fe$var$scrollListeners.delete(container);
        if (listener) {
            $ba289e0a3f6556fe$var$getEventTarget(container).removeEventListener("scroll", listener);
            (_a = $ba289e0a3f6556fe$var$resizeListeners.get(container)) === null || _a === void 0 || _a();
            window.removeEventListener("resize", listener);
        }
    };
}


const $ca0d1ae6cb2d213c$var$Process = (parent)=>{
    const wrapper = parent.querySelector(".process-wrapper");
    const children = parent.querySelectorAll(".giantpeach-processtile");
    const yAxis = parent.querySelector('.y-axis-anim');
    (0, $ba289e0a3f6556fe$export$209876d7b1ac8f3)((progress, info)=>{
        yAxis.style.transform = "scaleY(" + progress.y.progress + ")";
    }, {
        target: wrapper,
        offset: [
            "start center",
            "end center"
        ]
    });
    children.forEach((child)=>{
        let observer;
        (0, $3019b940a732e107$export$acb1e9cb9ce4ca56)(child, (info)=>{
            child.classList.add("active");
            return (_)=>{
                child.classList.remove("active");
            };
        }, {
            margin: `0px 0px -${parseInt(window.innerHeight / 2)}px 0px`
        });
    });
};
var $ca0d1ae6cb2d213c$export$2e2bcd8739ae039 = $ca0d1ae6cb2d213c$var$Process;



const $5d434dcfcf14d55c$var$AnimatedScroll = (parent)=>{
    const elementNodes = parent.querySelectorAll('.animated');
    (0, $ba289e0a3f6556fe$export$209876d7b1ac8f3)((progress)=>{
        const factor = progress.y.progress;
        if (factor < 1) elementNodes.forEach((el)=>{
            let xTransform = el.dataset.fromX * factor;
            let yTransform = el.dataset.fromY * factor;
            el.style.transform = `translate(${xTransform}px, ${yTransform}px)`;
        });
    }, {
        target: parent,
        offset: [
            "start 0.3",
            "start end"
        ]
    });
};
var $5d434dcfcf14d55c$export$2e2bcd8739ae039 = $5d434dcfcf14d55c$var$AnimatedScroll;



const $55d913a54d8ff892$var$HomeBanner = (parent)=>{
    const scrollParallaxEl = parent.querySelector('.scroll-parallax');
    const scrollImageContainer = parent.querySelector('.scroll-image-container');
    if (scrollParallaxEl) (0, $ba289e0a3f6556fe$export$209876d7b1ac8f3)((progress)=>{
        parent.style.setProperty("--scroll-percent", progress.y.progress);
        if (progress.y.progress >= 1) scrollImageContainer.classList.add("!rounded-none");
        else scrollImageContainer.classList.remove("!rounded-none");
    }, {
        target: scrollParallaxEl,
        offset: [
            `-${scrollParallaxEl.querySelector('.sticky-element').offsetHeight * 2}px end`,
            "end end"
        ]
    });
};
var $55d913a54d8ff892$export$2e2bcd8739ae039 = $55d913a54d8ff892$var$HomeBanner;



const $0718df5b9f85432a$var$ContentScrollable = (parent)=>{
    const wrapper = parent.querySelector(".snap-y");
    const children = wrapper.children;
    if (window.innerWidth < 992) wrapper.style.height = children[0].offsetHeight + "px";
    if (window.innerWidth >= 992) {
        const sectionHeight = children[0].offsetHeight;
        wrapper.style.top = (window.innerHeight + 20 + document.querySelector("#page-navbar").offsetHeight - sectionHeight) / 2 + "px";
        let currentItem = 0;
        parent.style.height = sectionHeight * children.length + "px";
        wrapper.style.height = sectionHeight + "px";
        const setMediaPlayState = (el, playing)=>{
            el.querySelectorAll("video").forEach((video)=>{
                if (playing) video.play().catch(()=>{});
                else video.pause();
            });
            if (!playing) el.querySelectorAll('iframe[src*="youtube.com/embed"]').forEach((iframe)=>{
                iframe.contentWindow?.postMessage(JSON.stringify({
                    event: "command",
                    func: "pauseVideo",
                    args: []
                }), "*");
            });
        };
        const updateCurrentItem = (_)=>{
            if (typeof children[currentItem] != "undefined" && children[currentItem]) {
                Array.from(children).forEach((el)=>{
                    if (el !== children[currentItem]) {
                        el.classList.remove("active");
                        setMediaPlayState(el, false);
                    }
                });
                children[currentItem].classList.add("active");
                setMediaPlayState(children[currentItem], true);
            }
        };
        updateCurrentItem();
        (0, $ba289e0a3f6556fe$export$209876d7b1ac8f3)((scrollEvent)=>{
            if (scrollEvent.y.progress > 0) {
                const currentOffset = scrollEvent.y.current - scrollEvent.y.offset[0];
                currentItem = Math.floor(currentOffset / sectionHeight);
                updateCurrentItem();
            }
        }, {
            target: parent,
            offset: [
                "start center",
                "end end"
            ]
        });
    }
};
var $0718df5b9f85432a$export$2e2bcd8739ae039 = $0718df5b9f85432a$var$ContentScrollable;



var $iOXsB = parcelRequire("iOXsB");
var $4e2f912138c8bae8$exports = {};


/**
 * Flickity fade v2.0.0
 * Fade between Flickity slides
 */ (function(window1, factory) {
    // universal module definition
    if ($4e2f912138c8bae8$exports) // CommonJS
    $4e2f912138c8bae8$exports = factory((parcelRequire("iOXsB")), (parcelRequire("7KKWT")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : $4e2f912138c8bae8$exports, function factory(Flickity, utils) {
    // ---- Slide ---- //
    let Slide = Flickity.Slide;
    Slide.prototype.renderFadePosition = function() {};
    Slide.prototype.setOpacity = function(alpha) {
        this.cells.forEach((cell)=>{
            cell.element.style.opacity = alpha;
        });
    };
    // ---- Flickity ---- //
    Flickity.create.fade = function() {
        this.fadeIndex = this.selectedIndex;
        this.prevSelectedIndex = this.selectedIndex;
        this.on('select', this.onSelectFade);
        this.on('dragEnd', this.onDragEndFade);
        this.on('settle', this.onSettleFade);
        this.on('activate', this.onActivateFade);
        this.on('deactivate', this.onDeactivateFade);
    };
    let proto = Flickity.prototype;
    let updateSlides = proto.updateSlides;
    proto.updateSlides = function() {
        updateSlides.apply(this, arguments);
        if (!this.options.fade) return;
        this.slides.forEach((slide, i)=>{
            // position cells at selected target
            let slideTargetX = slide.target - slide.x;
            let firstCellX = slide.cells[0].x;
            slide.cells.forEach((cell)=>{
                let targetX = cell.x - firstCellX - slideTargetX;
                this._renderCellPosition(cell, targetX);
            });
            // set initial opacity
            let alpha = i === this.selectedIndex ? 1 : 0;
            slide.setOpacity(alpha);
        });
    };
    /* ---- events ---- */ proto.onSelectFade = function() {
        // in case of resize, keep fadeIndex within current count
        this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1);
        this.prevSelectedIndex = this.selectedIndex;
    };
    proto.onSettleFade = function() {
        delete this.didDragEnd;
        if (!this.options.fade) return;
        // set full and 0 opacity on selected & faded slides
        this.selectedSlide.setOpacity(1);
        let fadedSlide = this.slides[this.fadeIndex];
        if (fadedSlide && this.fadeIndex !== this.selectedIndex) this.slides[this.fadeIndex].setOpacity(0);
    };
    proto.onDragEndFade = function() {
        // set flag
        this.didDragEnd = true;
    };
    proto.onActivateFade = function() {
        if (this.options.fade) this.element.classList.add('is-fade');
    };
    proto.onDeactivateFade = function() {
        if (!this.options.fade) return;
        this.element.classList.remove('is-fade');
        // reset opacity
        this.slides.forEach((slide)=>{
            slide.setOpacity('');
        });
    };
    /* ---- position & fading ---- */ let positionSlider = proto.positionSlider;
    proto.positionSlider = function() {
        if (!this.options.fade) {
            positionSlider.apply(this, arguments);
            return;
        }
        this.fadeSlides();
        this.dispatchScrollEvent();
    };
    let positionSliderAtSelected = proto.positionSliderAtSelected;
    proto.positionSliderAtSelected = function() {
        if (this.options.fade) // position fade slider at origin
        this.setTranslateX(0);
        positionSliderAtSelected.apply(this, arguments);
    };
    proto.fadeSlides = function() {
        if (this.slides.length < 2) return;
        // get slides to fade-in & fade-out
        let indexes = this.getFadeIndexes();
        let fadeSlideA = this.slides[indexes.a];
        let fadeSlideB = this.slides[indexes.b];
        let distance = this.wrapDifference(fadeSlideA.target, fadeSlideB.target);
        let progress = this.wrapDifference(fadeSlideA.target, -this.x);
        progress /= distance;
        fadeSlideA.setOpacity(1 - progress);
        fadeSlideB.setOpacity(progress);
        // hide previous slide
        let fadeHideIndex = indexes.a;
        if (this.isDragging) fadeHideIndex = progress > 0.5 ? indexes.a : indexes.b;
        let isNewHideIndex = this.fadeHideIndex !== undefined && this.fadeHideIndex !== fadeHideIndex && this.fadeHideIndex !== indexes.a && this.fadeHideIndex !== indexes.b;
        if (isNewHideIndex) // new fadeHideSlide set, hide previous
        this.slides[this.fadeHideIndex].setOpacity(0);
        this.fadeHideIndex = fadeHideIndex;
    };
    proto.getFadeIndexes = function() {
        if (!this.isDragging && !this.didDragEnd) return {
            a: this.fadeIndex,
            b: this.selectedIndex
        };
        if (this.options.wrapAround) return this.getFadeDragWrapIndexes();
        else return this.getFadeDragLimitIndexes();
    };
    proto.getFadeDragWrapIndexes = function() {
        let distances = this.slides.map(function(slide, i) {
            return this.getSlideDistance(-this.x, i);
        }, this);
        let absDistances = distances.map(function(distance) {
            return Math.abs(distance);
        });
        let minDistance = Math.min(...absDistances);
        let closestIndex = absDistances.indexOf(minDistance);
        let distance = distances[closestIndex];
        let len = this.slides.length;
        let delta = distance >= 0 ? 1 : -1;
        return {
            a: closestIndex,
            b: utils.modulo(closestIndex + delta, len)
        };
    };
    proto.getFadeDragLimitIndexes = function() {
        // calculate closest previous slide
        let dragIndex = 0;
        for(let i = 0; i < this.slides.length - 1; i++){
            let slide = this.slides[i];
            if (-this.x < slide.target) break;
            dragIndex = i;
        }
        return {
            a: dragIndex,
            b: dragIndex + 1
        };
    };
    proto.wrapDifference = function(a, b) {
        let diff = b - a;
        if (!this.options.wrapAround) return diff;
        let diffPlus = diff + this.slideableWidth;
        let diffMinus = diff - this.slideableWidth;
        if (Math.abs(diffPlus) < Math.abs(diff)) diff = diffPlus;
        if (Math.abs(diffMinus) < Math.abs(diff)) diff = diffMinus;
        return diff;
    };
    // ---- wrapAround ---- //
    let _updateWrapShiftCells = proto._updateWrapShiftCells;
    proto._updateWrapShiftCells = function() {
        if (this.options.fade) // update isWrapping
        this.isWrapping = this.getIsWrapping();
        else _updateWrapShiftCells.apply(this, arguments);
    };
    let shiftWrapCells = proto.shiftWrapCells;
    proto.shiftWrapCells = function() {
        if (!this.options.fade) shiftWrapCells.apply(this, arguments);
    };
    return Flickity;
});


var $eed110a2c0323f24$exports = {};


/*!
 * Flickity imagesLoaded v2.0.0
 * enables imagesLoaded option for Flickity
 */ /*jshint browser: true, strict: true, undef: true, unused: true */ (function(window1, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */ if (typeof define == 'function' && define.amd) // AMD
    define([
        'flickity/js/index',
        'imagesloaded/imagesloaded'
    ], function(Flickity, imagesLoaded) {
        return factory(window1, Flickity, imagesLoaded);
    });
    else if ($eed110a2c0323f24$exports) // CommonJS
    $eed110a2c0323f24$exports = factory(window1, (parcelRequire("cHCZe")), (parcelRequire("a1W8t")));
    else // browser global
    window1.Flickity = factory(window1, window1.Flickity, window1.imagesLoaded);
})(window, function factory(window1, Flickity, imagesLoaded) {
    'use strict';
    Flickity.createMethods.push('_createImagesLoaded');
    var proto = Flickity.prototype;
    proto._createImagesLoaded = function() {
        this.on('activate', this.imagesLoaded);
    };
    proto.imagesLoaded = function() {
        if (!this.options.imagesLoaded) return;
        var _this = this;
        function onImagesLoadedProgress(instance, image) {
            var cell = _this.getParentCell(image.img);
            _this.cellSizeChange(cell && cell.element);
            if (!_this.options.freeScroll) _this.positionSliderAtSelected();
        }
        imagesLoaded(this.slider).on('progress', onImagesLoadedProgress);
    };
    return Flickity;
});


const $31d52f9d3041ab46$var$pad = (num, size)=>{
    num = num.toString();
    while(num.length < size)num = "0" + num;
    return num;
};
const $31d52f9d3041ab46$var$TestimonialSlider = (parentNode)=>{
    parentNode.classList.add('opacity-0');
    const firstChild = parentNode.querySelector('.gp-testimonial-slider').children.item(0);
    if (firstChild) parentNode.style.setProperty('--testimonial-temp-height', firstChild.offsetHeight + 'px');
    setTimeout((_)=>{
        const statusNavCurrent = parentNode.querySelector('.flickity-status-current');
        const statusNavMax = parentNode.querySelector('.flickity-status-max');
        let flkty = new (0, (/*@__PURE__*/$parcel$interopDefault($iOXsB)))(parentNode.querySelector('.gp-testimonial-slider'), {
            wrapAround: true,
            draggable: false,
            loop: true,
            autoPlay: false,
            pageDots: false,
            prevNextButtons: false,
            fade: true,
            adaptiveHeight: true,
            imagesLoaded: true,
            on: {
                ready: function() {
                    parentNode.classList.remove('opacity-0');
                    if (statusNavMax) statusNavMax.innerHTML = $31d52f9d3041ab46$var$pad(this.slides.length, 2);
                },
                select: function() {
                    if (statusNavCurrent) statusNavCurrent.innerHTML = $31d52f9d3041ab46$var$pad(this.selectedIndex + 1, 2);
                }
            }
        });
        parentNode.querySelector('.slider-next').addEventListener('click', (e)=>{
            e.preventDefault();
            flkty.next();
        });
        parentNode.querySelector('.slider-prev').addEventListener('click', (e)=>{
            e.preventDefault();
            flkty.previous();
        });
    }, 100);
};
var $31d52f9d3041ab46$export$2e2bcd8739ae039 = $31d52f9d3041ab46$var$TestimonialSlider;


/**
 * name: body-scroll-lock-upgrade
 * version: v1.1.0
 * author: Rick.li
 */ let $377c30ec3e1a0a0d$var$hasPassiveEvents = false;
if (typeof window !== "undefined") {
    const passiveTestOptions = {
        get passive () {
            $377c30ec3e1a0a0d$var$hasPassiveEvents = true;
            return void 0;
        }
    };
    window.addEventListener("testPassive", null, passiveTestOptions);
    window.removeEventListener("testPassive", null, passiveTestOptions);
}
const $377c30ec3e1a0a0d$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
let $377c30ec3e1a0a0d$var$locks = [];
let $377c30ec3e1a0a0d$var$locksIndex = /* @__PURE__ */ new Map();
let $377c30ec3e1a0a0d$var$documentListenerAdded = false;
let $377c30ec3e1a0a0d$var$initialClientY = -1;
let $377c30ec3e1a0a0d$var$previousBodyOverflowSetting;
let $377c30ec3e1a0a0d$var$htmlStyle;
let $377c30ec3e1a0a0d$var$bodyStyle;
let $377c30ec3e1a0a0d$var$previousBodyPaddingRight;
const $377c30ec3e1a0a0d$var$allowTouchMove = (el)=>$377c30ec3e1a0a0d$var$locks.some((lock)=>{
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
const $377c30ec3e1a0a0d$var$preventDefault = (rawEvent)=>{
    const e = rawEvent || window.event;
    if ($377c30ec3e1a0a0d$var$allowTouchMove(e.target)) return true;
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
const $377c30ec3e1a0a0d$var$setOverflowHidden = (options)=>{
    if ($377c30ec3e1a0a0d$var$previousBodyPaddingRight === void 0) {
        const reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        const scrollBarGap = window.innerWidth - document.documentElement.getBoundingClientRect().width;
        if (reserveScrollBarGap && scrollBarGap > 0) {
            const computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
            $377c30ec3e1a0a0d$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = `${computedBodyPaddingRight + scrollBarGap}px`;
        }
    }
    if ($377c30ec3e1a0a0d$var$previousBodyOverflowSetting === void 0) {
        $377c30ec3e1a0a0d$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    }
};
const $377c30ec3e1a0a0d$var$restoreOverflowSetting = ()=>{
    if ($377c30ec3e1a0a0d$var$previousBodyPaddingRight !== void 0) {
        document.body.style.paddingRight = $377c30ec3e1a0a0d$var$previousBodyPaddingRight;
        $377c30ec3e1a0a0d$var$previousBodyPaddingRight = void 0;
    }
    if ($377c30ec3e1a0a0d$var$previousBodyOverflowSetting !== void 0) {
        document.body.style.overflow = $377c30ec3e1a0a0d$var$previousBodyOverflowSetting;
        $377c30ec3e1a0a0d$var$previousBodyOverflowSetting = void 0;
    }
};
const $377c30ec3e1a0a0d$var$setPositionFixed = ()=>window.requestAnimationFrame(()=>{
        const $html = document.documentElement;
        const $body = document.body;
        if ($377c30ec3e1a0a0d$var$bodyStyle === void 0) {
            $377c30ec3e1a0a0d$var$htmlStyle = {
                ...$html.style
            };
            $377c30ec3e1a0a0d$var$bodyStyle = {
                ...$body.style
            };
            const { scrollY: scrollY, scrollX: scrollX, innerHeight: innerHeight } = window;
            $html.style.height = "100%";
            $html.style.overflow = "hidden";
            $body.style.position = "fixed";
            $body.style.top = `${-scrollY}px`;
            $body.style.left = `${-scrollX}px`;
            $body.style.width = "100%";
            $body.style.height = "auto";
            $body.style.overflow = "hidden";
            setTimeout(()=>window.requestAnimationFrame(()=>{
                    const bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollY >= innerHeight) $body.style.top = -(scrollY + bottomBarHeight) + "px";
                }), 300);
        }
    });
const $377c30ec3e1a0a0d$var$restorePositionSetting = ()=>{
    if ($377c30ec3e1a0a0d$var$bodyStyle !== void 0) {
        const y = -parseInt(document.body.style.top, 10);
        const x = -parseInt(document.body.style.left, 10);
        const $html = document.documentElement;
        const $body = document.body;
        $html.style.height = ($377c30ec3e1a0a0d$var$htmlStyle == null ? void 0 : $377c30ec3e1a0a0d$var$htmlStyle.height) || "";
        $html.style.overflow = ($377c30ec3e1a0a0d$var$htmlStyle == null ? void 0 : $377c30ec3e1a0a0d$var$htmlStyle.overflow) || "";
        $body.style.position = $377c30ec3e1a0a0d$var$bodyStyle.position || "";
        $body.style.top = $377c30ec3e1a0a0d$var$bodyStyle.top || "";
        $body.style.left = $377c30ec3e1a0a0d$var$bodyStyle.left || "";
        $body.style.width = $377c30ec3e1a0a0d$var$bodyStyle.width || "";
        $body.style.height = $377c30ec3e1a0a0d$var$bodyStyle.height || "";
        $body.style.overflow = $377c30ec3e1a0a0d$var$bodyStyle.overflow || "";
        window.scrollTo(x, y);
        $377c30ec3e1a0a0d$var$bodyStyle = void 0;
    }
};
const $377c30ec3e1a0a0d$var$isTargetElementTotallyScrolled = (targetElement)=>targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
const $377c30ec3e1a0a0d$var$handleScroll = (event, targetElement)=>{
    const clientY = event.targetTouches[0].clientY - $377c30ec3e1a0a0d$var$initialClientY;
    if ($377c30ec3e1a0a0d$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) return $377c30ec3e1a0a0d$var$preventDefault(event);
    if ($377c30ec3e1a0a0d$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) return $377c30ec3e1a0a0d$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
const $377c30ec3e1a0a0d$export$24fdf68abf432c44 = (targetElement, options)=>{
    if (!targetElement) {
        console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        return;
    }
    $377c30ec3e1a0a0d$var$locksIndex.set(targetElement, ($377c30ec3e1a0a0d$var$locksIndex == null ? void 0 : $377c30ec3e1a0a0d$var$locksIndex.get(targetElement)) ? ($377c30ec3e1a0a0d$var$locksIndex == null ? void 0 : $377c30ec3e1a0a0d$var$locksIndex.get(targetElement)) + 1 : 1);
    if ($377c30ec3e1a0a0d$var$locks.some((lock2)=>lock2.targetElement === targetElement)) return;
    const lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $377c30ec3e1a0a0d$var$locks = [
        ...$377c30ec3e1a0a0d$var$locks,
        lock
    ];
    if ($377c30ec3e1a0a0d$var$isIosDevice) $377c30ec3e1a0a0d$var$setPositionFixed();
    else $377c30ec3e1a0a0d$var$setOverflowHidden(options);
    if ($377c30ec3e1a0a0d$var$isIosDevice) {
        targetElement.ontouchstart = (event)=>{
            if (event.targetTouches.length === 1) $377c30ec3e1a0a0d$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = (event)=>{
            if (event.targetTouches.length === 1) $377c30ec3e1a0a0d$var$handleScroll(event, targetElement);
        };
        if (!$377c30ec3e1a0a0d$var$documentListenerAdded) {
            document.addEventListener("touchmove", $377c30ec3e1a0a0d$var$preventDefault, $377c30ec3e1a0a0d$var$hasPassiveEvents ? {
                passive: false
            } : void 0);
            $377c30ec3e1a0a0d$var$documentListenerAdded = true;
        }
    }
};
const $377c30ec3e1a0a0d$export$45a3ef215b2a5866 = ()=>{
    if ($377c30ec3e1a0a0d$var$isIosDevice) {
        $377c30ec3e1a0a0d$var$locks.forEach((lock)=>{
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($377c30ec3e1a0a0d$var$documentListenerAdded) {
            document.removeEventListener("touchmove", $377c30ec3e1a0a0d$var$preventDefault, $377c30ec3e1a0a0d$var$hasPassiveEvents ? {
                passive: false
            } : void 0);
            $377c30ec3e1a0a0d$var$documentListenerAdded = false;
        }
        $377c30ec3e1a0a0d$var$initialClientY = -1;
    }
    if ($377c30ec3e1a0a0d$var$isIosDevice) $377c30ec3e1a0a0d$var$restorePositionSetting();
    else $377c30ec3e1a0a0d$var$restoreOverflowSetting();
    $377c30ec3e1a0a0d$var$locks = [];
    $377c30ec3e1a0a0d$var$locksIndex.clear();
};
const $377c30ec3e1a0a0d$export$e5d0524c3725571e = (targetElement)=>{
    if (!targetElement) {
        console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        return;
    }
    $377c30ec3e1a0a0d$var$locksIndex.set(targetElement, ($377c30ec3e1a0a0d$var$locksIndex == null ? void 0 : $377c30ec3e1a0a0d$var$locksIndex.get(targetElement)) ? ($377c30ec3e1a0a0d$var$locksIndex == null ? void 0 : $377c30ec3e1a0a0d$var$locksIndex.get(targetElement)) - 1 : 0);
    if (($377c30ec3e1a0a0d$var$locksIndex == null ? void 0 : $377c30ec3e1a0a0d$var$locksIndex.get(targetElement)) === 0) {
        $377c30ec3e1a0a0d$var$locks = $377c30ec3e1a0a0d$var$locks.filter((lock)=>lock.targetElement !== targetElement);
        $377c30ec3e1a0a0d$var$locksIndex == null || $377c30ec3e1a0a0d$var$locksIndex.delete(targetElement);
    }
    if ($377c30ec3e1a0a0d$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($377c30ec3e1a0a0d$var$documentListenerAdded && $377c30ec3e1a0a0d$var$locks.length === 0) {
            document.removeEventListener("touchmove", $377c30ec3e1a0a0d$var$preventDefault, $377c30ec3e1a0a0d$var$hasPassiveEvents ? {
                passive: false
            } : void 0);
            $377c30ec3e1a0a0d$var$documentListenerAdded = false;
        }
    }
    if ($377c30ec3e1a0a0d$var$locks.length === 0) {
        if ($377c30ec3e1a0a0d$var$isIosDevice) $377c30ec3e1a0a0d$var$restorePositionSetting();
        else $377c30ec3e1a0a0d$var$restoreOverflowSetting();
    }
};


(0, $f7be985f79bfefb2$export$2e2bcd8739ae039).plugin((0, $290e903578575c63$export$2e2bcd8739ae039));
window.Alpine = (0, $f7be985f79bfefb2$export$2e2bcd8739ae039);
(0, $f7be985f79bfefb2$export$2e2bcd8739ae039).start();
const $69b95ab15881497e$var$domReady = ()=>{
    (0, $9211fbba4da27573$export$2e2bcd8739ae039)();
    $69b95ab15881497e$var$initModules();
    $69b95ab15881497e$var$initAnimations();
    window.clearAllBodyScrollLocks = (0, $377c30ec3e1a0a0d$export$45a3ef215b2a5866);
    document.addEventListener('modal:open', (e)=>{
        if (e.detail && e.detail.overflowWrapper) (0, $377c30ec3e1a0a0d$export$24fdf68abf432c44)(e.detail.overflowWrapper);
    });
    document.addEventListener('modal:close', (e)=>{
        if (e.detail && e.detail.overflowWrapper) (0, $377c30ec3e1a0a0d$export$45a3ef215b2a5866)();
    });
    document.querySelector("select")?.addEventListener("change", function() {
        this.classList.toggle("has-value", this.value !== "");
    });
    document.querySelectorAll('.giantpeach-contentscrollable .overflow-y-scroll').forEach((el)=>{
        setTimeout((_)=>{
            el.scrollTo(0, 0);
        }, 100);
    });
};
/*

Each module should be treated as an individual block. 
Please pass each node as module param. 
Module path is case-sensitive. Wrong path will throw an error on dev server after running `npm run build`.

*/ function $69b95ab15881497e$var$initModules() {
    new (0, $318b5cce15d78d5d$export$2e2bcd8739ae039)();
    const testimonialSliderNodes = document.querySelectorAll(".giantpeach-testimonialslider");
    if (testimonialSliderNodes.length) testimonialSliderNodes.forEach((slider)=>{
        (0, $31d52f9d3041ab46$export$2e2bcd8739ae039)(slider);
    });
    const logoSliderNodes = document.querySelectorAll('.gp-logoslider');
    if (logoSliderNodes.length) logoSliderNodes.forEach((slider)=>{
        (0, $53123ad321311283$export$2e2bcd8739ae039)(slider);
    });
    const processNodes = document.querySelectorAll('.giantpeach-process');
    if (processNodes.length) processNodes.forEach((el)=>{
        (0, $ca0d1ae6cb2d213c$export$2e2bcd8739ae039)(el);
    });
    const contentScrollableNodes = document.querySelectorAll('.giantpeach-contentscrollable');
    if (contentScrollableNodes.length) contentScrollableNodes.forEach((el)=>{
        (0, $0718df5b9f85432a$export$2e2bcd8739ae039)(el);
    });
    const homeBannerNodes = document.querySelectorAll('.giantpeach-homebanner');
    if (homeBannerNodes.length) homeBannerNodes.forEach((el)=>{
        (0, $55d913a54d8ff892$export$2e2bcd8739ae039)(el);
    });
    const animatedScrollNodes = document.querySelectorAll('.giantpeach-animatedscroll');
    if (animatedScrollNodes.length) animatedScrollNodes.forEach((el)=>{
        (0, $5d434dcfcf14d55c$export$2e2bcd8739ae039)(el);
    });
}
function $69b95ab15881497e$var$initAnimations() {
    let transitionableBlocks = document.querySelectorAll(".transition-block");
    let inViewStop = (0, $3019b940a732e107$export$acb1e9cb9ce4ca56)(transitionableBlocks, ({ target: target })=>{
        (0, $d522be3249d946e5$export$e3607ec2d7a891c4)(target, {
            opacity: 1,
            transform: "none"
        }, {
            delay: 0.2,
            duration: 0.5,
            easing: [
                0.25,
                0.1,
                0.25,
                1
            ]
        });
        return ()=>{
            (0, $d522be3249d946e5$export$e3607ec2d7a891c4)(target, {
                opacity: 0,
                transform: "translateY(60px)"
            }, {
                duration: 0.5,
                easing: [
                    0.25,
                    0.1,
                    0.25,
                    1
                ]
            });
        };
    });
    document.addEventListener("block:load", ()=>{
        transitionableBlocks = document.querySelectorAll(".transition-block");
        inViewStop();
        inViewStop = (0, $3019b940a732e107$export$acb1e9cb9ce4ca56)(transitionableBlocks, ({ target: target })=>{
            (0, $d522be3249d946e5$export$e3607ec2d7a891c4)(target, {
                opacity: 1,
                transform: "none"
            }, {
                delay: 0.2,
                duration: 0.5,
                easing: [
                    0.25,
                    0.1,
                    0.25,
                    1
                ]
            });
            return ()=>{
                (0, $d522be3249d946e5$export$e3607ec2d7a891c4)(target, {
                    opacity: 0,
                    transform: "translateY(60px)"
                }, {
                    duration: 0.5,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ]
                });
            };
        });
    });
    let transitionableFadeBlocks = document.querySelectorAll(".transition-block-fade");
    let inViewStopFade = (0, $3019b940a732e107$export$acb1e9cb9ce4ca56)(transitionableFadeBlocks, ({ target: target })=>{
        (0, $d522be3249d946e5$export$e3607ec2d7a891c4)(target, {
            opacity: 1
        }, {
            delay: target.dataset.delay ?? 0.2,
            duration: 0.5,
            easing: [
                0.25,
                0.1,
                0.25,
                1
            ]
        });
        return ()=>{
            (0, $d522be3249d946e5$export$e3607ec2d7a891c4)(target, {
                opacity: 0
            }, {
                duration: 0.5,
                easing: [
                    0.25,
                    0.1,
                    0.25,
                    1
                ]
            });
        };
    });
    let transitionableBlocksProse = document.querySelectorAll(".transition-block-prose");
    (0, $3019b940a732e107$export$acb1e9cb9ce4ca56)(transitionableBlocksProse, ({ target: target })=>{
        target.classList.add('animated');
        return ()=>{
            target.classList.remove('animated');
        };
    });
    let transitionableBlocksClass = document.querySelectorAll(".transition-block-class");
    (0, $3019b940a732e107$export$acb1e9cb9ce4ca56)(transitionableBlocksClass, ({ target: target })=>{
        target.classList.add('animated');
        return ()=>{
            target.classList.remove('animated');
        };
    });
    let transitionableStaggerBlocks = document.querySelectorAll(".transition-block-stagger");
    transitionableStaggerBlocks.forEach((el)=>{
        const stagger = parseInt(el.dataset.stagger);
        if (stagger) el.dataset.staggerItem = Array.from(el.closest(".stagger-child").parentNode.children).indexOf(el.closest(".stagger-child"));
    });
    (0, $3019b940a732e107$export$acb1e9cb9ce4ca56)(transitionableStaggerBlocks, ({ target: target })=>{
        console.log(target);
        (0, $d522be3249d946e5$export$e3607ec2d7a891c4)(target, {
            opacity: 1,
            transform: "none"
        }, {
            delay: window.innerWidth < 992 ? 0 : parseInt(target.dataset.staggerItem) * 0.25,
            duration: 0.5,
            easing: [
                0.25,
                0.1,
                0.25,
                1
            ]
        });
        return ()=>{
            (0, $d522be3249d946e5$export$e3607ec2d7a891c4)(target, {
                opacity: 0,
                transform: "translateY(60px)"
            }, {
                duration: 0.5,
                easing: [
                    0.25,
                    0.1,
                    0.25,
                    1
                ]
            });
        };
    });
}
document.addEventListener("DOMContentLoaded", $69b95ab15881497e$var$domReady);

})();
//# sourceMappingURL=main.js.map
